webpackJsonp([2],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
// http

/* harmony default export */ __webpack_exports__["a"] = ({
  //请求基础路径
  API_ROOT: function API_ROOT() {
    // http://api.testing.nczxhx.com/cgi/business/banner/home
    if (true) {
      if (document.location.protocol == 'https:') {
        return 'https://zsyteapi.zhixinhuixue.com/cgi/';
      } else {
        return 'http://zsycgi.zhixinhuixue.com/cgi/';
      }
    } else if (process.env.NODE_ENV === 'testing') {
      return 'http://api.testing.nczxhx.com/cgi/';
      // return 'http://zsy.dev.xueping.com/cgi/';
    } else {
      return 'http://api.testing.nczxhx.com/cgi/';
      // return 'http://zsy.dev.xueping.com/cgi/';
    }
  },
  // TEACHER_API_ROOT: function () {
  //   if (process.env.NODE_ENV === 'production') {
  //     return 'http://zsyte2.zhixinhuixue.com/teacher/';
  //   } else if (process.env.NODE_ENV === 'testing') {
  //     return 'http://zsy.dev.xueping.com/teacher/';
  //   } else {
  //     return 'http://zsy.dev.xueping.com/teacher/';
  //   }
  // },
  SIGN_NAME_API_ROOT: function SIGN_NAME_API_ROOT() {
    if (true) {
      return 'http://zsyapi.zhixinhuixue.com';
    } else if (process.env.NODE_ENV === 'testing') {
      return 'http://api.testing.nczxhx.com/cgi/';
    } else {
      return 'http://api.testing.nczxhx.com/cgi/';
      // return 'http://zxhx:533166afe82356ff5bc22ae9a263fb4e@zsyapi.dev.xueping.com';
      // return 'http://192.168.1.105:105';
    }
  },
  //联考报名
  SIGN_UP_API_ROOT: function SIGN_UP_API_ROOT() {
    if (true) {
      return 'http://zsyapi.zhixinhuixue.com';
    } else if (process.env.NODE_ENV === 'testing') {
      return 'http://zsyapi.testing.nczxhx.com';
    } else {
      return 'http://zsyapi.testing.nczxhx.com';
      // return 'http://zxhx:533166afe82356ff5bc22ae9a263fb4e@zsyapi.dev.xueping.com';
      // return 'http://192.168.1.105:105';
    }
  },
  // production: http://zsyhm.zhixinhuixue.com/#/token/
  // testing: http://zsyhm.dev.xueping.com/#/token/
  // dev: http://zsyhm.dev.xueping.com/#/token/
  // 校长端登录成功跳转
  JUMP_URL: function JUMP_URL() {
    var url = {};
    if (true) {
      url.hm = 'http://zsyhm2.zhixinhuixue.com';
    } else if (process.env.NODE_ENV === 'testing') {
      url.hm = 'http://zsyhm2.dev.xueping.com';
    } else {
      url.hm = 'http://zsyhm2.dev.xueping.com';
    }
    return url;
  },
  JUMP_TEACHER_URL: function JUMP_TEACHER_URL() {
    var url = {};
    if (true) {
      url.hm = 'http://zsyte.zhixinhuixue.com';
    } else if (process.env.NODE_ENV === 'testing') {
      url.hm = 'http://zsyte.testing.nczxhx.com';
    } else {
      url.hm = 'http://zsyte.dev.xueping.com';
    }
    return url;
  },
  //   production: http://zsyst.zhixinhuixue.com/index?token=
  // testing: http://zsyst2hd.dev.xueping.com/index?token=
  // dev: http://zsyst2hd.dev.xueping.com/index?token=
  JUMP_STUDENT_URL: function JUMP_STUDENT_URL() {
    var url = {};
    if (true) {
      url.hm = 'http://zsyst.zhixinhuixue.com';
    } else if (process.env.NODE_ENV === 'dev') {
      url.hm = 'http://zsyst2hd.dev.xueping.com';
    } else {
      url.hm = 'http://zsyst2hd.testing.nczxhx.com';
    }
    return url;
  },
  //请求方法
  HTTP_METHOD: {
    GET: "get",
    POST: "post",
    PUT: "put",
    DELETE: "delete"
  },
  //请求超时时间15s
  TIME_OUT: 15000,
  //返回数据类型JSON
  RESPONSE_TYPE: 'json',

  //AXIOS请求
  zsyHttpBase: function zsyHttpBase(_url, _method) {
    var _data = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    var success = arguments[3];
    var fail = arguments[4];
    var _catch = arguments[5];

    var _this = this;
    //请求全局配置
    var config = {};

    config.baseURL = _this.API_ROOT();
    config.url = _url;
    if (_method && _method == _this.HTTP_METHOD.GET) {
      config.params = _data;
    } else if (_method && (_method == _this.HTTP_METHOD.POST || _method == _this.HTTP_METHOD.PUT)) {
      config.data = _data;
    }
    config.method = _method;
    config.timeout = _this.TIME_OUT;
    config.responseType = _this.RESPONSE_TYPE;
    if (window.localStorage.getItem("token")) {
      config.headers = { 'Authorization': "Bearer " + window.localStorage.getItem("token") };
    }
    __WEBPACK_IMPORTED_MODULE_0_axios___default()(config).then(function (response) {
      var res = response.data;
      if (res.errCode != "00") {
        if (res.errCode == "02") {
          //重新登录
          Message.warning(res.errMsg);
          setTimeout(function () {
            window.vue.$router.push("/");
            window.localStorage.clear();
          }, 1000);
        } else {
          if (typeof fail == "function") {
            fail(res);
          } else {
            if (res.errMsg != "") {
              Message.error(res.errMsg);
            }
          }
        }
      } else {
        success && success(res);
      }
      ;
    }).catch(function (err) {
      _catch && _catch(err);
      if (err.message.indexOf("Network Error") != -1) {
        // Message.error('网络异常,请检查您的网络连接,请稍后重试.');
      } else if (err.message.indexOf("timeout") != -1) {
        // Message.error('当前网络连接不给力，请稍后重试.');
      } else if (err.message.indexOf("code 503") != -1) {
        // Message.error('当前服务不可用');
      } else {
          // Message.error('系统异常');
        }
    });
  },

  // GET请求
  zsyGetHttp: function zsyGetHttp(_url) {
    var _data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var success = arguments[2];
    var fail = arguments[3];
    var _catch = arguments[4];

    var _this = this;
    _this.zsyHttpBase(_url, _this.HTTP_METHOD.GET, _data, success, fail, _catch);
  },

  // POST请求
  zsyPostHttp: function zsyPostHttp(_url) {
    var _data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var success = arguments[2];
    var fail = arguments[3];
    var _catch = arguments[4];

    var _this = this;
    _this.zsyHttpBase(_url, _this.HTTP_METHOD.POST, _data, success, fail, _catch);
  },

  // PUT请求
  zsyPutHttp: function zsyPutHttp(_url) {
    var _data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var success = arguments[2];
    var fail = arguments[3];
    var _catch = arguments[4];

    var _this = this;
    _this.zsyHttpBase(_url, _this.HTTP_METHOD.PUT, _data, success, fail, _catch);
  },

  // DELETE请求
  zsyDeleteHttp: function zsyDeleteHttp(_url) {
    var _data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var success = arguments[2];
    var fail = arguments[3];
    var _catch = arguments[4];

    var _this = this;
    _this.zsyHttpBase(_url, _this.HTTP_METHOD.DELETE, _data, success, fail, _catch);
  },

  Axios: __WEBPACK_IMPORTED_MODULE_0_axios___default.a
});

/***/ }),
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__toast_vue__ = __webpack_require__(509);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__toast_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__toast_vue__);



var ToastConstructor = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend(__WEBPACK_IMPORTED_MODULE_1__toast_vue___default.a);

var instance = void 0;

var Toast = function Toast(text) {
  instance = new ToastConstructor({
    data: { text: text }
  });
  instance.$mount();
  document.body.appendChild(instance.$el);
  instance.visible = true;
};

/* harmony default export */ __webpack_exports__["a"] = (Toast);

/***/ }),
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */
/***/ (function(module, exports) {

!function () {
  var a = "@charset \"utf-8\";html{color:#000;background:#fff;overflow-y:scroll;-webkit-text-size-adjust:100%;-ms-text-size-adjust:100%}html *{outline:0;-webkit-text-size-adjust:none;-webkit-tap-highlight-color:rgba(0,0,0,0)}html,body{font-family:sans-serif}body,div,dl,dt,dd,ul,ol,li,h1,h2,h3,h4,h5,h6,pre,code,form,fieldset,legend,input,textarea,p,blockquote,th,td,hr,button,article,aside,details,figcaption,figure,footer,header,hgroup,menu,nav,section{margin:0;padding:0}input,select,textarea{font-size:100%}table{border-collapse:collapse;border-spacing:0}fieldset,img{border:0}abbr,acronym{border:0;font-variant:normal}del{text-decoration:line-through}address,caption,cite,code,dfn,em,th,var{font-style:normal;font-weight:500}ol,ul{list-style:none}caption,th{text-align:left}h1,h2,h3,h4,h5,h6{font-size:100%;font-weight:500}q:before,q:after{content:''}sub,sup{font-size:75%;line-height:0;position:relative;vertical-align:baseline}sup{top:-.5em}sub{bottom:-.25em}a:hover{text-decoration:underline}ins,a{text-decoration:none}",
      b = document.createElement("style");if (document.getElementsByTagName("head")[0].appendChild(b), b.styleSheet) b.styleSheet.disabled || (b.styleSheet.cssText = a);else try {
    b.innerHTML = a;
  } catch (c) {
    b.innerText = a;
  }
}();!function (a, b) {
  function c() {
    var b = f.getBoundingClientRect().width;b / i > 540 && (b = 540 * i);var c = b / 10;f.style.fontSize = c + "px", k.rem = a.rem = c;
  }var d,
      e = a.document,
      f = e.documentElement,
      g = e.querySelector('meta[name="viewport"]'),
      h = e.querySelector('meta[name="flexible"]'),
      i = 0,
      j = 0,
      k = b.flexible || (b.flexible = {});if (g) {
    console.warn("灏嗘牴鎹凡鏈夌殑meta鏍囩鏉ヨ缃缉鏀炬瘮渚�");var l = g.getAttribute("content").match(/initial\-scale=([\d\.]+)/);l && (j = parseFloat(l[1]), i = parseInt(1 / j));
  } else if (h) {
    var m = h.getAttribute("content");if (m) {
      var n = m.match(/initial\-dpr=([\d\.]+)/),
          o = m.match(/maximum\-dpr=([\d\.]+)/);n && (i = parseFloat(n[1]), j = parseFloat((1 / i).toFixed(2))), o && (i = parseFloat(o[1]), j = parseFloat((1 / i).toFixed(2)));
    }
  }if (!i && !j) {
    var p = (a.navigator.appVersion.match(/android/gi), a.navigator.appVersion.match(/iphone/gi)),
        q = a.devicePixelRatio;i = p ? q >= 3 && (!i || i >= 3) ? 3 : q >= 2 && (!i || i >= 2) ? 2 : 1 : 1, j = 1 / i;
  }if (f.setAttribute("data-dpr", i), !g) if (g = e.createElement("meta"), g.setAttribute("name", "viewport"), g.setAttribute("content", "initial-scale=" + j + ", maximum-scale=" + j + ", minimum-scale=" + j + ", user-scalable=no"), f.firstElementChild) f.firstElementChild.appendChild(g);else {
    var r = e.createElement("div");r.appendChild(g), e.write(r.innerHTML);
  }a.addEventListener("resize", function () {
    clearTimeout(d), d = setTimeout(c, 300);
  }, !1), a.addEventListener("pageshow", function (a) {
    a.persisted && (clearTimeout(d), d = setTimeout(c, 300));
  }, !1), "complete" === e.readyState ? e.body.style.fontSize = 12 * i + "px" : e.addEventListener("DOMContentLoaded", function () {
    e.body.style.fontSize = 12 * i + "px";
  }, !1), c(), k.dpr = a.dpr = i, k.refreshRem = c, k.rem2px = function (a) {
    var b = parseFloat(a) * this.rem;return "string" == typeof a && a.match(/rem$/) && (b += "px"), b;
  }, k.px2rem = function (a) {
    var b = parseFloat(a) / this.rem;return "string" == typeof a && a.match(/px$/) && (b += "rem"), b;
  };
}(window, window.lib || (window.lib = {}));

/***/ }),
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/app_bg.7bb1cc0.png";

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/open_imgs.7e83fbb.png";

/***/ }),
/* 81 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAMAAABHPGVmAAAAtFBMVEVHcEz/4jrk2lZdmdH44EP/4Tr/4Tj/4Tn/4Dn93jr/4DpzpL3/4Tpal9T/4TpbmNP/4Tn/4Tr/3zr/4Tv/4jp5pbX/4Dr43NA6OjpKkOL1yrj////1tp2+4/a/qjqnlo+ZijpqYl/dykv1w6/72XqqzfD+9/V/p7Fem9eXwO58cTr95pf+31X4z5b+8uh1run21caTsJ7i8PpJRjpiWzrjyr9ZVFJJRkXpxnP53L/Hu3r76d+IyCkEAAAAFnRSTlMAVhCHItwY65L6yTRtvaftQMkwu4RY5E4OGQAABFZJREFUaN61mglT8jAQhnsf3CgGWr4WaKtURblUPP7///p6gRaSzaYt7zjjUGie2SPbJFtJQsoYdKxeSzdtQmxTb/WszsCQmpQh93RCkd6TGwJpIyrgBBppdQlKZ0i4GnaUOm6ybIKSbVV1m4ZF5JgqXlNEEJksYafJJhGWKYt56pZU0q12XTNEjbFIDVm4vG2RWmohslnTSU3p3MDcmKS2zBuYMWiAkVAG17aDZ4vWECOhMONi6KQx6awco+auHfh+XsVsnyValWvh52DwNEn15hPi7ycs7efYWSlTfjg/jfM0n0B6otws44IOD1ySjwo+pe76eAbVlFuMs97wjP0b4TtMMesZQrWEmAo3s+YiEJ9f9zW7JmRPXxDYGu8xJQTxuY8ww64LSYJCHcM2OM/bYDKpHfpfUxS7CchkTjXlmGAduj/fBCH04HcKCH1NfTZNPtijH6A0Hhb5SzekHPfZeMZkzMCo5Fk8okPyIv+RWnBYvI/H4/cZQ+PCSmppIaMMokOQ2XjznhJAzSCInk0SAkG4gFTvkLuIwai/p8Afxigd2Dmc1+Iea1uTPm4/cJA8KAF9oB47JMm6IblvgYMsAG+lQTHYy5onIcg+YI1jSAM2ZC4CYTPIgFVThCFz9jgdaMfTFMRiJleDkJ40vD5kKOnXh+iSeX2IKQHnDvPDYoaDzBYHAGJLwB7jO3RdHGTjht/AQADkxXWxkPSXL4AlTHdFrhjEjdgQVuBXrijEXTEDr4OGbEQgETOFW1BExCxhRaXFLCsNQnrMAikE2bhuyIZYzFIfiVsSMUv94PrZNWA/fpubJwZ7IdHYjNeBJVFiS4iHhBHwzGIv7lJ9fqJm4+bzExhElsA1UaJnDOQZHMIAFtyFyzCQCDyUgrYOhTAQcIARtAnC+wv2lgZt546Tkg9Zgc0VeGOKNQU2pANvsY/6ghlfcF9FwR3Or2o468+5hwGbElVO37/HHrw+Q1SVUTqL0uyKFA6DaCItkxU1+l8roWaKwj1Ap2TyD49xdjwI1uJMr9OfUkXe/EynD5x7ZMSRbSkq0+nrv9DdZKBNsvb99zqdTuF5eCvacXhOISVxIbTOg9w0RBZuyolDLGxrI/jebpeptvdJmMOSHhKIl3+5/Q6wrY3zJk2wjZ2THhOIW1IKuT99H28DXJOmFPxg6fwVD5JoGWDaTX8aZ/bWcUQhjrO1UU3AogUYxA4LEh7/KBAnDhAtwMKWS8YREoKWFBReMzNry1IYOHflFF3DNJiXTnWIs2yhXpdQunRIrp3nebvjBwqki32JQWVCUoT3i7mEqPhXC9p9KsS7LxjeY+zRIP220FsS6iVkt3acgpIOvt5dQFRJUO1yZB53j1ny5JC4uFaCdNuSuEqY9fF/ylifX62KoFiT6T531nlOVUVkGPUiBTzv/EpfrYPIdHfGWa/PCHfNvOLVVrt9GqTfrW9DuabdqQmqHyf5Fcf9ZHj1Dv1Oz3/pLtM7Df920AAAAABJRU5ErkJggg=="

/***/ }),
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/0.bf1bb8a.png";

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/1.ba3ca27.png";

/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/2.8f075c4.png";

/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/3.9a93d4e.png";

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/4.85ca9d0.png";

/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/0.c6aefbc.png";

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/1.0de936c.png";

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/10.11be3e4.png";

/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/11.057b0be.png";

/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/12.4852617.png";

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/13.0f5881b.png";

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/2.606c47b.png";

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/3.cc165b0.png";

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/4.a190656.png";

/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/5.1d77320.png";

/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/6.ea58808.png";

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/7.478a308.png";

/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/8.582ce8c.png";

/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/9.29d0734.png";

/***/ }),
/* 139 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 140 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 141 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 142 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 143 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAsCAYAAAAehFoBAAAAAXNSR0IArs4c6QAAAW9JREFUWAnt2LFOwzAQBuD/qGBg7YP0bUAIiQkxsDB1gaVLWdgZECtCIPEwPARrR8SC3LtAhqAmrc93V0C25FZt7Pjzr8iODNRSE6gJ1AT+VQIUNpurdMRj3XyPd4E5vWjGjgFfplPG3XH9Go/wjl2MMaOPXPRObofs9j+xcoOEff6Uml18wauwQiROe0aLbC138AP3Y58wwbkGK318nuFh7DEO6PP3gB2x9gk7Y23BAVg7cBDWBhyILQcHY8vAW8DqwfIik/DAN+iu4wTZFIrWWUENFe1OJ29d4ViZiBY8FILrNS14yqrUkSUc4pUfk+c06vxv/EMHntMjO864hqO7z2FuGltYKcrAMsFgdDk4GG0DDkTbgYPQtuAAtD3YGe0DdkTrNg4BrSvXdM9N+jaX23Xd+677JdyO2LdO7zUnP9lnE34Jt+BVSctRFZrattr42x8sFEETvycT3poKnGjO1TaeVW1YE6gJ1AT+TgJLmICN12ORrW0AAAAASUVORK5CYII="

/***/ }),
/* 144 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAo9JREFUSA2tVcFLlEEU/826Rpe0LhEheKiOCkGHIISIiPCQILSe8mD9BxVJ60cbVhjaf1CCedKDoAcJkQjWoENQ2LE6GB2iS7ndKvf1ezPf57fTzrhQO/A5M+/93u838+a91aDVeCgHUMMNwi7xO57CP3BeQRdmcMv8SG3ByQStmXFCzkEwy683M3mzwRYMxnDPPPfsDZtCw9pfKnkd6yl5lUR6g6P2c+uq9SlGsZERvoFLyztLYPAAnUhQMXWPoyIF/MIkMbcpvsV09YXSFb6B5tylpRokVyUVVGHA3cS9k3cG3YQFgCGLNJhuOnkjhYooxg1NYdOICRyzSMHrpoi/DTkmqzAPERPwQP+ziQl8tKQGp1qS5xjtjaYRE1i2SMFNaLXEhvoU48ZKCBYO1g7V0gMGbCmGRLIyVYwr05mQQLgPFJk1GhiupajVkj2opsWdfIA+YS2ej3VzXEBFEhnDDm8DHNJtYHxDB3tm0swGfNYUFijLaXrv8mwXYoGe3WCN+zu4b155dm58gUXpwCbbv47x1LdNxALXzzhvohtfLME2jlC8n+uLnEc4d/PTVE3RmqBkdiyOf3KBihT5oMuEDdL6m74p/hQ8Yid/z8DBuSIHGXedvnHGFhm7yrghxilHg0BZnhJwhZavPMkw8/oySBgzJnKGN18ix2FyzDNdo7lAIiU+5gIdNZKfJfmbGM+e9kROUuQFRbr4+CPkWTRspP34ifcM7CH5NZbbkz1JWjkn5CpFHhP2GftwosBsD1pyg7d83mi5teLd9SuHcumBya2tXkqdczBGdoH/unAccza8jssq0Gc3nfzX166Rc/UXeJ2elPdTu/jJ47jIXeRmgyLCuq21TUC5yrJKPvkDzw2+eICiNDcAAAAASUVORK5CYII="

/***/ }),
/* 145 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAT9JREFUSA3tlr9KA0EQxn9zHKlSaRo7H8PK1iKlvUI6n0A8RE5RScDWFxCsbdTCUrDyQWw0FpYXs84mZPUucjcHd10GFnbnz/fNzu4yK6Suw4QzHHs6NmhChDeEG2JO4hn4lMMmcAOGT9Qp5gTl8Jl7iehzLo/BKXHvOl+nS49EPoLeMklcX93uPXYUyvIX3AJS5nMpDzOz7iQq82vC1jpBbM4ycQO9Gful/sIod47qbCeAHT2v7QqCF7X/XpRaBB0OyLguJVjjtWi37yCVsQY/FwGq1jUI3CbfbAXAqRasyxNH8hl0/0zsBBlXCrmbw/gi1fVpTldY2AngVmOzEC9KB/MHFZTLEzvBhdxpuB+1pPWHtiKoPI9ViQwl8g3ay7zNVQaYHBZYii0cuyFNN/1FFhGj2H8tfPfXh9/Kt+UH9TxKFrhsw3gAAAAASUVORK5CYII="

/***/ }),
/* 146 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAnZJREFUSA29ljtoVEEUhv/ZPBANiIWIXbCxs7BQsRDBRggxIVmxEzTiq4gvdGP2YpZN3LiiYGWEiEbRxlKNGIwBbWwTrQRtLBQL8QURV8nxmzGrLnjXvYt6YOaee2bm+889exjWKWfNmlVeTttlWq5azWlCRbe5Yntk+2AcJfZGKfVq0D1KBbiUSQSvoM6/9NuA5nQezh0iH/AnlbU1Thl7GeANatOw84vJLbIcwAGq8FRNWk0dvuiFpgCVUj8yrx+eB36CkhQBLgU9rndaAPcToymVPN1fTmRtEHhE5vs15PoAbmJ1ld7rOc+NiObqF4hsCGAW+F6ddBeCbLMe83xAbDHwNKJTjWEh6RRZgcz7gOwBMhqO5yxFeS7htzE8/JaPJxfI2jDwDGd3A7noIbS6h4/hbSP7buK3fdhbMoGsFSmL7/NdKjif7Xd4SVfwtjK6KNe4D+sYbYvVLhDZaeBHKEsPGV72h3XDGjQT4GniXcR/trmjs7DaBPrtDPBDjB4yHPMHA3xaV/G6gXcCvxvi5cmIYn8WyNpZ9h0EvoOyeGAZfo16dxLvAD4R4r+ZqrdpZAcAHGbcrIDP6HqAO+CFeLjXq/4Fc3y+9IzRocjy7M5rGrjUjr9FeXcPv6rFC+SsRSWtU4N28gWLaM0RWjENrZXqevhkVfL8YrzAV21gTxPwJcBXUpKP+K1k3g78fi1wvyf+NzCtCBDTOeBrGSO8r08C9+fjv2CZRvWau6VFT3TcvQ1idUzxAr3uM7yHdTArjsSXqGJb/S//QcDpVcgvY/6a/TtWZsF23HqnoPrr919YsVELufVmYSf921ItHV8V4yKE/Q0dMsI8rO5sdQAAAABJRU5ErkJggg=="

/***/ }),
/* 147 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAMCAYAAAB4MH11AAAAAXNSR0IArs4c6QAAAX5JREFUOBGdk71OAkEQx++WK7SxgidQW2stubvKgsRY6isoIrbGwlYU4ytopzHBxAY4Sq1t1SfQRhst7g5/c9lJjgByYRMys7P/j53bwe12uw3XdZuO47wQ94IgeCefe/X7/eXhcHiFwBqx5WLwxWbJKn54nlerVqvP8zgMBoP1OI47cCuW/224dTsnVkmSJOIWW7laoVQ4wgWs4o5omzAMT0gOOEhFibYW0zS97fV6+7IvsgQrHOFafIpmPdNWAbkBgJscyDHGXPi+fwQ4M1esRrAmiqIzxBtaA/vDb4e3vJeaqwcS5RvS5gPEstYB35VKpV3e5VdrFrsA9hrsdq4+9oYjBpa4wkM9kq8qEZMnTOTxPy2mjHgH8Q3FEF8ZkE0wb7naaAd6QCdTBQQz6wKqI3GsAz3EZOwT0EnWQZFPqDpTDQSAkGFCWqQyZZNWm0lpYjxxCITwr4EqYlLH7Jy9sTUZw0PELxUzLRYyEDLjWGMcTyVnfI8ZX/nHzlx/E/XCsPyZOCoAAAAASUVORK5CYII="

/***/ }),
/* 148 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGUAAABkCAMAAACo/g5YAAAAmVBMVEVHcEyG5X+F5X6G5X6G5H2F5X6G5X6L5Xef42aF5X7w2Q/72ATf3CHx2Q7k2xzv2hDt2RLW3SqF5H5ySSD/1wD43ND////1ybh2Vyr1t552bzd8oVV5h0Xtwa7K3Tb22Mr/3iqE2neCzG/76Nz/2RDXt6SLZkLGpY6Av2egfF2e4WJ/tGCtjW+53036+O393Gux6KX/8Kfp4suyUBnFAAAAEnRSTlMAaKOE2sBEEyzx+v545rSYyVeJaq6WAAAEnUlEQVRo3r2a6XqqMBCGi4JsWi2LRkAouCEube//5g4qikpmMoH2fP7ogwtvJ7NkkvD2RpU+UHqappqm45imqvX6ykB/+1UZSq+8eVNq/9dIRl91EGn97iAdR1QgpRPI6Dk0me0NIjM6cHQZxpUjD1FMR1rqQHKwVKeVevofG1KZY/yZR56k/O1o3UeNAhmYTkdp+n+AlM4RYRTnNySIgYHo92m+D8Nwn3WxRjBcecTcm4Iwa4kxMEga1ogKtMdCAMwTLIQbjAsnlw9oDf5JFrh8RalkeiLhtWcupAB0j2nIhVfoImKZTASo7SAYpjnh9OHhcgVioG8MchBnTERxA2o4w/EVuGKFtDgbtHVKJcg1pk4yJWUkSkAxpqsprgsVAbOjKUzWGKONKYctyTPqndJrE2Br//BU0KBb3Hs0MFdSGLLx/WTzOICi2tzK91vf9xdMIpjbDFhpSqktPTN1eIZkiFcu2hGirCcYsAwOsCvEnzGxY8y21XiTVJTHMcvQygwXyghKyMUN8hhnITbN6I6089d+rbU4YzR8JmZwENfaCd1v4k0FBeIvhO53dCxbuCHG1v6L7sakSJHRpELswfENz2RIXkr1LrukAfGT24d7JMhMOoVtfY5mwlAus98hp8tuxoPU7g/hUNaplM3a52tNSBhiUoKMhyKDUAwKZQcz/HrKBNNSJVEOPqYdgaITCswGpWwIjSyFwjBIIp5hNCySa98vEMqCRDEJlC1CeZjHkKxUCcVyR3E+XC77SLV8KJaIYxImbpYVZNqPgNkRyHwkLQe8WSxLG434gTJg1dIv581izRk5DxpVjCXAeCXua7OcNpaZJre7yN0gzyJ0Gm6WlwqT5czlri41Sg8OGDPjNCCMuyDvk3qXg9ArYKEZ8DvYSNSEcTISbstNYPmSu7S+YsEoeww9aGURwYsJbjVG1/4KtJnEX7SukYSEvXJf8puk/bDGpLzl/C9BCu7G8drL6GWlfeBV//XhedBYiKxeubNyuo+CksRYEIXnovHNa/i+nTQPL99zy+/t0ZU4tpdY63v5Cll+S237DyiQ6XQ6myX3AuafyjeEmKftHoIx55vO5mctytd8npTX05PoV32pPXHHOd90Ma/ln9+Yyu2Rw8YUxfEYx/Fxerflqost0/NH8fF4LArKbi83zIpjbHkX2d7nhbJYzG+vqy0rz7arr1jxEQkwaHe0qAhXXSjJrNayojwpLtDd0WYvE3u2PMWzY3wT/iUArJefEymlOfi5Rf/ZkrYUr4DH6yXOCrs9xcIP+x5ORhqmSFC8I37Ud98gL7wuFAs95alPrOJOlLNn0IMxhR9gN8ppWeqrVPnnBFNi0VmiAgzYlVLq5/Ny9VNdcime8DT5PGgxSFl+VperT2TELINy+GoBlNNXfb3yvk4AZWSQTqs9LuX09XLL1Q+XMqGd8evvNofys6K9OSY/RTC0vJayPmSeiJi0g0yMNym1Mccayj8Nw/MOJnvc6okYKY79bry1FJljj1szLpzhSMwYDbs/dvUxRkGjbmY8WfTODTnrffhbiBvpYziejCyr7L9s2xpNxsMPMuEfE5hYf8xO/hgAAAAASUVORK5CYII="

/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/img-products-1.52acda6.png";

/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/img-products-2.ba9cd4b.png";

/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/img-products-3.86b49cf.png";

/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/img-products-4.222792c.png";

/***/ }),
/* 153 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/img-seal.45eefd0.png";

/***/ }),
/* 155 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 156 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */
/***/ (function(module, exports) {

/*
	rem计算
*/
!function () {
    var htmlEl = document.getElementsByTagName('html')[0];
    var fitPage = function fitPage() {
        /* The calculate of with from zepto  */
        var w = htmlEl.getBoundingClientRect().width;
        w = Math.round(w);
        w = w > 750 ? 750 : w;
        var newW = w / 750 * 100;
        htmlEl.style.fontSize = newW + 'px';
    };
    fitPage();

    var t;
    var func = function func() {
        clearTimeout(t);
        t = setTimeout(fitPage, 25);
    };
    window.addEventListener('resize', func);
}();

/***/ }),
/* 161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(553);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Index__ = __webpack_require__(476);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Home__ = __webpack_require__(475);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Home__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Teacher__ = __webpack_require__(482);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Teacher___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_Teacher__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Student__ = __webpack_require__(481);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Student___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_Student__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Parent__ = __webpack_require__(480);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Parent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_Parent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_AppDownload__ = __webpack_require__(469);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_AppDownload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_AppDownload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_AppTeachDownload__ = __webpack_require__(471);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_AppTeachDownload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_AppTeachDownload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_AppStudentDownload__ = __webpack_require__(470);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_AppStudentDownload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_AppStudentDownload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Licence__ = __webpack_require__(478);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Licence___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_Licence__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_privates__ = __webpack_require__(503);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_privates___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_privates__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_race__ = __webpack_require__(504);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_race___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_race__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_sign_Clazz__ = __webpack_require__(505);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_sign_Clazz___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_sign_Clazz__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_sign_Student__ = __webpack_require__(508);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_sign_Student___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_sign_Student__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_sign_Sign__ = __webpack_require__(507);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_sign_Sign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_sign_Sign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_sign_LingYongChuKu__ = __webpack_require__(506);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_sign_LingYongChuKu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__components_sign_LingYongChuKu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_UserKnow__ = __webpack_require__(483);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_UserKnow___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__components_UserKnow__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_Version__ = __webpack_require__(484);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_Version___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__components_Version__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_Agreement__ = __webpack_require__(468);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_Agreement___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__components_Agreement__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_joint_assess_signUpListTwo__ = __webpack_require__(489);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_joint_assess_signUpListTwo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__components_joint_assess_signUpListTwo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_joint_assess_signUpListPhone__ = __webpack_require__(488);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_joint_assess_signUpListPhone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__components_joint_assess_signUpListPhone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_advHtml_english__ = __webpack_require__(485);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_advHtml_english___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__components_advHtml_english__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_advHtml_matics__ = __webpack_require__(486);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_advHtml_matics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__components_advHtml_matics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_advHtml_surelogin__ = __webpack_require__(487);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_advHtml_surelogin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__components_advHtml_surelogin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_ForgetPassWord__ = __webpack_require__(473);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_ForgetPassWord___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__components_ForgetPassWord__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_InitPassWord__ = __webpack_require__(477);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_InitPassWord___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__components_InitPassWord__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_licence_StudentPrivacy_vue__ = __webpack_require__(494);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_licence_StudentPrivacy_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__components_licence_StudentPrivacy_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_licence_StudentPrivacy2_vue__ = __webpack_require__(495);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_licence_StudentPrivacy2_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28__components_licence_StudentPrivacy2_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_licence_TeacherPrivacy_vue__ = __webpack_require__(496);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_licence_TeacherPrivacy_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29__components_licence_TeacherPrivacy_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_licence_TeacherPrivacy2_vue__ = __webpack_require__(497);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_licence_TeacherPrivacy2_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30__components_licence_TeacherPrivacy2_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__components_licence_ProductProtocol_vue__ = __webpack_require__(493);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__components_licence_ProductProtocol_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31__components_licence_ProductProtocol_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__components_licence_UseProtocol_vue__ = __webpack_require__(498);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__components_licence_UseProtocol_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32__components_licence_UseProtocol_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__components_licence_CopyrightNotice_vue__ = __webpack_require__(490);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__components_licence_CopyrightNotice_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33__components_licence_CopyrightNotice_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__components_licence_ParentCopyrightNotice_vue__ = __webpack_require__(491);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__components_licence_ParentCopyrightNotice_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_34__components_licence_ParentCopyrightNotice_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__components_licence_ParentPrivacy_vue__ = __webpack_require__(492);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__components_licence_ParentPrivacy_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_35__components_licence_ParentPrivacy_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__components_licence_XbTeacherPrivacy_vue__ = __webpack_require__(501);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__components_licence_XbTeacherPrivacy_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_36__components_licence_XbTeacherPrivacy_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__components_licence_XbProductProtocol_vue__ = __webpack_require__(500);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__components_licence_XbProductProtocol_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_37__components_licence_XbProductProtocol_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__components_licence_XbUseProtocol_vue__ = __webpack_require__(502);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__components_licence_XbUseProtocol_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_38__components_licence_XbUseProtocol_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__components_licence_XbCopyrightNotice_vue__ = __webpack_require__(499);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__components_licence_XbCopyrightNotice_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_39__components_licence_XbCopyrightNotice_vue__);






















// import signUpList from '@/components/joint-assess/signUpList'








// import Methodtreasurepage from '../../copyRightmethodtreasurepage.html'

// 隐私政策


















__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: "history",
  routes: [{
    path: "/",
    name: "Index",
    component: __WEBPACK_IMPORTED_MODULE_2__components_Index___default.a,
    children: [{
      path: "",
      name: "Home",
      component: __WEBPACK_IMPORTED_MODULE_3__components_Home___default.a
    }]
  }, {
    path: "/privacy",
    name: "privates",
    component: __WEBPACK_IMPORTED_MODULE_11__components_privates___default.a
  }, {
    path: "/race",
    name: "race",
    component: __WEBPACK_IMPORTED_MODULE_12__components_race___default.a
  }, {
    path: "/index",
    name: "Index",
    component: __WEBPACK_IMPORTED_MODULE_2__components_Index___default.a,
    children: [{
      path: "teacher",
      name: "Teacher",
      component: __WEBPACK_IMPORTED_MODULE_4__components_Teacher___default.a
    }, {
      path: "student",
      name: "Student",
      component: __WEBPACK_IMPORTED_MODULE_5__components_Student___default.a
    }, {
      path: "parent",
      name: "Parent",
      component: __WEBPACK_IMPORTED_MODULE_6__components_Parent___default.a
    }]
  }, {
    path: "/signUpList",
    name: "signUpList",
    component: __WEBPACK_IMPORTED_MODULE_20__components_joint_assess_signUpListTwo___default.a
  }, {
    path: "/signUpListPhone",
    name: "signUpListPhone",
    component: __WEBPACK_IMPORTED_MODULE_21__components_joint_assess_signUpListPhone___default.a
  }, {
    path: "/app",
    name: "AppDownload",
    component: __WEBPACK_IMPORTED_MODULE_7__components_AppDownload___default.a
  },
  // {
  //   path: '/methodtreasurepage',
  //   name: 'methodtreasurepage',
  //   component: Methodtreasurepage
  // },
  {
    path: "/teacherdownload",
    name: "AppTeachDownload",
    component: __WEBPACK_IMPORTED_MODULE_8__components_AppTeachDownload___default.a
  }, {
    path: "/studentdownload",
    name: "AppStudentDownload",
    component: __WEBPACK_IMPORTED_MODULE_9__components_AppStudentDownload___default.a
  }, {
    path: "/licence",
    name: "Licence",
    component: __WEBPACK_IMPORTED_MODULE_10__components_Licence___default.a
  }, {
    path: "/signclazz",
    name: "SignClazz",
    component: __WEBPACK_IMPORTED_MODULE_13__components_sign_Clazz___default.a
  }, {
    path: "/signstu",
    name: "SignStudent",
    component: __WEBPACK_IMPORTED_MODULE_14__components_sign_Student___default.a
  }, {
    path: "/sign",
    name: "Sign",
    component: __WEBPACK_IMPORTED_MODULE_15__components_sign_Sign___default.a
  }, {
    path: "/lingyong",
    name: "LingYong",
    component: __WEBPACK_IMPORTED_MODULE_16__components_sign_LingYongChuKu___default.a
  }, {
    path: "/userknow",
    name: "UserKnow",
    component: __WEBPACK_IMPORTED_MODULE_17__components_UserKnow___default.a
  }, {
    path: "/version",
    name: "Version",
    component: __WEBPACK_IMPORTED_MODULE_18__components_Version___default.a
  }, {
    path: "/agreement",
    name: "Agreement",
    component: __WEBPACK_IMPORTED_MODULE_19__components_Agreement___default.a
  }, {
    path: "/forgetpassword",
    name: "ForgetPassword",
    component: __WEBPACK_IMPORTED_MODULE_25__components_ForgetPassWord___default.a
  }, {
    path: "/initPassword",
    name: "InitPassWord",
    component: __WEBPACK_IMPORTED_MODULE_26__components_InitPassWord___default.a
  },
  // 猜题活动页
  {
    path: "/english",
    name: "english",
    component: __WEBPACK_IMPORTED_MODULE_22__components_advHtml_english___default.a
  }, {
    path: "/matics",
    name: "matics",
    component: __WEBPACK_IMPORTED_MODULE_23__components_advHtml_matics___default.a
  }, {
    path: "/surelogin",
    name: "surelogin",
    component: __WEBPACK_IMPORTED_MODULE_24__components_advHtml_surelogin___default.a
  }, {
    path: "/bigdatalogin",
    name: "BigDataLogin",
    component: function component() {
      return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 560));
    }
  }, {
    path: "/studentpricacy",
    name: "StudentPrivacy",
    component: __WEBPACK_IMPORTED_MODULE_27__components_licence_StudentPrivacy_vue___default.a,
    meta: {
      title: "隐私服务"
    }
  }, {
    path: "/studentpricacy2",
    name: "StudentPrivacy2",
    component: __WEBPACK_IMPORTED_MODULE_28__components_licence_StudentPrivacy2_vue___default.a,
    meta: {
      title: "隐私服务及权限说明"
    }
  }, {
    path: "/teacherpricacy",
    name: "TeacherPrivacy",
    component: __WEBPACK_IMPORTED_MODULE_29__components_licence_TeacherPrivacy_vue___default.a,
    meta: {
      title: "隐私服务"
    }
  }, {
    path: "/teacherpricacy2",
    name: "TeacherPrivacy2",
    component: __WEBPACK_IMPORTED_MODULE_30__components_licence_TeacherPrivacy2_vue___default.a,
    meta: {
      title: "隐私服务及权限说明"
    }
  }, {
    path: "/productprotocol",
    name: "ProductProtocol",
    component: __WEBPACK_IMPORTED_MODULE_31__components_licence_ProductProtocol_vue___default.a,
    meta: {
      title: "产品服务协议"
    }
  }, {
    path: "/useprotocol",
    name: "UseProtocol",
    component: __WEBPACK_IMPORTED_MODULE_32__components_licence_UseProtocol_vue___default.a,
    meta: {
      title: "软件使用协议"
    }
  }, {
    path: "/copyrightnotice",
    name: "CopyrightNotice",
    component: __WEBPACK_IMPORTED_MODULE_33__components_licence_CopyrightNotice_vue___default.a,
    meta: {
      title: "版权声明"
    }
  }, {
    path: "/parentcopyright",
    name: "ParentCopyrightNotice",
    component: __WEBPACK_IMPORTED_MODULE_34__components_licence_ParentCopyrightNotice_vue___default.a,
    meta: {
      title: "版权声明"
    }
  }, {
    path: "/parentpricacy",
    name: "ParentPrivacy",
    component: __WEBPACK_IMPORTED_MODULE_35__components_licence_ParentPrivacy_vue___default.a,
    meta: {
      title: "隐私政策"
    }
  }, {
    path: "/xbteacherpricacy",
    name: "XbTeacherPrivacy",
    component: __WEBPACK_IMPORTED_MODULE_36__components_licence_XbTeacherPrivacy_vue___default.a,
    meta: {
      title: "隐私政策"
    }
  }, {
    path: "/xbproductprotocol",
    name: "XbProductProtocol",
    component: __WEBPACK_IMPORTED_MODULE_37__components_licence_XbProductProtocol_vue___default.a,
    meta: {
      title: "产品服务协议"
    }
  }, {
    path: "/xbuseprotocol",
    name: "XbUseProtocol",
    component: __WEBPACK_IMPORTED_MODULE_38__components_licence_XbUseProtocol_vue___default.a,
    meta: {
      title: "软件使用协议"
    }
  }, {
    path: "/xbcopyrightnotice",
    name: "XbCopyrightNotice",
    component: __WEBPACK_IMPORTED_MODULE_39__components_licence_XbCopyrightNotice_vue___default.a,
    meta: {
      title: "版权声明"
    }
  }]
}));

/***/ }),
/* 162 */,
/* 163 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 164 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 165 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 166 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 167 */,
/* 168 */,
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(254),
  /* template */
  __webpack_require__(522),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app'
});

/***/ }),
/* 255 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {};
  }
});

/***/ }),
/* 256 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_Http__ = __webpack_require__(12);
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      // androidUrl: 'http://fastcvf.zhixinhuixue.com/apk/zxhx_teacher_1.0.0.apk'
      // androidUrl: 'http://fastcvf.zhixinhuixue.com/apk/zxhx_teacher_1.0.1.apk'
      appList: [{ name: '教师版下载', class: 'app-teacher' }, { name: '学生端下载', class: 'app-student' }],
      appUrl: [{
        iosUrl: 'https://itunes.apple.com/cn/app/慧学宝/id1427169032?mt=8',
        androidUrl: 'http://fastcvf.zhixinhuixue.com/apk/zxhx_teacher_1.5.6.apk'
      }, {
        iosUrl: 'https://itunes.apple.com/cn/app/%E6%85%A7%E5%AD%A6%E5%AE%9D%E5%AD%A6%E7%94%9F%E7%AB%AF/id1442487562?mt=8',
        androidUrl: 'http://fastcvf.zhixinhuixue.com/apk/zxhx_student_1.3.8.apk'
      }],
      weChat: false
    };
  },

  methods: {
    isPC: function isPC() {
      var userAgentInfo = navigator.userAgent;
      var Agents = ["Android", "iPhone", "Windows Phone", "iPad", "iPod"];
      var flag = true;
      for (var v = 0; v < Agents.length; v++) {
        if (userAgentInfo.indexOf(Agents[v]) > 0) {
          flag = false;
          break;
        }
      }
      return flag;
    },
    isWeChat: function isWeChat() {
      var ua = navigator.userAgent.toLowerCase();
      if (ua.indexOf("micromessenger") != -1 || ua.indexOf("qq/") != -1) {
        this.weChat = true;
      } else {
        this.weChat = false;
      }
    },
    toApp: function toApp(key) {
      var ua = navigator.userAgent.toLowerCase();

      if (/iphone|ipad|ipod/.test(ua)) {
        window.location.href = this.appUrl[key].iosUrl;
      } else if (/android/.test(ua)) {
        // window.location.href = this.appUrl[key].androidUrl;
        var softwareId = key === 1 ? 7 : 5;
        __WEBPACK_IMPORTED_MODULE_0__lib_Http__["a" /* default */].Axios.get(__WEBPACK_IMPORTED_MODULE_0__lib_Http__["a" /* default */].SIGN_NAME_API_ROOT() + 'cms/api/software/latest/' + softwareId, {}).then(function (res) {
          // console.log(res)
          window.location.href = res.data.data.fileUrl;
        }).catch(function (err) {});
      }
    }
  },
  mounted: function mounted() {
    this.isWeChat();
    // window.location.reload();
  }
});

/***/ }),
/* 257 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_Http__ = __webpack_require__(12);
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      // androidUrl: 'http://fastcvf.zhixinhuixue.com/apk/zxhx_teacher_1.0.0.apk'
      // androidUrl: 'http://fastcvf.zhixinhuixue.com/apk/zxhx_teacher_1.0.1.apk'
      appList: [{ name: '学生端下载', class: 'app-student' }],
      appUrl: [{
        iosUrl: 'https://itunes.apple.com/cn/app/%E6%85%A7%E5%AD%A6%E5%AE%9D%E5%AD%A6%E7%94%9F%E7%AB%AF/id1442487562?mt=8',
        androidUrl: 'http://fastcvf.zhixinhuixue.com/apk/zxhx_student_1.3.8.apk'
      }],
      weChat: false
    };
  },

  methods: {
    isPC: function isPC() {
      var userAgentInfo = navigator.userAgent;
      var Agents = ["Android", "iPhone", "Windows Phone", "iPad", "iPod"];
      var flag = true;
      for (var v = 0; v < Agents.length; v++) {
        if (userAgentInfo.indexOf(Agents[v]) > 0) {
          flag = false;
          break;
        }
      }
      return flag;
    },
    isWeChat: function isWeChat() {
      var ua = navigator.userAgent.toLowerCase();
      if (ua.indexOf("micromessenger") != -1 || ua.indexOf("qq/") != -1) {
        this.weChat = true;
      } else {
        this.weChat = false;
      }
    },
    toApp: function toApp(key) {
      var ua = navigator.userAgent.toLowerCase();
      if (/iphone|ipad|ipod/.test(ua)) {
        window.location.href = this.appUrl[key].iosUrl;
      } else if (/android/.test(ua)) {
        // window.location.href = this.appUrl[key].androidUrl;
        var softwareId = key === 1 ? 7 : 5;
        __WEBPACK_IMPORTED_MODULE_0__lib_Http__["a" /* default */].Axios.get(__WEBPACK_IMPORTED_MODULE_0__lib_Http__["a" /* default */].SIGN_NAME_API_ROOT() + 'cms/api/software/latest/' + softwareId, {}).then(function (res) {
          // console.log(res)
          window.location.href = res.data.data.fileUrl;
        }).catch(function (err) {});
      }
    }
  },
  mounted: function mounted() {
    this.isWeChat();
    // window.location.reload();
  }
});

/***/ }),
/* 258 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_Http__ = __webpack_require__(12);
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      // androidUrl: 'http://fastcvf.zhixinhuixue.com/apk/zxhx_teacher_1.0.0.apk'
      // androidUrl: 'http://fastcvf.zhixinhuixue.com/apk/zxhx_teacher_1.0.1.apk'
      appList: [{ name: '教师版下载', class: 'app-teacher' }],
      appUrl: [{
        iosUrl: 'https://itunes.apple.com/cn/app/慧学宝/id1427169032?mt=8',
        androidUrl: 'http://fastcvf.zhixinhuixue.com/apk/zxhx_teacher_1.5.6.apk'
      }],
      weChat: false
    };
  },

  methods: {
    isPC: function isPC() {
      var userAgentInfo = navigator.userAgent;
      var Agents = ["Android", "iPhone", "Windows Phone", "iPad", "iPod"];
      var flag = true;
      for (var v = 0; v < Agents.length; v++) {
        if (userAgentInfo.indexOf(Agents[v]) > 0) {
          flag = false;
          break;
        }
      }
      return flag;
    },
    isWeChat: function isWeChat() {
      var ua = navigator.userAgent.toLowerCase();
      if (ua.indexOf("micromessenger") != -1 || ua.indexOf("qq/") != -1) {
        this.weChat = true;
      } else {
        this.weChat = false;
      }
    },
    toApp: function toApp(key) {
      var ua = navigator.userAgent.toLowerCase();
      if (/iphone|ipad|ipod/.test(ua)) {
        window.location.href = this.appUrl[key].iosUrl;
      } else if (/android/.test(ua)) {
        // window.location.href = this.appUrl[key].androidUrl;
        var softwareId = key === 1 ? 7 : 5;
        __WEBPACK_IMPORTED_MODULE_0__lib_Http__["a" /* default */].Axios.get(__WEBPACK_IMPORTED_MODULE_0__lib_Http__["a" /* default */].SIGN_NAME_API_ROOT() + 'cms/api/software/latest/' + softwareId, {}).then(function (res) {
          // console.log(res)
          window.location.href = res.data.data.fileUrl;
        }).catch(function (err) {});
      }
    },
    openApp: function openApp() {
      var _this = this;
      // window.location.href = 'https://m.zsyte.zhixinhuixue.com';
      var iosUrl = 'zsyte://';
      var androidUrl = 'zxhx://teacher.app/openwith?openType=1';
      var ua = navigator.userAgent.toLowerCase();
      if (/iphone|ipad|ipod/.test(ua)) {
        window.location.href = iosUrl;
      } else if (/android/.test(ua)) {
        window.location.href = androidUrl;
      }
      setTimeout(function () {
        _this.toApp();
      }, 3000);
    }
  },
  mounted: function mounted() {
    this.isWeChat();
    // window.location.reload();
  }
});

/***/ }),
/* 259 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "Footer",
  data: function data() {
    return {
      baseUrl:  true ? 'https://www.zhixinhuixue.com/copyRight/' : 'http://zsy.dev.xueping.com/copyRight/'
    };
  },

  computed: {
    //获取年份
    getYear: function getYear() {
      return new Date().getFullYear();
    }
  },
  beforeMount: function beforeMount() {
    console.log("production");
  }
});

/***/ }),
/* 260 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_Http__ = __webpack_require__(12);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: "ForgetPassword",
  data: function data() {
    var _this2 = this;

    var that = this;
    var validatePass = function validatePass(rule, value, callback) {
      //验证密码
      if (value === "") {
        callback(new Error("请输入密码"));
        // this.disabled = true
      } else if (_this2.pass) {
        _this2.pass = 0;
        callback(new Error(_this2.passErrMsg));
      } else {
        if (that.ruleForm.checkPass !== "") {
          that.$refs.ruleForm.validateField("checkPass");
        }
        // this.disabled = false
        callback();
      }
    };
    var validatePass2 = function validatePass2(rule, value, callback) {
      //二次验证密码
      if (value === "") {
        callback(new Error("请再次输入密码"));
        _this2.disabled = true;
      } else if (value !== that.ruleForm.setPassword) {
        callback(new Error("两次输入密码不一致!"));
        _this2.disabled = true;
      } else {
        _this2.disabled = false;
        callback();
      }
    };
    var validateCode = function validateCode(rule, value, callback) {
      //验证验证码
      if (value == "") {
        callback(new Error("请输入验证码"));
        _this2.disabled = true;
      } else if (_this2.newCode) {
        console.log(_this2.newCode);
        _this2.newCode = 0;
        callback(new Error(_this2.newCodeErr));
        _this2.disabled = true;
      } else {
        _this2.disabled = false;
        callback();
      }
    };
    var validatePhone = function validatePhone(rule, value, callback) {
      //验证手机
      var reg = /^1[3-9]\d{9}$/;
      if (value == "") {
        _this2.phoneValidate = true;
        callback(new Error("请输入手机号"));
      } else if (!reg.test(value)) {
        callback(new Error("请输入正确的手机号"));
        _this2.phoneValidate = true;
      } else if (_this2.newPhone) {
        _this2.newPhone = 0;
        callback(new Error(_this2.newPhoneErr));
      } else {
        _this2.phoneValidate = false;
        callback();
      }
    };
    return {
      ruleForm: {
        phoneNumber: "",
        code: "",
        setPassword: "",
        checkPass: ""
      },
      active: 0,
      rules: {
        setPassword: [{ validator: validatePass, trigger: "blur" }, {
          min: 3,
          max: 10,
          message: "长度在 6 到 16 个字符",
          trigger: "blur"
        }],
        checkPass: [{ validator: validatePass2, trigger: "blur" }],
        phoneNumber: [{ required: true, validator: validatePhone, trigger: "blur" }],
        code: [{ required: true, validator: validateCode, trigger: "blur" }]
      },
      show: true,
      count: 60,
      timer: null,
      pass: 0,
      passErrMsg: "",
      newCodeErr: "",
      newCode: 0, //获取的验证码
      newPhoneErr: "",
      newPhone: 0, //获取的新手机号
      disabled: true, //验证吗禁用
      phoneValidate: true, //手机禁用
      loading: false,
      updateToken: ""
    };
  },
  activated: function activated() {
    var _this3 = this;

    this.ruleForm.phoneNumber = "";
    this.ruleForm.code = "";
    this.ruleForm.setPassword = "";
    this.ruleForm.checkPass = "";
    this.$nextTick(function () {
      _this3.$refs.ruleForm.clearValidate();
    });
  },

  methods: {
    next: function next(val) {
      var sendObj = {
        captcha: this.ruleForm.code,
        clientType: 1,
        username: this.ruleForm.phoneNumber,
        validType: 1
      };
      var _this = this;
      //下一步
      this.$refs.ruleForm.validate(function (valid) {
        if (valid) {
          if (val > 3) {
            return;
          }
          __WEBPACK_IMPORTED_MODULE_0__lib_Http__["a" /* default */].zsyPostHttp("/auth/teacher/sms/login", sendObj, function (ok) {
            _this.active = val;
            _this.updateToken = ok.data.updateToken;
          }, function (fail) {
            if (fail.errMsg == "验证码已过期，请重新获取") {
              _this.newCode = 1;
              _this.newCodeErr = "验证码已过期";
              _this.$nextTick(function () {
                _this.$refs.ruleForm.validateField("code");
              });
            } else if (fail.errMsg == "验证码不正确") {
              _this.newCode = 1;
              _this.newCodeErr = "验证码不正确";
              _this.$nextTick(function () {
                _this.$refs.ruleForm.validateField("code");
              });
            } else if (fail.errMsg == "登录手机号格式错误") {
              _this.newPhone = 1;
              _this.newPhoneErr = "手机号格式错误";
              _this.$nextTick(function () {
                _this.$refs.ruleForm.validateField("phoneNumber");
              });
            }
          });
        }
      });
    },
    last: function last(val) {
      this.active = val;
    },
    submitLoging: function submitLoging() {
      var _this4 = this;

      console.log(this.ruleForm.checkPass, this.ruleForm.setPassword);

      if (!this.ruleForm.checkPass) {
        this.$refs.ruleForm.validateField("checkPass");
        return;
      } else if (!this.ruleForm.setPassword) {
        this.$refs.ruleForm.validateField("setPassword");
        return;
      }
      var sendObj = {
        confirm: this.ruleForm.checkPass,
        clientType: 1,
        password: this.ruleForm.setPassword,
        updateToken: this.updateToken
      };
      var _this = this;
      __WEBPACK_IMPORTED_MODULE_0__lib_Http__["a" /* default */].zsyPutHttp("/auth/teacher/change/password", sendObj, function (ok) {
        window.location.href = __WEBPACK_IMPORTED_MODULE_0__lib_Http__["a" /* default */].JUMP_TEACHER_URL().hm + "/?portal=" + ok.data.portalToken;
      }, function (fail) {
        if (fail.errMsg == "新密码太简单，请更换安全的密码！") {
          _this.pass = 1;
          _this.passErrMsg = "新密码太简单";
          _this.$nextTick(function () {
            _this.$refs.ruleForm.validateField("setPassword");
          });
        } else if (fail.errMsg == "密码格式错误:密码位数6~16位，只能数字和字母组合。") {
          _this.pass = 1;
          _this.passErrMsg = "密码格式错误";
          _this.$nextTick(function () {
            _this.$refs.ruleForm.validateField("setPassword");
          });
        } else if (fail.errMsg === "授权已超时，请重新开始验证！") {
          _this4.$message.error("授权已超时，请重新开始验证！");
          setTimeout(function () {
            _this.$router.push("/");
          }, 2000);
        }
      });
    },
    teacherCode: function teacherCode() {
      var TIME_COUNT = 60;
      var _this = this;
      __WEBPACK_IMPORTED_MODULE_0__lib_Http__["a" /* default */].zsyGetHttp("/auth/captcha/teacher-sms/" + this.ruleForm.phoneNumber, {}, function (ok) {
        if (!_this.timer) {
          _this.count = TIME_COUNT;
          _this.show = false;
          _this.timer = setInterval(function () {
            if (_this.count > 0 && _this.count <= TIME_COUNT) {
              _this.count--;
            } else {
              _this.show = true;
              clearInterval(_this.timer);
              _this.timer = null;
            }
          }, 1000);
        }
      }, function (fail) {
        if (fail.errMsg == "教师账号不存在，请检查或者联系学管！") {
          _this.newPhone = 1;
          _this.newPhoneErr = "账号不存在";
          _this.$nextTick(function () {
            _this.$refs.ruleForm.validateField("phoneNumber");
          });
        }
      });
    },
    getCode: function getCode() {
      this.$refs.ruleForm.validateField("phoneNumber");
      if (this.phoneValidate) {
        return;
      }
      if (this.$route.query.from === "teacher") {
        this.teacherCode();
      }
    }
  }
});

/***/ }),
/* 261 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "Headers",
  data: function data() {
    return {
      showScanErma: false,
      activeType: 1
    };
  },
  beforeMount: function beforeMount() {
    this.getUrl();
    // console.log(this.activeType)
  },

  watch: {
    '$route': function $route(to, from) {
      // 对路由变化作出响应...
      // console.log(333)
      this.activeType = this.$route.params.status || 1;
      //显示顶部
      window.scrollTo(0, 0);
      // let element = document.getElementById("header");
      // element.scrollIntoView(true);
    }
  },
  computed: {
    classObject: function classObject() {
      return {
        'bg-home': this.activeType === 1,
        'bg-teacher': this.activeType === 2,
        'bg-student': this.activeType === 3,
        'bg-parent': this.activeType === 4
      };
    }
  },
  methods: {
    getUrl: function getUrl() {
      // console.log(this.$route.path);
      // let url = window.location.href;
      if (this.$route.path.indexOf('/teacher') > -1) {
        this.activeType = 2;
      } else if (this.$route.path.indexOf('/student') > -1) {
        this.activeType = 3;
      } else if (this.$route.path.indexOf('/parent') > -1) {
        this.activeType = 4;
      }
    },

    //nav点击切换事件
    handleNavClick: function handleNavClick() {
      //埋点监控
      _hmt.push(['_trackEvent', '知心慧学', 'click', '导航栏tab点击切换事件']);
    }
  }
});

/***/ }),
/* 262 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Login__ = __webpack_require__(479);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Login___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Login__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_Http__ = __webpack_require__(12);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: "Home",
  components: {
    Login: __WEBPACK_IMPORTED_MODULE_0__components_Login___default.a
  },
  data: function data() {
    return {
      productsType: 1,
      usageQuantity: {
        user: [0, 1, 2, 3, 4, 5, 6, 7],
        test: [{ value: 0, roll: 0 }, { value: 1, roll: 0 }, { value: 2, roll: 0 }, { value: 3, roll: 0 }, { value: 4, roll: 0 }, { value: 5, roll: 0 }, { value: 6, roll: 0 }, { value: 7, roll: 0 }],
        examination: [{ value: 0, roll: 0 }, { value: 1, roll: 0 }, { value: 2, roll: 0 }, { value: 3, roll: 0 }, { value: 4, roll: 0 }, { value: 5, roll: 0 }, { value: 6, roll: 0 }, { value: 7, roll: 0 }]
      },
      numberItem: 0,
      examinationVal: [],
      banners: [],
      testVal: [],
      isNight: false,
      userNum: 3473528,
      testNum: 568216,
      examinationNum: 24650949,
      sameDay: '',
      time: '',
      y: 2018,
      m: 12,
      d: 21,
      w: 5
    };
  },

  watch: {
    'examinationVal': function examinationVal(val, oldVal) {
      var _this2 = this;

      var _loop = function _loop(i) {
        if (val[i] != oldVal[i]) {
          _this2.usageQuantity.examination[i].roll = 1;
          var _this = _this2;
          setTimeout(function () {
            _this.usageQuantity.examination[i].roll = 0;
          }, 500);
        }
      };

      for (var i in val) {
        _loop(i);
      }
    },
    'testVal': function testVal(val, oldVal) {
      var _this3 = this;

      var _loop2 = function _loop2(i) {
        if (val[i] != oldVal[i]) {
          _this3.usageQuantity.test[i].roll = 1;
          var _this = _this3;
          setTimeout(function () {
            _this.usageQuantity.test[i].roll = 0;
          }, 500);
        }
      };

      for (var i in val) {
        _loop2(i);
      }
    }
  },
  created: function created() {
    this.userNum = this.userNum + this.sum(60, 10);
    this.getNowDate();
    this.editData();
    this.getData();
  },


  methods: {
    goJointAssess: function goJointAssess(item) {
      // this.$router.push("/signUpList")
      if (item.haveUrl) {
        location.href = item.url;
      }
    },
    getData: function getData() {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_1__lib_Http__["a" /* default */].Axios.get(__WEBPACK_IMPORTED_MODULE_1__lib_Http__["a" /* default */].API_ROOT() + 'business/banner/home ').then(function (res) {
        _this4.banners = res.data.data;
      });
    },
    editData: function editData() {
      var _this = this;
      this.setTestNum(this.sameDay, this.time, this.y);
      this.setExaminationNum(this.sameDay, this.time, this.y);

      setInterval(function () {
        _this.getNowDate();
      }, 1000);

      setInterval(function () {
        _this.setTestNum(_this.sameDay, _this.time, _this.y);
      }, 5000);
      setInterval(function () {
        _this.setExaminationNum(_this.sameDay, _this.time, _this.y);
      }, 30000);

      this.setUserNum(this.sameDay, this.y);
    },

    // 产品显示切换
    productsLeft: function productsLeft() {
      this.productsType = this.productsType - 1;
      if (this.productsType == 0) {
        this.productsType = 4;
      }
    },
    productsRight: function productsRight() {
      this.productsType = this.productsType + 1;
      if (this.productsType == 5) {
        this.productsType = 1;
      }
    },

    //随机数
    sum: function sum(m, n) {
      var num = Math.floor(Math.random() * (m - n) + n);
      return num;
    },

    //使用知心慧学数量
    getNowDate: function getNowDate() {
      var date = new Date();
      var y = date.getFullYear();
      var m = date.getMonth() + 1;
      if (m < 10) {
        m = '0' + m;
      }
      var d = date.getDate();
      if (d < 10) {
        d = '0' + d;
      }
      var h = date.getHours();
      if (h < 7 || h > 20) {
        this.isNight = true;
      }
      if (h < 10) {
        h = '0' + h;
      }
      var i = date.getMinutes();
      if (i < 10) {
        i = '0' + i;
      }
      var s = date.getSeconds();
      if (s < 10) {
        s = '0' + s;
      }
      var w = date.getDay();

      this.sameDay = y.toString() + m.toString() + d.toString();
      this.time = h.toString() + i.toString() + s.toString();
      this.y = y;
      this.m = m;
      this.d = d;
      this.w = w;
    },
    setUserNum: function setUserNum(sameDay, y) {
      //师生量
      var userVal2 = Number(sameDay) * 4 / 9 + (y - 2018) * 100000 + this.userNum;
      var userVal3 = Math.round(userVal2).toString();
      var userVal = [];
      userVal = userVal3.split("");
      this.usageQuantity.user = userVal;
    },
    setTestNum: function setTestNum(sameDay, time, y, w) {
      //组卷数量
      var testVal2 = Number(sameDay) / 36 + (y - 2018) * 1024000 + Number(time) * 2 / 9 + this.testNum;
      if (this.isNight) {
        testVal2 = Number(sameDay) / 36 + (y - 2018) * 1024000 + Number(205959) * 2 / 9 + this.testNum;
      }
      var testVal3 = Math.round(testVal2).toString();
      testVal3 = '0' + testVal3;
      this.testVal = testVal3.split("");
      for (var x in this.testVal) {
        this.usageQuantity.test[x].value = this.testVal[x];
      }
    },
    setExaminationNum: function setExaminationNum(sameDay, time, y) {
      //考试数量
      var examinationVal2 = Number(sameDay) / 5 + (y - 2018) * 2048000 + Number(time) * 2 / 3 + this.examinationNum;

      if (sessionStorage.examinationVal2) {
        var v = sessionStorage.examinationVal2;
        v = Number(v);
        var s = this.sum(23, 11);
        examinationVal2 = v + s;
      }
      sessionStorage.examinationVal2 = examinationVal2;
      if (this.isNight) {
        examinationVal2 = Number(sameDay) / 5 + (y - 2018) * 2048000 + Number(205959) * 2 / 3 + this.examinationNum;
      }
      var examinationVal3 = Math.round(examinationVal2).toString();
      this.examinationVal = examinationVal3.split("");

      for (var x in this.examinationVal) {
        this.usageQuantity.examination[x].value = this.examinationVal[x];
      }
    }
  }
});

/***/ }),
/* 263 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Header__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Header___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Header__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Footer__ = __webpack_require__(472);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Footer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Footer__);
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'index',
  components: {
    Headers: __WEBPACK_IMPORTED_MODULE_0__components_Header___default.a,
    Footers: __WEBPACK_IMPORTED_MODULE_1__components_Footer___default.a
  },
  data: function data() {
    return {};
  },
  beforeMount: function beforeMount() {
    var fullPath = this.$route.fullPath;
    if (fullPath.includes('#')) {
      if (fullPath.includes('home')) {
        window.location.href = 'http://' + window.location.host;
        return;
      }
      window.location.href = 'http://' + window.location.host + fullPath.substr(fullPath.indexOf('#') + 1);
    }
  },

  methods: {
    backTop: function backTop() {
      window.scrollTo(0, 0);
    }
  }
});

/***/ }),
/* 264 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_Http__ = __webpack_require__(12);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: "InitPassWord",
  data: function data() {
    var _this2 = this;

    var validatePass = function validatePass(rule, value, callback) {
      //验证密码
      // let reg = /[^\u00-\uFF]/;
      if (value === "") {
        callback(new Error("请输入密码"));
        // this.disabled = true
      } else if (value.length < 6) {
        callback(new Error("密码太短"));
      } else if (_this2.pass) {
        _this2.pass = 0;
        callback(new Error(_this2.passErr));
      } else {
        if (_this2.ruleForm.surePassWord !== "") {
          _this2.$refs.ruleForm.validateField("surePassWord");
        }
        // this.disabled = false
        callback();
      }
    };
    var validatePass2 = function validatePass2(rule, value, callback) {
      //二次验证密码
      if (value === "") {
        callback(new Error("请再次输入密码"));
        _this2.disabled = true;
      } else if (value !== _this2.ruleForm.setPassWord) {
        callback(new Error("两次输入密码不一致!"));
        _this2.disabled = true;
      } else if (value.length < 6) {
        callback(new Error("密码太短"));
        _this2.disabled = true;
      } else {
        _this2.disabled = false;
        callback();
      }
    };
    return {
      disabled: true,
      rules: {
        setPassWord: [{ validator: validatePass, trigger: "blur" }],
        surePassWord: [{ validator: validatePass2, trigger: "blur" }]
      },
      ruleForm: {
        setPassWord: "",
        surePassWord: ""
      },
      pass: 0,
      passErr: "",
      needForce: "",
      updateToken: "",
      portalToken: ""
    };
  },
  created: function created() {
    this.needSession(1);
  },
  activated: function activated() {
    var _this3 = this;

    this.needSession(1);
    this.ruleForm.setPassWord = "";
    this.ruleForm.surePassWord = "";
    this.$nextTick(function () {
      _this3.$refs.ruleForm.clearValidate();
    });
  },

  methods: {
    needSession: function needSession(val) {
      if (val) {
        this.needForce = sessionStorage.getItem("forceUpdate");
        this.updateToken = sessionStorage.getItem("updateToken");
        this.portalToken = sessionStorage.getItem("portalToken");
      } else {
        sessionStorage.removeItem("forceUpdate");
        sessionStorage.removeItem("updateToken");
        sessionStorage.removeItem("portalToken");
      }
    },
    onNext: function onNext() {
      if (+this.needForce) return;
      // this.needSession(0);
      window.location.href = __WEBPACK_IMPORTED_MODULE_0__lib_Http__["a" /* default */].JUMP_TEACHER_URL().hm + "/?portal=" + this.portalToken;
    },
    initSubmit: function initSubmit() {
      var _this4 = this;

      var sendObj = {
        clientType: 1,
        password: this.ruleForm.setPassWord,
        confirm: this.ruleForm.surePassWord,
        updateToken: this.updateToken
      };
      var _this = this;
      if (this.$route.query.from === "teacher") {
        __WEBPACK_IMPORTED_MODULE_0__lib_Http__["a" /* default */].zsyPutHttp("/auth/teacher/change/password", sendObj, function (ok) {
          window.location.href = __WEBPACK_IMPORTED_MODULE_0__lib_Http__["a" /* default */].JUMP_TEACHER_URL().hm + "/?portal=" + ok.data.loginToken;
        }, function (fail) {
          console.log(fail);
          if (fail.errMsg == "新密码太简单，请更换安全的密码！") {
            _this.pass = 1;
            _this.passErr = "新密码太简单";
            _this.$nextTick(function () {
              _this.$refs.ruleForm.validateField("setPassWord");
            });
          } else if (fail.errMsg == "授权已超时，请重新开始验证！") {
            _this4.$message.error("授权已超时，请重新开始验证！");
            setTimeout(function () {
              _this.needSession(0);
              _this.$router.push("/");
            }, 2000);
          } else if (fail.errMsg == "密码格式错误:密码位数6~16位，只能数字和字母组合。") {
            _this.pass = 1;
            _this.passErr = "密码格式错误";
            _this.$nextTick(function () {
              _this.$refs.ruleForm.validateField("setPassWord");
            });
          }
        });
      }
    }
  }
});

/***/ }),
/* 265 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {};
  },

  methods: {},
  mounted: function mounted() {}
});

/***/ }),
/* 266 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_Http__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_Helper__ = __webpack_require__(286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_qrcodejs2__ = __webpack_require__(402);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_qrcodejs2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_qrcodejs2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_js_cookie__ = __webpack_require__(395);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_js_cookie__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: "Login",
  data: function data() {
    return {
      timer: null,
      currQrStatus: 0,
      showTit: false,
      forgetPassword: false,
      show: true,
      count: 60,
      showType: 1,
      qrId: "",
      loginData: {
        id: '',
        password: '',
        code: ''
      },
      //教师登录
      teacherLoginBtnText: '登录',
      isTeacherDisabled: true,
      isTeacherActive: "ap",
      teacherApData: {
        username: '',
        password: '',
        captcha: '',
        captchaKey: __WEBPACK_IMPORTED_MODULE_2__lib_Helper__["a" /* default */].abcd(),
        clientType: 1
      },
      tearcherSmsData: {
        username: "",
        captcha: '',
        validType: 0,
        clientType: 1
        // codeKey: Helper.abcd(),
      },
      teacherApErrMsg: {
        username: '',
        password: '',
        captcha: ''
      },
      teacherSmsErrMsg: {
        username: '',
        captcha: ''
      },
      qrTimer: null,

      //学生登录
      studentLoginBtnText: '登录',
      isStudentDisabled: true,
      studentData: {
        account: '',
        password: '',
        code: '',
        codeKey: __WEBPACK_IMPORTED_MODULE_2__lib_Helper__["a" /* default */].abcd()
      },
      studentErrMsg: {
        account: '',
        password: '',
        code: ''
      },

      //校长登录
      schoolMasterLoginBtnText: '登录',
      isSchoolMasterDisabled: true,
      schoolMasterData: {
        account: '',
        password: '',
        code: '',
        codeKey: __WEBPACK_IMPORTED_MODULE_2__lib_Helper__["a" /* default */].abcd(),
        client: 1
      },
      schoolMasterErrMsg: {
        account: '',
        password: '',
        code: ''
      },
      codeUrl: '',
      codeUrl2: '',
      serviceDialogVisible: false,
      agreementSite: '',
      baseUrl:  true ? "https://www.zhixinhuixue.com/" : "http://zsy.dev.xueping.com/",
      agreementAgreed: false,
      studentToken: '',
      studentEditPasswordUrl: __WEBPACK_IMPORTED_MODULE_1__lib_Http__["a" /* default */].JUMP_STUDENT_URL().hm + '/editpassword'
    };
  },

  watch: {
    showType: function showType(val) {
      if (val == 2) {
        this.initTeacherQRcode();
      } else {
        if (this.qrTimer) {
          clearInterval(this.qrTimer);
        }
        this.qrTimer = null;
        this.qrId = "";
      }
    }
  },
  created: function created() {
    this.getValidCode();
    this.getValid2Code();
    this.agreementAgreed = !!localStorage.agreementAgreed;
  },
  activated: function activated() {
    this.clearQRTime();
  },
  deactivated: function deactivated() {
    this.clearQRTime();
  },

  methods: {
    onReset: function onReset() {
      this.showType = 1;
      this.currQrStatus = 0;
    },
    clearQRTime: function clearQRTime() {
      if (this.qrTimer) {
        clearInterval(this.qrTimer);
        this.showType = 1;
      }
      this.qrTimer = null;
      this.qrId = "";
    },
    onTeacherChange: function onTeacherChange(val) {
      this.isTeacherActive = val;
      this.teacherApData.username = "";
      this.teacherApData.password = "";
      this.teacherApData.captcha = "";

      this.teacherApErrMsg.username = "";
      this.teacherApErrMsg.password = "";
      this.teacherApErrMsg.captcha = "";

      this.tearcherSmsData.username = "";
      this.tearcherSmsData.captcha = "";

      this.teacherSmsErrMsg.username = "";
      this.teacherSmsErrMsg.captcha = "";
      this.getValidCode();
    },
    onStudentChange: function onStudentChange(val) {
      this.isStudentActive = val;
    },
    qrcodeScan: function qrcodeScan() {
      var _this2 = this;

      //生成二维码
      this.$nextTick(function () {
        var prcode = _this2.$refs.qrcode;
        _this2.$nextTick(function () {
          prcode.setAttribute("title", "");
        });
        prcode.innerHTML = "";
        // if(!prcode) return;
        // let imgs = prcode.querySelectorAll("img")
        // if(imgs.length >= 1) return;
        new __WEBPACK_IMPORTED_MODULE_3_qrcodejs2___default.a(_this2.$refs.qrcode, {
          width: 82, // 二维码宽度
          height: 82, // 二维码高度
          text: _this2.baseUrl + 'surelogin?qrId=' + _this2.qrId, //登录的地址,
          // text: `http://192.168.1.92:8080/surelogin?qrId=${this.qrId}`,
          correctLevel: __WEBPACK_IMPORTED_MODULE_3_qrcodejs2___default.a.CorrectLevel.H
        });
      });
    },
    getCode: function getCode() {
      var _this3 = this;

      var TIME_COUNT = 60;
      var _this = this;
      if (!this.tearcherSmsData.username) {
        this.teacherSmsErrMsg.username = "请输入手机号！";
        return;
      }
      __WEBPACK_IMPORTED_MODULE_1__lib_Http__["a" /* default */].zsyGetHttp('/auth/captcha/teacher-sms/' + this.tearcherSmsData.username, {}, function (ok) {
        if (!_this3.timer) {
          _this3.count = TIME_COUNT;
          _this3.show = false;
          _this3.timer = setInterval(function () {
            if (_this3.count > 0 && _this3.count <= TIME_COUNT) {
              _this3.count--;
            } else {
              _this3.show = true;
              clearInterval(_this3.timer);
              _this3.timer = null;
            }
          }, 1000);
        }
        console.log(ok);
      }, function (fail) {
        console.log(fail);
        if (fail.errMsg === '教师账号不存在，请检查或者联系学管！') {
          _this.teacherSmsErrMsg.username = '教师账号不存在';
        }
      });
    },
    initTeacherQRcode: function initTeacherQRcode() {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_1__lib_Http__["a" /* default */].zsyPostHttp('/auth/teacher/qrcode/login', {}, function (ok) {
        _this4.qrId = ok.data.qrId;
        _this4.qrcodeScan();
        _this4.pollingApi();
      }, function (fail) {
        console.log(fail);
      });
    },
    pollingApi: function pollingApi() {
      var _this5 = this;

      this.qrTimer = window.setInterval(function () {
        setTimeout(function () {
          __WEBPACK_IMPORTED_MODULE_1__lib_Http__["a" /* default */].zsyPostHttp('/auth/teacher/qrcode/login/' + _this5.qrId + '/scan_info', {}, function (ok) {
            if (+ok.data.status === 3) {
              clearInterval(_this5.qrTimer);
              _this5.qrId = ok.data.qrcodeInfo.qrId;
              _this5.qrcodeScan();
              _this5.pollingApi();
            } else if (+ok.data.status === 2) {
              window.location.href = __WEBPACK_IMPORTED_MODULE_1__lib_Http__["a" /* default */].JUMP_TEACHER_URL().hm + '/?portal=' + ok.data.portalToken;
            } else {
              _this5.currQrStatus = ok.data.status;
            }
          }, 0);
        });
      }, 2000);
    },
    onDisagreeBtnClick: function onDisagreeBtnClick() {
      var _this6 = this;

      __WEBPACK_IMPORTED_MODULE_0_element_ui__["MessageBox"].confirm('若您不同意服务协议书政策，很遗憾我们将无法为您提供服务', '同意服务协议书才能继续使用', {
        cancelButtonText: '仍不同意',
        confirmButtonText: '再次查看'
      }).then(function () {}).catch(function () {
        _this6.serviceDialogVisible = false;
        _this6.studentLoginBtnText = '登录';
      });
    },
    onAgreeBtnClick: function onAgreeBtnClick() {
      this.studentLoginBtnText = '登录成功,正在跳转';
      this.serviceDialogVisible = false;
      localStorage.agreementAgreed = 'agree';
      window.location.href = __WEBPACK_IMPORTED_MODULE_1__lib_Http__["a" /* default */].JUMP_STUDENT_URL().hm + '/index?token=' + this.studentToken;
    },

    // 登录切换
    handleLoginCheckClick: function handleLoginCheckClick(type) {
      this.showType = type;
      console.log(type);

      this.getValidCode();
      switch (type) {
        case 2:
          //埋点监控
          _hmt.push(['_trackEvent', '知心慧学', 'click', '进入教师登录']);
          break;
        case 3:
          //埋点监控
          _hmt.push(['_trackEvent', '知心慧学', 'click', '进入学生登录']);
          window.open(__WEBPACK_IMPORTED_MODULE_1__lib_Http__["a" /* default */].JUMP_STUDENT_URL().hm);
          break;
        case 4:
          //埋点监控
          _hmt.push(['_trackEvent', '知心慧学', 'click', '进入家长登录']);
          break;
        case 5:
          //埋点监控
          _hmt.push(['_trackEvent', '知心慧学', 'click', '进入校长登录']);
          break;
        default:
          console.log("err");
          break;
      }
    },

    //获取验证码
    getValidCode: function getValidCode() {
      this.codeUrl = __WEBPACK_IMPORTED_MODULE_1__lib_Http__["a" /* default */].API_ROOT() + 'auth/captcha/image/' + __WEBPACK_IMPORTED_MODULE_2__lib_Helper__["a" /* default */].abcd() + '?_t=' + new Date().getTime();
    },
    getValid2Code: function getValid2Code() {
      this.codeUrl2 = __WEBPACK_IMPORTED_MODULE_1__lib_Http__["a" /* default */].API_ROOT() + "business/captcha/image?abcd=" + __WEBPACK_IMPORTED_MODULE_2__lib_Helper__["a" /* default */].abcd() + "&_t=" + new Date().getTime();
    },

    //教师登录输入验证
    teacherLoginBtn: function teacherLoginBtn(val) {
      if (val === 'ap') {
        this.teacherApErrMsg.username = '';
        this.teacherApErrMsg.password = '';
        this.teacherApErrMsg.captcha = '';
        //去空格
        this.teacherApData.username = __WEBPACK_IMPORTED_MODULE_2__lib_Helper__["a" /* default */].trim(this.teacherApData.username);
        this.teacherApData.password = __WEBPACK_IMPORTED_MODULE_2__lib_Helper__["a" /* default */].trim(this.teacherApData.password);
        this.teacherApData.captcha = __WEBPACK_IMPORTED_MODULE_2__lib_Helper__["a" /* default */].trim(this.teacherApData.captcha);

        if (this.teacherApData.username != '' && this.teacherApData.password != '' && this.teacherApData.captcha != '') {
          this.isTeacherDisabled = false;
        } else {
          this.isTeacherDisabled = true;
        }
      } else {
        this.teacherSmsErrMsg.username = '';
        this.teacherSmsErrMsg.captcha = '';

        this.tearcherSmsData.username = __WEBPACK_IMPORTED_MODULE_2__lib_Helper__["a" /* default */].trim(this.tearcherSmsData.username);
        this.tearcherSmsData.captcha = __WEBPACK_IMPORTED_MODULE_2__lib_Helper__["a" /* default */].trim(this.tearcherSmsData.captcha);
        if (this.tearcherSmsData.username != "" && this.tearcherSmsData.captcha != '') {
          this.isTeacherDisabled = false;
        } else {
          this.isTeacherDisabled = true;
        }
      }
    },

    //教师登录
    teacherLogin: function teacherLogin(val) {
      this.teacherLoginBtnText = '登录中';
      var _this = this;
      // _hmt.push(['_trackEvent', '知心慧学', 'click', '教师登陆']);
      if (val === 'ap') {
        __WEBPACK_IMPORTED_MODULE_1__lib_Http__["a" /* default */].zsyPostHttp("/auth/teacher/password/login", this.teacherApData, function (ok) {
          var cookieExpires = ".zhixinhuixue.com";
          __WEBPACK_IMPORTED_MODULE_4_js_cookie___default.a.set('is_teaching', 0, {
            expires: 15,
            path: cookieExpires,
            domain: cookieExpires
          });
          if (ok.data.updatePassword) {
            _this.$router.push({
              path: '/initPassword',
              query: {
                from: "teacher"
              }
            });
            sessionStorage.setItem("forceUpdate", ok.data.forceUpdate);
            sessionStorage.setItem("portalToken", ok.data.portalToken);
            sessionStorage.setItem("updateToken", ok.data.updateToken);
          } else {
            window.location.href = __WEBPACK_IMPORTED_MODULE_1__lib_Http__["a" /* default */].JUMP_TEACHER_URL().hm + '/?portal=' + ok.data.portalToken;
          }

          _this.teacherLoginBtnText = '登录';
          //   _hmt.push(['_trackEvent', '知心慧学', 'callback', '教师登陆成功']);
        }, function (fail) {
          _this.teacherLoginBtnText = '登录';
          if (fail.errMsg === '账号不存在，请检查或联系学管！') {
            _this.teacherApErrMsg.username = '账号不存在!';
          } else if (fail.errMsg === "验证码不正确" || fail.errMsg === "验证码已过期") {
            _this.teacherApErrMsg.captcha = fail.errMsg;
          } else if (fail.errMsg === "用户名或密码错误！") {
            _this.teacherApErrMsg.password = fail.errMsg;
          } else if (fail.errCode === "10011") {
            _this.$alert(fail.errMsg, '提示', {
              confirmButtonText: '确定'
            });
          } else {
            _this.teacherApErrMsg.password = fail.errMsg;
          }
          _this.getValidCode();
        });
      } else {
        __WEBPACK_IMPORTED_MODULE_1__lib_Http__["a" /* default */].zsyPostHttp("/auth/teacher/sms/login", this.tearcherSmsData, function (ok) {
          if (ok.data.updatePassword) {
            _this.$router.push({
              path: '/initPassword',
              query: {
                from: "teacher"
              }
            });
            sessionStorage.setItem("forceUpdate", ok.data.forceUpdate);
            sessionStorage.setItem("portalToken", ok.data.portalToken);
            sessionStorage.setItem("updateToken", ok.data.updateToken);
            _this.teacherLoginBtnText = '登录';
          } else {
            window.location.href = __WEBPACK_IMPORTED_MODULE_1__lib_Http__["a" /* default */].JUMP_TEACHER_URL().hm + '/?portal=' + ok.data.portalToken;
          }
        }, function (fail) {
          if (fail.errMsg == "验证码已过期，请重新获取") {
            _this.teacherSmsErrMsg.captcha = "验证码已过期";
          } else if (fail.errMsg == "登录手机号格式错误") {
            _this.teacherSmsErrMsg.username = "手机号格式错误";
          } else if (fail.errMsg == "验证码不正确") {
            _this.teacherSmsErrMsg.captcha = "验证码不正确";
          } else if (fail.errCode === "10011") {
            _this.$alert(fail.errMsg, '提示', {
              confirmButtonText: '确定'
            });
          }
          _this.teacherLoginBtnText = '登录';
          _this.getValidCode();
        });
      }
    },


    //学生登录输入验证
    studentLoginBtn: function studentLoginBtn() {
      this.studentErrMsg.account = '';
      this.studentErrMsg.code = '';

      //去空格
      this.studentData.account = __WEBPACK_IMPORTED_MODULE_2__lib_Helper__["a" /* default */].trim(this.studentData.account);
      this.studentData.password = __WEBPACK_IMPORTED_MODULE_2__lib_Helper__["a" /* default */].trim(this.studentData.password);
      this.studentData.code = __WEBPACK_IMPORTED_MODULE_2__lib_Helper__["a" /* default */].trim(this.studentData.code);

      if (this.studentData.account != '' && this.studentData.password != '' && this.studentData.code != '') {
        this.isStudentDisabled = false;
      } else {
        this.isStudentDisabled = true;
      }
    },

    //学生登录
    studentLogin: function studentLogin() {
      var _this7 = this;

      var _this = this;
      _this.studentLoginBtnText = '登录中';
      //请求登陆
      //埋点监控
      _hmt.push(['_trackEvent', '知心慧学', 'click', '学生登陆']);
      __WEBPACK_IMPORTED_MODULE_1__lib_Http__["a" /* default */].zsyPostHttp('/business/student/login-from-index', this.studentData, function (ok) {
        //登陆成功
        // 埋点监控
        _hmt.push(['_trackEvent', '知心慧学', 'callback', '学生登陆成功']);
        if (_this7.agreementAgreed) {
          _this.studentLoginBtnText = '登录成功,正在跳转';
          window.location.href = __WEBPACK_IMPORTED_MODULE_1__lib_Http__["a" /* default */].JUMP_STUDENT_URL().hm + '/index?token=' + ok.data;
        } else {
          _this7.serviceDialogVisible = true;
          _this7.studentToken = ok.data;
        }

        // window.location.href = `${Http.JUMP_STUDENT_URL().hm}/index?token=${ok.data}`
      }, function (fail) {
        _this7.isStudentDisabled = true;
        //登陆失败
        _this.studentLoginBtnText = '登录';
        if (fail.errMsg == '验证码不正确') {
          _this.studentErrMsg.code = '验证码错误';
        } else {
          _this.studentErrMsg.account = '用户名或密码错误';
        }
        _this.getValid2Code();
      });
    },


    //校长登录输入验证
    schoolMasterLoginBtn: function schoolMasterLoginBtn() {
      this.schoolMasterErrMsg.account = '';
      this.schoolMasterErrMsg.code = '';
      //去空格
      this.schoolMasterData.account = __WEBPACK_IMPORTED_MODULE_2__lib_Helper__["a" /* default */].trim(this.schoolMasterData.account);
      this.schoolMasterData.password = __WEBPACK_IMPORTED_MODULE_2__lib_Helper__["a" /* default */].trim(this.schoolMasterData.password);
      this.schoolMasterData.code = __WEBPACK_IMPORTED_MODULE_2__lib_Helper__["a" /* default */].trim(this.schoolMasterData.code);

      if (this.schoolMasterData.account != '' && this.schoolMasterData.password != '' && this.schoolMasterData.code != '') {
        this.isSchoolMasterDisabled = false;
      } else {
        this.isSchoolMasterDisabled = true;
      }
    },

    //校长登陆
    schoolMasterLogin: function schoolMasterLogin() {
      var _this = this;
      // 埋点监控
      _hmt.push(['_trackEvent', '知心慧学', 'click', '校长登陆']);

      _this.schoolMasterLoginBtnText = '登录中';
      //请求登陆
      // Http.Axios.post(`${Http.TEACHER_API_ROOT()}basic/hm/pc/login`, this.schoolMasterData).then(function (response) {
      __WEBPACK_IMPORTED_MODULE_1__lib_Http__["a" /* default */].Axios.post(__WEBPACK_IMPORTED_MODULE_1__lib_Http__["a" /* default */].API_ROOT() + 'business/schoolmaster/login', this.schoolMasterData).then(function (response) {
        // debugger
        var res = response.data;
        if (res.errCode != "00") {
          if (res.errCode == "01") {
            _this.isSchoolMasterDisabled = true;
            _this.schoolMasterLoginBtnText = '登录';
            if (res.errMsg == '验证码不正确') {
              _this.schoolMasterErrMsg.code = '验证码错误';
            } else {
              _this.schoolMasterErrMsg.account = '用户名或密码错误';
            }
            _this.getValid2Code();
          } else if (res.errCode == "02") {
            //重新登录
            Message.warning(res.errMsg);
            setTimeout(function () {
              window.vue.$router.push("/");
              window.localStorage.clear();
            }, 1000);
          } else {
            if (typeof fail == "function") {
              fail(res);
            } else {
              if (res.errMsg != "") {
                Message.error(res.errMsg);
              }
            }
          }
        } else {
          // 埋点监控
          _hmt.push(['_trackEvent', '知心慧学', 'callback', '校长登陆成功']);
          _this.schoolMasterLoginBtnText = '登录成功,正在跳转';
          // 跳转
          window.location.href = __WEBPACK_IMPORTED_MODULE_1__lib_Http__["a" /* default */].JUMP_URL().hm + '/#/token/' + encodeURIComponent(res.data);
        }
      }).catch(function (err) {
        _this.schoolMasterLoginBtnText = '登录';
        // _this.getValidCode2();
        // console.log(1)
      });
    }
  },
  components: {
    QRCode: __WEBPACK_IMPORTED_MODULE_3_qrcodejs2___default.a
  }
});

/***/ }),
/* 267 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {};
  },

  computed: {},
  methods: {}
});

/***/ }),
/* 268 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {};
  },

  computed: {},
  methods: {}
});

/***/ }),
/* 269 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {};
  },

  computed: {},
  methods: {}
});

/***/ }),
/* 270 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {};
  }
});

/***/ }),
/* 271 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {};
  }
});

/***/ }),
/* 272 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'english',
  components: {},
  data: function data() {
    return {
      urls: [__webpack_require__(120), __webpack_require__(121), __webpack_require__(122), __webpack_require__(123), __webpack_require__(124)],
      urls2: []
    };
  },
  mounted: function mounted() {
    var imgTotal = 4;
    for (var i = 0; i < imgTotal; i++) {
      var url = __webpack_require__(555)("./" + i + '.png');
      this.urls.push(url);
    }
  }
});

/***/ }),
/* 273 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "matics",
  components: {},
  data: function data() {
    return {
      urls: [__webpack_require__(125), __webpack_require__(126), __webpack_require__(131), __webpack_require__(132), __webpack_require__(133), __webpack_require__(134), __webpack_require__(135), __webpack_require__(136), __webpack_require__(137), __webpack_require__(138), __webpack_require__(127), __webpack_require__(128), __webpack_require__(129), __webpack_require__(130)]
    };
  },
  mounted: function mounted() {
    var imgTotal = 13;
    for (var i = 0; i < imgTotal; i++) {
      var url = __webpack_require__(556)("./" + i + ".png");
      this.urls.push(url);
    }
  }
});

/***/ }),
/* 274 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//

// import Http from "../../lib/Http";
/* harmony default export */ __webpack_exports__["default"] = ({
  name: "surelogin",
  data: function data() {
    return {
      // upDataToken: "",
      // needQrId: "",
      // clientType: "",
      baseUrl:  true ? "https://www.zhixinhuixue.com/copyRight/" : "http://zsy.dev.xueping.com/copyRight/"
      // err: null,
      // succ: null,
      // canClick: false,
    };
  },
  created: function created() {
    var userAgentInfo = navigator.userAgent;
    var Agent = userAgentInfo.search("app_zxhx_zsyte");
    if (Agent == -1) {
      window.location.href = this.baseUrl + "/teacherdownload.html";
    } else {
      var isiOS = !!userAgentInfo.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
      if (isiOS) {
        this.clientType = isiOS;
      } else {
        this.clientType = isiOS;
      }
    }

    // const { token, qrId } = this.$route.query;
    // this.upDataToken = token;
    // this.needQrId = qrId;
    // if (this.upDataToken && this.needQrId) {
    //   this.getVerify();
    // }
  },

  methods: {
    // getVerify() {
    //   Http.zsyPutHttp(
    //     `/auth/teacher/qrcode/login/${this.needQrId}/verify`,
    //     {
    //       token: this.upDataToken,
    //     },
    //     (ok) => {
    //       this.succ = ok;
    //       console.log(ok);
    //     },
    //     (fail) => {
    //       window.webkit.messageHandlers.ZXHXJsListener.postMessage({
    //         msg: "参数错误",
    //         status: 0,
    //       });
    //     },
    //     (ca) => {
    //       console.log(ca);
    //     },
    //     true
    //   );
    // },
    // handleLogin() {
    //   let _this = this;
    //   this.canClick = true;
    //   Http.zsyPutHttp(
    //     `/auth/teacher/qrcode/login/${this.needQrId}/confirm`,
    //     {
    //       token: this.upDataToken,
    //     },
    //     (ok) => {
    //       _this.succ = ok;
    //       if (this.clientType) {
    //         this.canClick = false;
    //         window.webkit.messageHandlers.ZXHXJsListener.postMessage({
    //           msg: "登录成功",
    //           status: 1,
    //         });
    //       } else {
    //         window.ZXHXJsListener.onFinish();
    //       }
    //     },
    //     (fail) => {
    //       this.canClick = false;
    //       _this.err = fail;
    //       window.webkit.messageHandlers.ZXHXJsListener.postMessage({
    //         msg: "登录失败",
    //         status: 0,
    //       });
    //     },
    //     (ca) => {
    //       this.canClick = false;
    //       console.log(ca);
    //     },
    //     true
    //   );
    // },
    // handleFinish() {
    //   if (this.clientType) {
    //     window.webkit.messageHandlers.ZXHXJsListener.postMessage({ status: 2 });
    //   } else {
    //     window.ZXHXJsListener.onFinish();
    //   }
    // },
  }
});

/***/ }),
/* 275 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "signUpListPhone",
  data: function data() {
    return {
      signUpData: false,
      subject: ['语文', '英语', '数学(文)', '文科综合', '数学(理)', '理科综合'],
      school_name: '',
      mobile: '',
      userName: '',
      signUpSuccess: false,
      isStop: false,
      HtmlFontSize: '',
      isAndroids: false
    };
  },
  created: function created() {
    this.showAndroid();
  },
  mounted: function mounted() {
    window.addEventListener("resize", this.setHtmlFontSize);
    var _this = this;
    setTimeout(function () {
      _this.getFontSize();
    }, 500);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener("resize", this.setHtmlFontSize);
  },

  methods: {
    showAndroid: function showAndroid() {
      var u = navigator.userAgent;
      this.isAndroids = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1;
    },
    getFontSize: function getFontSize() {
      var htmlEl = document.getElementsByTagName('html')[0];
      this.HtmlFontSize = htmlEl.style.fontSize;
    },
    setHtmlFontSize: function setHtmlFontSize() {
      var u = navigator.userAgent;
      var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1;
      if (isAndroid) {
        return false;
      }

      if (this.HtmlFontSize == '') {
        return false;
      }
      var _this = this;
      var htmlEl = document.getElementsByTagName('html')[0];
      setTimeout(function () {
        htmlEl.style.fontSize = _this.HtmlFontSize;
      }, 301);
    },
    AndroidHtmlFontSize: function AndroidHtmlFontSize() {
      this.HtmlFontSize = '36px';
      var _this = this;
      var htmlEl = document.getElementsByTagName('html')[0];
      var setHtmlFontSize = setInterval(function () {
        htmlEl.style.fontSize = _this.HtmlFontSize;
      }, 1);
      setTimeout(function () {
        clearInterval(setHtmlFontSize);
      }, 310);
    },
    save: function save() {
      var _this = this;
      var data = {
        subjects: '',
        school_name: this.school_name,
        mobile: this.mobile,
        userName: this.userName
      };
      this.subject.forEach(function (i) {
        data.subjects = data.subjects + i + ',';
      });

      if (this.school_name == '') {
        this.$message.error('请填写学校名称');
        this.mobile = '';
        return false;
      }
      if (this.userName == '') {
        this.$message.error('请填写姓名');
        this.mobile = '';
        return false;
      }
      if (!this.isPhoneNum(this.mobile)) {
        this.$message.error('请填写正确的手机号码');
        this.mobile = '';
        return false;
      }
      if (data.subjects == '') {
        this.$message.error('请选择科目');
        this.mobile = '';
        return false;
      }
      Http.Axios.post(Http.SIGN_UP_API_ROOT() + '/rest/official_enroll/joint_sign', data).then(function (res) {
        _this.signUpData = false;
        _this.signUpSuccess = true;
      }).catch(function (err) {
        _this.$message.error('提交失败');
      });
    },
    isPhoneNum: function isPhoneNum(str) {
      return (/^(0|86|17951)?(13[0-9]|15[012356789]|16[0-9]|17[678]|18[0-9]|19[0-9]|14[57])[0-9]{8}$/.test(str)
      );
    }
  }
});

/***/ }),
/* 276 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_Http_js__ = __webpack_require__(12);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: "signUpList",
  data: function data() {
    return {
      signUpData: false,
      subject: ['语文', '英语', '数学(文)', '文科综合', '数学(理)', '理科综合'],
      school_name: '',
      mobile: '',
      userName: '',
      signUpSuccess: false
    };
  },
  created: function created() {
    this.isPhone();
  },

  methods: {
    isPhone: function isPhone() {
      var go = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);
      if (go) {
        this.$router.push("/signUpListPhone");
      }
    },
    save: function save() {
      var _this = this;
      var data = {
        subjects: '',
        school_name: this.school_name,
        mobile: this.mobile,
        userName: this.userName
      };
      this.subject.forEach(function (i) {
        data.subjects = data.subjects + i + ',';
      });

      if (this.school_name == '') {
        this.$message.error('请填写学校名称');
        this.mobile = '';
        return false;
      }
      if (this.userName == '') {
        this.$message.error('请填写姓名');
        this.mobile = '';
        return false;
      }
      if (!this.isPhoneNum(this.mobile)) {
        this.$message.error('请填写正确的手机号码');
        this.mobile = '';
        return false;
      }
      if (data.subjects == '') {
        this.$message.error('请选择科目');
        this.mobile = '';
        return false;
      }
      __WEBPACK_IMPORTED_MODULE_0__lib_Http_js__["a" /* default */].Axios.post(__WEBPACK_IMPORTED_MODULE_0__lib_Http_js__["a" /* default */].SIGN_UP_API_ROOT() + '/rest/official_enroll/joint_sign', data).then(function (res) {
        _this.signUpData = false;
        _this.signUpSuccess = true;
      }).catch(function (err) {
        _this.$message.error('提交失败');
      });
    },
    isPhoneNum: function isPhoneNum(str) {
      return (/^(0|86|17951)?(13[0-9]|15[012356789]|16[0-9]|17[678]|18[0-9]|19[0-9]|14[57])[0-9]{8}$/.test(str)
      );
    }
  }
});

/***/ }),
/* 277 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  methods: {
    clickPrivacy: function clickPrivacy(type) {
      // btnType 1《用户服务协议》2《隐私政策》
      var msg = { btnType: type };
      var u = navigator.userAgent;
      var isAndroid = u.includes('Android') || u.includes('Adr'); //android终端
      var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
      if (isAndroid && window.injectedObject) {
        console.log('an');
        window.injectedObject.sendClickEventPrivacy(type);
      } else if (isiOS && window.webkit) {
        console.log('ios');
        window.webkit.messageHandlers.sendClickEventPrivacy.postMessage(msg);
      }
    }
  }
});

/***/ }),
/* 278 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  methods: {
    clickPrivacy: function clickPrivacy(type) {
      // btnType 1《用户服务协议》2《隐私政策》
      var msg = { btnType: type };
      var u = navigator.userAgent;
      var isAndroid = u.includes('Android') || u.includes('Adr'); //android终端
      var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
      if (isAndroid && window.injectedObject) {
        console.log('an');
        window.injectedObject.sendClickEventPrivacy(type);
      } else if (isiOS && window.webkit) {
        console.log('ios');
        window.webkit.messageHandlers.sendClickEventPrivacy.postMessage(msg);
      }
    }
  }
});

/***/ }),
/* 279 */
/***/ (function(module, exports) {

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 280 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({});

/***/ }),
/* 281 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__flexible__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__flexible___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__flexible__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__toast_js__ = __webpack_require__(32);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ClazzList',
  data: function data() {
    return {
      data: {
        outputDetails: [],
        signDetails: []
      },
      isInvalid: false
    };
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    next(function (vm) {
      console.log(from);
      var outId = to.query.outId;
      if (from.name === null) {
        __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("http://api.zsyims.zhixinhuixue.com" + "/ims/storage-output/sign/" + outId).then(function (res) {
          if (res.data.errCode === '00') {
            vm.data = res.data.data;
          } else if (res.data.errCode === '01') {
            vm.isInvalid = true;
          } else {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__toast_js__["a" /* default */])(res.data.errMsg);
          }
        }, function (err) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__toast_js__["a" /* default */])('出错了');
        });
      } else if (to.query.signed === 'signed') {
        var clazz = vm.data.signDetails.find(function (item) {
          return item.clazzId === to.query.clazzId;
        }) || {};
        clazz.classSign = true;
        clazz.signRole = to.query.role;
        clazz.signPhone = to.query.phone;
        clazz.signUrl = to.params.url;
      }
    });
  },

  methods: {
    goSignStu: function goSignStu(clazz) {
      this.$router.push({
        name: 'SignStudent', params: {
          clazzId: clazz.clazzId,
          clazzName: clazz.clazzName,
          studentNames: clazz.studentNames,
          outputDetail: this.data.outputDetails[0] || {},
          outDate: this.data.outDate.split(' ')[0],
          orderId: this.data.orderId,
          outId: this.data.outId,
          isSigned: clazz.classSign,
          signRole: clazz.signRole,
          signPhone: clazz.signPhone,
          url: clazz.signUrl
        }
      });
    }
  }
});

/***/ }),
/* 282 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__flexible__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__flexible___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__flexible__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__toast_js__ = __webpack_require__(32);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ClazzList',
  data: function data() {
    return {
      data: {},
      isCompleted: false,
      url: null,
      loading: false
    };
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    next(function (vm) {
      if (from.name === 'Sign') {
        vm.url = vm.$route.params.url;
      } else {
        var outId = to.query.outId;
        vm.isCompleted = false;
        if (from.name === null) {
          __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("http://api.zsyims.zhixinhuixue.com" + "/ims/storage/coach/sign/take/info/" + outId).then(function (res) {
            if (res.data.errCode === '00') {
              vm.data = res.data.data;
            } else {
              __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__toast_js__["a" /* default */])(res.data.errMsg);
            }
          }, function (err) {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__toast_js__["a" /* default */])('出错了');
          });
        }
      }
    });
  },

  methods: {
    save: function save() {
      var _this = this;

      if (!this.url) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__toast_js__["a" /* default */])('请签名');
        return;
      }
      if (this.loading) return;
      this.loading = true;
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post("http://api.zsyims.zhixinhuixue.com" + "/ims/storage-output/sign/add", {
        businessId: this.data.outId,
        signType: 0,
        signUrl: this.url
      }).then(function (res) {
        if (res.data.errCode === '00') {
          _this.isCompleted = true;
        } else {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__toast_js__["a" /* default */])(res.data.errMsg);
        }
        _this.loading = false;
      }, function (err) {
        _this.loading = false;
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__toast_js__["a" /* default */])('出错了');
      });
    },
    gotoSign: function gotoSign() {
      this.$router.push({ name: 'Sign', params: { url: this.url } });
    }
  }
});

/***/ }),
/* 283 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_signature_pad__ = __webpack_require__(405);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__toast_js__ = __webpack_require__(32);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Sign',
  data: function data() {
    return {
      signaturePad: null,
      from: null,
      preSignImg: null,
      preSignImgData: null
    };
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    next(function (vm) {
      vm.from = from.name;
      if (vm.signaturePad) {
        vm.signaturePad.clear();
        if (!to.params.needClear && vm.preSignImgData) {
          vm.signaturePad.fromData([].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(vm.preSignImgData)));
        } else {
          vm.preSignImg = null;
          vm.preSignImgData = null;
        }
      }
    });
  },

  // watch: {
  //   preSignImgData() {
  //     console.log('change')
  //   }
  // },
  mounted: function mounted() {
    var _this = this;

    window.addEventListener("resize", function () {
      _this.$refs.canvas.width = _this.$refs.canvas.clientWidth;
      _this.$refs.canvas.height = _this.$refs.canvas.clientHeight;
      _this.signaturePad = new __WEBPACK_IMPORTED_MODULE_1_signature_pad__["a" /* default */](_this.$refs.canvas, { minWidth: 2 });
    });

    this.$refs.canvas.width = this.$refs.canvas.clientWidth;
    this.$refs.canvas.height = this.$refs.canvas.clientHeight;
    this.signaturePad = new __WEBPACK_IMPORTED_MODULE_1_signature_pad__["a" /* default */](this.$refs.canvas, { minWidth: 2 });
  },

  methods: {
    clear: function clear() {
      this.signaturePad.clear();
    },
    back: function back() {
      this.$router.replace({
        name: this.from,
        params: { url: this.preSignImg }
      });
    },
    save: function save() {
      if (this.signaturePad.isEmpty()) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__toast_js__["a" /* default */])('请签名');
      } else {
        this.savePreData();
        this.$router.push({ name: this.from, params: { url: this.signaturePad.toDataURL() } });
      }
    },
    savePreData: function savePreData() {
      this.preSignImg = this.signaturePad.toDataURL();
      this.preSignImgData = this.signaturePad.toData();
    }
  }
});

/***/ }),
/* 284 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__flexible__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__flexible___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__flexible__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__toast_js__ = __webpack_require__(32);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'StudentList',
  data: function data() {
    return {
      roleList: ['无职务', '教师', '班长', '学习委员', '体育委员'],
      roleListVisible: false,
      studentNames: [],
      outputDetail: {},
      clazzName: '',
      outDate: '',
      showMore: false,
      role: null,
      tempRole: null,
      phone: null,
      url: null,
      orderId: null,
      outId: null,
      isSubmit: false,
      isSigned: false,
      needClear: false
    };
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    next(function (vm) {
      if (from.name === 'Sign') {
        vm.url = vm.$route.params.url;
        vm.needClear = false;
      } else {
        vm.studentNames = vm.$route.params.studentNames || [];
        vm.outputDetail = vm.$route.params.outputDetail || {};
        vm.clazzName = vm.$route.params.clazzName;
        vm.clazzId = vm.$route.params.clazzId;
        vm.orderId = vm.$route.params.orderId;
        vm.outId = vm.$route.params.outId;
        vm.outDate = vm.$route.params.outDate;
        vm.isSigned = vm.$route.params.isSigned;

        vm.role = vm.$route.params.signRole;
        vm.phone = vm.$route.params.signPhone;
        vm.url = vm.$route.params.url;
        vm.needClear = true;
      }
    });
  },


  methods: {
    toggleRoleListVisible: function toggleRoleListVisible() {
      if (this.isSigned) return;
      this.roleListVisible = !this.roleListVisible;
    },
    submit: function submit() {
      var _this = this;

      if (!this.url) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__toast_js__["a" /* default */])('请签名');
        return;
      }
      if (!this.role) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__toast_js__["a" /* default */])('请选择职务');
        return;
      }
      if (!/^1[3|4|5|6|7|8|9][0-9]\d{8}$/.test(this.phone)) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__toast_js__["a" /* default */])('请输入正确的手机号码');
        return;
      }
      if (this.isSubmit) return;
      this.isSubmit = true;
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post("http://api.zsyims.zhixinhuixue.com" + '/ims/storage-output/sign/add', {
        signType: 1,
        orderId: this.orderId,
        clazzId: this.clazzId,
        businessId: this.outId,
        signRole: this.role,
        signPhone: this.phone,
        signUrl: this.url
      }).then(function (res) {
        _this.isSubmit = false;
        if (res.data.errCode !== '00') {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__toast_js__["a" /* default */])(res.data.errMsg);
        } else {
          _this.$router.push({
            name: 'SignClazz',
            query: { outId: _this.outId, clazzId: _this.clazzId, signed: 'signed', role: _this.role, phone: _this.phone },
            params: { url: _this.url }
          });
        }
      }, function (err) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__toast_js__["a" /* default */])('出错了');
      });
    },
    changeTempRole: function changeTempRole(role) {
      this.tempRole = role;
    },
    changeRole: function changeRole(isCancel) {
      if (isCancel) {
        this.tempRole = this.role;
      } else {
        this.role = this.tempRole;
      }

      this.toggleRoleListVisible();
    },
    gotoSign: function gotoSign() {
      if (this.isSigned) return;
      this.$router.push({ name: 'Sign', params: { url: this.url, needClear: this.needClear } });
    }
  }
});

/***/ }),
/* 285 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'toast',
  data: function data() {
    return {
      visible: false,
      text: null,
      timer: null
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.timer = setTimeout(function () {
      _this.close();
    }, 2000);
  },

  methods: {
    close: function close() {
      clearTimeout(this.timer);
      this.visible = false;
    }
  }
});

/***/ }),
/* 286 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  //去空格
  trim: function trim(text) {
    var rTrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;
    return text == null ? "" : (text + "").replace(rTrim, "");
  },
  //...
  abcd: function abcd() {
    var c = window.localStorage.getItem("abcd");
    if (this.trim(c) == '') {
      c = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = Math.random() * 16 | 0,
            v = c == 'x' ? r : r & 0x3 | 0x8;
        return v.toString(16);
      });
      window.localStorage.setItem('abcd', c);
    }
    return c;
  }
});

/***/ }),
/* 287 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_es6_shim__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_es6_shim___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_es6_shim__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_index_css__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_common_js__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_common_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__lib_common_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_css_base_css__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_css_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__assets_css_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_lazyload__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_v_viewer__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_v_viewer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_v_viewer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_viewerjs_dist_viewer_css__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_viewerjs_dist_viewer_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_viewerjs_dist_viewer_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__sentry_browser__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__sentry_integrations__ = __webpack_require__(159);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.








// common css






__WEBPACK_IMPORTED_MODULE_1_vue__["default"].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_element_ui___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_8_vue_lazyload__["a" /* default */], {
  loading: __webpack_require__(166),
  preLoad: 1.2,
  attempt: 2
});
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_9_v_viewer___default.a, {
  defaultOptions: {
    zIndex: 9999,
    navbar: false
  }
});



if (true) {
  __WEBPACK_IMPORTED_MODULE_11__sentry_browser__["a" /* init */]({
    dsn: 'http://65b3b641323f48db90ed554bc6b10af8@zsy-sentry.zhixinhuixue.net/15',
    integrations: [new __WEBPACK_IMPORTED_MODULE_12__sentry_integrations__["a" /* Vue */]({ Vue: __WEBPACK_IMPORTED_MODULE_1_vue__["default"], attachProps: true })]
  });
}

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_1_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_2__App___default.a }
});

/***/ }),
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 348 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 349 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 350 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 351 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 352 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 353 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 354 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 355 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 356 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 357 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 358 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 359 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 360 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 361 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 362 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 363 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 364 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 365 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 366 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 367 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 368 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 369 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 370 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 371 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 372 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 373 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 374 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 375 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 376 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 377 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 378 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 379 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 380 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 381 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 382 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 383 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 384 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 385 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 386 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 387 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 388 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 389 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 390 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 391 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 392 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 393 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 409 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 410 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB0AAAAZCAYAAADNAiUZAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyZpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMDY3IDc5LjE1Nzc0NywgMjAxNS8wMy8zMC0yMzo0MDo0MiAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTUgKFdpbmRvd3MpIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOjE1MzI4N0QwQkRFOTExRTdCMzA4QjYwQzdGNzkzRENEIiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOjE1MzI4N0QxQkRFOTExRTdCMzA4QjYwQzdGNzkzRENEIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6MTUzMjg3Q0VCREU5MTFFN0IzMDhCNjBDN0Y3OTNEQ0QiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6MTUzMjg3Q0ZCREU5MTFFN0IzMDhCNjBDN0Y3OTNEQ0QiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz7tXetjAAABX0lEQVR42sSVvU4CQRRGZ1fstNLOxMJE+TEG2DVKNBbEko73sNCH8QEoKKztfAoLfABDVEQE0RIyfDe5m4ybcWdnWcYvOYSwM/ewOzN7PSmlQApgU6w+UzAXkLbBWLrJB2h59AX2LeEuzz4+ZsJtZiS94mftIiNw4/FGWgcbDqQTICOp0/jiH+IvMW8HrLmS7oMe6IMnULSuQGtqwQHoxw78CyjZ1LERlligyyso5y0tc+GkvIFKXtIKF1TzA67BNPb7OzhaVkoFBrHCJLrg6+dgohFXs0qrXEDNF4vUcQ2NeAhqttIaT1RDhc/+GH+iEY9AkFYacN+LCxuGpTjW9OVPEJqkIQ9UM+aCaTZdwHeYOD/TPzVQNz2paOCpzZqkIHFPRHeo2331jELT7g/p4oPtObPgUHPO76nLfCvv/yG4BI85tU7qRk0w+OWAeRd0wR13EbEC9kAH3ILthQADAHO7z2uJzWZiAAAAAElFTkSuQmCC"

/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/ctx.ae32d40.png";

/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/dtx.b9372cf.png";

/***/ }),
/* 413 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAeCAMAAAAbzM5ZAAAAP1BMVEUAAAD///////////////////////////////////////////////////////////////////////////////9Du/pqAAAAFHRSTlMAiKWW6azzMyIe693Vzpl5cGZWVMJp1KYAAABkSURBVCjP7ZJLDoAgDAWflSKIgh/uf1aJTQ1E3bpyVpPpsg/wZHKFIQ84SXV2YLE4FKI4w4oELgRxi/xAiXPXMJ2xRwP98YP4/g7BpmTVobYCi97B98jXbMy+qTnA05grRvI4AAJvE3gSTRBRAAAAAElFTkSuQmCC"

/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/licence.4d56f40.jpg";

/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/ltx.3d13d6b.png";

/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/parent-qr.782c1bf.jpg";

/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/race-example.50b33ae.png";

/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/completed.12f431b.png";

/***/ }),
/* 419 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAMNJREFUSA3tVVEKwjAMfSnFO3gldwevIUwRERG9hmfQXWmXGMakczL8WCLYj0EDgUBeXtM0vBK2/ABjhRxGaEIO3hEnj+KvsGaGumUGLvcNMP8DCAdeoMNRNmktvrRG7soTWhBuiNjHRP7ExlXoBWmjLJwd5AztXC2gwokaL8ckruZK8nflps8qnokmi35Nvld8/ltUbmA+fRlRGZE5ARMQRFbbhOoFyixwAQYu4Sbs+IJ/y/XQRcA16qegup1kO8OH8wLzhzjOyXaU6gAAAABJRU5ErkJggg=="

/***/ }),
/* 420 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAPdJREFUSA3tVt0JwjAQ/q4Ed3AWN7BvDuAaQisiYkXX8N037QpuoksUz0valBBMsbUKioW011zu/8J3hCUPUGAFxlTWEMAZGUYgYqGBlE+yPza0/yLkyCiutxM+CD0B4SprD4WFMspvmNWH2hGlE76MdpRFZwGxk/LFeB4hxppy/2yn/4R1VEcdCSHh0osNUSdlIaFKbxTi97X//QZUMBVN7ekL+e3q8PtK0eN2FUPhCNwL5HjUluwrgqDdcAT/GlRJ+9fAds8P34O3F/kDBjRA66eEOVu0175Wl4HMOW/RHfSbHYmwU3q00OgvwG/HlmahZ7jO2HIHzXBK4dHWJkUAAAAASUVORK5CYII="

/***/ }),
/* 421 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAMxJREFUSA3tlm0KwjAMht+U4h08064wvIUIQ0SGiB+38AzilbzEWEyqG2P139L+aqDQj/VJSLKkhCOv0KEFYyNjDQshvEF4wOPgA7zHzoI7MtRQFmYH0aGWqzhUONFr/GjJpOFKrj+VTWiYA+tMtIQZ3f1xXXRgvJFBgUZc5es3G/sHlrAJe76hx9aGPKM43JO7SNO0DnrTpGld0nQW1XjppCiVNI39MtkpaTpxxv9p8lKRQUGG/+Ai5dq26Q/hcLh6fVpo9w/NP8Gz5QOzyFTZTKjqngAAAABJRU5ErkJggg=="

/***/ }),
/* 422 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAMxJREFUSA3tlm0KwjAMht+U4h08064wvIUIQ0SGiB+38AzilbzEWEyqG2P139L+aqDQj/VJSLKkhCOv0KEFYyNjDQshvEF4wOPgA7zHzoI7MtRQFmYH0aGWqzhUONFr/GjJpOFKrj+VTWiYA+tMtIQZ3f1xXXRgvJFBgUZc5es3G/sHlrAJe76hx9aGPKM43JO7SNO0DnrTpGld0nQW1XjppCiVNI39MtkpaTpxxv9p8lKRQUGG/+Ai5dq26Q/hcLh6fVpo9w/NP8Gz5QOzyFTZTKjqngAAAABJRU5ErkJggg=="

/***/ }),
/* 423 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAUBJREFUSA1jZGj4z8bwh6GJ4T9DHBBLMpAPvgK1XmFgYpjJ0MywgIGR8T/IKEaGmv8dDP8Yysk3F6vOTQxsDKEMDYy/WMAuB6lhYvBmaGHchlU5MYIN/yWAIeEPdGwvULkfkN0CpMsYGar+g73C0MbISIw5BNVU/7cAqjkMdPhfoC/UmAhqIFVBK+MJoJZFQMzO8IuhgPoWQBy0EEwxMhiyQPhYyOr/W4He9MIigynEyLCNoZXRGy7BzXCd4QuYp0UtH0DiEWZDFeNrMPM/gxhuHyC7CK6R9ARBLR/AnIBBj1qAESToAqNBhB4iGHyaBxHujIbhFqAAqEhgABYgJADSLMCWuwlYRvMgooMFjAzPwb6s+o8obgl4m6A0zCyg2bSq9CFuYGLoZGFgYagDVtCgtEFpswXhMVCoMAKrTaDZAHAvRc0YxDgCAAAAAElFTkSuQmCC"

/***/ }),
/* 424 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAATxJREFUSA3tlr9OwzAQxr8zEQMjYmHkBRADr8BCF9Z26FMgIbWoQpCi8g5MTB2ztK+CxMbEwsbIn+O7KIeiphbQmAXVUWL7Ev/uvnMSW3Chm3jDJRR9nrtYtQieOfQQY3msI0IJ/8BZK7gRFTu8Fgx4q+4gKyM3S0AHuczrN3/UHqhWzz2QdYBX3LLf87HhK/JV4E6xOuCE1xfyuhjqqd8K3mhd53JPJ31ylMcEIz0yZjoHRsulgOCKrQ28Y4pz3cvMnqT4XPiMKLappEiroBnpfnsF1yJNLi2VoriDoc4o8Xjp4EWjYM4PrLNotn6qFHnmGz7iCiIRNQjfGFIpiLqJK1jPQZW09Rz42/OPv4PA//dTqXOgS/8lnoNf1c4iW7goTGCL/l+UgJsMGUbcWdhC127bUg/QsiK4M/YnK1ZYANPczh4AAAAASUVORK5CYII="

/***/ }),
/* 425 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAo9JREFUSA2tVcFLlEEU/826Rpe0LhEheKiOCkGHIISIiPCQILSe8mD9BxVJ60cbVhjaf1CCedKDoAcJkQjWoENQ2LE6GB2iS7ndKvf1ezPf57fTzrhQO/A5M+/93u838+a91aDVeCgHUMMNwi7xO57CP3BeQRdmcMv8SG3ByQStmXFCzkEwy683M3mzwRYMxnDPPPfsDZtCw9pfKnkd6yl5lUR6g6P2c+uq9SlGsZERvoFLyztLYPAAnUhQMXWPoyIF/MIkMbcpvsV09YXSFb6B5tylpRokVyUVVGHA3cS9k3cG3YQFgCGLNJhuOnkjhYooxg1NYdOICRyzSMHrpoi/DTkmqzAPERPwQP+ziQl8tKQGp1qS5xjtjaYRE1i2SMFNaLXEhvoU48ZKCBYO1g7V0gMGbCmGRLIyVYwr05mQQLgPFJk1GhiupajVkj2opsWdfIA+YS2ej3VzXEBFEhnDDm8DHNJtYHxDB3tm0swGfNYUFijLaXrv8mwXYoGe3WCN+zu4b155dm58gUXpwCbbv47x1LdNxALXzzhvohtfLME2jlC8n+uLnEc4d/PTVE3RmqBkdiyOf3KBihT5oMuEDdL6m74p/hQ8Yid/z8DBuSIHGXedvnHGFhm7yrghxilHg0BZnhJwhZavPMkw8/oySBgzJnKGN18ix2FyzDNdo7lAIiU+5gIdNZKfJfmbGM+e9kROUuQFRbr4+CPkWTRspP34ifcM7CH5NZbbkz1JWjkn5CpFHhP2GftwosBsD1pyg7d83mi5teLd9SuHcumBya2tXkqdczBGdoH/unAccza8jssq0Gc3nfzX166Rc/UXeJ2elPdTu/jJ47jIXeRmgyLCuq21TUC5yrJKPvkDzw2+eICiNDcAAAAASUVORK5CYII="

/***/ }),
/* 426 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAnRJREFUSA2lVT1rVEEUPfPciI2KpRKw0DadhU0aEZFEFCxSqUXwJxgia1ZWI0FN/AkGtItdgoiF2Kx2ghrt1CI2ipWu2Ji413Nm9u3u2zeTZJMLszNz73nnzMe9sw5b2T3bjyauEXae7Xgb/pn9Cg5gAdPud9sX7VzUmztn7BQMi2xHc1ehd1iDwyTuuJcFf88k6xkXhyJv4UWbvEEi7eCIb2Hc8DFhhE1YfAfhWD54Aoc5DKGGumsVOOqWYR2zxFQpvsbjGokdV3wHOvNwLI0ouZQkKGEg7CTcU2ENmsQFgAse6TBfWnkvhUSECaYjLFlK4JhHGt6Uvuh3dDF5hhUQKYECaDeTlMAXT+pwYkvyLka1UbKUwLJHGqagbEmZYsIEW4nB4h+rQpV6wKhPxZhInqbChDRdiAnE60DIvNDAz5WKypb8QnUsYeWjjBlz8XSqmtMCEqnZJP5xN8AhTUu2jaciLnDDTpLsFtd2JkK6Qd9Hth08dk9sD1ZZ/i1cJ4HEf/F3if1z9qs4iO+Ycn84D1a3vdjAbS7kCtvh3E3sN7bHqOBmpeOsWwXvsUzgGINa5V0+BQ9YyT87mP6ByFuY7nd7MaOfLF2Bdf8si/wHL+0iZt3r0of9Dq1clmGcl/ysE67aOMdPtbMgULMJXuZlkjcJPkvytx3wdgZ6kRLmWEj78BefGB8m+VWu5GECW3bP2H0eUV5o5XiG+YznNObJHd7xehfLqN15VOoTbYpHcM4GojNc8njdwZzjX1O7Aee8n3EJjPjJEP/6dmqb3EGF1zNMEdnXgfmV60pHZUw1snnGlUWvKGLM9+bAAiwkXzGbFNp/22HArfAh0XMAAAAASUVORK5CYII="

/***/ }),
/* 427 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAcCAYAAABoMT8aAAAAAXNSR0IArs4c6QAAAP9JREFUOBGdlEEOwiAQRYVew+N0485Fk5ro2p2ncedaFyZd9ADtbbyGqf9X2lBaYGCSSQfCfwxlBtX3/WEYhsfub7eyLFsTiz6aYvjeeNN1XS1SmkXaWVwA9EqBEHCDfy1QEkTzzEqpSy5ETTsj7RPSf2JcTHOEAn7GJm9rbhHOAM7mQBaAHMgKYCA1bwNx9DibgBSIFyCFBAESSBQQgVQigA+CGvm4vcC1SSbKgM3ludYqmkFAzBJvgxlExGN/eAESMX/WJkAq3gSkiFeAVPECkCOeAbniEQDxEUXSYBDtfQpcYyHd4VliwtxKjD6iFNmm0VFXdpXxKvQC28Ip/gE7MN9UXQdzgAAAAABJRU5ErkJggg=="

/***/ }),
/* 428 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAmlJREFUSA21Vs9rE0EUnjcb6EmkKtVuUwwpokILnqxHrxJojyKK4s2K+C+I/4N4FUG8R+j/UARB6MUfJBqTbvESCSKkkNnn9y2bsjG7s62kA8O8vPe97828efsmYjxDl5aqRnVTVRtGZAVymMBFIsgtEdmGvil7e70iGskz6PJyGDv3XFQfqjEBQA64DsgirBWQ16FfoC9tKvLKBsEz6XZpnxhTATQMN7DjNyA4BeN7sfYFiLel1+tnPbVeP20ODu4A+xhzDdjfONE9iaJ3WdyEDPKn8eJiHIfhL8i3J4yeH0jlffj8ga8jRy6UOycAswX5ci7Io0RaV+HbToNsjKFJiphzHY0+IRUOx1zHpX0ZA7IrdnqNv2H/mNWPZa1W1zSOd3BHTiqVK7wTSyMvNM35oyJy4pDr15yU8wbuaRcb3CIXOYkRliKifof8we7vr1NZNJDnr7TZKLpUhKEeadrFchUFUrPY1iYiBkm1+LyOYQPXS3KS2+LIDVyEYykeg8MPnZt7SwC5LYhXIHf+rXM/g98q7fYAm/5JbqYohDD1BfopjmAV+UbupIqOAP9vSCXZ/biJldP8KIekCPQrcjNFLagu4iM5U+Ys8/O3OMtw7FOoogVyW7bctKQaZY5mMAhKMQQMh3e5kJtV1GSZ4mN7QmXR0FrtAjBd7fc7SSctAkKP8txKS79p+Viwn+MU170d1Llz8GQaz5vR6GwRPzrDA3CtkpPcCISI2WZnzA309M95BLinmwgyhONOgX2q2R3iTqpdHwaggCB8cNwsH5wkRdkoPAkuaWZP5lSA5CQn+ehPnGYGf1v+AqDeb4vhUaG/AAAAAElFTkSuQmCC"

/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/ztx.a4debda.png";

/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/奖1.f89b35b.png";

/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/奖2.bf5322b.png";

/***/ }),
/* 432 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAAyBAMAAADy2KUxAAAAGFBMVEVQ0sL+///p+fd63dDN8u2d5dxm2Mq77ed+toh3AAAAVElEQVQ4y2NgGAXDGxg54JNlU1TAJ80kaIBP2lEYnyy7YAA+6UBxfLKsgnjdbSiE31dqFPiKgDQBwwk4jZDHCAQLoUAlECUMSYT8pkBBYhoFQxwAALLTBvOrBONMAAAAAElFTkSuQmCC"

/***/ }),
/* 433 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAAyBAMAAADy2KUxAAAAGFBMVEVQ0sL+///p+ffG8Otz285f1sek59+N4detn88uAAAAV0lEQVQ4y2NgGAXDFzCr4JVmEgrAJ80iqIpXe6EwXmk2QQO88oZi+N0uWIBPmlVRBK/2ICEH/H5ToECagOH4nUbAY/iDhUCg4o8SAhFKIDkQSEyjYOgDALwyBtitp44JAAAAAElFTkSuQmCC"

/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/img-chanping.746b7ef.png";

/***/ }),
/* 435 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAMAAADVRocKAAAARVBMVEVHcEz/8tn/0Xn/uTr/siX/syX/syj/sSX/siX/w1f/siX/8dj/89n/8tr/89j/8df/8dj/sSX/7tD/wlT/y27/tjL/4auTkX0kAAAAEHRSTlMAzhMkvEXa75EIae9pPXuirkE86QAAAkdJREFUaN7tmtmSgyAQRV1xiUkAm/z/pw4GUBRrRie3q1Iz6ZdUfLgHGnoRzLLYyr6tRKNQ1rRdrF70QqGtjeTbRuGtmfVrDvkF0LWKx7yLuopHPixypC/auixWS4+w2T9VbWkZ3Pow+jpjsc7vn2oe+3W45xf5ul3ya+SgoF/ccomz2zwB4df7JrF2zWo3Aef/68ozt+J1/5feQ9Xz77CdHsJcDPSJvqYGE2lOppz8sxo/oXKF+52WeL17DCrbzYD1BFAAs7joLjlcRH4G/dZDlgCYgyHtAXabSh7zABtoF16A6HJegKruzAAlNDPAmAcvwNr4YAZMG/fx0JoRgDUbZwHA1XjNkczVOs65iKv5tdk0AHjad6u8APAvICkAah/AewK6AdJW27566PYABbCq5UUKwFbNPAUM2EqQAnJuwIUbIP80YLdQf1+9zwD0OFW/7UPbgI8aAxifTY1OoPYhBKB926QTfaWQgJgQ9A3GRbQlBH1FuEWOCUf0z23TNeGQ/tk4iAjH9M9GckQ4pn86Vcy66pj++Vy0IRA+2a0IxJFNIwLxpGsd3v6NlswzGLVkXoOfCa/uoh8Jv44Dc5Dw20imbeYD5yJKcys0m9Je9gbWA9qvD7CKRpKnoulUDVuT9c5ooV2F64tob11wRd+kUmTSdu8fd9cfwAfwAbw1wJ0xFvijBO2vucRyE4g9DHFVUITb3r7AHudoCjeBNdvRe7jlrRSjTbe8ZcOn35SMH4VM+v4zhJLJS1W5fNnSgs/cVSNaN/wvWqv8/HtAnFQAAAAASUVORK5CYII="

/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/img-fwtd.a07a1e3.png";

/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/img-jctf.d86b34e.png";

/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/img-jstd.852a8ae.png";

/***/ }),
/* 439 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgBAMAAAAQtmoLAAAAGFBMVEXr8v////9jlPeGrPpunPihv/vb5/6+0/ylVd5ZAAACuklEQVRYw+2YPW/bMBCGSduxV7Gu1TWgJHt1BSRZAwFNVkMp2lUx0syumv7/8kipIqk7k0LdpSiXBJQe3wffI3liQo/0qZLBkd88C8H0+0kpo0bGO+BFRo4HAyRVLJBzDaxl9PiogWM8sNVALeWOi+BIWikLDagcfRcR44PKkwaUKR4DJOrFHhBR40+AhAUG9wDGYohJALsIcEWIKj8Yn0ZATSmiIABStfmlgMkuTQ46tHL/gX8LGAskII06XnykyPPLApNdmhz031uH1VOV35zigW/a9fxLLLDqQs1PYaBWJ9GQzCIMzOUtmw9J3AcB8eqsVhEGEraCN+948gP+niIAuG08wiT88xABKI+yBmbhYlP4IvGloYCq/12+MNp0ZVj4wOq35zy1gqgIeYvkCi4F3VGmfDoEAbUKuz62dlgJ2qUFXGw6YCblfTDo2QCwd1JeB9M6s16KAiyXmOUSDVhBs5aQH5VWZqWVBoaFY0tXfQ2hpUrmneReLGmolcia8+JjS1t8UFZ7Wt53MP3myLu0socVUPPqFhDU7TUO4CUKl/4DAWCbAMxlVE1bHUR2sgzsiXVwOo6OcA04QOp1KCbDrgEHePMPhMexARvYmCr52vBk+dPUzGFkwAa0Q5+0G4lIPxunfAMWMO+d6O6z2sFb34AFlO5+KkTbx47LGyLIG/vO3Ld1exxoR4+6tivDCwiauMJ/VCPnRA+skSNET2ZEiR6dCuufldau4AF2jQwmjqSFVGKbBFctm2x8IAFnNohHcK5Uo9/hpvF7jx+CkGxv/+tayyMWgtnDt8jNZkttjHxtLJej9rjGN0aIGoBxA14Sx7LKXmbaVa/Fr0bpMwNSaFpt7yMCBQgDbOyg9WcK6jZGtcBggZ2xgAJk84YCZ76ZZChQ00CBAi0N7FBgQQP3KJCSQWTPGPALwohAzbLmeiQAAAAASUVORK5CYII="

/***/ }),
/* 440 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAMAAADVRocKAAAAXVBMVEVHcExjlPeDqvtjlPjp8f/n7/9klfiLrvljlPiYu/tjlPhjlPhjlfljlfjs8//C1v1pmfmNsfrs8/9klfjl7v/q8v93ovns8//t9P/s8/+Ps/rr8v9jlPeiwPtsmvfTEM88AAAAG3RSTlMA+iOCy/fbFe4IlsE4pm/9Vf6Lbavm/jhNY8/q1o6nAAACj0lEQVRo3u2a25KkIAyGUUHAU5+me2YH4f0fc+ll1KAOPUqo3ao1d3ZZfE3ym0CAEGhNVYoexURZNWRuvO1RreX++HnZI1uZw/El+viWIAGg6hNYBRyUpQBkk5MK90vBCYrxYbzxl9oFnqCZk2Q9Pjv953iA3H0P47MLAUE0FwT/ER/Qzx47ylSUMdrJEEAhGOWJAYrKxADVpQbQ1ACWGqD+G4A223Kz0dsAenv615sAZjvA/FuA5C5KHuTjQzsAB+CoB0c92A4Q8IUULirgCymCLAthtEooU2tKHYC/BbjVoqzsBpamAUi3BRcN4fckgKEJIjj5lQLAM9AZoQkAzdQZach7UsCzcfG2fPnnCWM9VXDQJzqTfLHR19HJrvU6YNc5wESnaziFgsg7OmDodX0j1XgXee3GdinV2CBbO4OXcKQ6T3b1K6nGAhpPqpzhp2vQlBWSdPgALoJSRSg4N69Z+4EPeCFVhJKJK9W1mgykWpJlSooHwO77LVaqq6uKyktJ3Y66EF46EjlJNauIpHuSng6ui8JSNbHLd2uPUErCAJx6r3qiu4ioy+SjZfWMDrIFsN6T6h1Xps/Frw5WT4zVtfGOwCg+AMQ5ZqEX2B88UKpnADCTKkMHwDivLfTiAcwgVM/gHs2Tak7xASDO4i1BDKY4i0/rnyvFB3ylpE87tD7vU+oLwHMKpR3+9LBKvcYBMghgU+I8McUuf1LeHgAbj3szAQGjuy2J6cwJdc86kq4dWFsDY53M8CXsSand2pH7s+xPU7iMKfUjqkeV+Ufs4LP6mkLrAzZ32arZIbacDqzdJGo/ZW/tE3oXNxZ2FrMYDTcLdl49IWuXaWaAIuryzIo1s78gi5/OYbz+8xtDDhAf7TMUjgAAAABJRU5ErkJggg=="

/***/ }),
/* 441 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAD0AAAEHBAMAAADv2lOlAAAAJ1BMVEVHcExR08Nc4NhQ08NQ08NQ08NP0cBS1MJR0sJR1cNQ0sLJ8++C39TVPnRjAAAAC3RSTlMA+gS9w289O0cklI/6PmUAAAD0SURBVGje7dGxC0FRFMfx0329cm2IEsMlSibKIKMyMD1FIX+HWWS/il1hsZmvxWDij5IYiHtPWd7yu73t+97pc88jolJ/Ro7jJw7VwNF3mmTH8XlT9nXBPiCnu7ekjFv7XGbMUdetfeRfzSnY/925+ZyPu59g9kPFx36V4wXm/xDVlLvHmD6hcA/88MMPP/zwww8//PDDDz/88MMPP/zwww8//PDDDz/88MMPf7h+sRgol7/b2CYdQ8ttotXG3ntqPRQtaxZpP3sOlsrmj1SWxqS96dPvpejrGRtziQaP/iN+9F/nfT7n++d+FGX2k2f2+/o/d/EiX/DvIgeXAAAAAElFTkSuQmCC"

/***/ }),
/* 442 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAD0AAAByBAMAAAASQsRjAAAAKlBMVEVHcExR08Njzs5Q1MNQ0sJV48ZQ08NR08NQ0sJT1sFQ08VQ0cHJ8++C39Q+mY08AAAADHRSTlMA/AVvswnDTOolI4wDxrjEAAAAyUlEQVRIx2NgYAg3LmXAA5hbdnsY4JF3m8DAmYJHexKX8QI13AZETDC8K8zZilO+hEvmzMEF7jjlrZnvnDlrsJlseULmE3IfIf8RCh+C4csQLog3fhgYBBUYBjUg5L5R94+6f9T9o+4fdf+o+0fdP+r+UfePup+BgbXYPACfvIX3lmY80iyZDAzTHHC7z0xhsRVTMk551k5m2YsGM3C6gN1h4ZkzUiwFYA6jEAYS3mB75sxlbgOi5AmZz0C6+5D9Ryh8yApfaPwAAGgFQhBfKtmUAAAAAElFTkSuQmCC"

/***/ }),
/* 443 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAMAAADVRocKAAAARVBMVEVHcEz/lU7/59b/5dP/kEX/oGD/kkX/o2f/kEX/kEX/59X/59X/kEX/5tX/4c3/////tYP/qW7/nFn/0bH/xZ3/3MT/9u8BchzEAAAADHRSTlMAtH/f7VA6GI3XwPGE+zxCAAACsUlEQVRo3u2a2ZKrIBCGzWLQRBjWvP+jjgZQDOCJdnedmqr8V5qL/mh6ASFN43Xr+uuApmvf3ZpU7DSg68QW+7frQKDr7AQjsT8Sog+ngUinMEEDmfwkdf6lCw75twYkFm2+3vrkGQkQR92/nn2IGS6A+TCXLOIAUjP/B8BhetwrgDMSgPMyoOXEgDs14EEN4F/AXwQYK5WShgTgjFSx82uLDHBW6vXiItEAIhl4nXAQkA88kQECjFV6cwXWxwG1WZmsSuuMzl34HLAxK3pMz59JT51F4VOAkBXjyrrnzyxzFCD01sAXOQ/dD1DbA/fzM/5gD3pg14luRW6ci1FhIHY3QG3Mymh7NO7ES/pgFoXkcJWBzzJ5bn8G8M9r86+Bv8lmMd7lgTL8WRz4LJk3o50xmArWGicq0kd7kXmvACWtye37KhgcR6iDkFKlEOgj7VpUepxy/wgBuBfp1Im8zPZ006lVFzqSTnwohGDvgiOmzcMao7bK7OCS6SbMskJulBlg0RfchbDIdQgk4rbFE/RGmQEBobDWZSYwN16rIJTKDAoIiV8vMyhAplHWhTKDAmxSCaVOBwaYJI1MMQRAQJpGslRm4O27XtJIFUMABSRpNJTKDAxY0sgUywwMWNLIlkMABSxpVC4zMCCuMbUyg38ExjRylRCAATGNyp0OARDKy6lKCMCA9ZbM4gPECuAIzipk/SMfB5Ds+bQgOW2ZCcpRHeeYcSumlf2eeH0BRCe/rnxBgXd2LZMrFoLT97jD7xJAi3qZGcQSAIW6hhbQM1pAtE8F6N5u5pAvYtML6+hRyxoavc0YFaBtiAHegfP9wZF0OecAduGYioQ+ThGyfc5ZeqU/BvmMbD+60MY0vRABwhzR/SshukDXTuP/Egg6RkNMmAFN25NO0QuBv2TqKci/9gZ9A64g1qUAAAAASUVORK5CYII="

/***/ }),
/* 444 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADYAAAA2CAMAAAC7m5rvAAAAaVBMVEVHcExX2cZQ08Ne2Mjv+/lQ08RQ0sNS08RQ1MNQ0sLD7+pQ08NQ08NQ0sNQ0sJQ08Pw/Pvw+/rw+/rw+vrw+vpQ0sLv+vlp2cuI4NVe1sdV08S06+WX5Nt63dHh9/Tq+fel59/Y9PHN8e0TR9QeAAAAFXRSTlMAB4kR5j33IVns/styttyeSG+vzZU4sUr3AAACcUlEQVRIx61V6bqiMAwtoiyCeOfeKQgoi+//kJOkga4CM9+cPzY0adOTkyiERpxuIhZBnOQOTqGoi9zFJRBW7IcVflQGn2+ZQoku8Itp3/lbdgMjc6OiSsokZaPkhKLcuCFNpKwiJ6xUT/4+I1opG1o84ev1zECjtKNiODePxVeNuML+RKsZVo+aMbTk45IPJ/3Q/kvKbqjdZV1PbhE471/eFfpiwNgY70fciaXoTLv4hvfiic9cwuoemdUspqom6rKxMz0xsetqwXVSX3cjwuNxPbJfHQc45LVamPPNlBUYv9cT23F1rB+wOa/Wy5BYQVenauMNxlNHOfasJZaph36HTvdufywSY1l9hd4SfitJjGX1E2LOZ7ZmiVmycupUe3VUHuCPssqrqm0UwOoaG+AnW9s8iVx1YCL/BvmRpg61eYrXtQ8GZvBwYX1EIweBXSC/rg+yHagJOiSXpdzde5vJpSbvTk8UJLOdfR//pLk1OxU7oFECGuSGSobGbrhCO29ockT9F8bwIjqfwQ64ahtPrKwZhHRyKtbUMc2JqXeHsuKiN6eOMY809e587WZmTjfYqmOivvT/BHB6NQMn07ultqk3/wWwDK/RVsVyBI5IPXzsgV7xO3SDLQl71FuzOVds2DRMfFCVig9YyrCSzospSKJ+Hqt6KTGXHs0kExtgVbOglNA+UW9CqVrJV8ka/9YM/X7Ik1StmoWaSFEf7YSxqjGip1iiPha7IDoneA8m1z8D+g2DVN3QhGp3qPdVTWGYoczEQdyXeXiAelfVjLs4DlI1YZ96rwze6DhYhoPUu2U4Sr2t6iQT/4A0Ff8bfwBB+pCTNLkadQAAAABJRU5ErkJggg=="

/***/ }),
/* 445 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADYAAAA2CAMAAAC7m5rvAAAAjVBMVEVHcExQ0sNQ1MRQ0sJQ0sJQ08NQ08NP08NP18ZQ08J54dZn2MpQ08OI4tZQ08NQ08NS1MRR08Tw+/pQ08Pw+/rw+vrw+/rt+/nr+/rg9/Tw/Prw+/mF4NXw/Prv+vrw+vrE8OuC4NTv+vlQ0sJb1cam6N/b9fKJ4NZp2MvE7+qA3tOZ5Nzl+Paz6+V33NCG5y7EAAAAInRSTlMA0Ezg+F2tICztBQyEFJhyQjbyvtyfwVIqQZevwGJxab7VYis94AAAAs1JREFUSMeVVum6oyAMFRQtWne732XGpbW19v0fbwhugPiN5se9xXBIchISDGNRfN/YLhgVBcJbUaTgQrahPNrBqLcJFhW9RNsiG2DbonMGmLMtOLtD2RuZ9FJApf9nxMEkJHhyCu/3Y2BeHGEcz9MfBz3jhZWGcjwesc1eR20imnfsQpJ0oj22LUlFQ3dMEi1UQUEnaTFX9c5E/DwURo7vxCQwZxupHeJ4t8NhZ5nG3EOwheK+6s9nPw4kv0zM3fLgQnghbKZ+nyEbNO73LcmZJMcv0Jkg7ADLcU/XI2iS7HpyUJdNh2kQoC5ZPkg51jAU2d8knyQ7AW5nhH29/kyqJ/vUZgcudVGUuSR/mHYPPpoMdRIUD7b13f9u2aanjGMnpQbirrqTh/mb+fjQLsZTTYOCScnYUzLwmHnZMJoMi8OuwueKwe4LKwV2lJ2ol2z3egpOBoaRySG/hCWDNRLsxTLWUyLCSnlfrXJSA6JLgEgkO74Sdn2K4iOi7jxve/bXE2MDWCv7JMFaXh+Yt6eDfJoCqxVGLM/wLODkZz2s7BpTCsFdVsOefYuHWo7dZC0lL+5j10kD47aYKDmN97F5pnC7TpLzj3xp2YxzAWZS6CWrqgQuBOr6h8vqy3SvCxzcpVAbYeZBxslZVJULpQzGzKFR+hTayU1/VVpx1UgDFsyFF/1VgZ2iw0h4E1Ag86iNRoz0o8xJSPn+rKW8nHht1YHnQgffHaZDa03NAB+WM5vVyE+mcN7zQB/8os2Hbvg7743VeAR8Ra46SxkrVnyccTIycgcXY+2zB50TlZPx50fj4uBm8D2YKJVkNDoXefKATXKT62SoEWCG6t8oMFWtKBtGjtjKIbDFZxsk3bwkYkRdst81v8oacTEhBNxEX1VVwVRj/yqI6FNVQAdleoLV6DRPAp2kCsxaB7MU2H4dbJY53+Gy00undMZX1z9FOPa7Kjs0zgAAAABJRU5ErkJggg=="

/***/ }),
/* 446 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADYAAAA2CAMAAAC7m5rvAAAAflBMVEVHcExQ0sJQ08JQ0sJc2MdR08JQ08NR08NP0sNl2spQ0sJs2stQ08NQ0sNQ08NQ0sNQ0sPp+fdR1cRQ08NQ08Oa5dxQ0sPt+vnw+/rx/Pqr6uLw+/rw+vrv+/rw+/rv+vlQ0sKH4NVt2cy87edX1MWs6eJg1sjO8u573dHc9fM6fvnjAAAAH3RSTlMA9rC/FjnKe+QJ7SaV/F7Ycf5KU4j+n+eHO5qpymxZwdHFlAAAAs1JREFUSMfNVunSmzAMNGACNhhCDnJ+xSH3+79gbUmAOdIJM51O9SOJjSRLu2sRxj4YL6UsOZtrgdZaLeZGrTXYembYEsOW/+Y06E0HsyERaRyngv0nlmThNN9+nE4+CLPEQOZpvZl6Wn7Af6O1t2a5VcOEiLhJp/OJfQX70gKdjB9HwNtq3JPdliw1nxPSE7H+QNzCbKdMREE6UWOGKpmog6dB9JHPBYWVs1gJbYgFxfvDleOjQ32LLxQafXQuLRFjlEsgJx5AFWgZtgWpcEip1iE7ju6OCFp44WpJFzIhgZWkuA05sNIhvqB9HfMB+hnbV1s8daCBoOPd5OhwgZ6E2FXvPgeZSwonivwe+hH7VVXVxeUg9NCRLobSvSWgb3zPJuzpcJBI8qN1s6R7kiD6h8paDfVCUXHjljmt2LVaO+ifIOze+AmQW+xQYrkoU5BTSOgHjBcQVjwIcR9oWjnQ+oCHT/QtMeFPhUYcUNajcytSSC9sGzrnpKgdhVkOlL/EHn6u9pt3UjLXf/eAOMTmUDVmOVAA9vJQ2FaVM+8lY+fnjaAy6J/asGcDYJrsACHpkG9SnFuPlCVVZzWpQZyx02YurbDgE8Fte947YXfS3okqDlwxoSvgplZi10UVL9jj+6bRRoQcMd63meXROewCW+rYFtxoUHRMPbDKx7uN2lK/rzasneEeYG4Uf21Qq4teY9Yg082d8DnI2lBl27g9uuSUB+rc2rWj5GbQHpCALdJ3Ac7oJ6QrUDLdgEdRcuz+TUeY7G88uMCdO1EfOoNFGTZg4rzahq5F3bZp42sK4+58M5cDQLt28NUdqHd8BKcKdyAZ0VPKjizb0RM5x0JstNebSGoDM7C+oLVM0Bq63Na9V+Vaz7BF//3yrfn94f2tOX8DQn9hLI975nmyv5Fbp+gv/KfJoi8tG73PvrPN4J07G0gDSfxtVIxC/g0K66lC9RcTnQAAAABJRU5ErkJggg=="

/***/ }),
/* 447 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAMAAADVRocKAAAARVBMVEVHcExFpPtFpftFpPtGpftFpfxFpftSq/zg8P9FpPtFpfvo9f/q9v/n9P9FpPr+//+Ryf1Rqvv1+v+y2v51vPxisvvN5/6+e4sjAAAADXRSTlMA9FDGmTe2Ef7jcctszzoqPwAAAxVJREFUaN7tmtuygyAMRb2hoFVuyv9/6rEVERWUWJg5D+WtHcsiOyGE2CyzRtPWJB+ijJzUbZMdRhtpcgNpd9M35RB9lLYR9ZBg1Nv8xZBkFGkNsE0gy2d0cv2z0aBlxcR8swCziOMw4w8QCHh1uP9q4O51CegjjK5JDOi71ID+FQhgHLZrOduZcAtg8MSgCTgMwOEArn/6TwDPJepTO7lPHaY/wA/wA/xTQEja+CZVsCTJDp66+f8FJJcouZMjhCmxNUwBaN+fpHlEsmkWhU9MxgJkRT2uk2Fbcc5wHECWmdUfHMplXADzh18UwOiKwDEegF1voa8B0qxZYiGwNPbIOACs/Tup93NCUKom7WkcBaAFmsxsgooRLpIfwA/zfwjTAN3lXoB06C2oAnvBC2CumBR0hGrkBUzOpdLFsCkCYHGBOjwuMNQJXsDy3TEghYAeFkBAHwuAPRL1UImwB9B5nNxDndx5AC93mK4JNjxMX66W2scE6dxS1kbD0Jtnve/kdedUMU9qpQrw3bk4dKmq4UTAdrL7ojGrbSCaYFSSOl2TT5sJ2N2uz03SYjtwFMZqO3AK28JHzXG7PjoP/WxTBdrgbO9f9JiNlsh8hZ71IgtPD7su7A705hTo9BfvEMri4IMK3tCu72IC7T5DRbp/w5JrgapHIlW7q4RU81FJRa/mMvvIqfSzOUQk6w0OZ0qYo2am0EMCmhe+7kf0YP5zKf1myGmfXgqoSGZ+52XggzAG2IJWQP0n5cnwMwJPdnjCRFrTw3hRf1JTQy5pAyJSk4dcAmaZ9GmQN5vVQZFUh10yZplGKzOFi4QGxzHmJug6eJk0WCQdQer+MJ89rfMSJJIQoPw3bkAAkSrABWYWiVurDhOJQIqedcMRe3HXkYQ89ajPhN6WJUSkFlYWrqHa7mqE6tYFLBwgd1NWt4ASdv9ab2zlrpBCtz5WwYWtdoIpalE5kOLKyTnEx2/AchvJge9Mwy8vlALf2ya3gDz7MwDJwIcl8C8Zj6oVwAivWNpngDa8YHn0j5kcUNShEozIy/CK6w/mFlwmlj6XJAAAAABJRU5ErkJggg=="

/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/img-separate.d8b180d.png";

/***/ }),
/* 449 */
/***/ (function(module, exports) {

module.exports = "data:image/gif;base64,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"

/***/ }),
/* 450 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/img-sing-up-right.f73de6c.gif";

/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/img-sing-up-top-phone.1a55363.png";

/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/img-sing-up-top.0ca57b1.png";

/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/img-sjwj.6698722.png";

/***/ }),
/* 455 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAADpUlEQVRYR82Xz48URRTHv68WqkH8SYIXZ2qUxJ2e5WTgQvgDWNllCSYiMTGBixKIBxPBCwkQTizxpiJeIHKAlcQfLBL5A4wX1MPG3R4M6HQPF0jkhwToGrYfqd7upaenp+fXJtqX+VGv3vvUe6+qvk34jx/qNf6VtXjhuXlrUxAEL5MQa8x8DoJbQoib/w75P2+4jru9+OwaYLZkbRGMCYA/yA9AJwPChZGaf6kbkI4AV5U1HoDfB7C1G4cJm2kB+mrY9S/mzcsFqCp5ioFdKQfXAcyAMQMyn/SIEBQCoEJE4wBeTdoTcLrs6t3tINoCOEr+lXTGwO+CMVn29Lm8FbXJ2N+2q1/LmpcJ4Ch5BcD6aMIDAu8pu40zvZTAUfJtAN8k5vxqu3pD2kcLgKPkMQAHkoYMHKm4+nAvAMb2TyVH5oE/EvMmbVd/kirR059R+qajf+4BeD4e7ReiWlj5Cov5euxHgLYmG7MpA46SF+JuZ6ZREG8k4NCgELMFuV0IfBv5mbZdPRH7XAS4WrLGAuZ4y1y2XT1qjOaUPLwUEMnFCaLx4Zr/o/G/COAoabr7nfBkYxqteP7lmHIpIFLlnbJdvXMRoKbw0kPIf6KANdvVTXt5qTJRVdJjoGD8rYReXXJxO8xAtWRtYeYwJWD8ZHv6zayOHzQTjrJOALwnXDnRWLnmXwoB5orLdxHRqXCA+dOy1/i43ZYbBKJaXL6XiT5fKDPvrniN0yGAU7L2g3nSfBeMd4c9fTZvz/cL4RStCRD/EPomOmDX/OMtAGDaZnu+2Y65Tz8QjpI7AEy1AKRKsK/sNb7oBNBPYzpFeRSEgy0lSDYhM39W8RofdgPQK4Sj5PcAtrU0oVE5zz6Wd6KgbW+uQRvTUfIagLXGz/1l+kWjnhIHkfVlrHbS53U32ejUE9Wi3MmEqLnppO36C9sxdr4guaKzAGg6r7sB6FSOOSV/I+ANYxcQjcWSre1lBGCH7erz3QaP7bIyIcDXGPR1ZJN9GZnB1HmNIWDd666eHRQCwAMAz4TnTN51bAzSOpCCoUK5/vDGEkCYerfow3aSrEkPBgHeGqnr73qBmCtam4nYSLJY1GTurjxRmtSFJnZXMjsK/BGAzQngTD3YtAuyVpelDwmoM+gicTDDEHUBXsXg9QxaB0IFQCnlq0UHJsf/3y8mSdJIsr0Xq6acfpgSRGdiydWpbzpmIO3AqKdHZG3Mejldwf4vRuV0CtpTCXpx1o/tEw2U1DA8G/h7AAAAAElFTkSuQmCC"

/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/img-wmdcp.37de5f8.png";

/***/ }),
/* 457 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAMAAADVRocKAAAANlBMVEVHcExFpPvc7/9FpfpFpPtEpPxEpPtEpPpFpftruf5Fpfvo9f/n9P9FpPpst/xQqvuSyv273v5HRV0VAAAADHRSTlMAnvnW7lcxwoYRtnztlcZEAAACKklEQVRo3u2a0ZKDIAxFQQEBrcD//+xaURps0U0N3c6seap1JgduaBIyZexuRnLbkZjl0rAn0+JGaEJv3JvuRmxdvgly/xMh0+dWwYBKZtG/pQlyu8ThIZKM7hUjMhURMn3B52cy/xNhdsjTs503wAht3oLNz1BHCdh4/AxgHAis6SsDhqGvDWhqA4Z/A/AOk9ecxwI8NnV6JMBhAe7bANUlqh7k64d2AS7AVQ8+kOx43jrSp2uVN7v0AKa0VqyiRK86SdIgHwNOHtML8OcA2XUajhOoAWq5FScINQDc6yOkIiBe+akBps0JFU6R5O0B4HyqUHYPcDrZGTjgok/XmfupshEDFM/fSVqJpN2+M5RBDiOcDIpl6EJ2TOGyWmnUOpeiATTQfSfX3kIQpQqozc3Ggi/W5uU8YHKfli+4goM1SQDwYPVOpzpgZtzpdJ1JPx2nzThWngRk7sewKZlKqnMFJ4vs7J60JmfufUNd9HPpm0JXocV90o9JFUtWCFB6X2xbdKlk+oO8Fp6kfw0Q8aTi0rWDC9i63wDeKjgPAJQeAKLu+4AjiYax4H7oV933AYdBHkIoDX5FyhB7gHfNJKe0AO+WnbEagN7oFJsagFV2Rw1YZUmykwKALKwGAMpSBQBlqQJgXwawtQGxGw71ALKQ2skAZkmd4+8soAEMdR1wk5hYQDOibhsjGtDjCB4NmAiYK01ZoqYEwPxxY+nOS37KL5B2AS4A/PwD3g9br30qKywAAAAASUVORK5CYII="

/***/ }),
/* 458 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/img-yftd.252ca3f.png";

/***/ }),
/* 460 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAMAAADVRocKAAAAS1BMVEVHcEz/6sX/sST/sSX/syr/tTL/siX/sCb/siT/sSX/8tn/89n/8dj/sSX/yGb///7/tjL/z3j/79L/4Kf/vUj/9+f/6L//147/tC1Vq2jPAAAADHRSTlMA9rXy3xh2okmWymx4O0uZAAAC20lEQVRo3u2ax5KDMAxAGSAEEjBuGP//ly7FRS4pgNndA7rR9Kxqz4gsW6SumnsSaao6C6Uuu4RSBoh7l1jurv6m604l1N0JAr20+r/I0wQ5L9Y4+AbktyyR3HLPhGpZfzL9E2GxoXJDnGcJZTGhcXP0nhLgafxlwPNB26OCXgNujzaBvAEk0b8AcBkDPNtkgA49I4BHSsAjAlDxpQRjYmI9XX1qPOBtC6ARgHqBzHdIC68+CQkB7WvAsmLcwquPNvwvwOkuShPkN4A0aXoBLsAF+NtKvtr11a6vQrsAF+Bq11e7vtr1/wCoGJ4HELLrpDgR0ApCRHsmYJVkAMEIQYgQJk4AUIZAlWDE0gIiNQhqbl8lOw9kWNTSvrG3F+kH48sOwtkHwPtuuj4QCGpEU5Q5uIHoUQDD1mei7/thGOaAG59xccxFo/VGP6s3YTF+k+xIkDUTu+pXhLZi3J+mWj8ZfPVOdKq9AKKdoJfPEJeS08EY4RK2AtTnnM765xUv6SPpetXCFKj3AJjSP7unp0bZ2MNwCEjYBlCfcu1+rWrhWRvU7fK2GcDB+u111/V9lJBvBawBwEY/0+mrLLBJxaR20hYAXdclzFpNwxgVgHprKbcBmFU2tNBDaxZN+rl3uJhM2AJYSgADZ9uGLcehH0YpfXObnYDBB2iOn3DNDhcRmy082AtCF4Ex14YgD60bZLMThEEGg7otaerUtRUWpikYNW4ptCHqIx4pNDAsRW+E+a3C7TpqgxCRVvHtuHeETpGGwOC5iLn6i3rLQBwH7Vop43AjjrTrb0fiPNhwdN9ZNxx7qvM2nG9/GhgjW2a0oaNQv/3tofwUZIeAWVgpZtOv4pPU74al9tgyUle9DnlRH5voWp9OJ2pqTtqmNZWHJ+xqcq/s4NPJERZEk2Is7SWGfPdnyE4jmiKWbUWV8P+DKkjvskr4f8PiqDtglE2dnSC3qYYmqer42n8AR/ln12hm+HYAAAAASUVORK5CYII="

/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/img-ywfw.d6b1d5b.png";

/***/ }),
/* 462 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAMAAADVRocKAAAAY1BMVEVHcEz/kUT/kEX/kET/5NH/kET/kT3/kkP/kEX/kUX/kEX/5tT/5tb/kEX/lUD/6Nf/kkn/59X/kEb/6Nf/59b/6Nf/nl3/kEX/5tX/////lk//uIj/o2X/2b7/y6j/sHv/+PQBGXrvAAAAF3RSTlMAdOxa+5QLJfiryNzE4xg/B1pXI4Vty4BomqUAAAMNSURBVGje7ZrtmqIwDIWdseg4sMN8sGttAb3/q1zGUkklNW3T7p+d/JPn8RyapOG1uNn8RHjsPqvX55djzniudjf5fZVXe45qln8vIz+twei/vR6PJQ32v0rpmxS9FdM3RX63+Xk5bPc7ZitiYtV86bDP0OuI2H7un6ccewkTqxD9tmtqIRPivBbbGc8DuPRRy8QQaiW2+TQlWVL21cjkGO/FbhlaPFuRrj9nyFnAxrTVNou+7F2xazxfr9lFfbH0pXLETJga2/3VsPTl0REzYa7Z/vF8cdD9dHOq10OIwcZvgPfn0C/TpR9iDWCKWrS3tTvAzpEpgkXuMP3+fkT2IqrIsE0bb+e5DlFtCjcaUgKNjXkds9HgqFivfZgl1SgvFzmq+eMQMSrgsBO+BOnL6XSaHMT5cZKwYQfHde1ZwHmSPznzeAgf1/AZ0eAVUNP9X9x79FXBpvQJf8p1eIbGRd96ehtJI8/f5Tn9ZxwE0tfS5me5R+V95PQIQWDYovSyMy9gAVKYa9e7VaFsioKXvhnADNlrvi3iYVMMHRUwkJiBYrJpTgMyRZKXIqrIHoPgIt/hJMSWxwahbbrCyQW84g10GJv+FokG2KhYsyljBSFsyqlBCJs6aBdrEMCmLjrGGtBseoeOsQY0mzaSZUCy6YfkGZBsWmcx8LNpKwsYwBR1skCKYJEbrgHFpjXXgGJTwTWIZtMcowIOO3aKKDZlF5liU3abUmzK3mgUmx7u2TTPQ784tpQHr/+DTYVWSotybGqOK64HFWw2xcDL/kCefi4XYdMRJo7NpmuyA8lWxzOXTRGywyKZTTGyCzeg2RQlu7m+oyINaDZFyc52KDxaS2RTnOy+j0OuK7OHLelsipPdvOuc86k0Nm3xL3xvr1uW1aOzCopNO3TbuCeZphA6jU3Xh4K3EQePOZXSieemye8NQtlUcA0oNmUbJJyb8l9QwFHRcA0oNu24BhSbtjJPjrxsyi8CwabeNyDhQbDptuZ2ajCb5n2nX/qFdflX7uX/NFD+bw//4I8bP+GLv2Kvg1KgyH/IAAAAAElFTkSuQmCC"

/***/ }),
/* 463 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 464 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIMAAAAeCAMAAAA4u13JAAAAS1BMVEVHcEz////////////////////////////////////////////////////////////////////////////////////////////////ScsZwAAAAGHRSTlMAHFLV4UUmCvgvOaMS7ANvYH7Ai8uWrrYzrCGFAAAEh0lEQVRIx8VX13IjOQxkznEi/v9LtzlBlmy56q5q18aDNOZQZANoNGDGYHx1q7atcXZZas3q6ObHwj+3shApU4lyOBd0JqpGES0/BcFy3KbZTADhx4IHBJqZGMjsj0BoKvi9ssDjsvVWxkqPSzSB1d1r1X4AArxFBsKkBg3KlZyEjzwhKIFI/HsMy7jFZJLMy80GxB4fm/RMUjasEV682v/hqanwbzjWV/ORe/hm+xnfuY+3O7lQwMeJbaQ7yZQkdU3bAFdLcHh6Me/W78n9aauYSE4q8zU6UtmdMLhUHL7l9EgCsyIIwaUTLLQCclbgkaV5JpzkAi8/sXKi7zDwGF8XJA1Tix9fTskTg13A9yIJgeAZj6dtittk6wgZ0boSdTxWy1Ew2xv6VKGD50zHfVG5PrlNdJRVuhdqnMgtudpFOpLy3Fq43nwIfRaiLeTwjZRZpkha1pzGjrDN8z7CI1xjVpJiybxgqHTaxN358BSmSDvcjPkGkc44tCMgLvcjChN9MudZ3RAcZGWnjGAAE+7EQwYPUBSL3V+Ls6xwjqSKhlwT+gUDYOlB8ju+aZoy7dsmlsXhO46tODMrJeUyTViJI+oe0rQg8xZOuBRvnYzJUUQcnPg48YGiHfLJiQD2xrCKwcd5vNE46Mrx5ekdu7EV0EcrEIGfBA6UDwp0nljjXdtbq4MquvOGPPSTHC+2H0vH9TcGT8721ac81GS6YdcYd1K11b46WrYjqfhFAsxhWUKBOnxFrVG1rIxsGTLMx4gPggh0VViq5F740JpGuR7Uc9h0Y5hxkkQiutRHIC4NCS+JP53RvjC/TeqgEwokjMOCKDHxoVSBvEV1KouHUQCcxyLCSwwUXXU2QdbMjaFk3D/+LuUs3ysQJiskfovbtu+KJv2qHgqM+vgzKyxUOCDMuII3cBRy5ZX6nAfU41UPaKvhxiBIlQc14NoVCD7HbUL93oFYP0HIT/5ZR1ljVvAURxxkiYgDn9HB3Zu2CZ+51wLVpG8MGxw3g1y3jslwCcYZsz2uXdH8nFWQXg6gyet0C1plq7HZebOuxrts/TqkQH2FACKX1I6IiwsDzjMI4kdjuXqfDWHap2mR0Gka48EThEZujrv8WAfzdMqLXUkNTilarcxJg61fMYDISY3fbVDbE4NfUJJtCNQX+X6i5H7E1NY5XoQ8LS8XNn1wsKO2SA1Wpj446vWbriDxAlgTBEUtclTaOHlg+9JHTDS1QsiENzwFfk4F19WAgWklvM5IbUxu4twgRtN8P7zwoUAQ8W38ALaVh1DnUQLr3P29d6NtkCaMprKROtfjXA+Bmt5ccPawQ9qgGivl93NCRZMfojJZFLUO5tGu9SO+4sEcMoBRoe1HveWnsIa0fhHgY6wsF5X96G7fDJLTyRFfvs4rQYtWa3/QfwhXf+R9mp4uLY7cO/48SHTIfflu9Iv/fY7S2AoKosWj+DEoPV0zVGb+bvi6Mfzt2f1zWG34dlg+cmHYr9rR0fTvYjg4VH/t+mJEXxcJW9YuTPkFCEZr//E/jhfC25+6+g8JGVV+z0A4NgAAAABJRU5ErkJggg=="

/***/ }),
/* 465 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 466 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 467 */,
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(376)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(255),
  /* template */
  __webpack_require__(537),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5bcb629f",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(385)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(256),
  /* template */
  __webpack_require__(544),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-878b78c4",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(352)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(257),
  /* template */
  __webpack_require__(514),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0b6cd286",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(353)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(258),
  /* template */
  __webpack_require__(515),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0c9f1e77",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(347)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(259),
  /* template */
  __webpack_require__(510),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-06204e54",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(368)
  __webpack_require__(369)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(260),
  /* template */
  __webpack_require__(530),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-45dea983",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(358)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(261),
  /* template */
  __webpack_require__(519),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1e223cc8",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(373)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(262),
  /* template */
  __webpack_require__(534),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5793fa4c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(348)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(263),
  /* template */
  __webpack_require__(511),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-06c79be7",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(351)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(264),
  /* template */
  __webpack_require__(513),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0ac1fce6",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(359)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(265),
  /* template */
  __webpack_require__(520),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-20adb2a6",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(379)
  __webpack_require__(381)
  __webpack_require__(380)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(266),
  /* template */
  __webpack_require__(540),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5f218204",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(391)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(267),
  /* template */
  __webpack_require__(550),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-cca3e736",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(361)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(268),
  /* template */
  __webpack_require__(523),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-22f4a4e0",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(384)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(269),
  /* template */
  __webpack_require__(543),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-75c46892",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(389)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(270),
  /* template */
  __webpack_require__(548),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-bb5a5c1e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(392)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(271),
  /* template */
  __webpack_require__(551),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-e9789ca6",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(387)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(272),
  /* template */
  __webpack_require__(546),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-934efe58",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(360)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(273),
  /* template */
  __webpack_require__(521),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-20b363f6",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(383)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(274),
  /* template */
  __webpack_require__(542),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-70daac50",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(350)
  __webpack_require__(349)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(275),
  /* template */
  __webpack_require__(512),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0a08456b",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(357)
  __webpack_require__(356)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(276),
  /* template */
  __webpack_require__(518),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1c39feee",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(393)
}
var Component = __webpack_require__(0)(
  /* script */
  null,
  /* template */
  __webpack_require__(552),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-f5c1ffd4",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(370)
}
var Component = __webpack_require__(0)(
  /* script */
  null,
  /* template */
  __webpack_require__(531),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-45e73fcc",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(371)
}
var Component = __webpack_require__(0)(
  /* script */
  null,
  /* template */
  __webpack_require__(532),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-530d1356",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(390)
}
var Component = __webpack_require__(0)(
  /* script */
  null,
  /* template */
  __webpack_require__(549),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-bb607184",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(378)
}
var Component = __webpack_require__(0)(
  /* script */
  null,
  /* template */
  __webpack_require__(539),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5ddb0986",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(377)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(277),
  /* template */
  __webpack_require__(538),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5d9dd09c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(388)
}
var Component = __webpack_require__(0)(
  /* script */
  null,
  /* template */
  __webpack_require__(547),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-ba59fd02",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(386)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(278),
  /* template */
  __webpack_require__(545),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-90b6507a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(363)
}
var Component = __webpack_require__(0)(
  /* script */
  null,
  /* template */
  __webpack_require__(525),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2abd3356",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(366)
}
var Component = __webpack_require__(0)(
  /* script */
  null,
  /* template */
  __webpack_require__(528),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3da0090c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(375)
}
var Component = __webpack_require__(0)(
  /* script */
  null,
  /* template */
  __webpack_require__(536),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5ad0d034",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(372)
}
var Component = __webpack_require__(0)(
  /* script */
  null,
  /* template */
  __webpack_require__(533),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-563201c9",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(367)
}
var Component = __webpack_require__(0)(
  /* script */
  null,
  /* template */
  __webpack_require__(529),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3e35b168",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(354)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(279),
  /* template */
  __webpack_require__(516),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-18d87b2b",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(364)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(280),
  /* template */
  __webpack_require__(526),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2d00a8a8",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(374)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(281),
  /* template */
  __webpack_require__(535),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5a6b0b81",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(382)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(282),
  /* template */
  __webpack_require__(541),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-666b1304",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(362)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(283),
  /* template */
  __webpack_require__(524),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-258bb924",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(355)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(284),
  /* template */
  __webpack_require__(517),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1a82d9a4",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(365)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(285),
  /* template */
  __webpack_require__(527),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-323d5020",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "footer-top clearfix"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "footer-middle fl"
  }, [_c('a', {
    attrs: {
      "href": "http://www.zhixinhuixue.com"
    }
  }, [_vm._m(1), _vm._v(" "), _c('p', {
    staticClass: "website"
  }, [_vm._v("www.zhixinhuixue.com")]), _vm._v(" "), _c('a', {
    staticClass: "block",
    attrs: {
      "href": (_vm.baseUrl + "agreement.html"),
      "target": "_blank"
    }
  }, [_vm._v("软件使用协议")]), _vm._v(" "), _c('a', {
    staticClass: "block",
    attrs: {
      "href": (_vm.baseUrl + "version.html"),
      "target": "_blank"
    }
  }, [_vm._v("版权声明")])])]), _vm._v(" "), _vm._m(2)]), _vm._v(" "), _c('div', {
    staticClass: "footer-bottom"
  }, [_c('div', {
    staticClass: "company clearfix"
  }, [_c('span', {
    staticClass: "fl"
  }, [_vm._v("©" + _vm._s(_vm.getYear) + " 江西风向标智能科技有限公司 All Rights Reserved")]), _vm._v(" "), _c('a', {
    staticClass: "lg-c fr",
    attrs: {
      "href": "http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=36010602000036",
      "target": "_blank"
    }
  }, [_vm._v("赣公网安备36010602000036号")]), _vm._v(" "), _c('a', {
    staticClass: "fr",
    staticStyle: {
      "margin-right": "30px"
    },
    attrs: {
      "href": "http://beian.miit.gov.cn/",
      "target": "_blank"
    }
  }, [_vm._v("赣ICP备17000955号-3 ")]), _vm._v(" "), _c('router-link', {
    staticClass: "fr",
    staticStyle: {
      "margin-right": "30px"
    },
    attrs: {
      "to": "/licence"
    }
  }, [_vm._v("增值电信业务经营许可证：赣B2-20200065")])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer-left fl"
  }, [_c('img', {
    staticClass: "footer-logo",
    attrs: {
      "src": __webpack_require__(465),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "text"
  }, [_c('span', {
    staticClass: "highlight-border"
  }, [_vm._v("公司")]), _vm._v("官网\n          ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer-right fl"
  }, [_c('p', [_c('span', {
    staticClass: "highlight-border"
  }, [_vm._v("友情")]), _vm._v("链接：")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "http://www.fxbjy.com/index"
    }
  }, [_vm._v("江西风向标智能科技有限公司")])])
}]}

/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "index"
    }
  }, [_c('Headers'), _vm._v(" "), _c('router-view'), _vm._v(" "), _c('Footers'), _vm._v(" "), _c('div', {
    staticClass: "to-top",
    on: {
      "click": _vm.backTop
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(410),
      "alt": ""
    }
  })])], 1)
},staticRenderFns: []}

/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sign-up-list-phone"
  }, [_c('div', {
    staticClass: "top"
  }, [_c('img', {
    staticClass: "img-sing-up-top-phone",
    attrs: {
      "src": __webpack_require__(452),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "btn-add-sign-up-top",
    class: {
      'android': _vm.isAndroids
    }
  }, [_vm._v("我要报名")])]), _vm._v(" "), _c('div', {
    staticClass: "main",
    class: {
      'android': _vm.isAndroids
    }
  }, [_c('div', {
    staticClass: "content"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('span', {
    staticClass: "btn-sing-up",
    on: {
      "click": function($event) {
        _vm.isStop = true
      }
    }
  }, [_vm._v("我要报名"), (_vm.isStop) ? _c('img', {
    staticClass: "img-stop",
    attrs: {
      "src": __webpack_require__(455),
      "alt": ""
    }
  }) : _vm._e()])])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "填写报名资料",
      "visible": _vm.signUpData,
      "width": "90%"
    },
    on: {
      "update:visible": function($event) {
        _vm.signUpData = $event
      }
    }
  }, [_c('div', {
    staticClass: "sign-up-data"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('span', {
    staticClass: "left"
  }, [_vm._v("学校\n            "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])]), _vm._v(" "), _c('el-input', {
    attrs: {
      "placeholder": "请输入内容"
    },
    model: {
      value: (_vm.school_name),
      callback: function($$v) {
        _vm.school_name = $$v
      },
      expression: "school_name"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('span', {
    staticClass: "left"
  }, [_vm._v("姓名\n            "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])]), _vm._v(" "), _c('el-input', {
    attrs: {
      "placeholder": "请输入内容"
    },
    model: {
      value: (_vm.userName),
      callback: function($$v) {
        _vm.userName = $$v
      },
      expression: "userName"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('span', {
    staticClass: "left"
  }, [_vm._v("手机\n            "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])]), _c('el-input', {
    attrs: {
      "placeholder": "请输入内容",
      "minlength": "6",
      "maxlength": "11"
    },
    model: {
      value: (_vm.mobile),
      callback: function($$v) {
        _vm.mobile = $$v
      },
      expression: "mobile"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('span', {
    staticClass: "left",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("考试科目\n          "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])]), _vm._v(" "), _c('span', {
    staticClass: "subject-box subject-checkbox-box"
  }, [_c('el-checkbox-group', {
    model: {
      value: (_vm.subject),
      callback: function($$v) {
        _vm.subject = $$v
      },
      expression: "subject"
    }
  }, [_c('el-checkbox', {
    attrs: {
      "label": "语文"
    }
  }), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "数学(文)"
    }
  }), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "数学(理)"
    }
  }), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "英语"
    }
  }), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "文科综合"
    }
  }), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "理科综合"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', [_c('p', {
    staticClass: "red"
  }, [_vm._v("注：不参加联考的科目请自行取消勾选")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('span', {
    staticClass: "btn-add-sing-up",
    on: {
      "click": _vm.save
    }
  }, [_vm._v("提交")])])])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "提交成功",
      "visible": _vm.signUpSuccess,
      "width": "760px"
    },
    on: {
      "update:visible": function($event) {
        _vm.signUpSuccess = $event
      }
    }
  }, [_c('div', {
    staticClass: "sign-up-success"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(153),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "msg-box"
  }, [_c('p', {
    staticClass: "big-msg"
  }, [_vm._v("恭喜你！提交成功")]), _vm._v(" "), _c('p', {
    staticClass: "msg"
  }, [_vm._v("我们的工作人员将会及时联系您，并妥善保管您的相关信息！")])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('img', {
    staticClass: "img-yaoqinghan",
    attrs: {
      "src": __webpack_require__(156),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text"
  }, [_c('p', {
    staticStyle: {
      "text-indent": "0"
    }
  }, [_vm._v("全国各高中学校：")]), _vm._v(" "), _c('p', [_vm._v("为帮助各高中学校检验本校高三复习效果，帮助学生找到复习中存在的问题，满足全国师生在备考时各项需求，\n          达到错因精准定位，排名精准评估，成绩精准提升的目的，风向标教育联合全国千余所高级中学，开展本次"), _c('span', {
    staticClass: "red"
  }, [_vm._v("全学科、高保真")]), _vm._v("的高三联合质量评估考试。")]), _vm._v(" "), _c('p', [_vm._v("通过本次联合质量评估，学校可以清晰掌握本校复习各项指标，梳理各班、各层次学生的复习情况，为接下来的复习定标准、找方向。利用风向标智能精准教学系统，为每一所学校提供专项报告、每一名教师提供专属教案，每一位学生提供个性化提升方案。\n          为了实现教师精准备考、学生个性化复习，风向标教育联合高考命题专家，举办线上联合评估质量分析会议，进一步明确复习亮点和不足，打造行之有效的精准复习备考策略。")]), _vm._v(" "), _c('p', {
    staticClass: "text-title"
  }, [_vm._v("一、报名方式")]), _vm._v(" "), _c('p', [_vm._v("知心慧学项目学校通过学管登录学管端进行考试报名；（学校告知在校学管报名）")]), _vm._v(" "), _c('p', [_vm._v("其他学校可以通过知心慧学官网提交报名信息，或者通过业务经理进行报名。")]), _vm._v(" "), _c('p', [_vm._v("采用邮箱报名：zhao@fxbjy.com")]), _vm._v(" "), _c('p', {
    staticClass: "text-title"
  }, [_vm._v("二、组织考试")]), _vm._v(" "), _c('p', [_vm._v("考试时间：2019年12月19日-20日（具体科目时间安排见下表）")]), _vm._v(" "), _c('table', {
    staticClass: "table-sing-up",
    attrs: {
      "border": "1"
    }
  }, [_c('tr', {
    staticClass: "table-head"
  }, [_c('td', {
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v("考试时间安排")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "width": "0.34rem"
    }
  }, [_vm._v("适用范围")]), _vm._v(" "), _c('td', [_vm._v("时间")]), _vm._v(" "), _c('td', [_vm._v("上午")]), _vm._v(" "), _c('td', [_vm._v("下午")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("全国")]), _vm._v(" "), _c('td', [_vm._v("12月19日")]), _vm._v(" "), _c('td', [_vm._v("语文  "), _c('br'), _vm._v("09:00-11:30")]), _vm._v(" "), _c('td', [_vm._v("数学（文理）"), _c('br'), _vm._v("  15:00-17:00")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("全国")]), _vm._v(" "), _c('td', [_vm._v("12月20日")]), _vm._v(" "), _c('td', [_vm._v("文科综合"), _c('br'), _vm._v("理科综合 "), _c('br'), _vm._v(" 09:00-11:30")]), _vm._v(" "), _c('td', [_vm._v("英语 "), _c('br'), _vm._v(" 15:00-17:00")])])]), _vm._v(" "), _c('p', [_vm._v("为保证本次联合质量评估的公平、公正，参评学校名称在系统内均以"), _c('span', {
    staticClass: "red"
  }, [_vm._v("特定代码的方式")]), _vm._v("呈现。系统"), _c('span', {
    staticClass: "red"
  }, [_vm._v("提前2小时")]), _vm._v("发布试卷，由学管（或学校相关人员）按时下载并打印试卷、答题卡。")]), _vm._v(" "), _c('p', [_vm._v("考试结束后学管（或学校相关人员）扫描答题卡。")]), _vm._v(" "), _c('p', [_vm._v("参考学校的老师，在12月21日12点前完成所有线上阅卷（阅卷规则和时间"), _c('span', {
    staticClass: "red"
  }, [_vm._v("详见附件1")]), _vm._v("）。")]), _vm._v(" "), _c('p', {
    staticClass: "text-title"
  }, [_vm._v("三、成绩报告")]), _vm._v(" "), _c('p', [_vm._v("2019年12月23日-24日，老师可以登录风向标智能精准教学系统（知心慧学）在线查看本校成绩报告，也可以在线查看本省整体综合报告。")]), _vm._v(" "), _c('p', {
    staticClass: "text-title"
  }, [_vm._v("四、联合质量分析会议")]), _vm._v(" "), _c('p', [_vm._v("2019年12月26日及27日举办线上质量分析会议，帮助学校进一步精准找到原因，明确本次联评存在的问题，结合今年高考预测，共同打造高效的二轮精准备考方案。（具体科目时间安排见下表）")]), _vm._v(" "), _c('table', {
    staticClass: "table-sing-up",
    attrs: {
      "border": "1"
    }
  }, [_c('tr', {
    staticClass: "table-head"
  }, [_c('td', {
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v("线上质量分析会议时间安排")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "width": "0.34rem"
    }
  }, [_vm._v("适用范围")]), _vm._v(" "), _c('td', [_vm._v("时间")]), _vm._v(" "), _c('td', [_vm._v("上午")]), _vm._v(" "), _c('td', [_vm._v("下午")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("全国")]), _vm._v(" "), _c('td', [_vm._v("12月26日")]), _vm._v(" "), _c('td', [_vm._v("语文  "), _c('br'), _vm._v("09:00-11:30")]), _vm._v(" "), _c('td', [_vm._v("数学（文理）"), _c('br'), _vm._v("  15:00-17:00")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("全国")]), _vm._v(" "), _c('td', [_vm._v("12月27日")]), _vm._v(" "), _c('td', [_vm._v("文科综合 "), _c('br'), _vm._v("理科综合 "), _c('br'), _vm._v(" 09:00-11:30")]), _vm._v(" "), _c('td', [_vm._v("英语  "), _c('br'), _vm._v(" 15:00-17:00")])])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0"
    }
  }, [_vm._v("阅卷规则详见"), _c('span', {
    staticClass: "red"
  }, [_vm._v("附件1")]), _vm._v("。")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0"
    }
  }, [_vm._v("考试的各科考察范围及命卷细目详情见"), _c('span', {
    staticClass: "red"
  }, [_vm._v("附件2")]), _vm._v("。")]), _vm._v(" "), _c('p', [_vm._v("诚挚邀请！")]), _vm._v(" "), _c('div', {
    staticClass: "corporate-name"
  }, [_c('img', {
    staticClass: "seal",
    attrs: {
      "src": __webpack_require__(154),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "name"
  }, [_c('p', [_vm._v("江西风向标教育科技有限公司")]), _vm._v(" "), _c('p', [_vm._v("2019年12月3日")])])]), _vm._v(" "), _c('div', {
    staticClass: "down"
  }, [_c('p', [_vm._v("附件1:\n            "), _c('a', {
    attrs: {
      "href": "/static/lk-yj.PNG",
      "target": "_blank"
    }
  }, [_vm._v("教师线上阅卷规则说明(点击预览)")])]), _vm._v(" "), _c('p', [_vm._v("附件2:\n            "), _c('a', {
    attrs: {
      "href": "/static/lk-km.PNG",
      "target": "_blank"
    }
  }, [_vm._v("命卷细目表及各科考试安排(点击预览)")])])])])
}]}

/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "init-login-wrapper"
  }, [_c('div', {
    staticClass: "init-login-content"
  }, [_vm._m(0), _vm._v(" "), _c('h2', {
    staticClass: "init-login-title"
  }, [_vm._v("修改初始密码")]), _vm._v(" "), _c('p', {
    staticClass: "init-login-mess"
  }, [_vm._v("\n      为保障您的账户及内部数据安全，防止信息泄露，您需要修改初始密码后才可登录\n    ")]), _vm._v(" "), _c('el-form', {
    ref: "ruleForm",
    attrs: {
      "model": _vm.ruleForm,
      "rules": _vm.rules
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "setPassWord"
    }
  }, [_c('el-input', {
    staticClass: "init-login-input",
    attrs: {
      "maxlength": "16",
      "minlength": "6",
      "placeholder": "设置新密码，6-16位的字母或数字组合"
    },
    model: {
      value: (_vm.ruleForm.setPassWord),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "setPassWord", $$v)
      },
      expression: "ruleForm.setPassWord"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "surePassWord"
    }
  }, [_c('el-input', {
    staticClass: "init-login-input",
    attrs: {
      "maxlength": "16",
      "minlength": "6",
      "type": "password",
      "placeholder": "验证新密码"
    },
    model: {
      value: (_vm.ruleForm.surePassWord),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "surePassWord", $$v)
      },
      expression: "ruleForm.surePassWord"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "sure-login"
  }, [_c('el-button', {
    attrs: {
      "disabled": _vm.disabled
    },
    on: {
      "click": _vm.initSubmit
    }
  }, [_vm._v("确定并登录")])], 1)], 1), _vm._v(" "), (+_vm.needForce === 0) ? _c('p', {
    staticClass: "next-change",
    on: {
      "click": _vm.onNext
    }
  }, [_vm._v("下次再改")]) : _vm._e()], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "init-login-logo"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(139),
      "alt": ""
    }
  })])
}]}

/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app-download"
  }, [(_vm.weChat) ? _c('img', {
    staticClass: "open",
    attrs: {
      "src": __webpack_require__(80),
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('img', {
    staticClass: "open",
    attrs: {
      "src": __webpack_require__(79),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "app-list"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(140)
    },
    on: {
      "click": function($event) {
        return _vm.toApp(0)
      }
    }
  })])])
},staticRenderFns: []}

/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app-download"
  }, [(_vm.weChat) ? _c('img', {
    staticClass: "open",
    attrs: {
      "src": __webpack_require__(80),
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('img', {
    staticClass: "open",
    attrs: {
      "src": __webpack_require__(79),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "app-list"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(141)
    },
    on: {
      "click": function($event) {
        return _vm.toApp(0)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "btn-open-app",
    on: {
      "click": _vm.openApp
    }
  }, [_vm._v("打开教师端")])])])
},staticRenderFns: []}

/***/ }),
/* 516 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-con"
  }, [_c('h2', {
    staticClass: "tac"
  }, [_vm._v("法律声明及隐私权政策")]), _vm._v(" "), _c('div', {
    staticClass: "tar"
  }, [_vm._v("最近更新日期：2018年10月25日")]), _vm._v(" "), _c('div', {
    staticClass: "warns"
  }, [_vm._v("提示条款")]), _vm._v("\n      \n    您的信任对我们非常重要，我们深知个人信息对您的重要性，我们将按法律法规要求，采取相应安全保护措施，尽力保护您的个人信息安全可控。鉴此，慧学宝服务提供者（或简称“我们”）制定本《法律声明及隐私权政策》（下称“本政策 /本隐私权政策”）并提醒您：\n  "), _c('br'), _vm._v("\n      本政策适用于慧学宝产品或服务。需要特别说明的是，"), _c('span', {
    staticClass: "tbunderline"
  }, [_vm._v("本政策不适用于其他第三方向您提供的服务，也不适用于慧学宝中已另行独立设置法律声明及隐私权政策的产品或服务。")]), _c('br'), _vm._v("\n      "), _c('span', {
    staticClass: "tbunderline"
  }, [_vm._v("在使用慧学宝各项产品或服务前，请您务必仔细阅读并透彻理解本政策，在确认充分理解并同意后使用相关产品或服务。一旦您开始使用慧学宝各项产品或服务，即表示您已充分理解并同意本政策。")]), _c('br'), _vm._v(" "), _c('div', [_vm._v("第一部分 定义")]), _vm._v("\n      慧学宝：指慧学宝客户端。"), _c('br'), _vm._v("\n      慧学宝服务提供者：上海互教教育科技有限公司"), _c('br'), _vm._v(" "), _c('div', [_vm._v("第二部分 隐私权政策")]), _vm._v("\n      本隐私权政策部分将帮助您了解以下内容："), _c('br'), _vm._v("\n      1、我们如何收集和使用您的个人信息 "), _c('br'), _vm._v("\n      2、我们如何使用 Cookie 和同类技术"), _c('br'), _vm._v("\n      3、我们如何共享、转让、公开披露您的个人信息"), _c('br'), _vm._v("\n      4、我们如何保护您的个人信息"), _c('br'), _vm._v("\n      5、您如何管理您的个人信息"), _c('br'), _vm._v("\n      6、我们如何处理未成年人的个人信息"), _c('br'), _vm._v("\n      7、本隐私权政策如何更新"), _c('br'), _vm._v("\n      8、如何联系我们"), _c('br'), _vm._v("\n      一、我们如何收集和使用您的信息"), _c('br'), _vm._v("\n      我们会出于本政策所述的以下目的，收集和使用您的个人信息："), _c('br'), _vm._v("\n      （一）帮助您成为我们的用户"), _c('br'), _vm._v("\n      为成为我们的用户，以便我们为您提供用户服务，为您提供账户和密码，根据您对学生试卷的批改情况，我们会统计学生的正确率，学生答题的易错点等。"), _c('br'), _vm._v("\n      （二）征得授权同意的例外"), _c('br'), _vm._v("\n      根据相关法律法规规定，以下情形中收集您的个人信息无需征得您的授权同意："), _c('br'), _vm._v("\n      1、与国家安全、国防安全有关的；"), _c('br'), _vm._v("\n      2、与公共安全、公共卫生、重大公共利益有关的；"), _c('br'), _vm._v("\n      3、与犯罪侦查、起诉、审判和判决执行等有关的；"), _c('br'), _vm._v("\n      4、出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到您本人同意的；"), _c('br'), _vm._v("\n      5、所收集的个人信息是您自行向社会公众公开的；"), _c('br'), _vm._v("\n      6、从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道；"), _c('br'), _vm._v("\n      7、根据您的要求签订合同所必需的；"), _c('br'), _vm._v("\n      8、用于维护所提供的产品或服务的安全稳定运行所必需的，例如发现、处置产品或服务的故障；"), _c('br'), _vm._v("\n      9、为合法的新闻报道所必需的；"), _c('br'), _vm._v("\n      10、学术研究机构基于公共利益开展统计或学术研究所必要，且对外提供学术研究或描述的结果时，对结果中所包含的个人信息进行去标识化处理的；"), _c('br'), _vm._v("\n      11、法律法规规定的其他情形。"), _c('br'), _vm._v("\n      如我们停止运营慧学宝产品或服务，我们将及时停止继续收集您个人信息的活动，将停止运营的通知以逐一送达或公告的形式通知您，对所持有的个人信息进行删除或匿名化处理。"), _c('br'), _vm._v("\n      二、我们如何使用 Cookie 和同类技术"), _c('br'), _vm._v("\n      （一）Cookie"), _c('br'), _vm._v("\n      为确保网站正常运转、为您获得更轻松的访问体验、向您推荐您可能感兴趣的内容，我们会在您的计算机或移动设备上存储名为 Cookie 的小数据文件。Cookie 通常包含标识符、站点名称以及一些号码和字符。借助于 Cookie，网站能够存储您的偏好或购物篮内的商品等数据。"), _c('br'), _vm._v("\n      您可根据自己的偏好管理或删除 Cookie。有关详情，请参见 AboutCookies.org。您可以清除计算机上保存的所有 Cookie，大部分网络浏览器都设有阻止 Cookie 的功能。但如果您这么做，则需要在每一次访问我们的网站时更改用户设置。如需详细了解如何更改浏览器设置，请访问您使用的浏览器的相关设置页面。"), _c('br'), _vm._v("\n      （二）网站信标和像素标签"), _c('br'), _vm._v("\n      除 Cookie 外，我们还会在网站上使用网站信标和像素标签等其他同类技术。例如，我们向您发送的电子邮件可能含有链接至我们网站内容的地址链接，如果您点击该链接，我们则会跟踪此次点击，帮助我们了解您的产品或服务偏好以便于我们主动改善客户服务体验。网站信标通常是一种嵌入到网站或电子邮件中的透明图像。借助于电子邮件中的像素标签，我们能够获知电子邮件是否被打开。如果您不希望自己的活动以这种方式被追踪，则可以随时从我们的寄信名单中退订。"), _c('br'), _vm._v("\n      三、我们如何共享、转让、公开披露您的个人信息"), _c('br'), _vm._v("\n      （一）共享"), _c('br'), _vm._v("\n      我们不会与慧学宝服务提供者以外的公司、组织和个人共享您的个人信息，但以下情况除外："), _c('br'), _vm._v("\n      1、在获取明确同意的情况下共享：获得您的明确同意后，我们会与其他方共享您的个人信息。"), _c('br'), _vm._v("\n      2、在法定情形下的共享：我们可能会根据法律法规规定、诉讼争议解决需要，或按行政、司法机关依法提出的要求，对外共享您的个人信息。"), _c('br'), _vm._v("\n      3、与第三方服务商共享：当您在慧学宝购买商品或服务时，涉及到第三方服务，我们会与对应第三方签署相关协议以保证您的个人信息。"), _c('br'), _vm._v("\n      （二）转让"), _c('br'), _vm._v("\n      我们不会将您的个人信息转让给任何公司、组织和个人，但以下情况除外："), _c('br'), _vm._v("\n      1、在获取明确同意的情况下转让：获得您的明确同意后，我们会向其他方转让您的个人信息；"), _c('br'), _vm._v("\n      2、在慧学宝服务提供者发生合并、收购或破产清算情形，或其他涉及合并、收购或破产清算情形时，如涉及到个人信息转让，我们会要求新的持有您个人信息的公司、组织继续受本政策的约束，否则我们将要求该公司、组织和个人重新向您征求授权同意。"), _c('br'), _vm._v("\n      （三）公开披露"), _c('br'), _vm._v("\n      我们仅会在以下情况下，公开披露您的个人信息："), _c('br'), _vm._v("\n      1、获得您明确同意或基于您的主动选择，我们可能会公开披露您的个人信息；"), _c('br'), _vm._v("\n      "), _c('span', {
    staticClass: "tbunderline"
  }, [_vm._v("2、如果我们确定您出现违反法律法规或严重违反慧学宝相关协议规则的情况，或为保护慧学宝用户或公众的人身财产安全免遭侵害，我们可能依据法律法规或慧学宝相关协议规则征得您同意的情况下披露关于您的个人信息，")]), _vm._v("包括相关违规行为以及慧学宝已对您采取的措施。"), _c('br'), _vm._v("\n      （四）共享、转让、公开披露个人信息时事先征得授权同意的例外"), _c('br'), _vm._v("\n      以下情形中，共享、转让、公开披露您的个人信息无需事先征得您的授权同意："), _c('br'), _vm._v("\n      1、与国家安全、国防安全有关的；"), _c('br'), _vm._v("\n      2、与公共安全、公共卫生、重大公共利益有关的；"), _c('br'), _vm._v("\n      3、与犯罪侦查、起诉、审判和判决执行等有关的；"), _c('br'), _vm._v("\n      4、出于维护您或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；"), _c('br'), _vm._v("\n      5、您自行向社会公众公开的个人信息；"), _c('br'), _vm._v("\n      6、从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道。"), _c('br'), _vm._v("\n      根据法律规定，共享、转让经去标识化处理的个人信息，且确保数据接收方无法复原并重新识别个人信息主体的，不属于个人信息的对外共享、转让及公开披露行为，对此类数据的保存及处理将无需另行向您通知并征得您的同意。"), _c('br'), _vm._v("\n      四、我们如何保护您的个人信息安全"), _c('br'), _vm._v("\n      （一）我们已采取符合业界标准、合理可行的安全防护措施保护您提供的个人信息安全，防止个人信息遭到未经授权访问、公开披露、使用、修改、损坏或丢失。例如，在您的浏览器与服务器之间交换数据（如信用卡信息）时受 SSL（Secure Socket Layer）协议加密保护；我们同时对慧学宝网站提供HTTPS（Hyper Text Transfer Protocol over Secure Socket Layer）协议安全浏览方式；我们会使用加密技术提高个人信息的安全性；我们会使用受信赖的保护机制防止个人信息遭到恶意攻击；我们会部署访问控制机制，尽力确保只有授权人员才可访问个人信息；以及我们会举办安全和隐私保护培训课程，加强员工对于保护个人信息重要性的认识。"), _c('br'), _vm._v("\n      （二）我们有行业先进的以数据为核心，围绕数据生命周期进行的数据安全管理体系，从组织建设、制度设计、人员管理、产品技术等方面多维度提升整个系统的安全性。目前，我们的重要信息系统已经通过ISO27001等认证。"), _c('br'), _vm._v("\n      "), _c('span', {
    staticClass: "tbunderline"
  }, [_vm._v("（三）我们只会在达成本政策所述目的所需的期限内或法律要求的期限内保留您的个人信息，除非延长保留期征得您的同意或受到法律的允许。")]), _c('br'), _vm._v("\n      （四）互联网并非绝对安全的环境，请使用复杂密码，协助我们保证您的账号安全。我们将尽力保障您发送给我们的任何信息的安全性。如果我们的物理、技术或管理防护设施遭到破坏，导致信息被非授权访问、公开披露、篡改或毁坏，导致您的合法权益受损，我们将承担相应的法律责任。"), _c('br'), _vm._v("\n      （五）我们将不定期更新并公开安全风险、个人信息安全影响评估报告等有关内容，您可通过慧学宝公告方式获得。"), _c('br'), _vm._v("\n      （六）在不幸发生个人信息安全事件后，我们将按照法律法规的要求向您告知：安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施等。事件相关情况我们将以邮件、信函、电话、推送通知等方式告知您，难以逐一告知个人信息主体时，我们会采取合理、有效的方式发布公告。"), _c('br'), _vm._v("\n      同时，我们还将按照监管部门要求，上报个人信息安全事件的处置情况。"), _c('br'), _vm._v("\n      五、您如何管理您的个人信息"), _c('br'), _vm._v("\n      您可以通过以下方式访问及管理您的个人信息："), _c('br'), _vm._v("\n      （一）访问您的个人信息"), _c('br'), _vm._v("\n      您有权访问您的个人信息，法律法规规定的例外情况除外。您可以通过以下方式自行访问您的个人信息："), _c('br'), _vm._v("\n      账户信息—如果您希望访问或编辑您的账户中的个人基本资料信息、更改您的密码、添加安全信息或关闭您的账户等，您可以通过登录账号通过“账号管理”执行此类操作。"), _c('br'), _vm._v("\n      如果您无法通过上述路径访问该等个人信息，您可以随时通过慧学宝客服与我们取得联系。我们将在15天内回复您的访问请求。"), _c('br'), _vm._v("\n      对于您在使用我们的产品或服务过程中产生的其他个人信息，我们将根据本条“（七）响应您的上述请求”中的相关安排向您提供。"), _c('br'), _vm._v("\n      （二）更正或补充您的个人信息"), _c('br'), _vm._v("\n      当您发现我们处理的关于您的个人信息有错误时，您有权要求我们做出更正或补充。您可以通过“（一）访问您的个人信息”中列明的方式提出更正或补充申请。"), _c('br'), _vm._v("\n      （三）删除您的个人信息"), _c('br'), _vm._v("\n      您可以通过“访问您的个人信息”中列明的方式删除您的部分个人信息。"), _c('br'), _vm._v("\n      在以下情形中，您可以向我们提出删除个人信息的请求："), _c('br'), _vm._v("\n      1、如果我们处理个人信息的行为违反法律法规；"), _c('br'), _vm._v("\n      2、如果我们收集、使用您的个人信息，却未征得您的明确同意；"), _c('br'), _vm._v("\n      3、如果我们处理个人信息的行为严重违反了与您的约定；"), _c('br'), _vm._v("\n      4、如果您不再使用我们的产品或服务，或您主动注销了账号；"), _c('br'), _vm._v("\n      5、如果我们永久不再为您提供产品或服务。"), _c('br'), _vm._v("\n      若我们决定响应您的删除请求，我们还将同时尽可能通知从我们处获得您的个人信息的主体，要求其及时删除，除非法律法规另有规定，或这些主体获得您的独立授权。"), _c('br'), _vm._v("\n      "), _c('span', {
    staticClass: "tbunderline"
  }, [_vm._v("当您从我们的服务中删除信息后，我们可能不会立即从备份系统中删除相应的信息，但会在备份更新时删除这些信息。")]), _c('br'), _vm._v("\n      （四）改变您授权同意的范围"), _c('br'), _vm._v("\n      每个业务功能需要一些基本的个人信息才能得以完成（见本隐私权政策“第三部分第一条”）。除此之外，对于额外个人信息的收集和使用，您可以在慧学宝APP进行相应管理。"), _c('br'), _vm._v("\n      （五）个人信息主体注销账户"), _c('br'), _vm._v("\n      您可以自行在“注销账户”页面提交账户注销申请。"), _c('br'), _vm._v("\n      在您主动注销账户之后，我们将停止为您提供产品或服务，根据适用法律的要求删除您的个人信息，或使其匿名化处理。"), _c('br'), _vm._v("\n      （六）约束信息系统自动决策"), _c('br'), _vm._v("\n      在某些业务功能中，我们可能仅依据信息系统、算法等在内的非人工自动决策机制做出决定。如果这些决定显著影响您的合法权益，您有权要求我们做出解释，我们也将在不侵害慧学宝商业秘密或其他用户权益、社会公共利益的前提下提供申诉方法。"), _c('br'), _vm._v("\n      （七）响应您的上述请求"), _c('br'), _vm._v("\n      为保障安全，您可能需要提供书面请求，或以其他方式证明您的身份。我们可能会先要求您验证自己的身份，然后再处理您的请求。"), _c('br'), _vm._v("\n      我们将在15天内做出答复。如您不满意，还可以通过慧学宝意见反馈中发起投诉。"), _c('br'), _vm._v("\n      对于您合理的请求，我们原则上不收取费用，但对多次重复、超出合理限度的请求，我们将视情收取一定成本费用。对于那些无端重复、需要过多技术手段（例如，需要开发新系统或从根本上改变现行惯例）、给他人合法权益带来风险或者非常不切实际的请求，我们可能会予以拒绝。"), _c('br'), _vm._v("\n      在以下情形中，按照法律法规要求，我们将无法响应您的请求："), _c('br'), _vm._v("\n      1、与国家安全、国防安全有关的；"), _c('br'), _vm._v("\n      2、与公共安全、公共卫生、重大公共利益有关的；"), _c('br'), _vm._v("\n      3、与犯罪侦查、起诉、审判和执行判决等有关的；"), _c('br'), _vm._v("\n      4、有充分证据表明个人信息主体存在主观恶意或滥用权利的；"), _c('br'), _vm._v("\n      5、响应您的请求将导致您或其他个人、组织的合法权益受到严重损害的；"), _c('br'), _vm._v("\n      6、涉及商业秘密的。"), _c('br'), _vm._v("\n      七、本隐私权政策如何更新"), _c('br'), _vm._v("\n      我们的隐私权政策可能变更。"), _c('br'), _vm._v("\n      未经您明确同意，我们不会限制您按照本隐私权政策所应享有的权利。我们会在专门页面（"), _c('a', {
    attrs: {
      "href": "http://www.zhixinhuixue.com/privacy"
    }
  }, [_vm._v("http://www.zhixinhuixue.com/privacy")]), _vm._v("）上发布对隐私权政策所做的任何变更。"), _c('br'), _vm._v("\n      对于重大变更，我们还会提供更为显著的通知（包括我们会通过慧学宝公示的方式进行通知甚至向您提供弹窗提示）。"), _c('br'), _vm._v("\n      本政策所指的重大变更包括但不限于："), _c('br'), _vm._v("\n      1、我们的服务模式发生重大变化。如处理个人信息的目的、处理的个人信息类型、个人信息的使用方式等；"), _c('br'), _vm._v("\n      2、我们在控制权等方面发生重大变化。如并购重组等引起的所有者变更等；"), _c('br'), _vm._v("\n      3、个人信息共享、转让或公开披露的主要对象发生变化；"), _c('br'), _vm._v("\n      4、您参与个人信息处理方面的权利及其行使方式发生重大变化；"), _c('br'), _vm._v("\n      5、我们负责处理个人信息安全的责任部门、联络方式及投诉渠道发生变化时；"), _c('br'), _vm._v("\n      6、个人信息安全影响评估报告表明存在高风险时。"), _c('br')])
}]}

/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sign"
  }, [_c('div', {
    staticClass: "sign_head"
  }, [_c('img', {
    staticClass: "sign_back",
    attrs: {
      "src": __webpack_require__(143),
      "alt": ""
    },
    on: {
      "click": function($event) {
        return _vm.$router.replace(("/signclazz?outId=" + _vm.outId + "&clazzId=" + _vm.clazzId))
      }
    }
  }), _vm._v("学生签字\n    "), _c('div')]), _vm._v(" "), _c('div', {
    staticClass: "sign_panel"
  }, [_c('div', {
    staticClass: "sign_panel-head"
  }, [_c('div', [_c('img', {
    staticClass: "sign_icon",
    attrs: {
      "src": __webpack_require__(419),
      "alt": ""
    }
  }), _vm._v("\n        " + _vm._s(_vm.clazzName) + "\n        "), _c('span', {
    staticClass: "sign_panel-head-subtitle"
  }, [_vm._v("共" + _vm._s(_vm.studentNames.length) + "名学员")])])]), _vm._v(" "), _c('div', {
    staticClass: "sign_panel-body"
  }, [_c('div', {
    staticClass: "sign_item"
  }, [_c('span', {
    staticClass: "sign_item-label"
  }, [_vm._v("品目名称：")]), _vm._v(" "), _c('span', {
    staticClass: "sign_item-val"
  }, [_vm._v(_vm._s(_vm.outputDetail.itemName))])]), _vm._v(" "), _c('div', {
    staticClass: "sign_item"
  }, [_c('span', {
    staticClass: "sign_item-label"
  }, [_vm._v("领用日期：")]), _vm._v(" "), _c('span', {
    staticClass: "sign_item-val"
  }, [_vm._v(_vm._s(_vm.outDate))])])])]), _vm._v(" "), _c('div', {
    staticClass: "sign_panel"
  }, [_c('div', {
    staticClass: "sign_panel-head"
  }, [_vm._m(0), _vm._v(" "), _c('span', {
    staticClass: "sign_panel-head-subtitle"
  }, [_vm._v("数量：" + _vm._s(_vm.outputDetail.no))])]), _vm._v(" "), _c('div', {
    staticClass: "sign_panel-body sign_lyry"
  }, [_vm._l((_vm.studentNames), function(item, index) {
    return _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (index < 8 || _vm.showMore),
        expression: "index<8 || showMore"
      }],
      staticClass: "sign_item"
    }, [_c('span', [_vm._v(_vm._s(item))])])
  }), _vm._v(" "), (_vm.studentNames.length > 7 && _vm.showMore) ? _c('div', {
    staticClass: "sign_item sign_zkqb",
    on: {
      "click": function($event) {
        _vm.showMore = false
      }
    }
  }, [_c('img', {
    staticClass: "sign_icon",
    staticStyle: {
      "transform": "rotate(180deg)"
    },
    attrs: {
      "src": __webpack_require__(147),
      "alt": ""
    }
  }), _vm._v("收起\n      ")]) : _vm._e(), _vm._v(" "), (_vm.studentNames.length > 7 && !_vm.showMore) ? _c('div', {
    staticClass: "sign_item sign_zkqb",
    on: {
      "click": function($event) {
        _vm.showMore = true
      }
    }
  }, [_c('img', {
    staticClass: "sign_icon",
    staticStyle: {
      "margin-top": "0"
    },
    attrs: {
      "src": __webpack_require__(147),
      "alt": ""
    }
  }), _vm._v("展开全部\n      ")]) : _vm._e()], 2)]), _vm._v(" "), _c('div', {
    staticClass: "sign_panel"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "sign_panel-body"
  }, [_c('div', {
    staticClass: "qm",
    on: {
      "click": _vm.gotoSign
    }
  }, [(!_vm.url) ? [_c('img', {
    ref: "pImg",
    staticClass: "placeholeder",
    attrs: {
      "src": __webpack_require__(142),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v("点击进入签名")])] : _c('img', {
    ref: "signImg",
    staticClass: "signimg",
    attrs: {
      "src": _vm.url,
      "alt": ""
    }
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "sign_item"
  }, [_c('span', {
    staticClass: "sign_item-label"
  }, [_vm._v("职务：")]), _vm._v(" "), _c('div', [_c('div', {
    on: {
      "click": _vm.toggleRoleListVisible
    }
  }, [_vm._v(_vm._s(_vm.role || '请选择'))])])]), _vm._v(" "), _c('div', {
    staticClass: "sign_item"
  }, [_c('span', {
    staticClass: "sign_item-label"
  }, [_vm._v("电话：")]), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.phone),
      expression: "phone"
    }],
    attrs: {
      "type": "text",
      "placeholder": "请输入11位手机号",
      "readonly": _vm.isSigned
    },
    domProps: {
      "value": (_vm.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.phone = $event.target.value
      }
    }
  })])])])]), _vm._v(" "), (!_vm.isSigned) ? _c('button', {
    staticClass: "confirm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("确定")]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.roleListVisible),
      expression: "roleListVisible"
    }],
    staticClass: "select"
  }, [_c('div', {
    staticClass: "select_body"
  }, [_c('ul', {
    staticClass: "select_body-options"
  }, _vm._l((_vm.roleList), function(item) {
    return _c('li', {
      class: ['select_body-option', {
        selected: item === _vm.tempRole
      }],
      on: {
        "click": function($event) {
          return _vm.changeTempRole(item)
        }
      }
    }, [_vm._v(_vm._s(item) + "\n        ")])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "select_foot"
  }, [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.changeRole(true)
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('button', {
    staticClass: "select_confirm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.changeRole(false)
      }
    }
  }, [_vm._v("确定")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    staticClass: "sign_icon",
    attrs: {
      "src": __webpack_require__(425),
      "alt": ""
    }
  }), _vm._v("\n        领用人员\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sign_panel-head"
  }, [_c('div', [_c('img', {
    staticClass: "sign_icon",
    attrs: {
      "src": __webpack_require__(146),
      "alt": ""
    }
  }), _vm._v("\n        签名\n      ")])])
}]}

/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "test-sign-up"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "填写报名资料",
      "visible": _vm.signUpData,
      "width": "760px"
    },
    on: {
      "update:visible": function($event) {
        _vm.signUpData = $event
      }
    }
  }, [_c('div', {
    staticClass: "sign-up-data"
  }, [_c('p', [_vm._v("请完善一下信息，我们的工作人员会及时联系您")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('span', {
    staticClass: "left"
  }, [_vm._v("学校\n            "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])]), _vm._v(" "), _c('el-input', {
    attrs: {
      "placeholder": "请输入内容"
    },
    model: {
      value: (_vm.school_name),
      callback: function($$v) {
        _vm.school_name = $$v
      },
      expression: "school_name"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('span', {
    staticClass: "left"
  }, [_vm._v("姓名\n            "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])]), _vm._v(" "), _c('el-input', {
    attrs: {
      "placeholder": "请输入内容"
    },
    model: {
      value: (_vm.userName),
      callback: function($$v) {
        _vm.userName = $$v
      },
      expression: "userName"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('span', {
    staticClass: "left"
  }, [_vm._v("手机\n            "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])]), _c('el-input', {
    attrs: {
      "placeholder": "请输入内容",
      "minlength": "6",
      "maxlength": "11"
    },
    model: {
      value: (_vm.mobile),
      callback: function($$v) {
        _vm.mobile = $$v
      },
      expression: "mobile"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('span', {
    staticClass: "left",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("考试科目\n          "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])]), _vm._v(" "), _c('span', {
    staticClass: "subject-box"
  }, [_c('el-checkbox-group', {
    model: {
      value: (_vm.subject),
      callback: function($$v) {
        _vm.subject = $$v
      },
      expression: "subject"
    }
  }, [_c('el-checkbox', {
    attrs: {
      "label": "语文"
    }
  }), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "数学(文)"
    }
  }), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "数学(理)"
    }
  }), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "英语"
    }
  }), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "文科综合"
    }
  }), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "理科综合"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', [_c('p', {
    staticClass: "red"
  }, [_vm._v("注：不参加联考的科目请自行取消勾选")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('span', {
    staticClass: "btn-add-sing-up",
    on: {
      "click": _vm.save
    }
  }, [_vm._v("提交")])])])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "提交成功",
      "visible": _vm.signUpSuccess,
      "width": "760px"
    },
    on: {
      "update:visible": function($event) {
        _vm.signUpSuccess = $event
      }
    }
  }, [_c('div', {
    staticClass: "sign-up-success"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(153),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "msg-box"
  }, [_c('p', {
    staticClass: "big-msg"
  }, [_vm._v("恭喜你！提交成功")]), _vm._v(" "), _c('p', {
    staticClass: "msg"
  }, [_vm._v("我们的工作人员将会及时联系您，并妥善保管您的相关信息！")])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "top"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(453),
      "alt": "",
      "usemap": "#suspension"
    }
  }), _vm._v(" "), _c('map', {
    attrs: {
      "name": "suspension"
    }
  }, [_c('area', {
    staticClass: "btn-add",
    attrs: {
      "shape": "rect",
      "coords": "1080,16,1180,44",
      "alt": "点击报名"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(450),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(156),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_c('p', {
    staticStyle: {
      "text-indent": "0"
    }
  }, [_vm._v("全国各高中学校：")]), _vm._v(" "), _c('p', [_vm._v("为帮助各高中学校检验本校高三复习效果，帮助学生找到复习中存在的问题，满足全国师生在备考时各项需求，\n          达到错因精准定位，排名精准评估，成绩精准提升的目的，风向标教育联合全国千余所高级中学，开展本次"), _c('span', {
    staticClass: "red"
  }, [_vm._v("全学科、高保真")]), _vm._v("的高三联合质量评估考试。")]), _vm._v(" "), _c('p', [_vm._v("通过本次联合质量评估，学校可以清晰掌握本校复习各项指标，梳理各班、各层次学生的复习情况，为接下来的复习定标准、找方向。利用风向标智能精准教学系统，为每一所学校提供专项报告、每一名教师提供专属教案，每一位学生提供个性化提升方案。\n          为了实现教师精准备考、学生个性化复习，风向标教育联合高考命题专家，举办线上联合评估质量分析会议，进一步明确复习亮点和不足，打造行之有效的精准复习备考策略。")]), _vm._v(" "), _c('p', {
    staticClass: "text-title"
  }, [_vm._v("一、报名方式")]), _vm._v(" "), _c('p', [_vm._v("知心慧学项目学校通过学管登录学管端进行考试报名；（学校告知在校学管报名）")]), _vm._v(" "), _c('p', [_vm._v("其他学校可以通过知心慧学官网提交报名信息，或者通过业务经理进行报名。")]), _vm._v(" "), _c('p', [_vm._v("采用邮箱报名：zhao@fxbjy.com")]), _vm._v(" "), _c('p', {
    staticClass: "text-title"
  }, [_vm._v("二、组织考试")]), _vm._v(" "), _c('p', [_vm._v("考试时间：2019年12月19日-20日（具体科目时间安排见下表）")]), _vm._v(" "), _c('table', {
    staticClass: "table-sing-up",
    attrs: {
      "border": "1"
    }
  }, [_c('tr', {
    staticClass: "table-head"
  }, [_c('td', {
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v("考试时间安排")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "width": "117px"
    }
  }, [_vm._v("适用范围")]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "200px"
    }
  }, [_vm._v("时间")]), _vm._v(" "), _c('td', [_vm._v("上午")]), _vm._v(" "), _c('td', [_vm._v("下午")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("全国")]), _vm._v(" "), _c('td', [_vm._v("12月19日")]), _vm._v(" "), _c('td', [_vm._v("语文  09:00-11:30")]), _vm._v(" "), _c('td', [_vm._v("数学（文理）  15:00-17:00")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("全国")]), _vm._v(" "), _c('td', [_vm._v("12月20日")]), _vm._v(" "), _c('td', [_vm._v("文科综合/理科综合  09:00-11:30")]), _vm._v(" "), _c('td', [_vm._v("英语  15:00-17:00")])])]), _vm._v(" "), _c('p', [_vm._v("为保证本次联合质量评估的公平、公正，参评学校名称在系统内均以"), _c('span', {
    staticClass: "red"
  }, [_vm._v("特定代码的方式")]), _vm._v("呈现。系统"), _c('span', {
    staticClass: "red"
  }, [_vm._v("提前2小时")]), _vm._v("发布试卷，由学管（或学校相关人员）按时下载并打印试卷、答题卡。")]), _vm._v(" "), _c('p', [_vm._v("考试结束后学管（或学校相关人员）扫描答题卡。")]), _vm._v(" "), _c('p', [_vm._v("参考学校的老师，在12月21日12点前完成所有线上阅卷（阅卷规则和时间"), _c('span', {
    staticClass: "red"
  }, [_vm._v("详见附件1")]), _vm._v("）。")]), _vm._v(" "), _c('p', {
    staticClass: "text-title"
  }, [_vm._v("三、成绩报告")]), _vm._v(" "), _c('p', [_vm._v("2019年12月23日-24日，老师可以登录风向标智能精准教学系统（知心慧学）在线查看本校成绩报告，也可以在线查看本省整体综合报告。")]), _vm._v(" "), _c('p', {
    staticClass: "text-title"
  }, [_vm._v("四、联合质量分析会议")]), _vm._v(" "), _c('p', [_vm._v("2019年12月26日及27日举办线上质量分析会议，帮助学校进一步精准找到原因，明确本次联评存在的问题，结合今年高考预测，共同打造高效的二轮精准备考方案。（具体科目时间安排见下表）")]), _vm._v(" "), _c('table', {
    staticClass: "table-sing-up",
    attrs: {
      "border": "1"
    }
  }, [_c('tr', {
    staticClass: "table-head"
  }, [_c('td', {
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v("线上质量分析会议时间安排")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "width": "117px"
    }
  }, [_vm._v("适用范围")]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "200px"
    }
  }, [_vm._v("时间")]), _vm._v(" "), _c('td', [_vm._v("上午")]), _vm._v(" "), _c('td', [_vm._v("下午")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("全国")]), _vm._v(" "), _c('td', [_vm._v("12月26日")]), _vm._v(" "), _c('td', [_vm._v("语文  09:00-11:30")]), _vm._v(" "), _c('td', [_vm._v("数学（文理）  15:00-17:00")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("全国")]), _vm._v(" "), _c('td', [_vm._v("12月27日")]), _vm._v(" "), _c('td', [_vm._v("文科综合/理科综合  09:00-11:30")]), _vm._v(" "), _c('td', [_vm._v("英语  15:00-17:00")])])]), _vm._v(" "), _c('p', [_vm._v("阅卷规则详见"), _c('span', {
    staticClass: "red"
  }, [_vm._v("附件1")]), _vm._v("。")]), _vm._v(" "), _c('p', [_vm._v("考试的各科考察范围及命卷细目详情见"), _c('span', {
    staticClass: "red"
  }, [_vm._v("附件2")]), _vm._v("。")]), _vm._v(" "), _c('p', [_vm._v("诚挚邀请！")]), _vm._v(" "), _c('div', {
    staticClass: "corporate-name"
  }, [_c('img', {
    staticClass: "seal",
    attrs: {
      "src": __webpack_require__(154),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "name"
  }, [_c('p', [_vm._v("江西风向标教育科技有限公司")]), _vm._v(" "), _c('p', [_vm._v("2019年12月3日")])])]), _vm._v(" "), _c('div', {
    staticClass: "down"
  }, [_c('p', [_vm._v("附件1:\n            "), _c('a', {
    attrs: {
      "href": "/static/lk-yj.PNG",
      "target": "_blank"
    }
  }, [_vm._v("教师线上阅卷规则说明(点击预览)")])]), _vm._v(" "), _c('p', [_vm._v("附件2:\n            "), _c('a', {
    attrs: {
      "href": "/static/lk-km.PNG",
      "target": "_blank"
    }
  }, [_vm._v("命卷细目表及各科考试安排(点击预览)")])])])]), _vm._v(" "), _c('span', {
    staticClass: "btn-sing-up"
  }, [_vm._v("我要报名")]), _vm._v(" "), _c('img', {
    staticClass: "img-sing-up-bottom",
    attrs: {
      "src": __webpack_require__(449),
      "alt": ""
    }
  })]), _vm._v(" "), _c('img', {
    attrs: {
      "src": __webpack_require__(451),
      "alt": ""
    }
  })])
}]}

/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('header', {
    staticClass: "header",
    class: _vm.classObject,
    attrs: {
      "id": "header"
    }
  }, [_c('div', {
    staticClass: "top"
  }, [_c('div', {
    staticClass: "nav-wrap"
  }, [_c('img', {
    staticClass: "header-logo",
    attrs: {
      "src": __webpack_require__(464),
      "alt": ""
    }
  }), _vm._v(" "), _c('ul', {
    staticClass: "nav clearfix"
  }, [_c('li', {
    class: {
      'active': _vm.activeType === 1
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Home',
        params: {
          status: 1
        }
      }
    },
    on: {
      "click": _vm.handleNavClick
    }
  }, [_vm._v("首页")])], 1), _vm._v(" "), _c('li', {
    class: {
      'active': _vm.activeType === 2
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Teacher',
        params: {
          status: 2
        }
      }
    },
    on: {
      "click": _vm.handleNavClick
    }
  }, [_vm._v("老师")])], 1), _vm._v(" "), _c('li', {
    class: {
      'active': _vm.activeType === 3
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Student',
        params: {
          status: 3
        }
      }
    },
    on: {
      "click": _vm.handleNavClick
    }
  }, [_vm._v("学生")])], 1), _vm._v(" "), _c('li', {
    class: {
      'active': _vm.activeType === 4
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Parent',
        params: {
          status: 4
        }
      }
    },
    on: {
      "click": _vm.handleNavClick
    }
  }, [_vm._v("家长")])], 1), _vm._v(" "), _c('li', {
    staticClass: "down-scan"
  }, [_c('div', {
    staticClass: "app-down-warn",
    on: {
      "mouseover": function($event) {
        _vm.showScanErma = true
      },
      "mouseout": function($event) {
        _vm.showScanErma = false
      }
    }
  }, [_c('img', {
    staticClass: "phone-icon",
    attrs: {
      "src": __webpack_require__(413),
      "alt": ""
    }
  }), _vm._v("App下载\n            ")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showScanErma),
      expression: "showScanErma"
    }],
    staticClass: "scan-erma"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(409),
      "alt": ""
    }
  })])])])])])])])
},staticRenderFns: []}

/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "licence"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("增值电信业务经营许可证")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": __webpack_require__(414),
      "alt": ""
    }
  })])
}]}

/***/ }),
/* 521 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "matics"
  }, [_c('viewer', {
    attrs: {
      "images": _vm.urls
    }
  }, [_vm._l((_vm.urls), function(a, i) {
    return [(i <= 13) ? _c('img', {
      attrs: {
        "src": a
      }
    }) : _vm._e()]
  })], 2)], 1)
},staticRenderFns: []}

/***/ }),
/* 522 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('keep-alive', [_c('router-view')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "student"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "add-user"
  }, [_c('p', [_vm._v("开启您在知心慧学的全新旅程吧！")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'Home',
        params: {
          status: 1
        }
      }
    }
  }, [_c('button', {
    staticClass: "btn-add"
  }, [_vm._v("加入知心慧学")])])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "bangzhu"
  }, [_c('div', {
    staticClass: "title-box"
  }, [_c('h2', {
    staticClass: "title"
  }, [_vm._v("我们为学生们在学习上带来什么帮助")]), _vm._v(" "), _c('i', {
    staticClass: "border-bottom"
  })]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('img', {
    staticClass: "card-img",
    attrs: {
      "src": __webpack_require__(443),
      "alt": "学习路径指引"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "card-name"
  }, [_vm._v("学习路径指引")]), _vm._v(" "), _c('p', {
    staticClass: "card-text"
  }, [_vm._v("知心慧学悉心收集每位学生每次考试答题数据，依据学生知识点掌握情况生成学生个人知识能力模型，为每位学生规划个性化学习路径，指导学生更加有针对性地学习。")])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('img', {
    staticClass: "card-img",
    attrs: {
      "src": __webpack_require__(435),
      "alt": "错题管理"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "card-name"
  }, [_vm._v("错题管理")]), _vm._v(" "), _c('p', {
    staticClass: "card-text"
  }, [_vm._v("系统自动整理学生每次考试出现的错题，节约学生自己整理错题的时间。并为每道试题匹配知识点、提供解题思路指导，便于学生订正复习，培养错题管理和回顾总结的学习意识。")])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('img', {
    staticClass: "card-img",
    attrs: {
      "src": __webpack_require__(440),
      "alt": "精准练习"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "card-name"
  }, [_vm._v("精准练习")]), _vm._v(" "), _c('p', {
    staticClass: "card-text"
  }, [_vm._v("每次考后，知心慧学为学生打印个性化学习方案，准确告知各知识点的掌握情况。为每道错题匹配变式训练题，帮助学生针对知识薄弱点进行更加有针对性的练习，脱离题海，提高练习效率。")])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('img', {
    staticClass: "card-img",
    attrs: {
      "src": __webpack_require__(447),
      "alt": "重点教师讲解"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "card-name"
  }, [_vm._v("重点教师讲解")]), _vm._v(" "), _c('p', {
    staticClass: "card-text"
  }, [_vm._v("知心慧学在假期开展网络直播课，针对典型学习问题和重难点，聘请教师进行针对性讲解，让学生进一步掌握相关知识。")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "separate"
  }, [_c('img', {
    staticClass: "img-separate",
    attrs: {
      "src": __webpack_require__(448),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "txpj"
  }, [_c('div', {
    staticClass: "title-box"
  }, [_c('h2', {
    staticClass: "title"
  }, [_vm._v("看看使用知心慧学的同学怎么说")]), _vm._v(" "), _c('i', {
    staticClass: "border-bottom"
  })]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('img', {
    staticClass: "img-zxhx",
    attrs: {
      "src": __webpack_require__(463),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card bg-card-lt"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('img', {
    staticClass: "img-student-head",
    attrs: {
      "src": __webpack_require__(415),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('div', {
    staticClass: "top"
  }, [_c('span', {
    staticClass: "name"
  }, [_vm._v("李同学")])]), _vm._v(" "), _c('p', {
    staticClass: "bottom"
  }, [_vm._v("\n            我的数学成绩一直处于中下水平，即使语文和英语成绩很好，但是数学一直是我成绩的薄弱项，在使用了一个学期的产品后，知心慧学帮我逐步攻克了自己数学知识点上的薄弱环节，同时给予详细的解题思路，帮助我成长！")])])]), _vm._v(" "), _c('div', {
    staticClass: "card bg-card-rt"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('img', {
    staticClass: "img-student-head",
    attrs: {
      "src": __webpack_require__(412),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('div', {
    staticClass: "top"
  }, [_c('span', {
    staticClass: "name"
  }, [_vm._v("代同学")])]), _vm._v(" "), _c('p', {
    staticClass: "bottom"
  }, [_vm._v("\n            之前天天刷题，题目做了无数，但是数学成绩还是上不去，始终在80-90分徘徊。知心慧学最大的好处就是：让我刷题更有针对性了，哪里不会就练哪里。现在，我对数学考试的信心得到了进一步提高。")])])]), _vm._v(" "), _c('div', {
    staticClass: "card bg-card-rb"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('img', {
    staticClass: "img-student-head",
    attrs: {
      "src": __webpack_require__(429),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('div', {
    staticClass: "top"
  }, [_c('span', {
    staticClass: "name"
  }, [_vm._v("张同学")])]), _vm._v(" "), _c('p', {
    staticClass: "bottom"
  }, [_vm._v("\n            知心慧学错题本上面保留了我每次考试的作答原笔迹，还给每道错题配了老师指点，解析也非常详细。我会好好订正，保留好我每一个学期的错题本的，等到高三的时候再拿出来，应该会很有帮助！")])])]), _vm._v(" "), _c('div', {
    staticClass: "card bg-card-lb"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('img', {
    staticClass: "img-student-head",
    attrs: {
      "src": __webpack_require__(411),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('div', {
    staticClass: "top"
  }, [_c('span', {
    staticClass: "name"
  }, [_vm._v("曹同学")])]), _vm._v(" "), _c('p', {
    staticClass: "bottom"
  }, [_vm._v("\n            数学一直是我的薄弱环节，过去我即使大量地做题也没有获得太大的提高，用了知心慧学之后，错题本针对自己的薄弱项进行针对性的训练给予了我事半功倍的学习方法，大大减轻了我的学习负担！")])])])])])
}]}

/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sign"
  }, [_c('div', {
    ref: "head",
    staticClass: "sign_head"
  }, [_c('img', {
    staticClass: "sign_icon",
    attrs: {
      "src": __webpack_require__(143),
      "alt": ""
    },
    on: {
      "click": _vm.back
    }
  }), _vm._v(" "), _c('div', [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.clear
    }
  }, [_vm._v("清除")]), _vm._v(" "), _c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("确定")])])]), _vm._v(" "), _c('div', {
    staticClass: "sign_body"
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("请横向签名")]), _vm._v(" "), _c('canvas', {
    ref: "canvas"
  })])])
},staticRenderFns: []}

/***/ }),
/* 525 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "user-know"
  }, [_c('div', {
    staticClass: "update"
  }, [_c('p', [_vm._v("更新日期：2022年6月2日")]), _vm._v(" "), _c('p', [_vm._v("生效日期：2022年6月2日")])]), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("知心慧学软件使用协议")]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "title"
  }, [_vm._v("法律声明")]), _vm._v(" "), _c('p', [_vm._v("\n      凡访问、浏览或使用江西风向标智能科技有限公司（以下简称“风向标”）出品的“知心慧学平台”产品（包括知心慧学平台网页端、H5、手机APP、微信公众号、小程序等，以下统称“知心慧学”），表明您已阅读、理解并同意接受以下条款的约束，并遵守所有适用的法律和法规。您一旦使用知心慧学，则须秉持诚信的原则遵守以下条款。\n    ")])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "title"
  }, [_vm._v("一般原则")]), _vm._v(" "), _c('p', [_vm._v("\n      以下规则适用于所有知心慧学产品用户或浏览者，因业务调整，可能随时被修改。您应经常访问本页面以便了解当前的条款，因为这些条款与您密切相关。这些条款的某些条文也可能被知心慧学中某些页面上或某些具体服务明确指定的法律通告或条款所取代，您应该了解这些内容，一旦接受本条款，即意味着您已经同时详细阅读并接受了这些被引用或取代的条款。\n    ")])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "title"
  }, [_vm._v("权益说明")]), _vm._v(" "), _c('div', [_c('p', [_vm._v("\n        风向标对其发行的或与合作公司共同发行的包括但不限于提供的软件及相关产品或服务的全部内容，享有知识产权，受法律保护。如果相关内容未含权利声明，并不代表风向标对其不享有权利和不主张权利，您应根据法律、法规及诚信原则尊重权利人的合法权益并合法使用该内容。\n      ")]), _vm._v(" "), _c('p', [_vm._v("\n        未经风向标书面同意，任何单位及个人不得以任何方式或理由对上述软件、产品、服务、信息、文字的任何部分进行使用、复制、修改、抄录、传播或与其他产品捆绑使用、销售，或以超级链路连接或传送、存储于信息检索系统或者其他任何商业目的的使用，但对于非商业目的的、个人使用的下载或打印\n        （未作修改，且须保留该内容中的版权说明或其他所有权的说明）除外。")]), _vm._v(" "), _c('p', [_vm._v("\n        上述软件中使用和显示的商标和标识（以下统称“商标”）是风向标及其关联公司在教育及其他相关领域内注册和未注册的有关商标，受法律保护，该等软件中所载的任何内容，未经风向标书面许可，任何人不得以任何方式使用风向标、知心慧学及近似名称和相关商标、标识。\n      ")])])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "title"
  }, [_vm._v("用户信息")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "impress"
  }, [_vm._v("为知心慧学提供相应服务之必须，您需要仔细阅读《知心慧学学生端使用许可app&知心慧学学生端隐私政策》，并授权风向标按照《知心慧学学生端使用许可app&知心慧学学生端隐私政策》的约定采集、使用您的个人信息。同时，为能更好的给您提供服务，以最便利、最全面地实现您的多方位需求，知心慧学与其合作网络服务平台提供互补性服务，为实现该服务功能的正常运行，知心慧学与合作平台在用户同意的情况下将共享必要的用户信息。知心慧学对于共享用户实行相同的信息安全和用户隐私政策，并监督合作网络服务平台遵守不低于知心慧学信息安全和用户隐私政策标准的安全和隐私政策。")])])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "title"
  }, [_vm._v("责任限制声明")]), _vm._v(" "), _c('div', [_c('p', {
    staticClass: "impress"
  }, [_vm._v("\n        不论在何种情况下，风向标由于信息网络设备维护、信息网络连接故障、智能终端、通讯或其他系统的故障、电力故障、罢工、劳动争议、暴乱、起义、骚乱、火灾、洪水、风暴、爆炸、战争、政府行为、司法行政机关的命令、其他不可抗力或第三方的不作为而造成的不能服务或延迟服务不承担责任。\n      ")]), _vm._v(" "), _c('p', {
    staticClass: "impress"
  }, [_vm._v("\n        无论在任何情况下（包括但不限于疏忽原因），由于使用知心慧学上的信息或由知心慧学链接的信息，或其他与知心慧学链接的网站信息，对您或他人所造成任何的损失或损害（包括直接、简介、特别或后果性的损失或损害，例如收入或利润之损失，智能终端系统之损坏或数据丢失等后果），均由使用者自行承担责任（包括但不限于疏忽责任）。\n      ")]), _vm._v(" "), _c('p', {
    staticClass: "impress"
  }, [_vm._v("\n        知心慧学所载的信息，包括但不限于文本、图片、数据、观点、网页或链接，虽然力图准确和详尽，但风向标并不就其所包含的信息和内容的准确、完整、充分和可靠性做任何承诺。风向标表明不对这些信息和内容作出任何明示或默示的、包括但不限于没有侵犯第三方权利、质量和没有智能终端病毒的保证。\n      ")]), _vm._v(" "), _c('p', {
    staticClass: "impress"
  }, [_vm._v("\n        对于知心慧学上所提及或展示的非风向标产品或服务，风向标仅提供基本信息。风向标不是相关产品的生产者或经销者，亦不是服务的提供方。风向标不就知心慧学上所提及或展示的非风向标产品或服务做出任何声明或保证，所有展示的产品和服务应受其本公司或服务提供方所做质量承诺和条款的约束。\n      ")])])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "title"
  }, [_vm._v("知心慧学服务")]), _vm._v(" "), _c('p', [_vm._v("\n      知心慧学为在校学生提供个性化教学辅助，充分利用互联网、大数据和人工智能技术，通过系统对学生课业成绩进行数据分析、数据测评、错题提炼，为学生制定精准学习计划和方案，通过全学习过程数据的分析、知识和能力结构的建模、学习问题的诊断和分析、学科优势的发现和增强，助推个性化精准教学改革。\n      知心慧学由江西风向标智能科技有限公司提供内容服务和数据分析服务。")])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "title"
  }, [_vm._v("第三方链接及服务")]), _vm._v(" "), _c('p', [_vm._v("\n      知心慧学可能保留有第三方网站或网址的链接及第三方服务，是否访问这些链接或接受相应服务将由用户自己做出决定，风向标并不就这些链接上所提供的任何信息、数据、观点、图片、陈述或建议的准确性、完整性、充分性和可靠性提供承诺或保证。风向标没有审查过任何第三方网站，对这些网站及其内容不进行控制，也不负任何法律责任。如果您决定访问任何与本平台链接的第三方网站，其可能带来的结果和风险全部由您自己承担。\n    ")])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "title"
  }, [_vm._v("适用法律和管辖权")]), _vm._v(" "), _c('p', [_vm._v("\n      通过访问知心慧学使用风向标提供的或其合作服务提供商提供的服务，即表示您同意该访问或服务受中华人民共和国法律的约束，且您同意受中华人民共和国法院的管辖。访问或接受服务过程中发生的争议应当协商解决，协商不成的，由实际服务提供者或实际网络信息服务提供者住所地有管辖权的法院诉讼解决。\n    ")])])])
}]}

/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "race-wrapper"
  }, [_c('div', {
    staticClass: "race-top"
  }), _vm._v(" "), _c('div', {
    staticClass: "race-content"
  }, [_c('div', {
    staticClass: "race-item"
  }, [_c('div', {
    staticClass: "race-item-title"
  }, [_vm._v("获奖名单")]), _vm._v(" "), _c('div', {
    staticClass: "race-item-title-top"
  }, [_c('span', {
    staticStyle: {
      "font-weight": "700"
    }
  }, [_vm._v("\"Star of Outlook\"")]), _vm._v("\n        知心慧学杯英语作文大赛已经圆满结束啦，本次大赛共产生92个获奖名额，应用文写作板块和读后续写板块各46位同学入围，恭喜以下获奖同学！愿各位同学前程似锦！未来可期！\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "race-item-title-mhk"
  }, [_vm._v("应用作文写作（第一名）获奖名单")]), _vm._v(" "), _c('div', {
    staticClass: "race-item-text"
  }, [_c('table', {
    staticClass: "tab-mhk",
    attrs: {
      "border": "1",
      "align": "center",
      "width": "50%",
      "cellspacing": "0"
    }
  }, [_c('tr', [_c('td', [_vm._v("等第")]), _vm._v(" "), _c('td', [_vm._v("学生")]), _vm._v(" "), _c('td', [_vm._v("学校名称")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("一等奖")]), _vm._v(" "), _c('td', [_vm._v("申家兴")]), _vm._v(" "), _c('td', [_vm._v("阳泉市第十五中学校")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "rowspan": "10"
    }
  }, [_vm._v("二等奖")]), _vm._v(" "), _c('td', [_vm._v("葛慧玲")]), _vm._v(" "), _c('td', [_vm._v("阳泉市第十一中学校")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("李子浩")]), _vm._v(" "), _c('td', [_vm._v("潍坊文昌中学")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("张馨予")]), _vm._v(" "), _c('td', [_vm._v("宝清县第一高级中")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("郭晴儿")]), _vm._v(" "), _c('td', [_vm._v("阳泉市第十五中学校")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("付则玮")]), _vm._v(" "), _c('td', [_vm._v("福建省宁化第一中学")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("韩泽坤")]), _vm._v(" "), _c('td', [_vm._v("山西省汾阳中学校")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("赵秒")]), _vm._v(" "), _c('td', [_vm._v("佛山市顺德区李兆基中学")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("徐家根")]), _vm._v(" "), _c('td', [_vm._v("万安县崇文中学")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("何子焓")]), _vm._v(" "), _c('td', [_vm._v("甘肃省礼县第一中学")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("胡瑛娜")]), _vm._v(" "), _c('td', [_vm._v("黑河市第一中学")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "rowspan": "15"
    }
  }, [_vm._v("三等奖")]), _vm._v(" "), _c('td', [_vm._v("荚靖文")]), _vm._v(" "), _c('td', [_vm._v("福建省清流县第一中学")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("王诺")]), _vm._v(" "), _c('td', [_vm._v("东平高级中学")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("李锦弈")]), _vm._v(" "), _c('td', [_vm._v("东平高级中学")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("尚亦佳")]), _vm._v(" "), _c('td', [_vm._v("东平高级中学")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("温键宜")]), _vm._v(" "), _c('td', [_vm._v("佛山市顺德区李兆基中学")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("曾苹")]), _vm._v(" "), _c('td', [_vm._v("东平高级中学")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("刘晓倩")]), _vm._v(" "), _c('td', [_vm._v("山西省汾阳中学校")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("宫佳婧")]), _vm._v(" "), _c('td', [_vm._v("甘肃省礼县第一中学")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("金姝琦")]), _vm._v(" "), _c('td', [_vm._v("华亭县第一中学")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("张睿")]), _vm._v(" "), _c('td', [_vm._v("东平高级中学")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("何芳霞")]), _vm._v(" "), _c('td', [_vm._v("甘肃省礼县第一中学")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("何潼铟")]), _vm._v(" "), _c('td', [_vm._v("佛山市顺德区李兆基中学")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("冯昊杰")]), _vm._v(" "), _c('td', [_vm._v("山西省汾阳中学校")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("刁炳桓")]), _vm._v(" "), _c('td', [_vm._v("宝清县第一高级中")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("马悦")]), _vm._v(" "), _c('td', [_vm._v("北方民族大学附属中学")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "rowspan": "20"
    }
  }, [_vm._v("四等奖")]), _vm._v(" "), _c('td', [_vm._v("蒋诗博")]), _vm._v(" "), _c('td', [_vm._v("玉门油田第一中学")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("张一涵")]), _vm._v(" "), _c('td', [_vm._v("山西省汾阳中学校")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("安康")]), _vm._v(" "), _c('td', [_vm._v("东平高级中学")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("饶菡")]), _vm._v(" "), _c('td', [_vm._v("山西省汾阳中学校")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("刘嘉欣")]), _vm._v(" "), _c('td', [_vm._v("佛山市顺德区李兆基中学")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("黄翔宇")]), _vm._v(" "), _c('td', [_vm._v("东莞外国语学校")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("黄金烨")]), _vm._v(" "), _c('td', [_vm._v("龙江县第一中学")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("曹可心")]), _vm._v(" "), _c('td', [_vm._v("宝清县第一高级中")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("朱柯桦")]), _vm._v(" "), _c('td', [_vm._v("阳泉市第十一中学校")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("刘凤怡")]), _vm._v(" "), _c('td', [_vm._v("宝清县第二高级中学")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("陈佳萍")]), _vm._v(" "), _c('td', [_vm._v("梅州市曾宪梓中学")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("张梓跃")]), _vm._v(" "), _c('td', [_vm._v("阳泉市第十一中学校")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("谢金秀")]), _vm._v(" "), _c('td', [_vm._v("佛山市顺德区李兆基中学")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("邹旭洁")]), _vm._v(" "), _c('td', [_vm._v("福建省清流县第一中学")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("常瑞婷")]), _vm._v(" "), _c('td', [_vm._v("山西省汾阳中学校")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("刘烨")]), _vm._v(" "), _c('td', [_vm._v("东平高级中学")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("高岩岩")]), _vm._v(" "), _c('td', [_vm._v("甘肃省合水县第一中学")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("陈雅萱")]), _vm._v(" "), _c('td', [_vm._v("福建省清流县第一中学")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("武嘉旭")]), _vm._v(" "), _c('td', [_vm._v("中阳县第一中学校")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("张家硕")]), _vm._v(" "), _c('td', [_vm._v("宝清县第二高级中学")])])])]), _vm._v(" "), _c('div', {
    staticClass: "race-item-title-mhk"
  }, [_vm._v("读后续写（第二题）获奖名单")]), _vm._v(" "), _c('div', {
    staticClass: "race-item-text"
  }, [_c('table', {
    staticClass: "tab-mhk",
    attrs: {
      "border": "1",
      "align": "center",
      "width": "50%",
      "cellspacing": "0"
    }
  }, [_c('tr', [_c('td', [_vm._v("等第")]), _vm._v(" "), _c('td', [_vm._v("学生")]), _vm._v(" "), _c('td', [_vm._v("学校名称")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("一等奖")]), _vm._v(" "), _c('td', [_vm._v("王思佳")]), _vm._v(" "), _c('td', [_vm._v("福建省清流县第一中学")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "rowspan": "10"
    }
  }, [_vm._v("二等奖")]), _vm._v(" "), _c('td', [_vm._v("张睿")]), _vm._v(" "), _c('td', [_vm._v("东平高级中学")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("申家兴")]), _vm._v(" "), _c('td', [_vm._v("阳泉市第十五中学校")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("高宇欣")]), _vm._v(" "), _c('td', [_vm._v("中阳县第一中学校")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("刘蕊")]), _vm._v(" "), _c('td', [_vm._v("新源县第二中学")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("刘艺")]), _vm._v(" "), _c('td', [_vm._v("东平高级中学")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("韩泽坤")]), _vm._v(" "), _c('td', [_vm._v("山西省汾阳中学校")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("张一涵")]), _vm._v(" "), _c('td', [_vm._v("山西省汾阳中学校")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("张雨北")]), _vm._v(" "), _c('td', [_vm._v("山西省汾阳中学校")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("李雨潼")]), _vm._v(" "), _c('td', [_vm._v("凌海市第二高级中学")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("房婷婷")]), _vm._v(" "), _c('td', [_vm._v("梅州市曾宪梓中学")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "rowspan": "15"
    }
  }, [_vm._v("三等奖")]), _vm._v(" "), _c('td', [_vm._v("王诺")]), _vm._v(" "), _c('td', [_vm._v("东平高级中学")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("杨忻俣")]), _vm._v(" "), _c('td', [_vm._v("东平高级中学")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("孙雨菡")]), _vm._v(" "), _c('td', [_vm._v("潍坊文昌中学")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("李志浩")]), _vm._v(" "), _c('td', [_vm._v("东平高级中学")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("荚爱华")]), _vm._v(" "), _c('td', [_vm._v("福建省清流县第一中学")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("曲禹行")]), _vm._v(" "), _c('td', [_vm._v("宝清县第二高级中学")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("安康")]), _vm._v(" "), _c('td', [_vm._v("东平高级中学")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("任涛")]), _vm._v(" "), _c('td', [_vm._v("山西省汾阳中学校")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("方雍童")]), _vm._v(" "), _c('td', [_vm._v("东莞外国语学校")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("张礼栋")]), _vm._v(" "), _c('td', [_vm._v("山西省汾阳中学校")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("辛成成")]), _vm._v(" "), _c('td', [_vm._v("东平高级中学")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("胡瑛娜")]), _vm._v(" "), _c('td', [_vm._v("黑河市第一中学")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("李舒涵")]), _vm._v(" "), _c('td', [_vm._v("潍坊文昌中学")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("赵婉竹")]), _vm._v(" "), _c('td', [_vm._v("山西省汾阳中学校")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("郭美娴")]), _vm._v(" "), _c('td', [_vm._v("佛山市顺德区郑裕彤中学")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "rowspan": "20"
    }
  }, [_vm._v("四等奖")]), _vm._v(" "), _c('td', [_vm._v("余璐")]), _vm._v(" "), _c('td', [_vm._v("东莞外国语学校")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("曹可心")]), _vm._v(" "), _c('td', [_vm._v("宝清县第一高级中")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("蔡铭")]), _vm._v(" "), _c('td', [_vm._v("梅州市曾宪梓中学")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("王静")]), _vm._v(" "), _c('td', [_vm._v("大连市一〇三中学")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("李王赫")]), _vm._v(" "), _c('td', [_vm._v("东平高级中学")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("孙娅涵")]), _vm._v(" "), _c('td', [_vm._v("山西省汾阳中学校")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("王美清")]), _vm._v(" "), _c('td', [_vm._v("福建省清流县第一中学")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("李奕金")]), _vm._v(" "), _c('td', [_vm._v("福建省清流县第一中学")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("张心如")]), _vm._v(" "), _c('td', [_vm._v("山西省汾阳中学校")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("杨璐")]), _vm._v(" "), _c('td', [_vm._v("山西省汾阳中学校")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("舒贵豪")]), _vm._v(" "), _c('td', [_vm._v("福建省武夷山第一中学")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("张琦")]), _vm._v(" "), _c('td', [_vm._v("东平高级中学")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("尚亦佳")]), _vm._v(" "), _c('td', [_vm._v("东平高级中学")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("牛万一")]), _vm._v(" "), _c('td', [_vm._v("东平高级中学")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("吴一")]), _vm._v(" "), _c('td', [_vm._v("东平高级中学")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("齐成宇")]), _vm._v(" "), _c('td', [_vm._v("东平高级中学")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("杨静")]), _vm._v(" "), _c('td', [_vm._v("山西省汾阳中学校")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("杨安宁")]), _vm._v(" "), _c('td', [_vm._v("甘肃省礼县第一中学")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("吴晓彤")]), _vm._v(" "), _c('td', [_vm._v("东平高级中学")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("杨红霞")]), _vm._v(" "), _c('td', [_vm._v("山西省汾阳中学校")])])])]), _vm._v(" "), _c('div', {
    staticClass: "race-item-title-top",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_vm._v("\n             再次恭喜以上获奖同学，所有获奖证书和奖品已寄出，如有疑问请咨询客服“知夏”（微信号：zljx_2）。获奖的同学们可以根据自己的名次，从以下奖品设置中获知自己的奖品哦！\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "race-item-title-top",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('h3', [_vm._v("应用文（第一题）奖项设置：")])]), _vm._v(" "), _c('div', [_c('img', {
    attrs: {
      "src": __webpack_require__(430),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "race-item-title-top",
    staticStyle: {
      "margin-top": "10px",
      "margin-bottom": "10px"
    }
  }, [_c('h3', [_vm._v("读后续写（第二题）奖项设置：")])]), _vm._v(" "), _c('div', [_c('img', {
    attrs: {
      "src": __webpack_require__(431),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "race-item-title-top"
  }, [_c('p', [_vm._v("注意：")]), _vm._v("\n          1. 本次大赛最终得分为自动批改得分与人工复评综合得分；\n        "), _c('br'), _vm._v("\n          2.\n        人工复评过程中发现部分非原创作品，此类作品不享有获奖权限。\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "race-item"
  }, [_c('div', {
    staticClass: "race-item-title"
  }, [_vm._v("简介")]), _vm._v(" "), _c('div', {
    staticClass: "race-item-text"
  }, [_vm._v("\n        英语是高考必修科目，也是需要良好的语言积累的学科，其中作文是分值很大的一道题，考察学生的句法、用词、拼写、标点等综合语言书写能力，写得越多，语言就越准确。同时英语写作对阅读、听力、口语、翻译等各方面都有促进作用，在竞争激烈的高考中，将英语作文这一板块牢牢攥紧，硬核提升自然不在话下！\n        "), _c('br'), _vm._v(" "), _c('br'), _vm._v("\n        而对于高考来说，今年有9个省针对语文、英语作文等主观性命题引入了机器阅卷，意味着对学生的卷面、书写、词语使用、语法的要求变高。\n        "), _c('br'), _vm._v(" "), _c('br'), _vm._v("\n        为助力学生有效训练英语作文技巧，提高逻辑思考及分析问题的能力，培养良好的英语书写习惯和卷面意识，在英语作文自动批改功能上线之际，风向标教育特别举办知心慧学杯英语作文大赛，训练学生英语作文技巧的同时，体验人工智能即时批阅英语作文的神奇，有效把握高考作文分。\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "race-item"
  }, [_c('div', {
    staticClass: "race-item-title"
  }, [_vm._v("参赛题目")]), _vm._v(" "), _c('div', {
    staticClass: "race-item-icon"
  }, [_c('div', {
    staticClass: "icon-left"
  }), _vm._v(" "), _c('div', {
    staticClass: "icon-student"
  }), _vm._v(" "), _c('span', [_vm._v("第一题")]), _vm._v(" "), _c('div', {
    staticClass: "icon-right"
  })]), _vm._v(" "), _c('div', {
    staticClass: "race-item-text first-font"
  }, [_vm._v("\n        假定你是李华，你校将为交换生举办一场名为“Cover Chinese songs in\n        "), _c('br'), _vm._v("\n        English”的比赛。请用英文给在你校学习了3年的留学生朋友Peter写一封邮件，邀请他参赛。要点包括：\n        "), _c('br'), _vm._v("\n          1. 简单介绍比赛目的；\n        "), _c('br'), _vm._v("\n          2. 请Peter谈谈喜欢的中国偶像歌手；\n        "), _c('br'), _vm._v("\n          3. 报名截止日期：6月20日。\n        "), _c('br'), _vm._v("\n        注意：\n        "), _c('br'), _vm._v("\n        1. 词数100左右；\n        "), _c('br'), _vm._v("\n        2. 可以适当增加细节，以使行文连贯。\n        "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("Dear Peter,")]), _vm._v("\n        ________\n        "), _c('p', [_vm._v("Yours")]), _vm._v(" "), _c('p', [_vm._v("Li Hua")])]), _vm._v(" "), _c('div', {
    staticClass: "race-item-icon mt"
  }, [_c('div', {
    staticClass: "icon-left"
  }), _vm._v(" "), _c('div', {
    staticClass: "icon-student"
  }), _vm._v(" "), _c('span', [_vm._v("第二题")]), _vm._v(" "), _c('div', {
    staticClass: "icon-right"
  })]), _vm._v(" "), _c('div', {
    staticClass: "race-item-text race-font"
  }, [_vm._v("\n        读后续写（满分25分）\n        "), _c('br'), _vm._v("\n        阅读下面短文，根据所给情节进行续写，使之构成一个完整的故事。\n        "), _c('p', [_vm._v("\n          It was the first run of a family ski weekend in Colorado. It was a\n          perfect spring morning, and the skies were cloudless. I was tired\n          and considered opting out of the run. But the\n          "), _c('u', [_c('b', [_vm._v("kids")])]), _vm._v(" were "), _c('u', [_c('b', [_vm._v("complaining")])]), _vm._v(" about attending\n          ski school, and I figured I should push through — that if I skipped\n          out, then they’d think that they could too.\n        ")]), _vm._v(" "), _c('p', [_vm._v("\n          I "), _c('u', [_c('b', [_vm._v("dropped")])]), _vm._v(" the kids at ski school, then I was fully\n          prepared so I could chase my "), _c('u', [_c('b', [_vm._v("friend")])]), _vm._v(", and my husband, "), _c('u', [_c('b', [_vm._v("Adam")])]), _vm._v(", who were already off and running.\n        ")]), _vm._v(" "), _c('p', [_vm._v("\n          I pushed off and caught up with my friend. My\n          "), _c('u', [_c('b', [_vm._v("legs")])]), _vm._v(" felt heavy; I debated, again, calling it a day.\n          Then, three minutes into the run, my left ski came off; then my\n          right ski inverted and took my leg with it, I remember seeing my ski\n          careening（倾斜） toward me at an obscene angle, and then I heard\n          the crack.\n        ")]), _vm._v(" "), _c('p', [_vm._v("\n          I lay splattered on the snow, my leg distorted at a right angle to\n          my body. My friend heard my shrieks and doubled back. A kind man\n          stopped and phoned ski patrol. I was strapped onto a toboggan and\n          taken down the mountain to an ambulance.\n        ")]), _vm._v(" "), _c('p', [_vm._v("\n          I woke up after surgery with my leg bandaged beyond recognition,\n          with tubes coming out of various limbs and my mind flighty and\n          confused. I wouldn’t walk for three months, optimistically. I\n          couldn’t drive. I couldn’t navigate the steps in our house. I\n          couldn’t even shower on my own. I would sit in an\n          "), _c('u', [_c('b', [_vm._v("recovery")])]), _vm._v(" machine for six hours a day.\n        ")]), _vm._v(" "), _c('p', [_vm._v("\n          Who would get the kids to the "), _c('u', [_c('b', [_vm._v("bus")])]), _vm._v(" at 7:15 a.m., since\n          my husband was in his office by 6 a.m. each day? Who would\n          "), _c('u', [_c('b', [_vm._v("deal with")])]), _vm._v(" the dogs, two rambunctious Labradors, who\n          relied on my companionship and long walks? Who would prepare\n          "), _c('u', [_c('b', [_vm._v("dinner")])]), _vm._v(" ?\n        ")]), _vm._v(" "), _c('p', [_vm._v("\n          “We’ll figure it out,” Adam said. I nodded, because what was the\n          alternative? But in any of my mind did I believe him. Not even a\n          tiny bit.\n        ")]), _vm._v("\n        注意：\n        "), _c('br'), _vm._v("\n        1. 所续写短文的词数应为150左右；\n        "), _c('br'), _vm._v("\n        2. 至少使用5个短文中标有下划线的关键词语；\n        "), _c('br'), _vm._v("\n        3. 续写部分分为两段，每段的开头语已为你写好；\n        "), _c('br'), _vm._v(" "), _c('br'), _vm._v("\n        Paragraph 1:"), _c('br'), _vm._v("\n        I wrote each person back, thanking them all but not taking them up on\n        their kind offers.\n        "), _c('br'), _vm._v("\n        ________\n        "), _c('br'), _vm._v("\n        Paragraph 2:\n        "), _c('br'), _vm._v("\n        My kids learned to be both autonomous and considerate.\n        "), _c('br'), _vm._v("\n        ________\n        "), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "race-item"
  }, [_c('div', {
    staticClass: "race-item-title"
  }, [_vm._v("参赛时间")]), _vm._v(" "), _c('div', {
    staticClass: "race-item-text"
  }, [_c('p', [_vm._v("2021.1.29-2021.2.26（参赛通道开放）")]), _vm._v(" "), _c('p', [_vm._v("\n          大赛获奖结果将于2021.3.5号后通过知心慧学教师端、学生端的英语作文大赛海报/微信公众号/微博/官方微信朋友圈等方式告知。\n        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "race-item"
  }, [_c('div', {
    staticClass: "race-item-title"
  }, [_vm._v("参赛方式")]), _vm._v(" "), _c('div', {
    staticClass: "race-item-text"
  }, [_vm._v("\n        1. \n        参赛者在应用文和读后续写两个题型中任选一个题型（或两个题型都参赛），进行手写英语作文，拍照或扫描后在规定时间内上传至自动批改系统。（作文题由江西风向标教育互联网教育研究院英语研究组按照高考命题标准命制，两个题型均有奖项设置，每个题型仅限上传一次，若选择两个题型都参赛，则需同时上传）\n        "), _c('br'), _vm._v("\n        2. \n        登录知心慧学学生端后点击英语作文大赛参赛入口海报，在规定时间内按步骤上传个人作文照片/扫描件，并填写正确的手机号（用来联系获奖者，寄送奖品）\n        （注意：书写潦草或拍照光线不足的图片将无法识别，需要按照基本标准和要求重新书写后再次上传，请务必保证填写的参赛信息是真实有效的，否则视作无效作品。\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "race-item"
  }, [_c('div', {
    staticClass: "race-item-title"
  }, [_vm._v("参赛要求")]), _vm._v(" "), _c('div', {
    staticClass: "race-item-text"
  }, [_vm._v("\n        （1）命题作文有应用文和读后续写两个题型，参赛者可任选一个题型进行参赛，也可两个题型都参赛。（两个题型均有奖项设置，每个题型仅限上传一次，若选择两个题型都参赛，则需同时上传）\n        "), _c('br'), _vm._v("\n        （2）参赛作文要求个人原创，内容要求符合审题标准，一旦发现抄袭，有权剥夺获奖权限。\n        "), _c('br'), _vm._v("\n        （3）务必保证填写的参赛信息真实有效，否则视作无效作品；如果出现雷同卷，将按上传和打分时间综合判断最终结果。\n        "), _c('br'), _vm._v("\n        （4）上传作品需确保书写工整、图片清晰。\n        "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "race-example"
  }, [_c('p', [_vm._v("示例图如下：")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": __webpack_require__(417),
      "alt": ""
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "race-item"
  }, [_c('div', {
    staticClass: "race-item-title"
  }, [_vm._v("成绩报告")]), _vm._v(" "), _c('div', {
    staticClass: "race-item-text"
  }, [_c('p', [_vm._v("\n          参赛者上传作品后，即可实时查看AI评分、智能点评与全国实时排名。最后经过英语研究组人工复评，给出最终获奖名单，并给出权威选拔评价，于结果日（2021.3.5）公布\n        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "race-item"
  }, [_c('div', {
    staticClass: "race-item-title"
  }, [_vm._v("奖励设置")]), _vm._v(" "), _c('div', {
    staticClass: "race-item-text"
  }, [_c('p', {
    staticClass: "hf"
  }, [_vm._v("应用文奖项设置：")]), _vm._v(" "), _c('p', [_vm._v("一等奖1名，二等奖10名，三等奖15名，优秀奖20名。")]), _vm._v(" "), _c('p', [_vm._v("一等奖：颁发相关荣誉证书+礼品（苹果Ipad）")]), _vm._v(" "), _c('p', [_vm._v("二等奖：颁发相关荣誉证书+礼品（小米AI音箱）")]), _vm._v(" "), _c('p', [_vm._v("三等奖：颁发相关荣誉证书+礼品（家用静音加湿器）")]), _vm._v(" "), _c('p', [_vm._v("优秀奖：颁发相关荣誉证书+礼品（定制精美笔袋）")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "hf"
  }, [_vm._v("读后续写奖项设置：")]), _vm._v(" "), _c('p', [_vm._v("一等奖1名，二等奖10名，三等奖15名，优秀奖20名。")]), _vm._v(" "), _c('p', [_vm._v("一等奖：颁发相关荣誉证书+礼品（苹果Ipad）")]), _vm._v(" "), _c('p', [_vm._v("二等奖：颁发相关荣誉证书+礼品（小爱触屏音箱）")]), _vm._v(" "), _c('p', [_vm._v("三等奖：颁发相关荣誉证书+礼品（小米体脂称）")]), _vm._v(" "), _c('p', [_vm._v("优秀奖：颁发相关荣誉证书+礼品（定制精美笔袋）")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("\n          获奖的所有作品将有机会做成英语作文优秀案例应用在知心慧学英语个性化学习宝当中，以图片的形式公布于“知心慧学”官方微博及“知了老师”、“知了家长”、“互联网教育风向标”微信公众号中。（作品一经收录，默认版权将归属我公司所有。）\n        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "race-item m0"
  }, [_c('div', {
    staticClass: "race-item-title"
  }, [_vm._v("其他")]), _vm._v(" "), _c('div', {
    staticClass: "race-item-text"
  }, [_vm._v("\n        英语作文自动批改是基于AI智能分析，结合专业的英语规则，从内容相关度、句子和词汇、篇章结构、字数、书写规范等多维度进行打分，得出最专业的作文分数，并提供个性化的成绩报告和分析指导。\n        "), _c('br'), _vm._v("\n        英语作文自动批改亮点：\n        "), _c('br'), _vm._v("\n        1. 评分维度丰富；\n        "), _c('br'), _vm._v("\n        2. 评语生动且个性化；\n        "), _c('br'), _vm._v("\n        3. 按句点评，错误各个击破；\n        "), _c('br'), _vm._v("\n        4. 亮词亮句点评，充分挖掘学生亮点\n        "), _c('br'), _vm._v("\n        5. 作文写作万能模板推荐，为学生奉上写作宝典\n        "), _c('br'), _vm._v("\n        知心慧学英语作文自动批改，更细致，更多维，更精准！只为让学生更精准有效提高英语写作水平！\n      ")])])])])
}]}

/***/ }),
/* 527 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.visible) ? _c('div', {
    staticClass: "toast"
  }, [_vm._v("\n  " + _vm._s(_vm.text) + "\n")]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 528 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "user-know"
  }, [_c('div', {
    staticClass: "update"
  }, [_c('p', [_vm._v("更新日期：2025年2月20日")]), _vm._v(" "), _c('p', [_vm._v("生效日期：2025年2月20日")])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "title"
  }, [_vm._v("版权声明")]), _vm._v(" "), _c('p', [_vm._v("\n      欢迎光临并使用数字校本平台，用户在使用数字校本平台前请认真阅读本声明，用户开始使用数字校本平台即表明已了解、尊重并遵守本声明的所有内容。如用户对本声明有任何异议，请不要使用数字校本平台。在以下声明中，数字校本平台的用户统称为“您”。\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      1、数字校本平台由上海互教智能科技有限公司（以下简称“上海互教”）出品，其载体包括手机APP、H5、网站、公众号、小程序等，上述载体的所有权、经营权、管理权均属于上海互教。本版权声明适用于上述所有载体。\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      2、您在数字校本平台上传的文章、试卷、课题集、作业集、课件、教案、学案等文字、图形资料和音频、视频材料（以下统称“作品”），如属于您原创，即表示上述作品的著作权归上海互教所有，或由您与上海互教协议约定共同所有。您保证对于您上传的原创作品拥有完整的、无瑕疵的著作权，若因第三方向上海互教追究上述作品著作权的法律责任，给上海互教造成的一切损失由您全部承担。\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      3、您转载他人的材料上传至上海互教，必须取得原著作权人的同意或非排他性许可，您通过其他渠道转载到数字校本平台的材料，须得到来源渠道的许可，如可以不经来源渠道许可转载的，您也须注明来源渠道的名称或地址，否则一切后果由您全部承担。\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      4、您承诺：您在数字校本平台所上传的所有作品内容符合法律、法规和规范性文件的相关规定，不侵犯任何第三方的合法权益。如您违反前述保证，上海互教有权删除相关内容，并可以暂停或终止向您提供服务。\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      5、任何转载数字校本平台已经刊登的作品的，均须得到作品原著作权人和上海互教的同意，否则因此引发的法律责任由转载方全部承担；作品原著作权人和上海互教未声明不得转载的，转载方也应在转载时注明作品出处，且不得对所转载内容进行任何形式的篡改、增减、节选、歪曲等，否则上海互教将依法追究其法律责任。\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      6、转载或引用数字校本平台原创或首发内容时，须注明作者姓名，并标注“来源：数字校本平台 www.schcur.com”，转载须保持作品完整，违者上海互教将依法追究其责任。\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      7、对于数字校本平台发布的非原创或非首发内容，均转载自其它媒体、杂志、刊物，转载目的在于传递更多信息，并不代表数字校本平台赞同其观点和对其真实性负责。\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      8、数字校本平台不拥有转载作品的版权，无权许可他人转载。如需转载，请联系著作权人，以获取授权。引用、转载、复制、摘编或以其他任何方式使用转载作品的，必须保留本网站注明的“来源”，不得擅自篡改为“来源：数字校本平台www.schcur.com”，违者本网站将依法追究其责任。\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      9、擅自使用数字校本平台名义转载不规范来源的信息、版权不明的资讯、稿件等作品，或盗用数字校本平台名义发布信息，上海互教将依法追究其法律责任。\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      10、异议协调：对于数字校本平台发布内容的版权或相关事项有异议的，请及时联系上海互教协商处理。邮箱："), _c('a', {
    attrs: {
      "href": "mailto:info@fxbjy.com"
    }
  }, [_vm._v("info@fxbjy.com")])]), _vm._v(" "), _c('p', [_vm._v("\n      11、因业务调整，本声明可能随时被修改。您应经常访问本页面以便了解当前的条款，因为这些条款与您密切相关。这些条款的某些条文也可能被数字校本平台中某些页面上或某些具体服务明确指定的法律通告或条款所取代，您应该了解这些内容，一旦接受本条款，即意味着您已经同时详细阅读并接受了这些被引用或取代的条款。\n    ")]), _vm._v(" "), _c('p', [_vm._v("12、上海互教拥有对本声明的最终解释权。")])])])
}]}

/***/ }),
/* 529 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "user-know"
  }, [_c('div', {
    staticClass: "update"
  }, [_c('p', [_vm._v("更新日期：2025年2月20日")]), _vm._v(" "), _c('p', [_vm._v("生效日期：2025年2月20日")])]), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("数字校本平台软件使用协议")]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "title"
  }, [_vm._v("法律声明")]), _vm._v(" "), _c('p', [_vm._v("\n      凡访问、浏览或使用上海互教智能科技有限公司（以下简称“上海互教”）出品的“数字校本平台”产品（包括数字校本平台网页端、H5、手机APP、微信公众号、小程序等，以下统称“数字校本平台”），表明您已阅读、理解并同意接受以下条款的约束，并遵守所有适用的法律和法规。您一旦使用数字校本平台，则须秉持诚信的原则遵守以下条款。\n    ")])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "title"
  }, [_vm._v("一般原则")]), _vm._v(" "), _c('p', [_vm._v("\n      以下规则适用于所有数字校本平台产品用户或浏览者，因业务调整，可能随时被修改。您应经常访问本页面以便了解当前的条款，因为这些条款与您密切相关。这些条款的某些条文也可能被数字校本平台中某些页面上或某些具体服务明确指定的法律通告或条款所取代，您应该了解这些内容，一旦接受本条款，即意味着您已经同时详细阅读并接受了这些被引用或取代的条款。\n    ")])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "title"
  }, [_vm._v("权益说明")]), _vm._v(" "), _c('p', [_vm._v("\n      上海互教对其发行的或与合作公司共同发行的包括但不限于提供的软件及相关产品或服务的全部内容，享有知识产权，受法律保护。如果相关内容未含权利声明，并不代表上海互教对其不享有权利和不主张权利，您应根据法律、法规及诚信原则尊重权利人的合法权益并合法使用该内容。\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      未经上海互教书面同意，任何单位及个人不得以任何方式或理由对上述软件、产品、服务、信息、文字的任何部分进行使用、复制、修改、抄录、传播或与其他产品捆绑使用、销售，或以超级链路连接或传送、存储于信息检索系统或者其他任何商业目的的使用，但对于非商业目的的、个人使用的下载或打印 （未作修改，且须保留该内容中的版权说明或其他所有权的说明）除外。\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      上述软件中使用和显示的商标和标识（以下统称“商标”）是上海互教及其关联公司在教育及其他相关领域内注册和未注册的有关商标，受法律保护，该等软件中所载的任何内容，未经上海互教书面许可，任何人不得以任何方式使用上海互教、数字校本平台及近似名称和相关商标、标识。\n    ")])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "title"
  }, [_vm._v("用户信息")]), _vm._v(" "), _c('p', {
    staticClass: "impress"
  }, [_vm._v("\n      为数字校本平台提供相应服务之必须，您需要仔细阅读《数字校本平台教师端使用许可app&数字校本平台教师端隐私政策》，并授权上海互教按照《数字校本平台教师端使用许可app&数字校本平台教师端隐私政策》的约定采集、使用您的个人信息。同时，为能更好的给您提供服务，以最便利、最全面地实现您的多方位需求，数字校本平台与其合作网络服务平台提供互补性服务，为实现该服务功能的正常运行，数字校本平台与合作平台在用户同意的情况下将共享必要的用户信息。数字校本平台对于共享用户实行相同的信息安全和用户隐私政策，并监督合作网络服务平台遵守不低于数字校本平台信息安全和用户隐私政策标准的安全和隐私政策。\n    ")])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "title"
  }, [_vm._v("责任限制声明")]), _vm._v(" "), _c('p', {
    staticClass: "impress"
  }, [_vm._v("\n      不论在何种情况下，上海互教由于信息网络设备维护、信息网络连接故障、智能终端、通讯或其他系统的故障、电力故障、罢工、劳动争议、暴乱、起义、骚乱、火灾、洪水、风暴、爆炸、战争、政府行为、司法行政机关的命令、其他不可抗力或第三方的不作为而造成的不能服务或延迟服务不承担责任。\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "impress"
  }, [_vm._v("\n      无论在任何情况下（包括但不限于疏忽原因），由于使用数字校本平台上的信息或由数字校本平台链接的信息，或其他与数字校本平台链接的网站信息，对您或他人所造成任何的损失或损害（包括直接、简介、特别或后果性的损失或损害，例如收入或利润之损失，智能终端系统之损坏或数据丢失等后果），均由使用者自行承担责任（包括但不限于疏忽责任）。\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "impress"
  }, [_vm._v("\n      数字校本平台所载的信息，包括但不限于文本、图片、数据、观点、网页或链接，虽然力图准确和详尽，但上海互教并不就其所包含的信息和内容的准确、完整、充分和可靠性做任何承诺。上海互教表明不对这些信息和内容作出任何明示或默示的、包括但不限于没有侵犯第三方权利、质量和没有智能终端病毒的保证。\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "impress"
  }, [_vm._v("\n      对于数字校本平台上所提及或展示的非上海互教产品或服务，上海互教仅提供基本信息。上海互教不是相关产品的生产者或经销者，亦不是服务的提供方。上海互教不就数字校本平台上所提及或展示的非上海互教产品或服务做出任何声明或保证，所有展示的产品和服务应受其本公司或服务提供方所做质量承诺和条款的约束。\n    ")])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "title"
  }, [_vm._v("数字校本平台服务")]), _vm._v(" "), _c('p', [_vm._v("\n      数字校本平台为在校学生提供个性化教学辅助，充分利用互联网、大数据和人工智能技术，通过系统对学生课业成绩进行数据分析、数据测评、错题提炼，为学生制定精准学习计划和方案，通过全学习过程数据的分析、知识和能力结构的建模、学习问题的诊断和分析、学科优势的发现和增强，助推个性化精准教学改革。 数字校本平台由上海互教智能科技有限公司提供内容服务和数据分析服务。\n    ")])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "title"
  }, [_vm._v("第三方链接及服务")]), _vm._v(" "), _c('p', [_vm._v("\n      数字校本平台可能保留有第三方网站或网址的链接及第三方服务，是否访问这些链接或接受相应服务将由用户自己做出决定，上海互教并不就这些链接上所提供的任何信息、数据、观点、图片、陈述或建议的准确性、完整性、充分性和可靠性提供承诺或保证。上海互教没有审查过任何第三方网站，对这些网站及其内容不进行控制，也不负任何法律责任。如果您决定访问任何与本平台链接的第三方网站，其可能带来的结果和风险全部由您自己承担。\n    ")])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "title"
  }, [_vm._v("适用法律和管辖权")]), _vm._v(" "), _c('p', [_vm._v("\n      通过访问数字校本平台使用上海互教提供的或其合作服务提供商提供的服务，即表示您同意该访问或服务受中华人民共和国法律的约束，且您同意受中华人民共和国法院的管辖。访问或接受服务过程中发生的争议应当协商解决，协商不成的，由实际服务提供者或实际网络信息服务提供者住所地有管辖权的法院诉讼解决。\n    ")])])])
}]}

/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "forget-login-wrapper"
  }, [_c('div', {
    staticClass: "forget-login-content"
  }, [_vm._m(0), _vm._v(" "), _c('h2', {
    staticClass: "forget-login-title"
  }, [_vm._v("忘记密码")]), _vm._v(" "), _c('div', {
    staticClass: "step"
  }, [_c('div', {
    staticClass: "step-item active"
  }, [_vm._v("1.验证手机号")]), _vm._v(" "), _c('div', {
    staticClass: "step-item",
    class: [!_vm.active ? 'no-active' : 'active']
  }, [_vm._v("\n        2.设置密码\n      ")])]), _vm._v(" "), _c('el-form', {
    ref: "ruleForm",
    attrs: {
      "model": _vm.ruleForm,
      "rules": _vm.rules
    }
  }, [_c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.active == 0),
      expression: "active == 0"
    }],
    attrs: {
      "prop": "phoneNumber"
    }
  }, [_c('el-input', {
    staticClass: "forget-login-input",
    attrs: {
      "placeholder": "请输入手机号"
    },
    model: {
      value: (_vm.ruleForm.phoneNumber),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "phoneNumber", $$v)
      },
      expression: "ruleForm.phoneNumber"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.active == 0),
      expression: "active == 0"
    }],
    attrs: {
      "prop": "code"
    }
  }, [_c('el-input', {
    staticClass: "forget-login-input",
    attrs: {
      "placeholder": "请输入验证码"
    },
    model: {
      value: (_vm.ruleForm.code),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "code", $$v)
      },
      expression: "ruleForm.code"
    }
  }), _vm._v(" "), (_vm.show) ? _c('div', {
    staticClass: "btn po",
    on: {
      "click": _vm.getCode
    }
  }, [_vm._v("获取验证码")]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.show),
      expression: "!show"
    }],
    staticClass: "po not"
  }, [_vm._v(_vm._s(_vm.count) + "S后重试")])], 1), _vm._v(" "), (_vm.active == 1) ? _c('el-form-item', {
    attrs: {
      "prop": "setPassword"
    }
  }, [_c('el-input', {
    staticClass: "forget-login-input",
    attrs: {
      "type": "password",
      "placeholder": "设置新密码,6-16位的字母或数字组合"
    },
    model: {
      value: (_vm.ruleForm.setPassword),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "setPassword", $$v)
      },
      expression: "ruleForm.setPassword"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.active == 1) ? _c('el-form-item', {
    attrs: {
      "prop": "checkPass"
    }
  }, [_c('el-input', {
    staticClass: "forget-login-input",
    attrs: {
      "type": "password",
      "placeholder": "验证新密码"
    },
    model: {
      value: (_vm.ruleForm.checkPass),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "checkPass", $$v)
      },
      expression: "ruleForm.checkPass"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    staticClass: "sure-login"
  }, [_c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.active == 0),
      expression: "active == 0"
    }],
    on: {
      "click": function($event) {
        return _vm.$router.push('/')
      }
    }
  }, [_vm._v("\n          返回\n        ")]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.active == 1),
      expression: "active == 1"
    }],
    on: {
      "click": function($event) {
        return _vm.last(_vm.active - 1)
      }
    }
  }, [_vm._v("上一步")]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.active == 1),
      expression: "active == 1"
    }],
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    on: {
      "click": function($event) {
        return _vm.submitLoging('ruleForm')
      }
    }
  }, [_vm._v("完成并登录")]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.active == 0),
      expression: "active == 0"
    }],
    attrs: {
      "disabled": _vm.disabled || _vm.phoneValidate
    },
    on: {
      "click": function($event) {
        return _vm.next(_vm.active + 1)
      }
    }
  }, [_vm._v("下一步")])], 1)], 1)], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "forget-login-logo"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(139),
      "alt": ""
    }
  })])
}]}

/***/ }),
/* 531 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "user-know"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('p', [_vm._v("江西风向标智能科技有限公司")]), _vm._v(" "), _c('p', [_vm._v("\n      产品服务协议（知了家长）\n    ")])]), _vm._v(" "), _c('p', {
    staticClass: "txt-title"
  }, [_vm._v("\n    尊敬的用户：\n  ")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("\n    您好！欢迎您使用江西风向标智能科技有限公司（以下简称“风向标”或“服务商”）出品的“知了家长”产品及配套服务。为使您的使用过程便捷，准确提升产品使用效率，请您认真阅读本协议，\n    您在阅读并确认使用上述产品后即表示您同意本协议的内容。")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("\n    江西风向标智能科技有限公司（以下简称“风向标”或“服务商”、“公司”）为您（指通过登录APP或网站、公众号、小程序等方式购买并使用风向标“知了家长”产品及配套服务的终端客户，以下也称为“用户”）提供“知了家长”产品和配套服务（以下简称“本产品”、“产品”），您自愿购买上述产品并基于购买产品后的使用而作出如下意思表示和授权，以下意思表示及授权均为您真实意愿，您同意承担由此带来的一切风险和责任。如果您是未成年人，则请您在法定监护人陪同下审阅和判断是否同意本协议的内容，未成年人使用本产品的行为视为已获得了法定监护人的认可。如果您不同意接受本协议的全部条款，则您无权注册、登录或使用本协议所涉及产品和服务，您下载、安装、使用本产品等行为，则意味着您将自愿遵守本协议及本产品的其他有关规则，并完全服从于本产品的统一管理。\n  ")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("\n    风向标有权根据业务需要对本协议不定时进行调整，并将调整后的协议公布于公司官网或者产品APP、公众号、小程序中，如果您不同意调整后的本协议的，您应当停止使用本产品，否则，如果在公司调整本协议并公布后，您继续使用本产品提供的服务的，则视为您同意遵守调整后的协议。\n  ")]), _vm._v(" "), _c('p', {
    staticClass: "txt-title bold"
  }, [_vm._v("一、关于购买产品")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("1、用户系自愿购买本产品，并通过线上或线下的方式向风向标支付用以购买产品的费用，用户用以登录产品使用端口的账号来自风向标的授予。")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("2、用户已具备与购买行为相适应的智力、健康状况，或经用户的法定监护人的同意购买本产品，并充分理解、知悉购买产品和使用产品行为产生的法律效果以及基于购买和使用产品的行为产生的个人信息采集情况。")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("3、经风向标许可，用户使用试用账号登录产品使用端口，并不表示用户同意即时付费，但这并不影响为正常使用产品而授权风向标采集用户的个人信息。")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("4、产品的试用期限届满后，用户无意付费购买的，用户同意风向标随时收回风向标授予本人的登录账号。")]), _vm._v(" "), _c('p', {
    staticClass: "txt-title bold"
  }, [_vm._v("二、用户权利和义务")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("\n    1、用户应妥善保管自己的账号、密码，不得转让、出借、出租、出售或分享予他人使用。否则风向标有权根据实际情况暂时封停或永久查封此账号，当用户的账号或密码遭到未经授权的使用时，用户应当立即通知风向标，否则未经授权的使用行为均视为用户本人行为。\n  ")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("\n    2、风向标有权随时对本产品内容等进行调整，包括但不限于增加、删除、修改本产品服务内容，一旦本产品的服务内容发生增加、删除、修改，公司将在相关页面上进行提示；如果用户不同意相关变更和修改，可以取消已经获取的服务并停止使用；如果用户继续使用本产品提供的服务，则视为用户已经接受全部变更、修改。除非另有明确约定，否则用户使用本产品内新增的服务内容将同样受本协议各项条款的约束。\n  ")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("\n    3、本产品内提供的服务分为试用期间的免费服务和正式使用的收费服务。对于现阶段免费提供的服务内容，公司有权随时根据公司政策的调整将其变更为收费服务，如果发生该等变更的，公司将提前告知用户，如果用户不同意的，可以停止使用该服务。对于收费的服务内容，公司有权自行确定该等服务的价格并不时调整，调整后的价格将在本产品平台中进行公示或以其他方式告知用户，如果用户不同意调整后的价格的，则用户可以在其原购买的收费服务到期后停止付费购买收费服务。如果用户在公司调整价格并公示或告知后，仍继续购买收费服务的，则视为用户同意该调整后的价格。\n  ")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("\n    4、用户如对付费购买的服务不满意的，有权终止服务。用户需在规定时间内，在客户端自行申请或拨打客服电话，申请终止服务及退款，退款金额按照客户端公示的退款规则计算，公司有权根据业务发展不时调整退款规则并在客户端内公示；公司有权保留已终止服务的用户的所有使用信息，对用户在使用付费服务期间发生的违反本协议及相关规定的行为，公司仍有权行使本协议规定的权利并追究用户的法律责任。\n  ")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("\n    5、公司不时将对付费服务提供优惠政策或开展优惠活动，该等优惠政策或优惠活动以本产品平台上的实时信息为准，用户知悉并认可，公司有权自行决定是否提供优惠政策或开展优惠互动，以及优惠政策或优惠活动的内容、条件和有效期，并不时进行调整或终止。\n  ")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("6、公司禁止以任何形式倒卖、贩售、出租、出借、转让用户账号的行为，一经查明，公司将采取包括但不限于封号、封禁IP、追究相关责任人法律责任的处理措施。")]), _vm._v(" "), _c('p', {
    staticClass: "txt-title bold"
  }, [_vm._v("三、平台管理")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("\n    1、用户应保证注册、登录并使用的账号符合中国相关法律法规的规定，符合《互联网用户账号名称管理规定》，符合本协议的各项规定。公司有权对用户注册、登录并使用的账号名称、头像和简介等注册信息进行审核，用户确保其使用的用户账号名称、头像和简介等信息中不得出现违法和不良信息，不存在以虚假信息骗取账号名称注册的情形；用户应确保其使用的用户账号名称不得为冒用关联机构或社会名人注册的账号名称。\n  ")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("\n    2、如果用户以虚假信息骗取账号名称注册，或用户的账号头像、简介等注册信息存在违法和不良信息的，公司有权采取通知限期改正、暂停使用、注销登记等措施；如果用户冒用关联机构或社会名人注册账号名称的，公司有权注销用户的账号，并向互联网信息内容主管部门报告。\n  ")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("\n    3、凡用户存在发布广告、暴力、色情、政治、宗教等内容，或抄袭、模仿管理人员ID，用以假冒管理人员或破坏管理人员形象，或模仿或盗用他人ID个人签名，发布的内容包含有严重影响网友浏览的内容或格式，或者存在其他扰乱本产品秩序的，或影响公司正常经营行为的，公司有权删除其相应账号，情节严重者，将酌情封禁对应IP。\n  ")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("4、公司提供账号注销功能，可以在本产品中实现。注销账号之后此账号内的数据无法恢复，账号信息内容也将全部清除，包含但不限于该账号发布过的文章、评论等。注销行为操作后无法撤销，请用户谨慎申请。")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("\n    5、投诉和举报：如果用户认为本产品中的信息、资料、内容等存在违反法律法规及本产品相关管理规定的，涉嫌侮辱或者诽谤他人，或者侵犯用户或第三方的知识产权或其他合法权利情形的，您可以通过本产品内的专用渠道进行举报、投诉，或者向公司官方邮箱info@fxbjy.com发送权利通知书，公司将在收到您的投诉后将依据中国法律法规和政府规范性文件及本产品平台管理规定采取措施进行处理，包括但不限于移除相关内容或屏蔽相关链接，以及其他公司认为适当的处理方式，情节严重者，公司有权向政府相关部门进行举报。\n  ")]), _vm._v(" "), _c('p', {
    staticClass: "txt-title bold"
  }, [_vm._v("四、知识产权")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("\n    1、无论您成为本产品之会员或使用本产品，均认可公司对本产品及本产品所收集、制作、发布之各类信息拥有完全知识产权或所有权，包括但不限于各类文档、图像、数据库等，除非法律明确规定该等权利属于用户个人以外，相关权限应涵盖包括复制、修改、改写、改编、发行、翻译、创造衍生性著作、出版、将前述内容(部分或全部)加以散布、展示等。您同意公司对您提交的信息进行有关编排处理后形成的数据库拥有完全的知识产权。\n  ")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("\n    2、如您将信息公布到本产品的任何公共区域，则表示您同意，同时您自动授予，并且您陈述并保证您有权授予本产品不可撤销的、永久的、非独占的、完全免费的、中华人民共和国范围的许可。在该等许可下，您同意本产品使用、复制、执行、显示并传播该内容，您也同意公司基于该内容创作衍生作品或将该内容整合到其他作品中且公司对该等衍生作品或整合作品拥有完全的所有者权益。除已获得公司书面许可的情况外，您不得复制、修改、公布、传播、执行、转载、许可使用、创建衍生作品、转移显示、出售、转售、以非法手段获取或以任何其他方式处置本产品收集、制作、发布的各类信息。\n  ")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("\n    3、请勿擅自复制或采用本产品所创造的用以制成网页的HTML。公司对其HTML享有著作权。同时，公司对其网址上的所有图标、图饰、图表、色彩、文字表述及其组合、版面设计、数据库均享有完全的著作权，对发布的信息均享有专有的发布和使用权，未经公司同意，不得擅自复制、使用或转载。\n  ")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("4、未经公司事先许可，禁止使用任何机器人、爬虫程序、其他自动设备，或手动程序等来监视或复制本产品网页或其所包含的任何内容。否则，公司有权依法追究法律责任。")]), _vm._v(" "), _c('p', {
    staticClass: "txt-title bold"
  }, [_vm._v("五、关于个人隐私和信息采集")]), _vm._v(" "), _c('p', {
    staticClass: "txt-title"
  }, [_vm._v("（一）信息采集授权")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("1、采集途径。您不可撤销地授权风向标以为您提供产品之目的，通过以下途径获取本人信息：")]), _vm._v(" "), _c('p', {
    staticClass: "txt bold"
  }, [_vm._v("（1）您确认，您在申请试用和正式使用本产品小程序时，向风向标提供的信息；")]), _vm._v(" "), _c('p', {
    staticClass: "txt bold"
  }, [_vm._v("（2）您在试用和正式使用产品后，风向标向您的被监护人所在学校班级任课老师和您提供的作业数据、考试数据、学习状况、在校情况等信息。")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("2、采集范围。您不可撤销地授权风向标以为您提供产品及服务之目的，获取您个人以下范围的信息：")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("（1）您申请试用产品时提交的姓名、手机号、被监护人的所在学校、年级、班级、学号、考号、姓名等等必要信息；")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("（2）您使用产品后通过产品系统上传的个人考卷、答题本、作业集、错题本以及历次考试成绩等；")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("（3）被监护人所在学校班级老师通过本产品教师端获取的被监护人的作业数据、考试数据、测评报告等。")]), _vm._v(" "), _c('p', {
    staticClass: "txt-title"
  }, [_vm._v("（二）信息使用授权")]), _vm._v(" "), _c('p', {
    staticClass: "txt bold"
  }, [_vm._v("\n    您同意并不可撤销地授权风向标以为您提供产品之目的，保存、整理、加工本协议第五条第一款所述的、通过合法途径采集的您的信息，用于您更好的使用产品，以及辅助老师教学，并基于此目的，授权风向标通过本产品教师端向您所在学校和班级老师推送上述信息。\n  ")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("上述授权系您对风向标做出的单方承诺，效力具有独立性，不受本条款所属协议成立与否及效力状态的影响。")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("以上授权期限为您作出本授权承诺之日起至您在风向标处所有业务终结之日止。")]), _vm._v(" "), _c('p', {
    staticClass: "txt-title"
  }, [_vm._v("（三）信息使用共享")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("\n    您授权风向标，除法律另有规定之外，将您提供给风向标的信息、使用产品产生的信息以及风向标根据本协议约定查询、收集的信息，用于风向标及其因服务必要委托的合作伙伴为您提供服务、推荐产品、开展市场调查以及信息数据分析。")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("您授权风向标，除法律另有规定外，基于为您提供更优质服务和产品的目的，向风向标因服务必要开展合伙的伙伴提供、查询、收集您的信息。")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("为确保您的个人信息安全，风向标对上述信息负有保密义务，并尽最大努力采取各种措施保证信息安全。")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("本条款自您签署或确认本协议时生效，具有独立法律效力，不受本条款所属协议成立与否及效力状态的影响。")]), _vm._v(" "), _c('p', {
    staticClass: "txt-title"
  }, [_vm._v("（四）用户知悉")]), _vm._v(" "), _c('p', {
    staticClass: "txt bold"
  }, [_vm._v("\n    包含您的被监护人的姓名、所在学校、年级、班级、学号、考号等信息为您的被监护人的个人信息。您应充分了解并明确知悉风向标向第三方采集并在法律法规许可范围内向信息使用者提供这些信息后，信息被其他主体对外提供和使用的风险，包括但不限于：这些信息对您的被监护人的学习可能产生不利影响；这些信息被风向标依法提供给第三方后被他人不当利用的风险；第三方向您推销产品或服务而打扰您的风险。此情况下，您同意并不可撤销地授权风向标依照本协议约定向其他机构提供您的个人信息。\n  ")]), _vm._v(" "), _c('p', {
    staticClass: "txt-title bold"
  }, [_vm._v("六、责任有限和免责条款")]), _vm._v(" "), _c('p', {
    staticClass: "txt bold"
  }, [_vm._v("\n    1、不允诺担保：本产品用户提问、回答、发言仅代表用户个人观点，与公司无关，且本产品不对用户发表的回答或评论的正确性、准确性、真实性进行保证。本产品为按现状提供，包含瑕疵及缺陷，公司不提供任何其他担保。公司不允诺其他无论是明示的还是默示的保证和担保，包括但不限于对特定目的的适销性和适应性，不侵权，以及任何出自交易过程或商业惯例的保证和条件。从公司或他处获取的任何建议或信息，不论是口头的还是书面的，都不会对公司产生本协议明确约定之外的其他保证和担保。\n  ")]), _vm._v(" "), _c('p', {
    staticClass: "txt bold"
  }, [_vm._v("\n    2、责任有限：适用法律所允许的最大范围内，不论出于何种原因，公司对用户的全部责任为用户为使用风向标的产品和服务而向公司支付的费用总额。如果公司免费向用户提供了本产品服务，则公司无义务对用户承担任何赔偿责任。任何情况下，公司不对出自本协议或与本协议有关的或与本产品的运行有关的任何特殊的、偶然的、惩罚性或间接的损害（包括但不限于数据损失、利润损失或营业损失）或采购替代产品承担责任，不论该等责任是基于合同、担保、侵权（包括过失）、严格责任或其他，也不论公司是否被事先告知了损失或损害发生的可能性。即使本协议约定的有限补救措施未能实现其根本目的，前述的责任限制依然适用。\n  ")]), _vm._v(" "), _c('p', {
    staticClass: "txt bold"
  }, [_vm._v("3、免责：如因下所列任何原因而造成的用户资料泄露、丢失、被盗用或被篡改等，公司均有权获得免责：")]), _vm._v(" "), _c('p', {
    staticClass: "txt bold"
  }, [_vm._v("（1）任何因政府管制而造成的暂时性关闭等影响网络正常浏览的不可抗力原因；")]), _vm._v(" "), _c('p', {
    staticClass: "txt bold"
  }, [_vm._v("（2）任何计算机系统问题、黑客攻击、计算机病毒侵入或发作的原因；")]), _vm._v(" "), _c('p', {
    staticClass: "txt bold"
  }, [_vm._v("（3）任何因网络安全问题导致的账户或银行卡信息泄露，该风险可能会给用户造成经济损失，用户承诺自行承担向侵权方追究责任及追究责任不能的后果；")]), _vm._v(" "), _c('p', {
    staticClass: "txt bold"
  }, [_vm._v("（4）任何因用户个人原因导致的用户资料泄露、丢失、被盗用或被篡改等；")]), _vm._v(" "), _c('p', {
    staticClass: "txt bold"
  }, [_vm._v("（5）其他不能归责于公司的原因。")]), _vm._v(" "), _c('p', {
    staticClass: "txt-title bold"
  }, [_vm._v("七、其他")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("1、如果本产品平台上某一子服务附有单独的使用协议的，则该子服务的使用将受该单独使用协议的约束。")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("2、本协议的签订、生效、履行、争议的解决均适用中华人民共和国法律。")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("3、有关本协议的争议应通过友好协商解决，如果协商不成，该争议将提交风向标所在地有管辖权的法院诉讼解决。")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("4、用户对知了家长平台的意见及建议可通过客服邮箱info@fxbjy.com与公司进行联系。")])])
}]}

/***/ }),
/* 532 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "privacy"
  }, [_c('h3', {
    staticClass: "title"
  }, [_vm._v("\n      知了家长小程序使用许可1.0&知了家长隐私政策1.0\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("\n      以下内容是《知了家长小程序使用许可1.0》及《知了家长隐私政策1.0》，在您登录注册知了家长前请务必审慎阅读、充分理解协议中相关条款内容。\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "txt"
  }, [_vm._v("\n      《知了家长小程序使用许可1.0》包括小程序使用许可、信息使用、风险提示、知识产权。《知了家长隐私政策1.0》包括适用范围、我们收集信息的原因和内容、我们会如何使用您的信息、我们可能如何收集信息、我们会如何共享、转让、公开披露您的个人信息、如何管理您的个人信息、推广服务、我们会如何保护和保存您的个人信息、第三方提供商及其服务、知了家长会如何处理未成年人的个人信息、本政策如何更新及适用范围以及联系我们。您一旦登录注册并使用知了家长，即视为您已了解并同意《知了家长小程序使用许可1.0》及《知了家长隐私政策1.0》的各项内容。\n      "), _c('p', {
    staticClass: "bold"
  }, [_vm._v("\n        在此特别提醒您，在点击接受本声明之前，您应事先认真阅读、了解清楚并充分理解本声明的全部内容，包括免除或者限制责任的免责条款及对您的权利限制条款。请您审阅后选择接受或不接受本声明（未成年人应在法定监护人陪同下审阅）。除非您接受本声明，否则您无权下载、安装或使用本公司基于应用软件提供的相关服务（以下称\"服务\"）。一旦您点击确认本声明，即意味着您已充分理解和接受本声明，并同意接受本声明各项条款的约束。并且，公司在法律许可的范围内享有对本声明的解释、修改以及变更的权利。\n      ")])]), _vm._v(" "), _c('h3', {
    staticClass: "title"
  }, [_vm._v("\n      知了家长小程序使用许可1.0\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "txt-title"
  }, [_vm._v("\n      一、小程序使用许可\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("\n      1.您使用的“知了家长小程序”（以下简称“小程序”、“本小程序”）是由江西风向标智能科技有限公司（以下简称“公司”）运营的教育服务平台。\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("\n      2.“知了家长用户”是指完成全部注册流程，愿意接受本协议并在知了家长相关使用规范的规定下使用知了家长小程序服务的注册用户。\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("\n      3.注册成为本小程序之用户或使用本小程序，即表示您保证您已具备单独签订本协议并遵守本协议所有条款之民事权利能力及民事行为能力。\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("\n      4.您郑重承诺，将以本人真实的身份，秉承诚实信用合法的原则使用本小程序，在登录和使用本小程序的全过程中都负有作为理性人的谨慎和注意义务。\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("\n      5.本小程序保留对小程序使用规定的解释、修改以及变更的权利，届时将通过小程序通告等方式向用户传达，如果不同意对本协议相关条款所做的修改，用户有权停止使用网络服务。如果用户继续使用网络服务，则视为用户接受本协议相关条款所做的修改。\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "txt-title"
  }, [_vm._v("\n      二、信息使用\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("\n      1.在注册、登录和使用本小程序时，您同意及不可撤销地授权将您的姓名和登录账户等信息提供给我们，包括但不限于您的真实姓名、学情信息、学籍信息、登录账号信息、联系方式等。\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("\n      2.您在使用本小程序时，承诺和保证如下内容：\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("(a)您所提供的资料为完整，最新及正确无误；")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("\n      (b)本协议一经签署，即具法律效力并同意受其约束。")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("\n      3.\n      您的注册信息包括注册号和密码仅供本人使用，您有义务提高自我保护和防范风险意识，如提高密码级别、不随意向其他人透露您的用户名、口令等信息。如若由于您个人对账号信息保管不慎或告知他人而导致任何个人信息泄露、账户损失等，本小程序及运营方将不承担任何法律责任。\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("\n      4.我们将对您所提供的资料进行严格的管理及保护，致力于保护用户个人数据及个人隐私安全，原则上不提供给任何个人或者第三方使用，拒绝任何组织和个人以营利为目的意图获取或者使用用户个人信息。特殊情况如司法机关、监管机构或其他政府部门依照法定程序要求提供用户个人信息等为例外。本小程序在必要时将会由专业技术人员代为对您相关信息资料进行处理，以符合专业分工的要求。\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("\n      如发生下列任何一种情形，本小程序有权随时使用用户提交信息资料、中断或终止向用户提供本协议项下的网络服务而无需通知用户:")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("\n      (a)用户提供的个人资料不真实；")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("\n      (b)用户违反本协议中规定的使用规则；")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("(c)为免除您在生命、身体或财产方面之急迫危险的；")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("(d)为防止他人权益之重大危害的；")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("(e)为增进公共利益，且无害于您的重大利益的。")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("\n      除前款所述情形外，本小程序同时保留在不事先通知用户的情况下因紧急事由随时中断或终止部分或全部网络服务的权利，对于所有服务的中断或终止而造成的任何损失，本小程序无需对用户或任何第三方承担任何责任。")]), _vm._v(" "), _c('p', {
    staticClass: "txt-title bold"
  }, [_vm._v("三、风险提示")]), _vm._v(" "), _c('p', {
    staticClass: "txt bold"
  }, [_vm._v("\n      1.您于订立协议时已表示理解并同意免除我们与此相应的法律责任。如在本小程序运营过程中出现我们误将您的帐户终止，或变更您的有关信息，或部分停止您的各类权限，则我们将在您提出书面通知后合理期间内处理该等事宜，若因此给您带来不便甚至造成损失，您同意免除我们的相应法律责任。\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "txt bold"
  }, [_vm._v("2.您了解并同意，我们不对因下述任一情况而导致的任何损害赔偿承担责任：")]), _vm._v(" "), _c('p', {
    staticClass: "txt bold"
  }, [_vm._v("(a)使用或未能使用本小程序服务；")]), _vm._v(" "), _c('p', {
    staticClass: "txt bold"
  }, [_vm._v("(b)对本小程序服务的错误理解；")]), _vm._v(" "), _c('p', {
    staticClass: "txt bold"
  }, [_vm._v("(c)第三方未使用真实身份，或者未经批准的使用他人的账号或更改他人的数据；")]), _vm._v(" "), _c('p', {
    staticClass: "txt bold"
  }, [_vm._v("(d)任何非因本小程序的原因而引起的与服务有关的损失")]), _vm._v(" "), _c('p', {
    staticClass: "txt bold"
  }, [_vm._v("3.对于任何本小程序无法控制的原因（包括但不限于政府管制、通讯设施故障及其他不可抗力因素）导致的小程序暂时关闭、用户信息泄露、被盗用、被篡改等非正常经营行为，本小程序不承担任何责任。\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "txt bold"
  }, [_vm._v("4.您承认对于您利用本小程序或信息而从事的各类行为，包括线上和线下，均为您个人行为且您个人对该类行为承担完全责任。")]), _vm._v(" "), _c('p', {
    staticClass: "txt bold"
  }, [_vm._v("\n      5.由于您将注册账户、密码告知他人或与他人共享注册帐户，由此导致的任何个人信息的泄露，任何由于黑客攻击、计算机病毒侵入或发作、因政府管制而造成的暂时性关闭等影响网络正常经营之不可抗力而造成的个人信息泄露、丢失、被盗用或被篡改等，由于本小程序不拥有或不控制的公司以及我们不雇佣或不管理的人员所造成的个人信息的泄露，本小程序不承担任何责任并应免于被追诉。\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "txt bold"
  }, [_vm._v("6.您同意保障和维护知了家长小程序及其他用户的利益，如因您违反有关法律、\n      法规或本协议项下的任何条款而给本小程序或任何其他第三人造成损失，您同意承担由此造成的损害赔偿责任。在注册成为本小程序用户或者使用本小程序过程中，您与任何第三方之间发生任何纠纷，由纠纷各方自行解决，本小程序并不承担任何责任。本小程序不对您使用本小程序的任何行为、效果或影响提供任何担保或条件，无论是明示或默示的。\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "txt-title"
  }, [_vm._v("四、知识产权")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("\n      1.无论您成为本小程序之会员或使用本小程序，均认可我们对本小程序及本小程序所收集、制作、发布之各类信息拥有完全知识产权或所有权，包括但不限于各类文档、图像、数据库等，除非法律明确规定该等权利属于会员个人以外，相关权限应涵盖包括复制、修改、改写、改编、发行、翻译、创造衍生性著作、出版、将前述内容(部分或全部)加以散布、展示等。您同意我们对所有您提交的信息进行有关编排处理后形成的数据库拥有完全的知识产权。\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("\n      2.如您将信息公布到本小程序的任何公共区域，则表示您同意，同时您自动授予，并且您陈述并保证您有权授予本小程序不可撤销的、永久的、非独占的、完全免费的、中国国内范围的许可。在该等许可下，您同意本小程序使用、复制、执行、显示并传播该内容，您也同意我们基于该内容创作衍生作品或将该内容整合到其他作品中且我们对该等衍生作品或整合作品拥有完全的所有者权益。除已获得我们书面许可的情况外，您不得复制、修改、公布、传播、执行、转载、许可使用、创建衍生作品、转移显示、出售、转售、以非法手段获取或以任何其他方式处置本小程序收集、制作、发布的各类信息。\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("\n      3.请勿擅自复制或采用本小程序所创造的用以制成网页的HTML。本小程序对其HTML享有著作权。同时，本小程序对其网址上的所有图标、图饰、图表、色彩、文字表述及其组合、版面设计、数据库均享有完全的著作权，对发布的信息均享有专有的发布和使用权，未经本小程序同意，不得擅自复制、使用或转载。\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "title bold"
  }, [_vm._v("知了家长隐私政策1.0\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "txt bold  line"
  }, [_vm._v("\n      【特别提示】请仔细阅读《知了家长隐私政策1.0》（尤其是加粗划线的内容）（以下简称“本隐私政策”）并确定了解我们对您个人信息的处理规则。阅读过程中，如您有任何疑问，可联系我们的客服咨询，如果您不同意相关协议或其中任何条款约定，知了家长将暂时无法为您提供服务。本隐私政策与您所使用的知了家长服务以及该服务所包括的各种业务功能（以下统称“我们的产品与/或服务”）息息相关，希望您在使用我们的产品与/或服务前仔细阅读并确认您已经充分理解本政策所写明的内容，并让您可以按照本隐私政策的指引做出您认为适当的选择。本隐私政策中涉及的相关术语，我们尽量以简明扼要的表述，并提供进一步说明的链接，以便您更好地理解。您使用或在我们更新本隐私政策后（我们会及时提示您更新的情况）继续使用我们的产品与/或服务，即意味着您同意本隐私政策(含更新版本)内容，并且同意我们按照本隐私政策收集、使用、保存和共享您的相关信息。如对本隐私政策或相关事宜有任何问题，您可随时通过发送邮件至legal@fxbjy.com或拨打我们的任何一部客服电话等多种方式与我们联系\n      。")]), _vm._v(" "), _c('p', {
    staticClass: "txt-title"
  }, [_vm._v("一、 适用范围")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("本隐私政策适用于知了家长提供的所有服务，您访问并使用知了家长网站、APP、小程序，均适用本隐私政策。")]), _vm._v(" "), _c('p', {
    staticClass: "txt-title"
  }, [_vm._v("二、我们收集信息的原因和内容")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("为了保障您能够流畅地使用我们的核心功能并向您提供更好、更优、更个性化的服务，同时为了保障您的信息安全，我们将根据您使用的服务收集您的以下信息。")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("2.1 您直接提供给我们的信息")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("\n      当您注册时，您需要至少向我们提供您准备使用的知了家长账户名、密码、您本人的手机号码、电子邮箱地址（用于验证邮箱），我们将通过发送短信验证码或邮件的方式来验证您的身份是否有效。此时，您需要向我们提供以下信息：帐号名称、头像（如有）和手机号码等。提供上述信息并同意注册协议和本政策后，您可以使用知了家长的部分业务功能，包括：考试查询、浏览知了家长平台内的内容等。在您注册知了家长帐号时，我们会使用手机号码对您的身份信息及您的被监护人信息（姓名、学校、学号/学籍号）进行绑定，便于将您与其他用户区分并准确判断您的被监护人学习情况，为您以及您的被监护人提供个性化的服务。如您拒绝提供手机号码或进行被监护人信息绑定，您仍可浏览部分知了家长平台内的内容，但将无法使用如作业数据提交、学习情况查询、个性化学情分析报告查看等核心功能。\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("2.2在您使用过程中产生的信息")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("\n      当您使用知了家长的某些业务功能时，为满足向您提供该产品和服务之目的，除注册信息外，您还需要进一步向我们提供包括但不限于您的个人身份信息及其他为您提供服务所必需的信息，同时，我们的产品集成友盟+SDK，友盟+SDK需要收集您的设备Mac地址、唯一设备识别码（IMEI/android\n      ID/IDFA/OPENUDID/GUID、SIM 卡 IMSI\n      信息）以提供统计分析服务。提供以上信息，将有助于我们给您提供个性化的推荐和更优的服务体验，如果您不提供这些信息，并不会影响您使用知了家长的基本功能。如果您不使用特定产品和服务，则无需提供相关信息。")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("\n      我们还可能为了提供服务及改进服务质量的合理需要而获得您的其他信息，包括您与客服联系时您提供的相关信息，您参与问卷调查时向我们发送的问卷答复信息，以及您与我们的关联方、我们合作伙伴之间互动时我们获得的相关信息。对于从您的各种设备上收集到的信息，我们可能会将它们进行关联，以便我们能在这些设备上为您提供一致的服务。我们可能会将来自某项服务的信息与来自其他服务的信息结合起来，以便为您提供服务、个性化内容和建议。\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("2.3 征得授权同意的例外")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("根据相关法律法规的规定，以下情形中收集您的个人信息无需征得您的授权同意：")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("2.3.1 涉及国家安全与利益、社会公共利益；")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("2.3.2 与犯罪侦查有关的相关活动；")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("2.3.3 出于维护您或他人的生命财产安全但在特殊情况下无法获得您的及时授权；")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("2.3.4 从其他合法公开的渠道中收集您的个人信息；")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("2.3.5 法律法规规定的其他情形。")]), _vm._v(" "), _c('p', {
    staticClass: "txt-title"
  }, [_vm._v("三、我们会如何使用您的信息")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("3.1\n      收集您的信息是为了向您提供服务及提升服务质量，我们会根据本隐私政策的约定进行使用。在收集您的信息后，我们将通过技术手段对数据进行去标识化处理，去标识化处理的信息将无法识别主体。请您了解并同意，在此情况下我们有权使用已经去标识化的信息，并在不透露您个人信息的前提下，我们有权对用户数据库进行分析并予以合法使用。\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("3.2 您的信息主要有以下用途：")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("3.2.1 为您提供您使用的各项个性化服务，并维护、改进这些服务；")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("3.2.2 帮助我们设计新服务，提升现有服务体验；")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("3.2.3 在我们提供服务时，用于身份验证、客户服务、安全防范、诈骗监测、存档和备份用途，确保我们向您提供的产品和服务的安全性；")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("3.2.4 向您发送您可能感兴趣的学习类产品和服务的信息，包括但不限于向您发出学习产品和服务信息，或通过系统向您展示个性化的学习产品推广信息；")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("3.2.5 邀请您参与知了家长活动和市场调查；")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("3.2.6 开展内部审计、数据分析和研究，以更好地改善我们的产品、服务及与用户之间的沟通。")]), _vm._v(" "), _c('p', {
    staticClass: "txt-title"
  }, [_vm._v("四、我们可能如何收集信息")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("4.1 您使用我们的服务时，我们会在您的计算机或移动设备上存储名为 Cookie 的小数据文件。Cookie\n      通常包含标识符、站点名称以及一些号码和字符。我们使用该等信息判断注册用户是否已经登录，提升服务/产品质量及优化用户体验。如您不希望个人信息保存在 Cookie 中，您可对浏览器进行配置，选择禁用 Cookie 功能。禁用\n      Cookie 功能后，可能影响您访问知了家长或不能充分取得知了家长提供的服务。")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("知了家长不会将 Cookie 用于本政策所述目的之外的任何用途。您可根据自己的偏好管理或删除Cookie。您可以清除计算机上保存的所有 Cookie，大部分网络浏览器都设有阻止 Cookie\n      的功能。")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("4.2 设备权限调用")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("\n      知了家长在提供服务的过程中，可能需要您开通一些设备权限，例如通知、相册、相机等访问权限。您也可以在设备的设置功能中随时选择关闭部分或者全部权限，从而拒绝知了家长收集相应的个人信息。在不同设备中，权限显示方式及关闭方式可能有所不同，具体请参考设备及系统开发方说明或指引。\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "txt bold"
  }, [_vm._v("4.3 根据您的服务使用情况，我们可能会调用的权限如下：")]), _vm._v(" "), _c('p', {
    staticClass: "txt bold"
  }, [_vm._v("4.3.1 储存权限：当您下载及升级应用、使用错题本功能进行导出和储存、上传文件联系在线客服反馈问题时，我们会调用您的储存权限，保障您能顺利实现此功能。")]), _vm._v(" "), _c('p', {
    staticClass: "txt bold"
  }, [_vm._v("4.3.2 摄像头权限：当您修改头像选择拍照上传或上传文件时，我们将调用您的摄像头权限，保障您进行个性化的使用。")]), _vm._v(" "), _c('p', {
    staticClass: "txt bold"
  }, [_vm._v("4.3.3短信权限：当您注册账号时，我们将调用短信权限，保障您能顺利完成注册。")]), _vm._v(" "), _c('p', {
    staticClass: "txt bold"
  }, [_vm._v("4.3.4 用户信息权限：当您注册或者登录时，我们将调用用户手机号权限，用于快捷登录使用。")]), _vm._v(" "), _c('p', {
    staticClass: "txt-title"
  }, [_vm._v("五、我们会如何共享、转让、公开披露您的个人信息")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("5.1 共享")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("知了家长不会在未经您同意或授权的情况下将您的个人信息提供给第三方。但是，经您确认同意，知了家长可在以下情况下共享您的个人信息：")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("5.1.1 在获取同意的情况下共享：获得您的明确同意后，知了家长会与其他方共享您的个人信息。")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("5.1.2\n      共享给知了家长的关联公司：在本政策声明的使用目的范围内，您的个人信息可能会与知了家长的关联公司共享。作为一项政策，我们只会共享必要的信息。关联公司如要改变个人信息的处理目的，将再次征求您的授权同意。")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("5.1.3\n      共享给授权合作伙伴：知了家长可能会与合作伙伴共享您的某些个人信息，以便给您提供服务、个性化内容和建议。例如，知了家长向您寄送礼品（如有）时，知了家长必须与物流服务提供商共享您的个人信息才能安排寄送，或者安排合作伙伴向您提供服务。我们仅会出于特定、明确而合法的目的处理您的个人信息，并且只会共享提供服务所必要的信息。同时，我们会与其签署严格的保密协定，要求他们按照我们的说明、本政策以及其他任何相关的保密和安全措施来处理个人信息。在法定情形下的共享：我们可能会根据法律法规规定、诉讼争议解决需要，或按行政、司法机关依法提出的要求，对外共享您的个人信息。\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("5.2 转让")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("我们不会将您的个人信息转让给任何公司、组织和个人，但以下情况除外：")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("5.2.1 事先获得您明确的同意或授权；")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("5.2.2 根据适用的法律法规、法律程序的要求、强制性的行政或司法要求所必须的情况进行提供；")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("5.2.3 符合与您签署的相关协议（包括在线签署的电子协议以及相应的平台规则）或其他的法律文件约定所提供；")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("5.2.4 在涉及合并、收购、资产转让或类似的交易时，如涉及到个人信息转让，我们会要求新的持有您个人信息的公司、组织继续受本隐私政策的约束，否则,我们将要求该公司、组织重新向您征求授权同意。\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("5.3 公开披露")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("我们仅会在以下情况下，且采取符合法律和业界标准的安全防护措施的前提下，才会公开披露您的个人信息：")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("5.3.1 根据您的需求，在您明确同意的披露方式下披露您所指定的个人信息；")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("5.3.2\n      根据法律、法规的要求、强制性的行政执法或司法要求所必须提供您个人信息的情况下，我们可能会依据所要求的个人信息类型和披露方式公开披露您的个人信息。在符合法律法规的前提下，当我们收到上述披露信息的请求时，我们会要求必须出具与之相应的法律文件，如传票或调查函。我们坚信，对于要求我们提供的信息，应该在法律允许的范围内尽可能保持透明。我们对所有的请求都进行了慎重的审查，以确保其具备合法依据，且仅限于执法部门因特定调查目的且有合法权利获取的数据。在法律法规许可的前提下，我们披露的文件均在加密密钥的保护之下。\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "txt-title"
  }, [_vm._v("六、 如何管理您的个人信息")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("我们将尽一切可能采取适当的技术手段，保证收集到的有关于您的个人信息的准确性，并保证及时进行更新。")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("6.1 更正或补充您的个人信息：")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("\n      除法律法规规定外，您有权随时访问和更正您的个人信息，具体包括：小程序端具体路径为：“我的”进入我的—“修改密码”；您也可以通过「我的」-【意见反馈】页面，按照知了家长的相关政策及提示，或联系在线客服，对您的个人信息进行访问、更正。\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "txt bold"
  }, [_vm._v("6.2 删除您的个人信息及注销账号")]), _vm._v(" "), _c('p', {
    staticClass: "txt bold"
  }, [_vm._v("\n      您可以通过小程序中「我的」-【安全中心】页面，点击账号注销，填写用户账号及密码后申请注销，或联系在线客服，或拨打客服电话0791-88282252，我们将在2周内帮助您进行注销账号及删除有关信息的处理。")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("6.3 管理消息和推送")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("\n      对于您在使用服务的过程中提供的设备号，我们在运营过程中可能会向您的设备发送消息推送，用于用户消息告知、任务提醒等目的。在「我的」-【消息管理】页面，您可以选择是否接受定向推送信息，或选择接受部分情况下的推送通知。\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "txt-title"
  }, [_vm._v("七、我们会如何保护和保存您的个人信息")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("\n      知了家长高度重视个人信息的安全。我们采取互联网业内标准做法来保护您的个人信息，防止信息遭到未经授权访问、披露、使用、修改、损坏或丢失。我们会采取一切合理可行的措施，保护您的个人信息。我们会采取一切合理可行的措施，确保未收集与知了家长提供的服务无关的个人信息。我们会尽全力保护您的个人信息，但请您理解，由于技术的限制以及可能存在的各种恶意手段，在互联网行业，不可能始终保证信息百分之百的安全。您需要了解，您接入我们的服务所用的系统和通讯网络，有可能因我们可控范围外的因素而出现问题。我们仅允许有必要知晓这些信息的知了家长及知了家长关联方的员工、合作伙伴访问个人信息，并为此设置了严格的访问权限控制和监控机制。我们同时要求可能接触到您个人信息的所有人员履行相应的保密义务。如果未能履行这些义务，可能会被追究法律责任或被中止与知了家长的合作关系。在发生个人信息安全事件的场合，我们将按照法律法规的要求，及时向您告知：安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施等。我们将及时将事件相关情况以邮件、信函、电话、推送通知等方式告知您，难以逐一告知个人信息主体时，我们会采取合理、有效的方式发布公告。同时，我们还将按照监管部门要求，主动上报个人信息安全事件的处置情况。我们在中华人民共和国境内收集和产生的个人信息将存储在中华人民共和国境内。如果日后为处理跨境业务，需要向境外机构传输境内收集的相关个人信息的，我们会事先征得您的同意，按照法律、行政法规和相关监管部门的规定执行，并通过签订协议、核查等有效措施，要求境外机构为所获得的个人信息保密。我们仅会在达到本政策所述目的所必需的时限内保存您的个人信息，但为了遵守适用的法律法规、法院判决或裁定、其他有权机关的要求、维护公共利益等目的，我们可能会将个人信息保存时间予以适当延长。\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "txt-title"
  }, [_vm._v("八、第三方提供商及其服务")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("\n      为确保流畅的浏览体验，您可能会收到来自知了家长及其合作伙伴外部的第三方（以下简称「第三方」）提供的内容或网络链接。知了家长对此类第三方无控制权。您可选择是否访问第三方提供的链接、内容、产品和服务。知了家长无法控制第三方的隐私和个人信息保护政策，此类第三方不受到本政策的约束。您在向第三方提交个人信息之前，请确保您阅读并认可这些第三方的隐私保护政策。\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "txt-title"
  }, [_vm._v("九、知了家长会如何处理未成年人的个人信息")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("\n      我们鼓励父母或监护人指导未满十八岁的未成年人使用我们的服务。我们建议未成年人鼓励他们的父母或监护人阅读本政策，并建议未成年人在提交个人信息之前寻求父母或监护人的同意和指导。但是，如果您确认自己能够完全理解本政策的全部内容且您为使用知了家长服务所进行的相关操作行为与您的年龄、智力相适应的，则您可以独立进行相关操作（包括向我们提交您的个人信息）。\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "txt-title"
  }, [_vm._v("十、本政策如何更新及适用范围")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("\n      为给用户提供更好的服务，知了家长的业务将不时变化，本隐私政策也将随之调整。知了家长会通过在知了家长网站、移动端上发出更新版本并提醒您相关内容的更新，也请您访问知了家长以便及时了解最新的隐私政策。知了家长保留不时更新或修改本政策的权利。如果该等修改造成您在本政策下权利的实质减少，知了家长会通过不同渠道向您发送变更通知，包括但不限于网站公示、短信、邮件通知等方式。若您不同意修改后的隐私政策，您有权并应立即停止使用知了家长的服务。如果您继续使用知了家长的服务，则视为您接受知了家长对本政策相关条款所做的修改。\n      知了家长的所有服务均适用本政策。但某些服务有其特定的隐私政策，该等特定的隐私政策更具体地说明知了家长在该服务中如何处理您的信息。如本政策与特定服务的隐私政策有不一致之处，请以该特定隐私政策为准。")]), _vm._v(" "), _c('p', {
    staticClass: "txt-title"
  }, [_vm._v("十一、 联系我们")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("如对本隐私政策或相关事宜有任何问题、建议、意见及咨询，您可随时通过发送邮件至 legal@fxbjy.com\n      或拨打我们的客服电话0791-83857059等多种方式与我们联系，我们将在十五个工作日内受理并处理。")])])
}]}

/***/ }),
/* 533 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "user-know"
  }, [_c('div', [_vm._v("本政策仅适用于上海互教智能科技有限公司的数字校本平台产品。")]), _vm._v(" "), _c('div', {
    staticClass: "update"
  }, [_c('p', [_vm._v("更新日期：2025年2月20日")]), _vm._v(" "), _c('p', [_vm._v("生效日期：2025年2月20日")])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "bold"
  }, [_vm._v("数字校本平台app使用许可1.0&数字校本平台教师端隐私政策1.0")]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_vm._v("\n      以下内容是《数字校本平台app使用许可1.0》及《数字校本平台隐私政策1.0》，在你登录注册数字校本平台前请务必审慎阅读、充分理解协议中相关条款内容。《数字校本平台app使用许可1.0》包括app使用许可；信息使用；风险提示；知识产权。《数字校本平台隐私政策1.0》包括适用范围；我们收集信息的原因和内容；我们会如何使用您的信息；我们可能如何收集信息；我们会如何共享、转让、公开披露您的个人信息；如何管理您的个人信息；推广服务；我们会如何保护和保存您的个人信息；第三方提供商及其服务；本政策如何更新及适用范围；联系我们。你一旦登录注册数字校本平台，即视为你已了解并同意《数字校本平台app使用许可1.0》及《数字校本平台隐私政策1.0》的各项内容。\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_vm._v("\n      在此特别提醒您，在点击接受本声明之前，您应事先认真阅读、了解清楚并充分理解本声明的全部内容，包括免除或者限制责任的免责条款及对您的权利限制条款。请您审阅并接受或不接受本声明（未成年人应在法定监护人陪同下审阅）。 除非您接受本声明，否则您无权下载、安装或使用本公司基于应用软件提供的相关服务（以下称\"服务\"）。一旦您点击确认本声明，即意味着您已充分理解和接受本声明，并同意接受本声明各项条款的约束。并且，公司在法律许可的范围内享有对本声明的解释、修改以及变更的权利。\n    ")])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "bold"
  }, [_vm._v("数字校本平台app使用许可1.0")]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_vm._v("一、APP使用许可")]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_vm._v("1.您使用的“数字校本平台”（以下简称“APP”）是由上海互教智能科技有限公司（以下简称“公司”）运营的在线教育增值服务平台。")]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_vm._v("2.“数字校本平台用户”是指完成全部注册流程，愿意接受本协议并在数字校本平台相关使用规范的规定下使用数字校本平台APP服务的注册用户。")]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_vm._v("3.注册成为本APP之用户或使用本APP，即表示您保证您已具备单独签订本协议并遵守本协议所有条款之民事权利能力及民事行为能力。")]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_vm._v("4.您郑重承诺，将以本人真实的身份，秉承诚实信用合法的原则使用本APP，在登录和使用本APP的全过程中都负有作为理性人的谨慎和注意义务。")]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_vm._v("5.本公司保留对APP使用规定的解释、修改以及变更的权利，届时将通过APP通告等方式向用户传达，如果不同意对本协议相关条款所做的修改，用户有权停止使用网络服务。如果用户继续使用网络服务，则视为用户接受本协议相关条款所做的修改。如您未在通知规定的时间内表示反对，将会被视为默认。")]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_vm._v("二、信息使用")]), _vm._v(" "), _c('p', {
    staticClass: "ident bold blue"
  }, [_vm._v("1.在注册、登陆和使用数字校本平台APP时，您同意及不可撤销地授权将您的姓名和账户等信息提供给我们，包括但不限于您的真实姓名、联系方式、身份证号码、住址、账号信息等。")]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_vm._v("2.您在使用数字校本平台时，承诺和保证如下内容：")]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_vm._v("(a)您所提供的资料为完整，最新及正确无误；")]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_vm._v("(b)本协议一经签署，即具法律效力并同意受其约束。")]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_vm._v("\n      3.您的注册信息包括注册号和密码仅供本人使用，您有义务提高自我保护和防范风险意识，如提高密码级别、不随意向其他人透露您的用户名、口令等信息。如若由于您个人对账号信息保管不慎或告知他人而导致任何个人信息泄露、账户损失等，数字校本平台将不予承担任何责任。\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "ident bold blue"
  }, [_vm._v("\n      4.我们将对您所提供的资料进行严格的管理及保护，致力于保护用户个人数据及个人隐私安全，原则上不提供给任何个人或者第三方使用，拒绝任何组织和个人以营利为目的意图获取或者使用用户个人信息。特殊情况如司法机关、监管机构或其他政府部门依照法定程序要求提供用户个人信息等为例外。本APP在必要时将会由专业技术人员代为对您相关信息资料进行处理，以符合专业分工的要求。\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_vm._v("\n      如发生下列任何一种情形，本APP有权随时使用用户提交信息资料、中断或终止向用户提供本协议项下的网络服务而无需通知用户：\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_vm._v("(a)用户提供的个人资料不真实；")]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_vm._v("(b)用户违反本协议中规定的使用规则；")]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_vm._v("(c)为免除您在生命、身体或财产方面之急迫危险的；")]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_vm._v("(d)为防止他人权益之重大危害的；")]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_vm._v("\n      (e)为增进公共利益，且无害于您的重大利益的。除前款所述情形外，本APP同时保留在不事先通知用户的情况下随时中断或终止部分或全部网络服务的权利，对于所有服务的中断或终止而造成的任何损失，本APP无需对用户或任何第三方承担任何责任。\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_vm._v("三、风险提示")]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_vm._v("\n      1.对在任何情况下因使用或不能使用本APP所产生的直接、间接、偶然、特殊及后续的损害及风险，我们不承担任何责任。损失包括但不限于决策对于由此给您造成的任何不便或损害，包括但不限于：决策失误、操作不当、遗忘或泄露账户密码、密码被他人破解、您使用的终端设备被第三方侵入而造成的损失。\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_vm._v("\n      2.您于订立协议时已表示理解并同意免除我们与此相应的法律责任。如在本APP运营过程中出现我们误将您的账户终止，或变更您的有关信息，或部分停止您的各类权限，则我们将在您提出书面通知后合理期间内处理该等事宜，若因此给您带来不便甚至造成损失，您同意免除我们的相应法律责任。\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_vm._v("\n      3.您了解并同意，我们不对因下述任一情况而导致的任何损害赔偿承担责任： (a)使用或未能使用本APP服务； (b)对本APP服务的错误理解； (c)第三方未使用真实身份，或者未经批准的使用他人的账号或更改他人的数据； (d)任何非因本APP的原因而引起的与服务有关的损失。\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_vm._v("\n      4.对于任何本APP无法控制的原因（包括但不限于政府管制、通讯设施故障及其他不可抗力因素）导致的APP暂时关闭、用户信息泄露、被盗用、被篡改等非正常经营行为，本APP不承担任何责任。\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_vm._v("\n      5.您承认对于您利用本APP或信息而从事的各类行为，包括线上和线下，均为您个人行为且您个人对该类行为承担完全责任。您同意保障和维护APP及其他用户的利益，如因违反有关法律、法规或本协议项下的任何条款而给本APP或任何其他第三人造成损失，您同意承担由此造成的损害赔偿责任。\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_vm._v("\n      6.由于您将用户密码告知他人或与他人共享注册账户，由此导致的任何个人信息的泄露，任何由于黑客攻击、计算机病毒侵入或发作、因政府管制而造成的暂时性关闭等影响网络正常经营之不可抗力而造成的个人信息泄露、丢失、被盗用或被篡改等，由于本APP不拥有或不控制的公司以及我们不雇佣或不管理的人员所造成的个人信息的泄露，本APP不承担任何责任并应免于被追诉。\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_vm._v("\n      7.用户同意保障和维护数字校本平台APP及其他用户的利益，如因用户违反有关法律、 法规或本协议项下的任何条款而给本APP或任何其他第三人造成损失，用户同意承担由此造成的损害赔偿责任。在注册成为本APP用户或者使用本APP过程中，您与任何第三方之间发生任何纠纷，由纠纷各方自行解决，本APP并不承担任何责任。本APP不对您使用本APP的任何行为、效果或影响提供任何担保或条件，无论是明示、默示或法定的。\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_vm._v("四、知识产权")]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_vm._v("\n      1.无论您成为本APP之会员或使用本APP，均认可我们对本APP及本APP所收集、制作、发布之各类信息拥有完全知识产权或所有权，包括但不限于各类文档、图像、数据库等，除非法律明确规定该等权利属于会员个人以外，相关权限应涵盖包括复制、修改、改写、改编、发行、翻译、创造衍生性著作、出版、将前述内容(部分或全部)加以散布、展示等。您同意我们对所有会员提交的信息进行有关编排处理后形成的数据库拥有完全的知识产权。\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_vm._v("\n      2.如您将信息公布到本APP的任何公共区域，则表示您同意，同时您自动授予，并且您陈述并保证您有权授予本APP不可撤销的、永久的、非独占的、完全免费的、世界范围的许可。在该等许可下，您同意本APP使用、复制、执行、显示并传播该内容，您也同意我们基于该内容创作衍生作品或将该内容整合到其他作品中且我们对该等衍生作品或整合作品拥有完全的所有者权益。除已获得我们书面许可的情况外，您不得复制、修改、公布、传播、执行、转载、许可使用、创建衍生作品、转移显示、出售、转售、以非法手段获取或以任何其他方式处置本APP收集、制作、发布的各类信息。\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_vm._v("\n      3.请勿擅自复制或采用本APP所创造的用以制成网页的HTML。本APP对其HTML享有著作权。同时，本APP对其网址上的所有图标、图饰、图表、色彩、文字表述及其组合、版面设计、数据库均享有完全的著作权，对发布的信息均享有专有的发布和使用权，未经本APP同意，不得擅自复制、使用或转载。\n    ")])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "bold"
  }, [_vm._v("数字校本平台隐私政策1.0")]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_vm._v("本政策仅适用于上海互教智能科技有限公司的数字校本平台产品。")]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_vm._v("最新更新日期：2024年3月28日。")]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_vm._v("\n      如对本隐私政策或相关事宜有任何问题、建议、意见及咨询，您可随时通过发送邮件至"), _c('a', {
    attrs: {
      "href": "mailto:legal@fxbjy.com"
    }
  }, [_vm._v("legal@fxbjy.com")]), _vm._v("或拨打我们的客服电话"), _c('a', {
    attrs: {
      "href": "tel:19970080755"
    }
  }, [_vm._v("19970080755")]), _vm._v("等多种方式与我们联系，我们将在十五个工作日内受理并处理。\n    ")])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "ident bold"
  }, [_vm._v("本政策将帮助您了解以下内容：")]), _vm._v(" "), _c('ul', {
    staticStyle: {
      "margin-left": "2em"
    }
  }, [_c('li', [_vm._v("数字校本平台的个人信息收集使用规则")]), _vm._v(" "), _c('li', [_vm._v("我们如何保护您的个人信息")]), _vm._v(" "), _c('li', [_vm._v("您的权利")]), _vm._v(" "), _c('li', [_vm._v("我们会如何共享、转让、公开披露您的个人信息")]), _vm._v(" "), _c('li', [_vm._v("本政策如何更新")]), _vm._v(" "), _c('li', [_vm._v("如何联系我们")])]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_vm._v("\n      【特别提示】请仔细阅读《数字校本平台隐私政策1.0》（尤其是加粗划线的内容）并确定了解我们（上海互教智能科技有限公司）对您个人信息的处理规则。阅读过程中，如您有任何疑问，可联系我们的客服咨询，如果您不同意相关协议或其中任何条款约定，数字校本平台将暂时无法为您提供定制服务。本隐私政策与您所使用的数字校本平台服务以及该服务所包括的各种业务功能（以下统称“我们的产品与/或服务”）息息相关，希望您在使用我们的产品与/或服务前仔细阅读并确认您已经充分理解本政策所写明的内容，并让您可以按照本隐私政策的指引做出您认为适当的选择。本隐私政策中涉及的相关术语，我们尽量以简明扼要的表述，并提供进一步说明的链接，以便您更好地理解。您使用或在我们更新本隐私政策后（我们会及时提示您更新的情况）继续使用我们的产品与/或服务，即意味着您同意本隐私政策(含更新版本)内容，并且同意我们按照本隐私政策收集、使用、保存和共享您的相关信息。如对本隐私政策或相关事宜有任何问题，您可随时通过发送邮件至info@fxbjy.com 或拨打我们的任何一部客服电话等多种方式与我们联系 。\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_vm._v("一、 适用范围")]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_vm._v("\n      本隐私政策适用于数字校本平台。数字校本平台提供的所有服务，您访问数字校本平台网站、客户端，均适用本隐私政策。\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_vm._v("二、我们收集信息的原因和内容")]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_vm._v("\n      为了保障您能够流畅地使用我们的核心功能并向您提供更好、更优的服务，同时为了保障您的信息安全，我们将根据您使用的服务收集您的以下信息。\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_vm._v("1、您直接提供给我们的信息")]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_c('span', {
    staticClass: "bold blue"
  }, [_vm._v("当您注册时，您需要至少向我们提供您准备使用的数字校本平台账户名、密码、您本人的手机号码、电子邮箱地址（用于验证邮箱），我们将通过发送短信验证码或邮件的方式来验证您的身份是否有效。此时，您需要向我们提供以下信息：账号名称、头像（如有）和手机号码等。")]), _vm._v("提供上述信息并同意注册协议和本政策后，您可以使用数字校本平台的部分业务功能，包括：查看学生学情分析、组卷、阅卷、浏览数字校本平台内的内容等。"), _c('span', {
    staticClass: "bold blue"
  }, [_vm._v("在您注册数字校本平台账号时，我们会使用手机号码对您任课的班级进行绑定，便于将您与其他用户区分并准确判断您的学习情况，为您提供考情报告信息。")]), _vm._v("如您拒绝提供手机号码或进行学情信息绑定，您仍可浏览部分数字校本平台内的内容，但将无法使用查看学生学情分析、组卷、阅卷等核心功能。\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_vm._v("2、在您使用过程中产生的信息")]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_vm._v("\n      当您使用数字校本平台的某些业务功能时，为满足向您提供该产品和服务之目的，"), _c('span', {
    staticClass: "bold blue"
  }, [_vm._v("除注册信息外， 您还需要进一步向我们提供包括但不限于您的个人身份信息及其他为您提供服务所必需的信息，同时，我们的产品集成友盟+SDK(友盟同欣(北京)科技有限公司),友盟+SDK 需要收集您的设备信息(设备型号、操作系统版本、设备 Mac 地址、Android ID、GAID/OAID 广告标识符、IMEI、IMSI、设备序列号)、应用安装列表、网络状态等信息,用于提供统计分析服务、消息推送服务、基础反作弊能力。上述信息由 SDK 在您使用 App 过程中自动采集,仅用于实现前述统计分析、推送及反作弊目的,不会用于其他用途,也不会与第三方共享(法律法规另有规定的除外)。提供以上信息将有助于我们给您提供更优的服务体验;如果您不提供这些信息,并不会影响您使用知心慧学教师端的基本功能。友盟+SDK 的详细隐私政策请见:[友盟隐私政策链接：https://developer.umeng.com/docs/147377/detail/3038360]。")]), _vm._v("提供以上信息，将有助于我们给您提供更优的服务体验，如果您不提供这些信息， 并不会影响您使用数字校本平台的基本功能。如果您不使用特定产品和服务，则无需提供相关信息（以下将详细阐明）。\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_vm._v("\n      我们可能对您的使用信息、浏览信息进行记录，用来为您展示历史使用、浏览记录。\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_vm._v("\n      我们还可能为了提供服务及改进服务质量的合理需要而获得您的其他信息，包括您与客服联系时您提供的相关信息， 您参与问卷调查时向我们发送的问卷答复信息，以及您与我们的关联方、我们合作伙伴之间互动时我们获得的相关信息。 对于您的账号个人设置信息，我们可能会将它们进行关联，以便我们能在您登录其他设备时为您提供一致的服务。 我们可能会将来自某项服务的信息与来自其他服务的信息结合起来，以便为您提供服务、定制内容和建议。\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_vm._v("3、征得授权同意的例外")]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_vm._v("根据相关法律法规的规定，以下情形中收集您的个人信息无需征得您的授权同意：")]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_vm._v("（1）涉及国家安全与利益、社会公共利益；")]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_vm._v("（2）与犯罪侦查有关的相关活动；")]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_vm._v("（3）出于维护您或他人的生命财产安全但在特殊情况下无法获得您的及时授权；")]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_vm._v("（4）从其他合法公开的渠道中收集您的个人信息；")]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_vm._v("（5）法律法规规定的其他情形。")]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_vm._v("三、我们会如何使用您的信息")]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_vm._v("\n      收集您的信息是为了向您提供服务及提升服务质量，我们会根据本隐私政策的约定进行使用，在收集您的信息后，我们将通过技术手段对数据进行去标识化处理，去标识化处理的信息将无法识别主体。请您了解并同意，在此情况下我们有权使用已经去标识化的信息；并在不透露您个人信息的前提下，我们有权对用户数据库进行分析并予以合法使用。\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "ident bold blue"
  }, [_vm._v("您的信息主要有以下用途：")]), _vm._v(" "), _c('p', {
    staticClass: "ident bold blue"
  }, [_vm._v("（1）为您提供您使用的各项定制服务，并维护、改进这些服务。")]), _vm._v(" "), _c('p', {
    staticClass: "ident bold blue"
  }, [_vm._v("（2）帮助我们设计新服务，提升现有服务体验。")]), _vm._v(" "), _c('p', {
    staticClass: "ident bold blue"
  }, [_vm._v("（3）在我们提供服务时，用于身份验证、客户服务、安全防范、诈骗监测、存档和备份用途，确保我们向您提供的产品和服务的安全性。")]), _vm._v(" "), _c('p', {
    staticClass: "ident bold blue"
  }, [_vm._v("（4）邀请您参与数字校本平台活动和市场调查。")]), _vm._v(" "), _c('p', {
    staticClass: "ident bold blue"
  }, [_vm._v("（5）开展内部审计、数据分析和研究，以更好地改善我们的产品、服务及与用户之间的沟通。")]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_vm._v("四、我们可能如何收集信息")]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_vm._v("\n      1、您使用我们的服务时，我们会在您的计算机或移动设备上存储名为 Cookie 的小数据文件。Cookie 通常包含标识符、站点名称以及一些号码和字符。我们使用该等信息判断注册用户是否已经登录，提升服务/产品质量及优化用户体验。如您不希望个人信息保存在 Cookie 中，您可对浏览器进行配置，选择禁用 Cookie 功能。禁用 Cookie 功能后，可能影响您访问数字校本平台或不能充分取得数字校本平台提供的服务。\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_vm._v("\n      数字校本平台不会将 Cookie 用于本政策所述目的之外的任何用途。您可根据自己的偏好管理或删除Cookie。您可以清除计算机上保存的所有 Cookie，大部分网络浏览器都设有阻止 Cookie 的功能。\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_vm._v("2、设备权限调用")]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_c('span', {
    staticClass: "bold blue"
  }, [_vm._v("数字校本平台在提供服务的过程中，可能需要您开通一些设备权限，例如通知、相册、相机等访问权限。您也可以在设备的设置功能中随时选择关闭部分或者全部权限，从而拒绝数字校本平台收集相应的个人信息。")]), _vm._v("在不同设备中，权限显示方式及关闭方式可能有所不同，具体请参考设备及系统开发方说明或指引。")]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_vm._v("根据您的服务使用情况，我们可能会调用的权限如下：")]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_vm._v("（1）储存权限。当您下载及升级应用、试卷保存、阅卷信息保存、联系在线客服反馈问题时，我们会调用您的储存权限，保障您能顺利实现此功能。")]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_vm._v("（2）摄像头权限。当您提交意见反馈、修改头像时，我们将调用您的摄像头权限，保障您的使用。")]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_vm._v("（3）语音权限：当您使用数字校本平台直播课功能，或类似直播服务用于线上上课和发言时，我们将调用您设备的语音权限，以保证您能顺利实现此功能。")]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_vm._v("（4）短信权限：当您注册账号时，我们将调用短信权限，保障您能顺利完成注册。")]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_vm._v("五、我们会如何共享、转让、公开披露您的个人信息")]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_vm._v("1、共享")]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_vm._v("\n      数字校本平台不会在未经您同意或授权的情况下将您的个人信息提供给第三方。但是，经您确认同意，数字校本平台可在以下情况下共享您的个人信息：\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_vm._v("\n      在获取同意的情况下共享：获得您的明确同意后，数字校本平台会与其他方共享您的个人信息。\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_vm._v("\n      共享给数字校本平台的关联公司：在本政策声明的使用目的范围内，您的个人信息可能会与数字校本平台的关联公司共享。作为一项政策，我们只会共享必要的信息。关联公司如要改变个人信息的处理目的，将再次征求您的授权同意。\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_vm._v("\n      共享给授权合作伙伴：数字校本平台可能会与合作伙伴共享您的某些个人信息，以便给您提供服务、内容和建议。例如，数字校本平台向您寄送礼品（如有）时，数字校本平台必须与物流服务提供商共享您的个人信息才能安排寄送，或者安排合作伙伴向您提供服务。我们仅会出于特定、明确而合法的目的处理您的个人信息，并且只会共享提供服务所必要的信息。同时，我们会与其签署严格的保密协定，要求他们按照我们的说明、本政策以及其他任何相关的保密和安全措施来处理个人信息。在法定情形下的共享：我们可能会根据法律法规规定、诉讼争议解决需要，或按行政、司法机关依法提出的要求，对外共享您的个人信息。\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "ident bold blue"
  }, [_vm._v("\n      事先获得您明确同意的情况下，我们会在法律法规允许且不违背公序良俗的范围内，依据您的授权范围与第三方共享您的信息。\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_vm._v("\n      为数字校本平台App相关功能的实现与应用安全稳定的运行，我们可能会接入由第三方提供的软件开发包（SDK）实现相关目的。 我们会对合作方获取信息的软件工具开发包（SDK）进行严格的安全监测，以保护数据安全。\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_vm._v("\n      请注意，第三方SDK可能因为其版本升级、策略调整原因导致数据处理类型存在一定变化，请以其公示的官方说明为准。\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_vm._v("\n      1.1 第三方SDK目录\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_vm._v("\n      第三方SDK名称：微信 SDK\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_vm._v("\n      所属公司名称：深圳市腾讯计算机系统有限公司\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_vm._v("\n      收集个人信息类型：设备品牌、设备型号、设备版本、系统版本、生成ID、手机样式、手机名、iccid、bssid、MAC地址、IMSI、IMEI、IP地址、网络状态\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_vm._v("使用目的：授权登录、内容分享")]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_vm._v("收集方式：sdk本机采集")]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_vm._v("使用场景：微信授权登录、分享内容至微信")]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_vm._v("第三方SDK隐私政策或开发指南：")]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_c('a', {
    attrs: {
      "href": "https://developers.weixin.qq.com/doc/oplatform/Mobile_App/Share_and_Favorites/Share_and_Favorites.html"
    }
  }, [_vm._v("https://developers.weixin.qq.com/doc/oplatform/Mobile_App/Share_and_Favorites/Share_and_Favorites.html")])]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_vm._v("第三方公司名称：友盟同欣（北京）科技有限公司")]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_vm._v("产品/类型：友盟sdk")]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_vm._v("收集个人信息类型：IMEI/OAID/MAC/Android ID /IDFA/OpenUDID/GUID/IP地址/SIM卡IMSI信息等）")]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_vm._v("使用目的：云平台、企业协作、辅助运营")]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_vm._v("收集方式：sdk本机采集")]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_vm._v("功能：为成功调起您用户设备中应用，高效实现第三方登录和社会化分享功能，我们会收集系统在装的应用列表信息，提升您用户的使用体验")]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_vm._v("第三方隐私权政策链接：")]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_c('a', {
    attrs: {
      "href": "https://www.umeng.com/page/policy?spm=a211eg.10560647.0.0.eb2c34dcwKPqBz"
    }
  }, [_vm._v("https://www.umeng.com/page/policy?spm=a211eg.10560647.0.0.eb2c34dcwKPqBz")])]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_vm._v("第三方公司名称：华为终端有限公司")]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_vm._v("产品/类型：华为推送sdk")]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_vm._v("\n      收集个人信息类型：应用基本信息、设备标识信息（IMEI、Android ID、AAID和Push Token）、设备的硬件信息、系统基本信息和系统设置信息、应用安装列表信息、申请获取存储权限、电话权限\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_vm._v("使用目的：用于向华为手机用户推送消息")]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_vm._v("收集方式：sdk本机采集")]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_vm._v("使用场景：向用户推送消息时")]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_vm._v("第三方隐私权政策链接：")]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_c('a', {
    attrs: {
      "href": "https://developer.huawei.com/consumer/cn/doc/development/HMSCore-Guides/sdk-data-security-0000001050042177"
    }
  }, [_vm._v("https://developer.huawei.com/consumer/cn/doc/development/HMSCore-Guides/sdk-data-security-0000001050042177")])]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_vm._v("第三方公司名称：小米公司")]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_vm._v("产品/类型：小米推送sdk")]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_vm._v("收集个人信息类型：设备标识信息(SSID、OAID、加密的Android ID)、推送消息内容、设备信息(设备厂商、型号、归属地、运营商名称等)、通知栏设置、运营商信息、申请获取存储权限、位置权限")]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_vm._v("使用目的：用于向小米用户推送消息")]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_vm._v("收集方式：sdk本机采集")]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_vm._v("使用场景：向用户推送消息时")]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_vm._v("第三方隐私权政策链接：")]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_c('a', {
    attrs: {
      "href": "https://dev.mi.com/console/doc/detail?pId=1822"
    }
  }, [_vm._v("https://dev.mi.com/console/doc/detail?pId=1822")])]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_vm._v("第三方公司名称：珠海市魅族通讯设备有限公司")]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_vm._v("产品/类型：魅族消息推送服务sdk")]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_vm._v("收集个人信息类型：设备标识信息（IMEI）、运营商信息、申请获取存储权限")]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_vm._v("使用目的：用于向魅族手机用户推送消息")]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_vm._v("收集方式：sdk本机采集")]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_vm._v("使用场景：向用户推送消息时")]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_vm._v("第三方隐私权政策链接：")]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_c('a', {
    attrs: {
      "href": "https://www.meizu.com/legal.html"
    }
  }, [_vm._v("https://www.meizu.com/legal.html")])]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_vm._v("第三方公司名称：OPPO广东移动通信有限公司")]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_vm._v("产品/类型：OPPO推送sdk")]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_vm._v("收集个人信息类型：匿名用户ID（OAID）")]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_vm._v("使用目的：用于向OPPO用户推送消息")]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_vm._v("收集方式：sdk本机采集")]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_vm._v("使用场景：向用户推送消息时")]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_vm._v("第三方隐私权政策链接：")]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_c('a', {
    attrs: {
      "href": "https://security.oppo.com/cn/privacy.html"
    }
  }, [_vm._v("https://security.oppo.com/cn/privacy.html")])]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_vm._v("第三方公司名称：维沃移动通信有限公司")]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_vm._v("产品/类型：VIVO推送sdk")]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_vm._v("收集个人信息类型：匿名用户ID（OAID）")]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_vm._v("使用目的：用于向VIVO用户推送消息")]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_vm._v("收集方式：sdk本机采集")]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_vm._v("使用场景：向用户推送消息时")]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_vm._v("功能：用于消息推送")]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_vm._v("收集个人信息字段：匿名用户ID（OAID）")]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_vm._v("第三方隐私权政策链接：")]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_c('a', {
    attrs: {
      "href": "https://dev.vivo.com.cn/documentCenter/doc/366"
    }
  }, [_vm._v("https://dev.vivo.com.cn/documentCenter/doc/366")])]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_vm._v("第三方公司名称：深圳市腾讯计算机系统有限公司")]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_vm._v("产品/类型：腾讯bugly")]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_vm._v("收集个人信息类型：设备信息（IMEI/MAC/Android ID/IDFA/OpenUDID/GUID/IP地址/SIM卡IMSI信息等）")]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_vm._v("使用目的：云平台、企业协作、辅助运营")]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_vm._v("收集方式：sdk本机采集")]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_vm._v("功能：云平台、企业协作、辅助运营")]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_vm._v("第三方隐私权政策链接：")]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_c('a', {
    attrs: {
      "href": "https://privacy.qq.com/document/preview/fc748b3d96224fdb825ea79e132c1a56"
    }
  }, [_vm._v("https://privacy.qq.com/document/preview/fc748b3d96224fdb825ea79e132c1a56")])]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_vm._v("自启动和关联启动说明")]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_vm._v("\n      (1)、为确保本应用处于关闭或后台运行状态下可正常接收到客户端推送的信息，本应用须使用(自启动)能力，将存在一定频率通过 系统发送广播唤醒本应用自启动或关联启动行为，是因实现功能及服务所必要的。\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_vm._v("\n      (2)、当您打开内容类推送消息，在征得您的明确同意后，会跳转打开相关内容。在未征得您同意的情况下，则不会有自启动或关联启动。\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_vm._v("\n      (3)、当您打开本App内部下载的文件后，会关联启动第三方App。\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_vm._v("2、转让")]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_vm._v("我们不会将您的个人信息转让给任何公司、组织和个人，但以下情况除外：")]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_vm._v("事先获得您明确的同意或授权；")]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_vm._v("根据适用的法律法规、法律程序的要求、强制性的行政或司法要求所必须的情况进行提供；")]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_vm._v("符合与您签署的相关协议（包括在线签署的电子协议以及相应的平台规则）或其他的法律文件约定所提供；在涉及合并、收购、资产转让或类似的交易时，如涉及个人信息转让，我们会要求新的持有您个人信息的公司、组织继续受本隐私政策的约束，否则,我们将要求该公司、组织重新向您征求授权同意")]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_vm._v("3、公开披露")]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_vm._v("我们仅会在以下情况下，且采取符合法律和业界标准的安全防护措施的前提下，才会公开披露您的个人信息：")]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_vm._v("根据您的需求，在您明确同意的披露方式下披露您所指定的个人信息；")]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_vm._v("根据法律、法规的要求、强制性的行政执法或司法要求所必须提供您个人信息的情况下，我们可能会依据所要求的个人信息类型和披露方式公开披露您的个人信息。在符合法律法规的前提下，当我们收到上述披露信息的请求时，我们会要求必须出具与之相应的法律文件，如传票或调查函。我们坚信，对于要求我们提供的信息，应该在法律允许的范围内尽可能保持透明。我们对所有的请求都进行了慎重的审查，以确保其具备合法依据，且仅限于执法部门因特定调查目的且有合法权利获取的数据。在法律法规许可的前提下，我们披露的文件均在加密密钥的保护之下。")]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_vm._v("六、 关于未成年个人信息")]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_vm._v("我们的产品主要面向成人，我们重视对未成年人个人信息的保护。若您是18周岁以下的未成年人，在使用我们的服务或产品前，应事先取得您的家长或法定监护人的同意并在他们的指导下使用。若您是未成年人的监护人，当您对您所监护的未成年人的个人信息有相关疑问或拒绝进一步收集被监护人信息，或要求我们删除被监护人信息，请通过第十一条中的联系方式与我们联系。")]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_vm._v("七、 如何管理您的个人信息")]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_vm._v("我们将尽一切可能采取适当的技术手段，保证收集到的有关于您的个人信息的准确性，并保证及时进行更新。")]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_vm._v("1、更正或补充您的个人信息")]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_vm._v("除法律法规规定外，您有权随时访问和更正您的个人信息，具体包括：")]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_vm._v("\n      Web端路径：您可以在右上角点击头像，页面的“个人资料”菜单中查阅您提交给数字校本平台的所有个人信息，你也可通过上述途径更新除教师认证信息之外的其他个人信息（您的姓名、学科、手机号、岗位）。移动端具体路径为： “我的”进入我的数字校本平台--账号管理：您也可以通过「我的」-【意见反馈】页面，按照数字校本平台的相关政策及提示，或联系在线客服，对您的个人信息进行访问、更正。\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "ident bold"
  }, [_vm._v("2、删除您的个人信息及注销账号")]), _vm._v(" "), _c('p', {
    staticClass: "ident bold blue"
  }, [_vm._v("\n      您可以通过「我的」-【账号管理】页面，点击账号注销，填写账号及密码后申请注销，或联系在线客服，或拨打客服电话19970080755，我们将在2周内帮助您进行注销账号及删除有关信息的处理。\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_vm._v("3、消息管理推送")]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_vm._v("\n      对于您在使用服务的过程中提供的设备号，我们在运营过程中可能会向您的设备发送消息推送，用于用户消息告知、任务提醒等目的。在「我的」-【消息推送管理】页面，您可以选择是否接受定向推送信息，或选择接受部分情况下的推送通知。IOS系统用户可以在[系统设置]-[通知]-[数字校本平台]页面设置是否允许通知，安卓系统用户可在[系统设置]-[通知]-[数字校本平台]页面设置是否允许通知。\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_vm._v("八、我们会如何保护和保存您的个人信息")]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_vm._v("\n      数字校本平台重视个人信息的安全。我们采取互联网业内标准做法来保护您的个人信息，防止信息遭到未经授权访问、披露、使用、修改、损坏或丢失。我们会采取一切合理可行的措施，保护您的个人信息。 我们会采取一切合理可行的措施，确保未收集与数字校本平台提供的服务无关的个人信息。我们会尽全力保护您的个人信息，但请您理解，由于技术的限制以及可能存在的各种恶意手段，在互联网行业，不可能始终保证信息百分之百的安全。您需要了解，您接入我们的服务所用的系统和通讯网络，有可能因我们可控范围外的因素而出现问题。我们仅允许有必要知晓这些信息的数字校本平台及数字校本平台关联方的员工、合作伙伴访问个人信息，并为此设置了严格的访问权限控制和监控机制。我们同时要求可能接触到您个人信息的所有人员履行相应的保密义务。如果未能履行这些义务，可能会被追究法律责任或被中止与数字校本平台的合作关系。我们同时要求可能接触到您个人信息的所有人员履行相应的保密义务。如果未能履行这些义务，可能会被追究法律责任或被中止与数字校本平台的合作关系。在发生个人信息安全事件的场合，我们将按照法律法规的要求，及时向您告知：安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施等。我们将及时将事件相关情况以邮件、信函、电话、推送通知等方式告知您，难以逐一告知个人信息主体时，我们会采取合理、有效的方式发布公告。同时，我们还将按照监管部门要求，主动上报个人信息安全事件的处置情况。我们在中华人民共和国境内收集和产生的个人信息将存储在中华人民共和国境内。如果日后为处理跨境业务，需要向境外机构传输境内收集的相关个人信息的，我们会事先征得您的同意，按照法律、行政法规和相关监管部门的规定执行，并通过签订协议、核查等有效措施，要求境外机构为所获得的个人信息保密。我们仅会在达到本政策所述目的所必需的时限内保存您的个人信息，但为了遵守适用的法律法规、法院判决或裁定、其他有权机关的要求、维护公共利益等目的，我们可能会将个人信息保存时间予以适当延长。\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_vm._v("九、 第三方提供商及其服务")]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_vm._v("\n      为确保流畅的浏览体验，您可能会收到来自数字校本平台及其合作伙伴外部的第三方（以下简称「第三方」）提供的内容或网络链接。数字校本平台对此类第三方无控制权。您可选择是否访问第三方提供的链接、内容、产品和服务。数字校本平台无法控制第三方的隐私和个人信息保护政策，此类第三方不受到本政策的约束。您在向第三方提交个人信息之前，请确保您阅读并认可这些第三方的隐私保护政策。\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_vm._v("十、本政策如何更新及适用范围")]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_vm._v("为给用户提供更好的服务，数字校本平台的业务将不时变化，本隐私政策也将随之调整。数字校本平台会通过在数字校本平台网站、移动端上发出更新版本并提醒您相关内容的更新，也请您访问数字校本平台以便及时了解最新的隐私政策。数字校本平台保留不时更新或修改本政策的权利。如果该等修改造成您在本政策下权利的实质减少，数字校本平台会通过不同渠道向您发送变更通知，包括但不限于网站公示、短信、邮件通知等方式。 若您不同意修改后的隐私政策，您有权并应立即停止使用数字校本平台的服务。如果您继续使用数字校本平台的服务，则视为您接受数字校本平台对本政策相关条款所做的修改。")]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_vm._v("数字校本平台的所有服务均适用本政策。但某些服务有其特定的隐私政策，该等特定的隐私政策更具体地说明数字校本平台在该服务中如何处理您的信息。如本政策与特定服务的隐私政策有不一致之处，请以该特定隐私政策为准。")]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_vm._v("十一、联系我们")]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_vm._v("您在使用数字校本平台的过程中对本隐私政策或对您个人信息有任何问题、建议、意见及咨询，请通过以下联系方式与我们联系：")]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_vm._v("联系电话"), _c('a', {
    attrs: {
      "href": "tel:19970080755"
    }
  }, [_vm._v("19970080755")])]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_vm._v("邮箱"), _c('a', {
    attrs: {
      "href": "mailto:legal@fxbjy.com"
    }
  }, [_vm._v("legal@fxbjy.com")])]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_vm._v("\n      如您有相关申诉问题，也可通过上方联系方式与我们联系。若您对我们的回复不满意，特别是您认为我们的个人信息处理行为损害了您的合法权益，在您向我们反馈后我们无法提供让您满意的回复且拒绝改进的，您可以向相关监管机构进行投诉和举报。\n    ")])])])
}]}

/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home"
  }, [_c('section', {
    staticClass: "joint-assessment"
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('section', {
    staticClass: "cpzx"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "products-description"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.productsType == 1),
      expression: "productsType==1"
    }],
    staticClass: "description-box"
  }, [_vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.productsType == 2),
      expression: "productsType==2"
    }],
    staticClass: "description-box"
  }, [_vm._m(6), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._m(8)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.productsType == 3),
      expression: "productsType==3"
    }],
    staticClass: "description-box"
  }, [_vm._m(9), _vm._v(" "), _vm._m(10), _vm._v(" "), _vm._m(11)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.productsType == 4),
      expression: "productsType==4"
    }],
    staticClass: "description-box"
  }, [_vm._m(12), _vm._v(" "), _vm._m(13), _vm._v(" "), _vm._m(14)])]), _vm._v(" "), _c('div', {
    staticClass: "products-img"
  }, [_c('div', {
    staticClass: "img-big"
  }, [_c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.productsType == 1),
      expression: "productsType==1"
    }],
    attrs: {
      "src": __webpack_require__(149),
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.productsType == 2),
      expression: "productsType==2"
    }],
    attrs: {
      "src": __webpack_require__(150),
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.productsType == 3),
      expression: "productsType==3"
    }],
    attrs: {
      "src": __webpack_require__(151),
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.productsType == 4),
      expression: "productsType==4"
    }],
    attrs: {
      "src": __webpack_require__(152),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "arrow-left",
    on: {
      "click": _vm.productsLeft
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(432),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "arrow-right",
    on: {
      "click": _vm.productsRight
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(433),
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "img-min"
  }, [_c('img', {
    class: {
      'active': _vm.productsType === 1
    },
    attrs: {
      "src": __webpack_require__(149),
      "alt": ""
    },
    on: {
      "click": function($event) {
        _vm.productsType = 1
      }
    }
  }), _vm._v(" "), _c('img', {
    class: {
      'active': _vm.productsType === 2
    },
    attrs: {
      "src": __webpack_require__(150),
      "alt": ""
    },
    on: {
      "click": function($event) {
        _vm.productsType = 2
      }
    }
  }), _vm._v(" "), _c('img', {
    class: {
      'active': _vm.productsType === 3
    },
    attrs: {
      "src": __webpack_require__(151),
      "alt": ""
    },
    on: {
      "click": function($event) {
        _vm.productsType = 3
      }
    }
  }), _vm._v(" "), _c('img', {
    class: {
      'active': _vm.productsType === 4
    },
    attrs: {
      "src": __webpack_require__(152),
      "alt": ""
    },
    on: {
      "click": function($event) {
        _vm.productsType = 4
      }
    }
  })])])])]), _vm._v(" "), _vm._m(15), _vm._v(" "), _c('section', {
    staticClass: "login-wrap"
  }, [_c('Login')], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "zxhx"
  }, [_c('div', {
    staticClass: "title-box"
  }, [_c('h2', {
    staticClass: "title"
  }, [_vm._v("进一步了解知心慧学")]), _vm._v(" "), _c('i', {
    staticClass: "border-bottom"
  })]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "top clearfix"
  }, [_c('div', {
    staticClass: "images fl"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(461),
      "alt": "业务范围"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text fr"
  }, [_c('h3', {
    staticClass: "ywfw"
  }, [_vm._v("我们的业务范围")]), _vm._v(" "), _c('p', [_vm._v("\n              知心慧学一直致力于互联网教育领域的产品研发，着力于用大数据及人工智能等信息技术提升教育的质量与效率。与基础教育学校一道，努力探索让信息技术深度融入于学校教学，在互联网+的大时代背景下推动学校的转型与发展。")])])]), _vm._v(" "), _c('div', {
    staticClass: "bottom clearfix"
  }, [_c('div', {
    staticClass: "text fl"
  }, [_c('h3', {
    staticClass: "sjwj"
  }, [_vm._v("强大的数据挖掘能力")]), _vm._v(" "), _c('p', [_vm._v("\n              知心慧学强大的数据挖掘与分析能力是实现个性化、精准化教学的基础与保障。我们将每个教师、每个学生、每场考试的过程数据收集记录下来，将每次鼠标点击、每道试题的分数转化为清晰的个人能力模型和精准的学情分析报告。")])]), _vm._v(" "), _c('div', {
    staticClass: "images fr"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(454),
      "alt": "数据挖掘"
    }
  })])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "jjfa"
  }, [_c('div', {
    staticClass: "title-box"
  }, [_c('h2', {
    staticClass: "title"
  }, [_vm._v("知心慧学基于测评大数据的解决方案")]), _vm._v(" "), _c('i', {
    staticClass: "border-bottom"
  })]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "card gstg"
  }, [_c('div', {
    staticClass: "card-in"
  }, [_c('div', {
    staticClass: "card-front"
  }, [_c('div', {
    staticClass: "card-title"
  }, [_c('h4', {
    staticClass: "text"
  }, [_vm._v("公司提供")])])]), _vm._v(" "), _c('div', {
    staticClass: "card-back"
  }, [_c('p', [_c('em', {
    staticClass: "sign"
  }, [_vm._v("·")]), _vm._v("周期作业、月度测评、学业评估的分析报告及错题本、个性化学习宝。基于大数据分析的网络课（每学期平时5次双师课，师生共同学习）\n                基于大数据分析的典型课（对学生 假期15次）\n                基于大数据分析个性化典型问题的微课、闯关训练")]), _vm._v(" "), _c('p', [_c('em', {
    staticClass: "sign"
  }, [_vm._v("·")]), _vm._v("专职学管，负责数据采集及打印试卷、错题本、个性化学习宝等服务")]), _vm._v(" "), _c('p', [_c('em', {
    staticClass: "sign"
  }, [_vm._v("·")]), _vm._v("办公电脑、大型扫描仪、打印机")]), _vm._v(" "), _c('p', [_c('em', {
    staticClass: "sign"
  }, [_vm._v("·")]), _vm._v("知心慧学大数据教育系统")])])])]), _vm._v(" "), _c('div', {
    staticClass: "card falj"
  }, [_c('div', {
    staticClass: "card-in"
  }, [_c('div', {
    staticClass: "card-front"
  }, [_c('div', {
    staticClass: "card-title"
  }, [_c('h4', {
    staticClass: "text"
  }, [_vm._v("方案逻辑")])])]), _vm._v(" "), _c('div', {
    staticClass: "card-back"
  }, [_c('p', [_c('em', {
    staticClass: "sign"
  }, [_vm._v("·")]), _vm._v("测试数据采集")]), _vm._v(" "), _c('p', [_c('em', {
    staticClass: "sign"
  }, [_vm._v("·")]), _vm._v("测试数据分析")]), _vm._v(" "), _c('p', [_c('em', {
    staticClass: "sign"
  }, [_vm._v("·")]), _vm._v("线下个性化训练方案")]), _vm._v(" "), _c('p', [_c('em', {
    staticClass: "sign"
  }, [_vm._v("·")]), _vm._v("线上网络方案")]), _vm._v(" "), _c('p', [_c('em', {
    staticClass: "sign"
  }, [_vm._v("·")]), _vm._v("线上典型考点微课学习及闯关训练")])])])]), _vm._v(" "), _c('div', {
    staticClass: "card xxtg"
  }, [_c('div', {
    staticClass: "card-in"
  }, [_c('div', {
    staticClass: "card-front"
  }, [_c('div', {
    staticClass: "card-title"
  }, [_c('h4', {
    staticClass: "text"
  }, [_vm._v("学校提供")])])]), _vm._v(" "), _c('div', {
    staticClass: "card-back"
  }, [_c('p', [_c('em', {
    staticClass: "sign"
  }, [_vm._v("·")]), _vm._v("大数据中心（学管办公室，30~60平方米，通电、通网）")]), _vm._v(" "), _c('p', [_c('em', {
    staticClass: "sign"
  }, [_vm._v("·")]), _vm._v("PAD学习教室（1~2间，每间50~60个座位，通电、通网）")])])])]), _vm._v(" "), _c('div', {
    staticClass: "card lszsm"
  }, [_c('div', {
    staticClass: "card-in"
  }, [_c('div', {
    staticClass: "card-front"
  }, [_c('div', {
    staticClass: "card-title"
  }, [_c('h4', {
    staticClass: "text"
  }, [_vm._v("老师做什么")])])]), _vm._v(" "), _c('div', {
    staticClass: "card-back"
  }, [_c('p', [_c('em', {
    staticClass: "sign"
  }, [_vm._v("·")]), _vm._v("检查学校生成错题本、个性化学习宝的情况")]), _vm._v(" "), _c('p', [_c('em', {
    staticClass: "sign"
  }, [_vm._v("·")]), _vm._v("组织学生参加网络双师课，并对学生进行指导")]), _vm._v(" "), _c('p', [_c('em', {
    staticClass: "sign"
  }, [_vm._v("·")]), _vm._v("组织学生参加PAD微课学习，并随堂指导讲解")]), _vm._v(" "), _c('p', [_c('em', {
    staticClass: "sign"
  }, [_vm._v("·")]), _vm._v("参加网络研修，学习方法、技巧，提升教学能力")])])])]), _vm._v(" "), _c('div', {
    staticClass: "card xszsm"
  }, [_c('div', {
    staticClass: "card-in"
  }, [_c('div', {
    staticClass: "card-front"
  }, [_c('div', {
    staticClass: "card-title"
  }, [_c('h4', {
    staticClass: "text"
  }, [_vm._v("学生做什么")])])]), _vm._v(" "), _c('div', {
    staticClass: "card-back"
  }, [_c('p', [_c('em', {
    staticClass: "sign"
  }, [_vm._v("·")]), _vm._v("看分析报告了解薄弱点")]), _vm._v(" "), _c('p', [_c('em', {
    staticClass: "sign"
  }, [_vm._v("·")]), _vm._v("完成错题本、个性化学习宝")]), _vm._v(" "), _c('p', [_c('em', {
    staticClass: "sign"
  }, [_vm._v("·")]), _vm._v("通过网络学习")]), _vm._v(" "), _c('p', [_c('em', {
    staticClass: "sign"
  }, [_vm._v("·")]), _vm._v("运用PAD学习薄弱考点微课，并完成闯关训练")])])])]), _vm._v(" "), _c('div', {
    staticClass: "card ldzsm"
  }, [_c('div', {
    staticClass: "card-in"
  }, [_c('div', {
    staticClass: "card-front"
  }, [_c('div', {
    staticClass: "card-title"
  }, [_c('h4', {
    staticClass: "text"
  }, [_vm._v("领导做什么")])])]), _vm._v(" "), _c('div', {
    staticClass: "card-back"
  }, [_c('p', [_c('em', {
    staticClass: "sign"
  }, [_vm._v("·")]), _vm._v("校长或年级主任主抓，制定奖惩制度")]), _vm._v(" "), _c('p', [_c('em', {
    staticClass: "sign"
  }, [_vm._v("·")]), _vm._v("制定考练计划，统一考试，统一阅卷")]), _vm._v(" "), _c('p', [_c('em', {
    staticClass: "sign"
  }, [_vm._v("·")]), _vm._v("及时反馈，及时讲评")]), _vm._v(" "), _c('p', [_c('em', {
    staticClass: "sign"
  }, [_vm._v("·")]), _vm._v("组织学生学习pad课程")])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title-box"
  }, [_c('h2', {
    staticClass: "title"
  }, [_vm._v("产品中心")]), _vm._v(" "), _c('i', {
    staticClass: "border-bottom"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "name-wrap"
  }, [_c('span', {
    staticClass: "name"
  }, [_vm._v("个性化学习宝")]), _vm._v(" "), _c('i', {
    staticClass: "triangle"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-big"
  }, [_c('p', [_vm._v("查漏补缺，举一反三，触类旁通，快速掌握")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-min"
  }, [_c('p', [_vm._v("量身定制个性化训练方案， 查缺补漏，举一反三，避免学生盲目训练，方便纠错学习。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "name-wrap"
  }, [_c('span', {
    staticClass: "name"
  }, [_vm._v("错题本")]), _vm._v(" "), _c('i', {
    staticClass: "triangle"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-big"
  }, [_c('p', [_vm._v("每天20至30分钟提升学习效率")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-min"
  }, [_c('p', [_vm._v("明晰自身学习的缺漏与不足，瞄准目标与方向。节省抄写的时间精力，保留作答原笔迹，提高回顾学习效率。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "name-wrap"
  }, [_c('span', {
    staticClass: "name"
  }, [_vm._v("教学宝")]), _vm._v(" "), _c('i', {
    staticClass: "triangle"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-big"
  }, [_c('p', {
    staticStyle: {
      "letter-spacing": "-2px"
    }
  }, [_vm._v("打印整合成册，让老"), _c('br'), _vm._v("师学生“教”“学”更方便”")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-min"
  }, [_c('p', [_vm._v("将答题详情、学情统计、学生成绩动态跟踪表、班级变式训练题等整理成册帮助教师科学备课、精准讲评、个性化授课。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "name-wrap"
  }, [_c('span', {
    staticClass: "name"
  }, [_vm._v("教研网")]), _vm._v(" "), _c('i', {
    staticClass: "triangle"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-big"
  }, [_c('p', [_vm._v("同步教研资源，骨干教师在线直播")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-min"
  }, [_c('p', [_vm._v("针对教师教学当中遇到的教材分析、教学目标、教学设计、学法指导、特色创新、课时作业设计等实际问题，开展在线互动讲座，帮助教师在备课、上课和布置训练时开阔视野，点拨思维。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "gstd"
  }, [_c('div', {
    staticClass: "title-box"
  }, [_c('h2', {
    staticClass: "title"
  }, [_vm._v("我们的团队")]), _vm._v(" "), _c('i', {
    staticClass: "border-bottom"
  })]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "card-box"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(436),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "name"
  }, [_vm._v("服务团队")])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(459),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "name"
  }, [_vm._v("研发团队")])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(438),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "name"
  }, [_vm._v("技术团队")])])]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("\n          风向标科技拥有强大的技术实力，在上海和南昌分别设立技术中心，拥有专职技术人员近百名，多人拥有海外上市技术公司的管理经验，团队服务过的在线测评、大数据分析处理的用户级别达千万。风向标技术团队始终紧跟前沿技术，技术的延伸性和先进性有机结合，形成了真正可靠稳定的技术优势，在大数据和人工智能领域都有专业建树。")])])])
}]}

/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sign"
  }, [_c('div', {
    staticClass: "sign_head"
  }, [_vm._v("学生签字")]), _vm._v(" "), (!_vm.isInvalid) ? [_c('div', {
    staticClass: "sign_panel sign_info"
  }, [_c('div', {
    staticClass: "sign_item"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "sign_info-val"
  }, [_vm._v("\n          " + _vm._s(_vm.data.outCode) + "\n        ")])]), _vm._v(" "), _vm._l((_vm.data.outputDetails), function(item) {
    return [_c('div', {
      staticClass: "sign_item"
    }, [_vm._m(1, true), _vm._v(" "), _c('div', {
      staticClass: "sign_info-val"
    }, [_vm._v("\n            " + _vm._s(item.itemName) + "\n          ")])]), _vm._v(" "), _c('div', {
      staticClass: "sign_item"
    }, [_vm._m(2, true), _vm._v(" "), _c('div', {
      staticClass: "sign_info-val"
    }, [_vm._v("\n            " + _vm._s(item.no) + "\n          ")])])]
  }), _vm._v(" "), _c('div', {
    staticClass: "sign_item"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "sign_info-val"
  }, [_vm._v("\n          " + _vm._s(_vm.data.studentNo) + "\n        ")])])], 2), _vm._v(" "), _c('div', {
    staticClass: "sign_panel sign_clazzlist"
  }, _vm._l((_vm.data.signDetails), function(item) {
    return _c('div', {
      key: item.clazzId,
      staticClass: "sign_item",
      on: {
        "click": function($event) {
          return _vm.goSignStu(item)
        }
      }
    }, [_c('span', {
      staticClass: "sign_item-label"
    }, [_vm._v(_vm._s(item.clazzName))]), _vm._v(" "), _c('div', [(item.classSign) ? _c('span', {
      staticClass: "sign_yq"
    }, [_vm._v("已签")]) : _c('span', {
      staticClass: "sign_wq"
    }, [_vm._v("未签")]), _vm._v(" "), _c('img', {
      staticClass: "sign_icon",
      attrs: {
        "src": __webpack_require__(427),
        "alt": ""
      }
    })])])
  }), 0)] : _c('div', {
    staticClass: "sign_invalid"
  }, [_vm._v("该链接已失效")])], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sign_item-label"
  }, [_c('img', {
    staticClass: "sign_icon",
    attrs: {
      "src": __webpack_require__(420),
      "alt": ""
    }
  }), _vm._v("出库单号：\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sign_item-label"
  }, [_c('img', {
    staticClass: "sign_icon",
    attrs: {
      "src": __webpack_require__(145),
      "alt": ""
    }
  }), _vm._v("品目名称：\n          ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sign_item-label"
  }, [_c('img', {
    staticClass: "sign_icon",
    attrs: {
      "src": __webpack_require__(421),
      "alt": ""
    }
  }), _vm._v("发货数量：\n          ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sign_item-label"
  }, [_c('img', {
    staticClass: "sign_icon",
    attrs: {
      "src": __webpack_require__(144),
      "alt": ""
    }
  }), _vm._v("领用人数：\n        ")])
}]}

/***/ }),
/* 536 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "user-know"
  }, [_c('div', {
    staticClass: "update"
  }, [_c('p', [_vm._v("更新日期：2025年2月20日")]), _vm._v(" "), _c('p', [_vm._v("生效日期：2025年2月20日")])]), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("上海互教智能科技有限公司")]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "title"
  }, [_vm._v("产品服务协议")]), _vm._v(" "), _c('p', [_vm._v("\n      尊敬的用户：\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_vm._v("\n      您好！欢迎您使用上海互教智能科技有限公司（以下简称“上海互教”或“服务商”）出品的“数字校本平台”产品及配套服务。为使您的使用过程便捷，准确提升产品使用效率，请您认真阅读本协议， 您在阅读并确认使用上述产品后即表示您同意本协议的内容。\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_vm._v("\n      上海互教智能科技有限公司（以下简称“上海互教”或“服务商”、“公司”）为您（指通过登录APP或网站、公众号、小程序等方式购买并使用上海互教“数字校本平台”产品及配套服务的终端客户，以下也称为“用户”）提供“数字校本平台”产品和配套服务（以下简称“本产品”、“产品”），您自愿购买上述产品并基于购买产品后的使用而作出如下意思表示和授权，以下意思表示及授权均为您真实意愿，您同意承担由此带来的一切风险和责任。如果您是未成年人，则请您在法定监护人陪同下审阅和判断是否同意本协议的内容，未成年人使用本产品的行为视为已获得了法定监护人的认可。如果您不同意接受本协议的全部条款，则您无权注册、登录或使用本协议所涉及产品和服务，您下载、安装、使用本产品等行为，则意味着您将自愿遵守本协议及本产品的其他有关规则，并完全服从于本产品的统一管理。\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_vm._v("\n      上海互教有权根据业务需要对本协议不定时进行调整，并将调整后的协议公布于公司官网或者产品APP、公众号、小程序中，如果您不同意调整后的本协议的，您应当停止使用本产品，否则，如果在公司调整本协议并公布后，您继续使用本产品提供的服务的，则视为您同意遵守调整后的协议。\n    ")])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "bold"
  }, [_vm._v("一、关于购买产品")]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_vm._v("1、用户系自愿购买本产品，并通过线上或线下的方式向上海互教支付用以购买产品的费用，用户用以登录产品使用端口的账号来自上海互教的授予。")]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_vm._v("2、用户已具备与购买行为相适应的智力、健康状况，或经用户的法定监护人的同意购买本产品，并充分理解、知悉购买产品和使用产品行为产生的法律效果以及基于购买和使用产品的行为产生的个人信息采集情况。")]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_vm._v("3、经上海互教许可，用户使用试用账号登录产品使用端口，并不表示用户同意即时付费，但这并不影响为正常使用产品而授权上海互教采集用户的个人信息。")]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_vm._v("4、产品的试用期限届满后，用户无意付费购买的，用户同意上海互教随时收回上海互教授予本人的登录账号。")])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "bold"
  }, [_vm._v("二、用户权利和义务")]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_vm._v("\n      1、用户应妥善保管自己的账号、密码，不得转让、出借、出租、出售或分享予他人使用。否则上海互教有权根据实际情况暂时封停或永久查封此账号，当用户的账号或密码遭到未经授权的使用时，用户应当立即通知上海互教，否则未经授权的使用行为均视为用户本人行为。\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_vm._v("\n      2、上海互教有权随时对本产品内容等进行调整，包括但不限于增加、删除、修改本产品服务内容，一旦本产品的服务内容发生增加、删除、修改，公司将在相关页面上进行提示；如果用户不同意相关变更和修改，可以取消已经获取的服务并停止使用；如果用户继续使用本产品提供的服务，则视为用户已经接受全部变更、修改。除非另有明确约定，否则用户使用本产品内新增的服务内容将同样受本协议各项条款的约束。\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_vm._v("\n      3、本产品内提供的服务分为试用期间的免费服务和正式使用的收费服务。对于现阶段免费提供的服务内容，公司有权随时根据公司政策的调整将其变更为收费服务，如果发生该等变更的，公司将提前告知用户，如果用户不同意的，可以停止使用该服务。对于收费的服务内容，公司有权自行确定该等服务的价格并不时调整，调整后的价格将在本产品平台中进行公示或以其他方式告知用户，如果用户不同意调整后的价格的，则用户可以在其原购买的收费服务到期后停止付费购买收费服务。如果用户在公司调整价格并公示或告知后，仍继续购买收费服务的，则视为用户同意该调整后的价格。\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_vm._v("\n      4、用户如对付费购买的服务不满意的，有权终止服务。用户需在规定时间内，在客户端自行申请或拨打客服电话，申请终止服务及退款，退款金额按照客户端公示的退款规则计算，公司有权根据业务发展不时调整退款规则并在客户端内公示；公司有权保留已终止服务的用户的所有使用信息，对用户在使用付费服务期间发生的违反本协议及相关规定的行为，公司仍有权行使本协议规定的权利并追究用户的法律责任。\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_vm._v("\n      5、公司不时将对付费服务提供优惠政策或开展优惠活动，该等优惠政策或优惠活动以本产品平台上的实时信息为准，用户知悉并认可，公司有权自行决定是否提供优惠政策或开展优惠互动，以及优惠政策或优惠活动的内容、条件和有效期，并不时进行调整或终止。\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_vm._v("\n      6、公司禁止以任何形式倒卖、贩售、出租、出借、转让用户账号的行为，一经查明，公司将采取包括但不限于封号、封禁IP、追究相关责任人法律责任的处理措施。\n    ")])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "bold"
  }, [_vm._v("三、平台管理")]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_vm._v("\n      1、用户应保证注册、登录并使用的账号符合中国相关法律法规的规定，符合《互联网用户账号名称管理规定》，符合本协议的各项规定。公司有权对用户注册、登录并使用的账号名称、头像和简介等注册信息进行审核，用户确保其使用的用户账号名称、头像和简介等信息中不得出现违法和不良信息，不存在以虚假信息骗取账号名称注册的情形；用户应确保其使用的用户账号名称不得为冒用关联机构或社会名人注册的账号名称。\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_vm._v("\n      2、如果用户以虚假信息骗取账号名称注册，或用户的账号头像、简介等注册信息存在违法和不良信息的，公司有权采取通知限期改正、暂停使用、注销登记等措施；如果用户冒用关联机构或社会名人注册账号名称的，公司有权注销用户的账号，并向互联网信息内容主管部门报告。\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_vm._v("\n      3、凡用户存在发布广告、暴力、色情、政治、宗教等内容，或抄袭、模仿管理人员ID，用以假冒管理人员或破坏管理人员形象，或模仿或盗用他人ID个人签名，发布的内容包含有严重影响网友浏览的内容或格式，或者存在其他扰乱本产品秩序的，或影响公司正常经营行为的，公司有权删除其相应账号，情节严重者，将酌情封禁对应IP。\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_vm._v("\n      4、公司提供账号注销功能，可以在本产品中实现。注销账号之后此账号内的数据无法恢复，账号信息内容也将全部清除，包含但不限于该账号发布过的文章、评论等。注销行为操作后无法撤销，请用户谨慎申请。\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_vm._v("\n      5、投诉和举报：如果用户认为本产品中的信息、资料、内容等存在违反法律法规及本产品相关管理规定的，涉嫌侮辱或者诽谤他人，或者侵犯用户或第三方的知识产权或其他合法权利情形的，您可以通过本产品内的专用渠道进行举报、投诉，或者向公司官方邮箱info@fxbjy.com发送权利通知书，公司将在收到您的投诉后将依据中国法律法规和政府规范性文件及本产品平台管理规定采取措施进行处理，包括但不限于移除相关内容或屏蔽相关链接，以及其他公司认为适当的处理方式，情节严重者，公司有权向政府相关部门进行举报。\n    ")])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "bold"
  }, [_vm._v("四、知识产权")]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_vm._v("\n      1、无论您成为本产品之会员或使用本产品，均认可公司对本产品及本产品所收集、制作、发布之各类信息拥有完全知识产权或所有权，包括但不限于各类文档、图像、数据库等，除非法律明确规定该等权利属于用户个人以外，相关权限应涵盖包括复制、修改、改写、改编、发行、翻译、创造衍生性著作、出版、将前述内容(部分或全部)加以散布、展示等。您同意公司对您提交的信息进行有关编排处理后形成的数据库拥有完全的知识产权。\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_vm._v("\n      2、如您将信息公布到本产品的任何公共区域，则表示您同意，同时您自动授予，并且您陈述并保证您有权授予本产品不可撤销的、永久的、非独占的、完全免费的、中华人民共和国范围的许可。在该等许可下，您同意本产品使用、复制、执行、显示并传播该内容，您也同意公司基于该内容创作衍生作品或将该内容整合到其他作品中且公司对该等衍生作品或整合作品拥有完全的所有者权益。除已获得公司书面许可的情况外，您不得复制、修改、公布、传播、执行、转载、许可使用、创建衍生作品、转移显示、出售、转售、以非法手段获取或以任何其他方式处置本产品收集、制作、发布的各类信息。\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_vm._v("\n      3、请勿擅自复制或采用本产品所创造的用以制成网页的HTML。公司对其HTML享有著作权。同时，公司对其网址上的所有图标、图饰、图表、色彩、文字表述及其组合、版面设计、数据库均享有完全的著作权，对发布的信息均享有专有的发布和使用权，未经公司同意，不得擅自复制、使用或转载。\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_vm._v("\n      4、未经公司事先许可，禁止使用任何机器人、爬虫程序、其他自动设备，或手动程序等来监视或复制本产品网页或其所包含的任何内容。否则，公司有权依法追究法律责任。\n    ")])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "bold"
  }, [_vm._v("五、关于个人隐私和信息采集")]), _vm._v(" "), _c('p', [_vm._v("（一）信息采集授权")]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_vm._v("1、采集途径。您不可撤销地授权的上海互教以为您提供产品之目的，通过以下途径获取本人信息：")]), _vm._v(" "), _c('p', {
    staticClass: "ident bold"
  }, [_vm._v("（1）您确认，您在申请试用和正式使用本产品（包括APP移动端、网站、H5页面链接、微信公众号、小程序等）时，向上海互教提供的信息；")]), _vm._v(" "), _c('p', {
    staticClass: "ident bold"
  }, [_vm._v("（2）您在试用和正式使用产品后，上海互教向您所在学校班级任课老师和您提供的考试成绩、学习状况、在校情况等信息。")]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_vm._v("2、采集范围。您不可撤销地授权上海互教以为您提供产品及服务之目的，获取您个人以下范围的信息：")]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_vm._v("（1）您申请试用产品时提交的姓名、所在学校、年级、班级、学号、考号等必要信息；")]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_vm._v("（2）您使用产品后通过产品系统上传的个人考卷、答题本、作业集、错题本以及历次考试成绩等；")]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_vm._v("（3）您所在学校班级老师通过本产品教师端获取的您考试成绩、测评报告等。")]), _vm._v(" "), _c('p', [_vm._v("（二）信息使用授权")]), _vm._v(" "), _c('p', {
    staticClass: "ident bold"
  }, [_vm._v("\n      您同意并不可撤销地授权上海互教以为您提供产品之目的，保存、整理、加工本协议第五条第一款所述的、通过合法途径采集的您的信息，用于您更好的使用产品，以及辅助老师教学，并基于此目的，授权上海互教通过本产品教师端向您所在学校和班级老师推送上述信息。\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_vm._v("上述授权系您对上海互教做出的单方承诺，效力具有独立性，不受本条款所属协议成立与否及效力状态的影响。")]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_vm._v("以上授权期限为您作出本授权承诺之日起至您在上海互教处所有业务终结之日止。")]), _vm._v(" "), _c('p', [_vm._v("（三）信息使用共享")]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_vm._v("\n      您授权上海互教，除法律另有规定之外，将您提供给上海互教的信息、使用产品产生的信息以及上海互教根据本协议约定查询、收集的信息，用于上海互教及其因服务必要委托的合作伙伴为您提供服务、推荐产品、开展市场调查以及信息数据分析。\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_vm._v("\n      您授权上海互教，除法律另有规定外，基于为您提供更优质服务和产品的目的，向上海互教因服务必要开展合伙的伙伴提供、查询、收集您的信息。\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_vm._v("\n      为确保您的个人信息安全，上海互教对上述信息负有保密义务，并尽最大努力采取各种措施保证信息安全。\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_vm._v("\n      本条款自您签署或确认本协议时生效，具有独立法律效力，不受本条款所属协议成立与否及效力状态的影响。\n    ")]), _vm._v(" "), _c('p', [_vm._v("（四）用户知悉")]), _vm._v(" "), _c('p', {
    staticClass: "ident bold"
  }, [_vm._v("\n      包含您姓名、所在学校、年级、班级、学号、考号等信息为您的个人信息。您应充分了解并明确知悉上海互教向第三方采集并在法律法规许可范围内向信息使用者提供这些信息后，信息被其他主体对外提供和使用的风险，包括但不限于：这些信息对您的学习可能产生不利影响；这些信息被上海互教依法提供给第三方后被他人不当利用的风险；第三方向您推销产品或服务而打扰您的风险。此情况下，您同意并不可撤销地授权上海互教依照本协议约定向其他机构提供您的个人信息。\n    ")])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "bold"
  }, [_vm._v("六、责任有限和免责条款")]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_vm._v("\n      1、不允诺担保：本产品用户提问、回答、发言仅代表用户个人观点，与公司无关，且本产品不对用户发表的回答或评论的正确性、准确性、真实性进行保证。本产品为按现状提供，包含瑕疵及缺陷，公司不提供任何其他担保。公司不允诺其他无论是明示的还是默示的保证和担保，包括但不限于对特定目的的适销性和适应性，不侵权，以及任何出自交易过程或商业惯例的保证和条件。从公司或他处获取的任何建议或信息，不论是口头的还是书面的，都不会对公司产生本协议明确约定之外的其他保证和担保。\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_vm._v("\n      2、责任有限：适用法律所允许的最大范围内，不论出于何种原因，公司对用户的全部责任为用户为使用上海互教的产品和服务而向公司支付的费用总额。如果公司免费向用户提供了本产品服务，则公司无义务对用户承担任何赔偿责任。任何情况下，公司不对出自本协议或与本协议有关的或与本产品的运行有关的任何特殊的、偶然的、惩罚性或间接的损害（包括但不限于数据损失、利润损失或营业损失）或采购替代产品承担责任，不论该等责任是基于合同、担保、侵权（包括过失）、严格责任或其他，也不论公司是否被事先告知了损失或损害发生的可能性。即使本协议约定的有限补救措施未能实现其根本目的，前述的责任限制依然适用。\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_vm._v("\n      3、免责：如因下所列任何原因而造成的用户资料泄露、丢失、被盗用或被篡改等，公司均有权获得免责：\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_vm._v("（1）任何因政府管制而造成的暂时性关闭等影响网络正常浏览的不可抗力原因；")]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_vm._v("（2）任何计算机系统问题、黑客攻击、计算机病毒侵入或发作的原因；")]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_vm._v("（3）任何因网络安全问题导致的账户或银行卡信息泄露，该风险可能会给用户造成经济损失，用户承诺自行承担向侵权方追究责任及追究责任不能的后果；")]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_vm._v("（4）任何因用户个人原因导致的用户资料泄露、丢失、被盗用或被篡改等；")]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_vm._v("（5）其他不能归责于公司的原因。")])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "bold"
  }, [_vm._v("七、其他")]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_vm._v("1、如果本产品平台上某一子服务附有单独的使用协议的，则该子服务的使用将受该单独使用协议的约束。")]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_vm._v("2、本协议的签订、生效、履行、争议的解决均适用中华人民共和国法律。")]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_vm._v("3、有关本协议的争议应通过友好协商解决，如果协商不成，该争议将提交上海互教所在地有管辖权的法院诉讼解决。")]), _vm._v(" "), _c('p', {
    staticClass: "ident"
  }, [_vm._v("4、用户对数字校本平台的意见及建议可通过客服邮箱info@fxbjy.com与公司进行联系。")])])])
}]}

/***/ }),
/* 537 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "user-know"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("知心慧学软件使用协议")]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "title"
  }, [_vm._v("法律声明")]), _vm._v(" "), _c('p', [_vm._v("\n      凡访问、浏览或使用江西风向标智能科技有限公司（以下简称“风向标”）出品的“知心慧学平台”产品（包括知心慧学平台网页端、H5、手机APP、微信公众号、小程序等，以下统称“知心慧学”），表明您已阅读、理解并同意接受以下条款的约束，并遵守所有适用的法律和法规。您一旦使用知心慧学，则须秉持诚信的原则遵守以下条款。\n    ")])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "title"
  }, [_vm._v("一般原则")]), _vm._v(" "), _c('p', [_vm._v("\n      以下规则适用于所有知心慧学产品用户或浏览者，因业务调整，可能随时被修改。您应经常访问本页面以便了解当前的条款，因为这些条款与您密切相关。这些条款的某些条文也可能被知心慧学中某些页面上或某些具体服务明确指定的法律通告或条款所取代，您应该了解这些内容，一旦接受本条款，即意味着您已经同时详细阅读并接受了这些被引用或取代的条款。\n    ")])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "title"
  }, [_vm._v("权益说明")]), _vm._v(" "), _c('div', [_c('p', [_vm._v("\n        风向标对其发行的或与合作公司共同发行的包括但不限于提供的软件及相关产品或服务的全部内容，享有知识产权，受法律保护。如果相关内容未含权利声明，并不代表风向标对其不享有权利和不主张权利，您应根据法律、法规及诚信原则尊重权利人的合法权益并合法使用该内容。")]), _vm._v(" "), _c('p', [_vm._v("\n        未经风向标书面同意，任何单位及个人不得以任何方式或理由对上述软件、产品、服务、信息、文字的任何部分进行使用、复制、修改、抄录、传播或与其他产品捆绑使用、销售，或以超级链路连接或传送、存储于信息检索系统或者其他任何商业目的的使用，但对于非商业目的的、个人使用的下载或打印\n        （未作修改，且须保留该内容中的版权说明或其他所有权的说明）除外。")]), _vm._v(" "), _c('p', [_vm._v("\n        上述软件中使用和显示的商标和标识（以下统称“商标”）是风向标及其关联公司在教育及其他相关领域内注册和未注册的有关商标，受法律保护，该等软件中所载的任何内容，未经风向标书面许可，任何人不得以任何方式使用风向标、知心慧学及近似名称和相关商标、标识。")])])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "title"
  }, [_vm._v("用户信息")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "impress"
  }, [_vm._v("为知心慧学提供相应服务之必须，您需要仔细阅读《知心慧学学生端使用许可app&知心慧学学生端隐私政策》，并授权风向标按照《知心慧学学生端使用许可app&知心慧学学生端隐私政策》的约定采集、使用您的个人信息。同时，为能更好的给您提供服务，以最便利、最全面地实现您的多方位需求，知心慧学与其合作网络服务平台提供互补性服务，为实现该服务功能的正常运行，知心慧学与合作平台在用户同意的情况下将共享必要的用户信息。知心慧学对于共享用户实行相同的信息安全和用户隐私政策，并监督合作网络服务平台遵守不低于知心慧学信息安全和用户隐私政策标准的安全和隐私政策。")])])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "title"
  }, [_vm._v("责任限制声明")]), _vm._v(" "), _c('div', [_c('p', {
    staticClass: "impress"
  }, [_vm._v("\n        不论在何种情况下，风向标由于信息网络设备维护、信息网络连接故障、智能终端、通讯或其他系统的故障、电力故障、罢工、劳动争议、暴乱、起义、骚乱、火灾、洪水、风暴、爆炸、战争、政府行为、司法行政机关的命令、其他不可抗力或第三方的不作为而造成的不能服务或延迟服务不承担责任。\n      ")]), _vm._v(" "), _c('p', {
    staticClass: "impress"
  }, [_vm._v("\n        无论在任何情况下（包括但不限于疏忽原因），由于使用知心慧学上的信息或由知心慧学链接的信息，或其他与知心慧学链接的网站信息，对您或他人所造成任何的损失或损害（包括直接、简介、特别或后果性的损失或损害，例如收入或利润之损失，智能终端系统之损坏或数据丢失等后果），均由使用者自行承担责任（包括但不限于疏忽责任）。\n      ")]), _vm._v(" "), _c('p', {
    staticClass: "impress"
  }, [_vm._v("\n        知心慧学所载的信息，包括但不限于文本、图片、数据、观点、网页或链接，虽然力图准确和详尽，但风向标并不就其所包含的信息和内容的准确、完整、充分和可靠性做任何承诺。风向标表明不对这些信息和内容作出任何明示或默示的、包括但不限于没有侵犯第三方权利、质量和没有智能终端病毒的保证。\n      ")]), _vm._v(" "), _c('p', {
    staticClass: "impress"
  }, [_vm._v("\n        对于知心慧学上所提及或展示的非风向标产品或服务，风向标仅提供基本信息。风向标不是相关产品的生产者或经销者，亦不是服务的提供方。风向标不就知心慧学上所提及或展示的非风向标产品或服务做出任何声明或保证，所有展示的产品和服务应受其本公司或服务提供方所做质量承诺和条款的约束。")])])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "title"
  }, [_vm._v("知心慧学服务")]), _vm._v(" "), _c('p', [_vm._v("\n      知心慧学为在校学生提供定制教学辅助，充分利用互联网、大数据和人工智能技术，通过系统对学生课业成绩进行数据分析、数据测评、错题提炼，为学生制定精准学习计划和方案，通过全学习过程数据的分析、知识和能力结构的建模、学习问题的诊断和分析、学科优势的发现和增强，助推精准教学改革。\n      知心慧学由江西风向标智能科技有限公司提供内容服务和数据分析服务。")])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "title"
  }, [_vm._v("第三方链接及服务")]), _vm._v(" "), _c('p', [_vm._v("\n      知心慧学可能保留有第三方网站或网址的链接及第三方服务，是否访问这些链接或接受相应服务将由用户自己做出决定，风向标并不就这些链接上所提供的任何信息、数据、观点、图片、陈述或建议的准确性、完整性、充分性和可靠性提供承诺或保证。风向标没有审查过任何第三方网站，对这些网站及其内容不进行控制，也不负任何法律责任。如果您决定访问任何与本平台链接的第三方网站，其可能带来的结果和风险全部由您自己承担。")])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "title"
  }, [_vm._v("适用法律和管辖权")]), _vm._v(" "), _c('p', [_vm._v("\n      通过访问知心慧学使用风向标提供的或其合作服务提供商提供的服务，即表示您同意该访问或服务受中华人民共和国法律的约束，且您同意受中华人民共和国法院的管辖。访问或接受服务过程中发生的争议应当协商解决，协商不成的，由实际服务提供者或实际网络信息服务提供者住所地有管辖权的法院诉讼解决。")])])])
}]}

/***/ }),
/* 538 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "privacy"
  }, [_c('p', [_vm._v("本政策仅适用于江西风向标智能科技有限公司的知心慧学学生端产品。")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('h2', [_vm._v("隐私政策及权限说明")]), _vm._v(" "), _c('p', {
    staticClass: "bold"
  }, [_vm._v("知心慧学学生端App采用严格的数据安全措施保护您的隐私安全。")]), _vm._v(" "), _c('p', {
    staticClass: "bold"
  }, [_vm._v("您选择【同意并开始使用】即表示您已充分阅读、理解和接受\n    "), _c('a', {
    staticClass: "blue",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        return _vm.clickPrivacy(1)
      }
    }
  }, [_vm._v("《用户服务协议》")]), _vm._v("和"), _c('a', {
    staticClass: "blue",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        return _vm.clickPrivacy(2)
      }
    }
  }, [_vm._v("《隐私政策》")]), _vm._v("。\n    您也可以选择【不同意并退出】，知心慧学学生端App将无法为您提供产品或服务。\n  ")]), _vm._v(" "), _c('h3', [_vm._v("\n    知心慧学学生端APP使用许可3.2&知心慧学学生端隐私政策3.2\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n    以下内容是《知心慧学学生端APP使用许可3.2》及《知心慧学学生端隐私政策3.2》，在您登录注册知心慧学学生端前请务必审慎阅读、充分理解协议中相关条款内容。 ")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('p', [_vm._v("\n     \n  ")]), _vm._v(" "), _c('h3', [_vm._v("\n    知心慧学学生端APP使用许可3.2\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n    一、APP使用许可\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n    1.您使用的“知心慧学学生端APP”（以下简称“APP”、“本APP”）是由江西风向标智能科技有限公司（以下简称“公司”）运营的教育服务平台。\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n    2.“知心慧学学生端用户”是指完成全部注册流程，愿意接受本协议并在知心慧学学生端相关使用规范的规定下使用知心慧学学生端APP服务的注册用户。\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n    3.注册成为本APP之用户或使用本APP，即表示您保证您已具备单独签订本协议并遵守本协议所有条款之民事权利能力及民事行为能力。\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n    4.您郑重承诺，将以本人真实的身份，秉承诚实信用合法的原则使用本APP，在登录和使用本APP的全过程中都负有作为理性人的谨慎和注意义务。\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n    5.本APP保留对APP使用规定的解释、修改以及变更的权利，届时将通过APP通告等方式向用户传达，如果不同意对本协议相关条款所做的修改，用户有权停止使用网络服务。如果用户继续使用网络服务，则视为用户接受本协议相关条款所做的修改。\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n    二、信息使用\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n    1.在注册、登录和使用本APP时，您同意及不可撤销地授权将您的姓名和登录账户等信息提供给我们，包括但不限于您的真实姓名、学情信息、学籍信息、登录账号信息、联系方式等。\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n    2.您在使用本APP时，承诺和保证如下内容：\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n    (a)您所提供的资料为完整，最新及正确无误；\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n    (b)本协议一经签署，即具法律效力并同意受其约束。\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n    3.\n    您的注册信息包括注册号和密码仅供本人使用，您有义务提高自我保护和防范风险意识，如提高密码级别、不随意向其他人透露您的用户名、口令等信息。如若由于您个人对账号信息保管不慎或告知他人而导致任何个人信息泄露、账户损失等，本APP及运营方将不承担任何法律责任。\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n    4.我们将对您所提供的资料进行严格的管理及保护，致力于保护用户个人数据及个人隐私安全，原则上不提供给任何个人或者第三方使用，拒绝任何组织和个人以营利为目的意图获取或者使用用户个人信息。特殊情况如司法机关、监管机构或其他政府部门依照法定程序要求提供用户个人信息等为例外。本APP在必要时将会由专业技术人员代为对您相关信息资料进行处理，以符合专业分工的要求。\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n    如发生下列任何一种情形，本APP有权随时使用用户提交信息资料、中断或终止向用户提供本协议项下的网络服务而无需通知用户:\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n    (a)用户提供的个人资料不真实；\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n    (b)用户违反本协议中规定的使用规则；\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n    (c)为免除您在生命、身体或财产方面之急迫危险的；\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n    (d)为防止他人权益之重大危害的；\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n    (e)为增进公共利益，且无害于您的重大利益的。\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n    除前款所述情形外，本APP同时保留在不事先通知用户的情况下因紧急事由随时中断或终止部分或全部网络服务的权利，对于所有服务的中断或终止而造成的任何损失，本APP无需对用户或任何第三方承担任何责任。\n  ")]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('p', [_vm._v("\n    四、知识产权\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n    1.无论您成为本APP之会员或使用本APP，均认可我们对本APP及本APP所收集、制作、发布之各类信息拥有完全知识产权或所有权，包括但不限于各类文档、图像、数据库等，除非法律明确规定该等权利属于会员个人以外，相关权限应涵盖包括复制、修改、改写、改编、发行、翻译、创造衍生性著作、出版、将前述内容(部分或全部)加以散布、展示等。您同意我们对所有您提交的信息进行有关编排处理后形成的数据库拥有完全的知识产权。\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n    2.如您将信息公布到本APP的任何公共区域，则表示您同意，同时您自动授予，并且您陈述并保证您有权授予本APP不可撤销的、永久的、非独占的、完全免费的、中国国内范围的许可。在该等许可下，您同意本APP使用、复制、执行、显示并传播该内容，您也同意我们基于该内容创作衍生作品或将该内容整合到其他作品中且我们对该等衍生作品或整合作品拥有完全的所有者权益。除已获得我们书面许可的情况外，您不得复制、修改、公布、传播、执行、转载、许可使用、创建衍生作品、转移显示、出售、转售、以非法手段获取或以任何其他方式处置本APP收集、制作、发布的各类信息。\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n    3.请勿擅自复制或采用本APP所创造的用以制成网页的HTML。本APP对其HTML享有著作权。同时，本APP对其网址上的所有图标、图饰、图表、色彩、文字表述及其组合、版面设计、数据库均享有完全的著作权，对发布的信息均享有专有的发布和使用权，未经本APP同意，不得擅自复制、使用或转载。\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n     \n  ")]), _vm._v(" "), _c('h3', [_vm._v("\n    知心慧学学生端隐私政策3.2\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n    本政策仅适用于江西风向标智能科技有限公司的知心慧学学生端产品。\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n    最新更新日期：2025年8月21日。\n  ")]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('p', {
    staticClass: "bold"
  }, [_vm._v("\n    本政策将帮助您了解以下内容：\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n    ·知心慧学学生端的个人信息收集使用规则\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n    ·我们如何保护您的个人信息\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n    ·您的权利\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n    ·我们会如何共享、转让、公开披露您的个人信息\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n    我们会如何处理未成年人的个人信息\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n    ·本政策如何更新\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n    ·如何联系我们\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n     \n  ")]), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('p', [_vm._v("\n    一、 适用范围\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n    本隐私政策适用于知心慧学学生端提供的所有服务，您访问并使用知心慧学学生端网站、APP、小程序，均适用本隐私政策。\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n    二、我们收集信息的原因和内容\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n    为了保障您能够流畅地使用我们的核心功能并向您提供更好、更优的服务，同时为了保障您的信息安全，我们将根据您使用的服务收集您的以下信息。\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n    2.1 您直接提供给我们的信息\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n    当您注册时，您需要至少向我们提供您准备使用的知心慧学学生端账户名、密码、您本人的手机号码、电子邮箱地址（用于验证邮箱），我们将通过发送短信验证码或邮件的方式来验证您的身份是否有效。此时，您需要向我们提供以下信息：帐号名称、头像（如有）和手机号码等。提供上述信息并同意注册协议和本政策后，您可以使用知心慧学学生端的部分业务功能，包括：考试查询、浏览知心慧学学生端平台内的内容等。在您注册知心慧学学生端帐号时，我们会使用手机号码对您的学生信息（姓名、学校、学号/学籍号）进行绑定，将您的账号与学校信息相互关联，为您提供学情分析服务。如您拒绝提供手机号码或进行学生信息绑定，您仍可浏览部分知心慧学学生端平台内的内容，但将无法使用如成个人学情分析、学习提升方案等核心功能。\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n    2.2在您使用过程中产生的信息\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n    当您使用知心慧学学生端的某些业务功能时，为满足向您提供该产品和服务之目的，除注册信息外，您还需要进一步向我们提供包括但不限于您的个人身份信息、位置信息及其他为您提供服务所必需的信息，同时，我们的产品集成友盟+SDK及腾讯+SDK，友盟+SDK及腾讯+SDK需要收集您的设备Mac地址、唯一设备识别码（IMEI/android\n    ID/IDFA/OPENUDID/GUID、SIM 卡 IMSI\n    信息），收集这些信息的目的是推送考试成绩，提供统计分析服务，提供基础反作弊能力。提供以上信息，将有助于我们给您提供更优的服务体验，如果您不提供这些信息，并不会影响您使用知心慧学学生端的基本功能。如果您不使用特定产品和服务，则无需提供相关信息（以下将详细阐明）。\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n    我们可能会收集您的订单信息、浏览信息、使用信息，用来在您的订单失效前提前对您提示，同时向您展示历史浏览、使用、记录。\n  ")]), _c('p', [_vm._v("\n    我们还可能为了提供服务及改进服务质量的合理需要而获得您的其他信息，包括您与客服联系时您提供的相关信息，您参与问卷调查时向我们发送的问卷答复信息，以及您与我们的关联方、我们合作伙伴之间互动时我们获得的相关信息。对于从您的各种设备上收集到的信息，我们可能会将它们进行关联，以便我们能在这些设备上为您提供一致的服务。我们可能会将来自某项服务的信息与来自其他服务的信息结合起来，以便为您提供服务、内容和建议。\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n    2.3 征得授权同意的例外\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n    根据相关法律法规的规定，以下情形中收集您的个人信息无需征得您的授权同意：\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n    2.3.1 涉及国家安全与利益、社会公共利益；\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n    2.3.2 与犯罪侦查有关的相关活动；\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n    2.3.3 出于维护您或他人的生命财产安全但在特殊情况下无法获得您的及时授权；\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n    2.3.4 从其他合法公开的渠道中收集您的个人信息；\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n    2.3.5 法律法规规定的其他情形。\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n    三、我们会如何使用您的信息\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n    3.1\n    收集您的信息是为了向您提供服务及提升服务质量，我们会根据本隐私政策的约定进行使用。在收集您的信息后，我们将通过技术手段对数据进行去标识化处理，去标识化处理的信息将无法识别主体。请您了解并同意，在此情况下我们有权使用已经去标识化的信息，并在不透露您个人信息的前提下，我们有权对用户数据库进行分析并予以合法使用。\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n    3.2 您的信息主要有以下用途：\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n    3.2.1 为您提供您使用的各项定制服务，并维护、改进这些服务；\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n    3.2.2 帮助我们设计新服务，提升现有服务体验；\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n    3.2.3 在我们提供服务时，用于身份验证、客户服务、安全防范、诈骗监测、存档和备份用途，确保我们向您提供的产品和服务的安全性；\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n    3.2.4 邀请您参与知心慧学学生端活动和市场调查；\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n    3.2.5 开展内部审计、数据分析和研究，以更好地改善我们的产品、服务及与用户之间的沟通。\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n    四、我们可能如何收集信息\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n    4.1 您使用我们的服务时，我们会在您的计算机或移动设备上存储名为 Cookie 的小数据文件。Cookie\n    通常包含标识符、站点名称以及一些号码和字符。我们使用该等信息判断注册用户是否已经登录，提升服务/产品质量及优化用户体验。如您不希望个人信息保存在 Cookie 中，您可对浏览器进行配置，选择禁用 Cookie 功能。禁用\n    Cookie 功能后，可能影响您访问知心慧学学生端或不能充分取得知心慧学学生端提供的服务。\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n    知心慧学学生端不会将 Cookie 用于本政策所述目的之外的任何用途。您可根据自己的偏好管理或删除Cookie。您可以清除计算机上保存的所有 Cookie，大部分网络浏览器都设有阻止 Cookie 的功能。\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n    4.2 设备权限调用\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n    知心慧学学生端在提供服务的过程中，可能需要您开通一些设备权限，例如通知、相册、相机等访问权限。您也可以在设备的设置功能中随时选择关闭部分或者全部权限，从而拒绝知心慧学学生端收集相应的个人信息。在不同设备中，权限显示方式及关闭方式可能有所不同，具体请参考设备及系统开发方说明或指引。\n  ")]), _vm._v(" "), _c('p', {
    staticClass: "bold"
  }, [_vm._v("\n    4.3 根据您的服务使用情况，我们可能会调用的权限如下：\n  ")]), _vm._v(" "), _c('p', {
    staticClass: "bold"
  }, [_vm._v("\n    4.3.1 储存权限：当您下载及升级应用、使用错题本功能进行导出和储存、上传文件联系在线客服反馈问题时，我们会调用您的储存权限，保障您能顺利实现此功能。\n  ")]), _vm._v(" "), _c('p', {
    staticClass: "bold"
  }, [_vm._v("\n    4.3.2 摄像头权限：当您修改头像选择拍照上传或上传文件时，我们将调用您的摄像头权限，保障您进行使用。\n  ")]), _vm._v(" "), _c('p', {
    staticClass: "bold"
  }, [_vm._v("\n    4.3.3短信权限：当您注册账号时，我们将调用短信权限，保障您能顺利完成注册。\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n    五、我们会如何共享、转让、公开披露您的个人信息\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n    5.1 共享\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n    知心慧学学生端不会在未经您同意或授权的情况下将您的个人信息提供给第三方。但是，经您确认同意，知心慧学学生端可在以下情况下共享您的个人信息：\n  ")]), _vm._v(" "), _c('p', [_vm._v("第三方公司名称：华为终端有限公司")]), _vm._v(" "), _c('p', [_vm._v("产品/类型：华为推送sdk")]), _vm._v(" "), _c('p', [_vm._v("共享信息：应用基本信息、设备标识信息（IMEI、Android ID、AAID和Push Token）、设备的硬件信息、系统基本信息和系统设置信息、应用安装列表信息、申请获取存储权限、电话权限")]), _vm._v(" "), _c('p', [_vm._v("使用目的：用于向华为手机用户推送消息")]), _vm._v(" "), _c('p', [_vm._v("使用场景：向用户推送消息时")]), _vm._v(" "), _c('p', [_vm._v("共享方式：sdk本机采集")]), _vm._v(" "), _c('p', [_vm._v("第三方隐私权政策链接：")]), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('p', [_vm._v("第三方公司名称：小米公司")]), _vm._v(" "), _c('p', [_vm._v("产品/类型：小米推送sdk")]), _vm._v(" "), _c('p', [_vm._v("共享信息：设备标识信息(SSID、OAID、加密的Android ID)、推送消息内容、设备信息(设备厂商、型号、归属地、运营商名称等)、通知栏设置、运营商信息、申请获取存储权限、位置权限")]), _vm._v(" "), _c('p', [_vm._v("使用目的：用于向小米用户推送消息")]), _vm._v(" "), _c('p', [_vm._v("使用场景：向用户推送消息时")]), _vm._v(" "), _c('p', [_vm._v("共享方式：sdk本机采集")]), _vm._v(" "), _c('p', [_vm._v("第三方隐私权政策链接：")]), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('p', [_vm._v("第三方公司名称：珠海市魅族通讯设备有限公司")]), _vm._v(" "), _c('p', [_vm._v("产品/类型：魅族消息推送服务sdk")]), _vm._v(" "), _c('p', [_vm._v("共享信息：设备标识信息（IMEI）、运营商信息、申请获取存储权限")]), _vm._v(" "), _c('p', [_vm._v("使用目的：用于向魅族手机用户推送消息")]), _vm._v(" "), _c('p', [_vm._v("使用场景：向用户推送消息时")]), _vm._v(" "), _c('p', [_vm._v("共享方式：sdk本机采集")]), _vm._v(" "), _c('p', [_vm._v("第三方隐私权政策链接：")]), _vm._v(" "), _vm._m(7), _vm._v(" "), _c('p', [_vm._v("第三方公司名称：OPPO广东移动通信有限公司")]), _vm._v(" "), _c('p', [_vm._v("产品/类型：OPPO推送sdk")]), _vm._v(" "), _c('p', [_vm._v("共享信息：匿名用户ID（OAID）")]), _vm._v(" "), _c('p', [_vm._v("使用目的：用于向OPPO用户推送消息")]), _vm._v(" "), _c('p', [_vm._v("使用场景：向用户推送消息时")]), _vm._v(" "), _c('p', [_vm._v("共享方式：sdk本机采集")]), _vm._v(" "), _c('p', [_vm._v("第三方隐私权政策链接：")]), _vm._v(" "), _vm._m(8), _vm._v(" "), _c('p', [_vm._v("第三方公司名称：维沃移动通信有限公司")]), _vm._v(" "), _c('p', [_vm._v("产品/类型：VIVO推送sdk")]), _vm._v(" "), _c('p', [_vm._v("使用目的：用于向VIVO用户推送消息")]), _vm._v(" "), _c('p', [_vm._v("共享信息：匿名用户ID（OAID）")]), _vm._v(" "), _c('p', [_vm._v("使用场景：向用户推送消息时")]), _vm._v(" "), _c('p', [_vm._v("共享方式：sdk本机采集")]), _vm._v(" "), _c('p', [_vm._v("功能：用于消息推送")]), _vm._v(" "), _c('p', [_vm._v("收集个人信息字段：匿名用户ID（OAID）")]), _vm._v(" "), _c('p', [_vm._v("第三方隐私权政策链接：")]), _vm._v(" "), _vm._m(9), _vm._v(" "), _c('p', [_vm._v("第三方公司名称：深圳市腾讯计算机系统有限公司")]), _vm._v(" "), _c('p', [_vm._v("产品/类型：腾讯bugly")]), _vm._v(" "), _c('p', [_vm._v("收集个人信息类型：设备信息（IMEI/MAC/Android ID/IDFA/OpenUDID/GUID/IP地址/SIM卡IMSI信息/手机参数信息等）")]), _vm._v(" "), _c('p', [_vm._v("使用目的：云平台、企业协作、辅助运营")]), _vm._v(" "), _c('p', [_vm._v("功能：云平台、企业协作、辅助运营")]), _vm._v(" "), _c('p', [_vm._v("第三方隐私权政策链接：")]), _vm._v(" "), _vm._m(10), _vm._v(" "), _c('p', [_vm._v("第三方SDK名称：Glide")]), _vm._v(" "), _c('p', [_vm._v("产品/类型：开源代码库")]), _vm._v(" "), _c('p', [_vm._v("使用目的：加载本地或网络图片，缓存图片到本地")]), _vm._v(" "), _c('p', [_vm._v("功能：加载网络图片或本地图片，添加图片缓存，减少用户的流量使用，提高用户体验")]), _vm._v(" "), _c('p', [_vm._v("链接：")]), _vm._v(" "), _vm._m(11), _vm._v(" "), _vm._m(12), _vm._v(" "), _c('p', [_vm._v("第三方SDK名称：PictureSelector")]), _vm._v(" "), _c('p', [_vm._v("产品/类型：开源代码库")]), _vm._v(" "), _c('p', [_vm._v("使用目的：加载本地相册图片，拍照选择，收集外部存储文件和文件夹。")]), _vm._v(" "), _c('p', [_vm._v("功能：选择头像，选择文件上传")]), _vm._v(" "), _vm._m(13), _vm._v(" "), _c('p', [_vm._v("第三方SDK名称：Network SDK")]), _vm._v(" "), _c('p', [_vm._v("收集个人信息类型：设备品牌、设备型号、设备版本、系统版本、手机样式、 手机名、MAC地址、IMSI、IMEI、IP地址、网络状态")]), _vm._v(" "), _c('p', [_vm._v("使用目的：网络数据请求，数据手机")]), _vm._v(" "), _c('p', [_vm._v("收集方式：sdk本机采集")]), _vm._v(" "), _c('p', [_vm._v("使用场景：登录，设备信息收集")]), _vm._v(" "), _c('p', [_vm._v("SDK名称：友盟统计分析SDK")]), _vm._v(" "), _c('p', [_vm._v("使用目的：进行APP运营统计与分析")]), _vm._v(" "), _c('p', [_vm._v("运营方：友盟同欣（北京）科技有限公司")]), _vm._v(" "), _c('p', [_vm._v("收集个人信息类型：设备信息（IMEI/MAC/Android ID/IDFA/OAID/OpenUDID/GUID/SIM卡IMSI/ICCID）、位置信息、网络信息")]), _vm._v(" "), _c('p', [_vm._v("第三方SDK名称：com.tencent.beacon【腾讯灯塔 SDK Android】")]), _vm._v(" "), _c('p', [_vm._v("收集个人信息类型：设备品牌、设备型号、操作系统版本、系统语言、屏幕分辨率、网络类型、IP地址、设备标识符（如IMEI、IMSI、Android ID）、应用安装列表、运行进程信息")]), _vm._v(" "), _c('p', [_vm._v("使用目的：统计分析、异常监控、性能监测")]), _vm._v(" "), _c('p', [_vm._v("使用场景：用于数据采集与分析，优化产品体验")]), _vm._v(" "), _c('p', [_vm._v("第三方SDK名称：com.umeng.message【友盟+消息推送】")]), _vm._v(" "), _c('p', [_vm._v("收集个人信息类型：设备标识符（如IMEI、OAID、Android ID）、设备型号、系统版本、网络类型、语言设置、应用安装列表")]), _vm._v(" "), _c('p', [_vm._v("使用目的：实现消息推送功能")]), _vm._v(" "), _c('p', [_vm._v("使用场景：向用户推送系统通知和个性化消息")]), _vm._v(" "), _c('p', [_vm._v("第三方SDK名称：com.uc.crashsdk【UC Crash SDK】")]), _vm._v(" "), _c('p', [_vm._v("收集个人信息类型：设备型号、操作系统版本、UUID、网络类型、日志信息、进程信息")]), _vm._v(" "), _c('p', [_vm._v("使用目的：捕获和分析崩溃信息，改善应用稳定性")]), _vm._v(" "), _c('p', [_vm._v("使用场景：在应用发生异常时收集错误信息")]), _vm._v(" "), _c('p', [_vm._v("第三方SDK名称：com.umeng.umcrash【友盟+应用性能监控】")]), _vm._v(" "), _c('p', [_vm._v("收集个人信息类型：设备标识符（如IMEI、Android ID）、设备型号、系统版本、网络类型、运行进程、内存使用情况")]), _vm._v(" "), _c('p', [_vm._v("使用目的：监控应用性能，分析卡顿及异常")]), _vm._v(" "), _c('p', [_vm._v("使用场景：实时监测应用运行状态，优化性能表现")]), _vm._v(" "), _c('p', [_vm._v("隐私权政策链接：")]), _vm._v(" "), _vm._m(14), _vm._v(" "), _c('p', [_vm._v("自启动和关联启动说明")]), _vm._v(" "), _c('p', [_vm._v("1、为确保本应用处于关闭或后台运行状态下可正常接收到客户端推送的信息，本应用须使用(自启动)能力，将存在一定频率通过 系统发送广播唤醒本应用自启动或关联启动行为，是因实现功能及服务所必要的。")]), _vm._v(" "), _c('p', [_vm._v("2、当您打开内容类推送消息，在征得您的明确同意后，会跳转打开相关内容。在未征得您同意的情况下，则不会有自启动或关联启动。")]), _vm._v(" "), _c('p', [_vm._v("3、当您打开本App内部下载的文件后，会关联启动第三方App。")]), _vm._v(" "), _c('p', [_vm._v("\n    5.1.1 在获取同意的情况下共享：获得您的明确同意后，知心慧学学生端会与其他方共享您的个人信息。\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n    5.1.2 共享给知心慧学学生端的关联公司：在本政策声明的使用目的范围内，您的个人信息可能会与知心慧学学生端的关联公司共享。作为一项政策，我们只会共享必要的信息。关联公司如要改变个人信息的处理目的，将再次征求您的授权同意。\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n    5.1.3\n    共享给授权合作伙伴：知心慧学学生端可能会与合作伙伴共享您的某些个人信息，以便给您提供服务、内容和建议。例如，知心慧学学生端向您寄送礼品（如有）时，知心慧学学生端必须与物流服务提供商共享您的个人信息才能安排寄送，或者安排合作伙伴向您提供服务。我们仅会出于特定、明确而合法的目的处理您的个人信息，并且只会共享提供服务所必要的信息。同时，我们会与其签署严格的保密协定，要求他们按照我们的说明、本政策以及其他任何相关的保密和安全措施来处理个人信息。在法定情形下的共享：我们可能会根据法律法规规定、诉讼争议解决需要，或按行政、司法机关依法提出的要求，对外共享您的个人信息。\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n    5.2 转让\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n    我们不会将您的个人信息转让给任何公司、组织和个人，但以下情况除外：\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n    5.2.1 事先获得您明确的同意或授权；\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n    5.2.2 根据适用的法律法规、法律程序的要求、强制性的行政或司法要求所必须的情况进行提供；\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n    5.2.3 符合与您签署的相关协议（包括在线签署的电子协议以及相应的平台规则）或其他的法律文件约定所提供；\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n    5.2.4 在涉及合并、收购、资产转让或类似的交易时，如涉及到个人信息转让，我们会要求新的持有您个人信息的公司、组织继续受本隐私政策的约束，否则,我们将要求该公司、组织重新向您征求授权同意。\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n    5.3 公开披露\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n    我们仅会在以下情况下，且采取符合法律和业界标准的安全防护措施的前提下，才会公开披露您的个人信息：\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n    5.3.1 根据您的需求，在您明确同意的披露方式下披露您所指定的个人信息；\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n    5.3.2\n    根据法律、法规的要求、强制性的行政执法或司法要求所必须提供您个人信息的情况下，我们可能会依据所要求的个人信息类型和披露方式公开披露您的个人信息。在符合法律法规的前提下，当我们收到上述披露信息的请求时，我们会要求必须出具与之相应的法律文件，如传票或调查函。我们坚信，对于要求我们提供的信息，应该在法律允许的范围内尽可能保持透明。我们对所有的请求都进行了慎重的审查，以确保其具备合法依据，且仅限于执法部门因特定调查目的且有合法权利获取的数据。在法律法规许可的前提下，我们披露的文件均在加密密钥的保护之下。\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n    六、 如何管理您的个人信息\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n    我们将尽一切可能采取适当的技术手段，保证收集到的有关于您的个人信息的准确性，并保证及时进行更新。\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n    6.1 更正或补充您的个人信息：\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n    除法律法规规定外，您有权随时访问和更正您的个人信息，具体包括：\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n    Web端路径：您可以在左上角点击头像，页面的“个人资料”菜单中查阅您提交给知心慧学学生端的所有个人信息，您也可通过上述途径更新除考生认证信息之外的其他个人信息（您的考生认证信息是您通过注册后实名认证时使用的姓名和身份证信息）。移动端具体路径为：“我的”进入我的知心慧学学生端—我的—安全中心—修改密码：您也可以通过「我的」-【意见反馈】页面，按照知心慧学学生端的相关政策及提示，或联系在线客服，对您的个人信息进行访问、更正。\n  ")]), _vm._v(" "), _c('p', [_vm._v("改变授权范围：您可以通过以下方式撤回您的授权或改变您授权我们收集和处理您的个人信息的范围:在“我的-安全中心-隐私设置中关闭系统对个人隐私信息的收集\n    ”中进行设置来授予或撤回您的授权同意。若您无法直接通过上述方式设置授权，可通过本隐私政策内提供的联系方式联系客服获得解释。")]), _vm._v(" "), _c('p', {
    staticClass: "bold"
  }, [_vm._v("\n    6.2 删除您的个人信息及注销账号\n  ")]), _vm._v(" "), _c('p', {
    staticClass: "bold"
  }, [_vm._v("\n    您可以通过「我的」-【安全中心】页面，点击账号注销，填写学生账号及学生密码后申请注销，或联系在线客服，或拨打客服电话19970080755，我们将在2周内帮助您进行注销账号及删除有关信息的处理。\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n    6.3 管理消息和推送\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n    对于您在使用服务的过程中提供的设备号，我们在运营过程中可能会向您的设备发送消息推送，用于用户消息告知、任务提醒等目的。在「我的」-【消息推送管理】页面，您可以选择是否接受定向推送信息，或选择接受部分情况下的推送通知。IOS系统用户可以在[系统设置]-[通知]-[知心慧学学生端]页面设置是否允许通知，安卓系统用户可在[系统设置]-[通知]-[知心慧学学生端]页面设置是否允许通知。\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n    七、我们会如何保护和保存您的个人信息\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n    知心慧学学生端高度重视个人信息的安全。我们采取互联网业内标准做法来保护您的个人信息，防止信息遭到未经授权访问、披露、使用、修改、损坏或丢失。我们会采取一切合理可行的措施，保护您的个人信息。我们会采取一切合理可行的措施，确保未收集与知心慧学学生端提供的服务无关的个人信息。我们会尽全力保护您的个人信息，但请您理解，由于技术的限制以及可能存在的各种恶意手段，在互联网行业，不可能始终保证信息百分之百的安全。您需要了解，您接入我们的服务所用的系统和通讯网络，有可能因我们可控范围外的因素而出现问题。我们仅允许有必要知晓这些信息的知心慧学学生端及知心慧学学生端关联方的员工、合作伙伴访问个人信息，并为此设置了严格的访问权限控制和监控机制。我们同时要求可能接触到您个人信息的所有人员履行相应的保密义务。如果未能履行这些义务，可能会被追究法律责任或被中止与知心慧学学生端的合作关系。在发生个人信息安全事件的场合，我们将按照法律法规的要求，及时向您告知：安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施等。我们将及时将事件相关情况以邮件、信函、电话、推送通知等方式告知您，难以逐一告知个人信息主体时，我们会采取合理、有效的方式发布公告。同时，我们还将按照监管部门要求，主动上报个人信息安全事件的处置情况。我们在中华人民共和国境内收集和产生的个人信息将存储在中华人民共和国境内。如果日后为处理跨境业务，需要向境外机构传输境内收集的相关个人信息的，我们会事先征得您的同意，按照法律、行政法规和相关监管部门的规定执行，并通过签订协议、核查等有效措施，要求境外机构为所获得的个人信息保密。我们仅会在达到本政策所述目的所必需的时限内保存您的个人信息，但为了遵守适用的法律法规、法院判决或裁定、其他有权机关的要求、维护公共利益等目的，我们可能会将个人信息保存时间予以适当延长。\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n    八、第三方提供商及其服务\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n    为确保流畅的浏览体验，您可能会收到来自知心慧学学生端及其合作伙伴外部的第三方（以下简称「第三方」）提供的内容或网络链接。知心慧学学生端对此类第三方无控制权。您可选择是否访问第三方提供的链接、内容、产品和服务。知心慧学学生端无法控制第三方的隐私和个人信息保护政策，此类第三方不受到本政策的约束。您在向第三方提交个人信息之前，请确保您阅读并认可这些第三方的隐私保护政策。\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n    九、知心慧学学生端会如何处理未成年人的个人信息\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n    我们鼓励父母或监护人指导未满十八岁的未成年人使用我们的服务。我们建议未成年人鼓励他们的父母或监护人阅读本政策，并建议未成年人在提交个人信息之前寻求父母或监护人的同意和指导。但是，如果您确认自己能够完全理解本政策的全部内容且您为使用知心慧学学生端服务所进行的相关操作行为与您的年龄、智力相适应的，则您可以独立进行相关操作（包括向我们提交您的个人信息）。\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n    十、本政策如何更新及适用范围\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n    为给用户提供更好的服务，知心慧学学生端的业务将不时变化，本隐私政策也将随之调整。知心慧学学生端会通过在知心慧学学生端网站、移动端上发出更新版本并提醒您相关内容的更新，也请您访问知心慧学学生端以便及时了解最新的隐私政策。知心慧学学生端保留不时更新或修改本政策的权利。如果该等修改造成您在本政策下权利的实质减少，知心慧学学生端会通过不同渠道向您发送变更通知，包括但不限于网站公示、短信、邮件通知等方式。若您不同意修改后的隐私政策，您有权并应立即停止使用知心慧学学生端的服务。如果您继续使用知心慧学学生端的服务，则视为您接受知心慧学学生端对本政策相关条款所做的修改。\n    知心慧学学生端的所有服务均适用本政策。但某些服务有其特定的隐私政策，该等特定的隐私政策更具体地说明知心慧学学生端在该服务中如何处理您的信息。如本政策与特定服务的隐私政策有不一致之处，请以该特定隐私政策为准。\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n    十一、 联系我们\n  ")]), _vm._v(" "), _vm._m(15)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "update"
  }, [_c('p', [_vm._v("更新日期：2025年8月21日")]), _vm._v(" "), _c('p', [_vm._v("生效日期：2025年8月21日")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n    《知心慧学学生端APP使用许可3.2》包括APP使用许可、信息使用、风险提示、知识产权。《知心慧学学生端隐私政策3.2》包括适用范围、我们收集信息的原因和内容、我们会如何使用您的信息、我们可能如何收集信息、我们会如何共享、转让、公开披露您的个人信息、如何管理您的个人信息、推广服务、我们会如何保护和保存您的个人信息、第三方提供商及其服务、知心慧学学生端会如何处理未成年人的个人信息、本政策如何更新及适用范围以及联系我们。您一旦登录注册并使用知心慧学学生端，即视为您已了解并同意《知心慧学学生端APP使用许可3.2》及《知心慧学学生端隐私政策3.2》的各项内容。\n    "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("在此特别提醒您，在点击接受本声明之前，您应事先认真阅读、了解清楚并充分理解本声明的全部内容，包括免除或者限制责任的免责条款及对您的权利限制条款。请您审阅后选择接受或不接受本声明（未成年人应在法定监护人陪同下审阅）。除非您接受本声明，否则您无权下载、安装或使用本公司基于应用软件提供的相关服务（以下称\"服务\"）。一旦您点击确认本声明，即意味着您已充分理解和接受本声明，并同意接受本声明各项条款的约束。并且，公司在法律许可的范围内享有对本声明的解释、修改以及变更的权利。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bold"
  }, [_c('p', [_vm._v("\n      三、风险提示\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      1.您于订立协议时已表示理解并同意免除我们与此相应的法律责任。如在本APP运营过程中出现我们误将您的帐户终止，或变更您的有关信息，或部分停止您的各类权限，则我们将在您提出书面通知后合理期间内处理该等事宜，若因此给您带来不便甚至造成损失，您同意免除我们的相应法律责任。\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      2.您了解并同意，我们不对因下述任一情况而导致的任何损害赔偿承担责任：\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      (a)使用或未能使用本APP服务；\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      (b)对本APP服务的错误理解；\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      (c)第三方未使用真实身份，或者未经批准的使用他人的账号或更改他人的数据；\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      (d)任何非因本APP的原因而引起的与服务有关的损失。\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      3.对于任何本APP无法控制的原因（包括但不限于政府管制、通讯设施故障及其他不可抗力因素）导致的APP暂时关闭、用户信息泄露、被盗用、被篡改等非正常经营行为，本APP不承担任何责任。\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      4.您承认对于您利用本APP或信息而从事的各类行为，包括线上和线下，均为您个人行为且您个人对该类行为承担完全责任。\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      5.由于您将注册账户、密码告知他人或与他人共享注册帐户，由此导致的任何个人信息的泄露，任何由于黑客攻击、计算机病毒侵入或发作、因政府管制而造成的暂时性关闭等影响网络正常经营之不可抗力而造成的个人信息泄露、丢失、被盗用或被篡改等，由于本APP不拥有或不控制的公司以及我们不雇佣或不管理的人员所造成的个人信息的泄露，本APP不承担任何责任并应免于被追诉。\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      6.您同意保障和维护知心慧学学生端APP及其他用户的利益，如因您违反有关法律、\n      法规或本协议项下的任何条款而给本APP或任何其他第三人造成损失，您同意承担由此造成的损害赔偿责任。在注册成为本APP用户或者使用本APP过程中，您与任何第三方之间发生任何纠纷，由纠纷各方自行解决，本APP并不承担任何责任。本APP不对您使用本APP的任何行为、效果或影响提供任何担保或条件，无论是明示或默示的。\n    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n    如对本隐私政策或相关事宜有任何问题、建议、意见及咨询，您可随时通过发送邮件至 "), _c('span', {
    staticClass: "blue"
  }, [_vm._v("legal@fxbjy.com")]), _vm._v(" 或拨打我们的客服电话"), _c('span', {
    staticClass: "blue"
  }, [_vm._v("19970080755")]), _vm._v("等多种方式与我们联系，我们将在十五个工作日内受理并处理。\n  ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "bold underline"
  }, [_vm._v("\n    【特别提示】请仔细阅读《知心慧学学生端隐私政策3.2》（尤其是加粗划线的内容）（以下简称“本隐私政策”）并确定了解我们（江西风向标智能科技有限公司）对您个人信息的处理规则。阅读过程中，如您有任何疑问，可联系我们的客服咨询，如果您不同意相关协议或其中任何条款约定，知心慧学学生端将暂时无法为您提供服务。本隐私政策与您所使用的知心慧学学生端服务以及该服务所包括的各种业务功能（以下统称“我们的产品与/或服务”）息息相关，希望您在使用我们的产品与/或服务前仔细阅读并确认您已经充分理解本政策所写明的内容，并让您可以按照本隐私政策的指引做出您认为适当的选择。本隐私政策中涉及的相关术语，我们尽量以简明扼要的表述，并提供进一步说明的链接，以便您更好地理解。您使用或在我们更新本隐私政策后（我们会及时提示您更新的情况）继续使用我们的产品与/或服务，即意味着您同意本隐私政策(含更新版本)内容，并且同意我们按照本隐私政策收集、使用、保存和共享您的相关信息。如对本隐私政策或相关事宜有任何问题，您可随时通过发送邮件至"), _c('span', {
    staticClass: "blue"
  }, [_vm._v("legal@fxbjy.com")]), _vm._v("或拨打我们的任何一部客服电话等多种方式与我们联系 。 ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    attrs: {
      "href": "https://developer.huawei.com/consumer/cn/doc/development/HMSCore-Guides/sdk-data-security-0000001050042177"
    }
  }, [_vm._v("https://developer.huawei.com/consumer/cn/doc/development/HMSCore-Guides/sdk-data-security-0000001050042177")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    attrs: {
      "href": "https://dev.mi.com/console/doc/detail?pId=1822"
    }
  }, [_vm._v("https://dev.mi.com/console/doc/detail?pId=1822")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    attrs: {
      "href": "https://www.meizu.com/legal.html"
    }
  }, [_vm._v("https://www.meizu.com/legal.html")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    attrs: {
      "href": "https://security.oppo.com/cn/privacy.html"
    }
  }, [_vm._v("https://security.oppo.com/cn/privacy.html")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    attrs: {
      "href": "https://dev.vivo.com.cn/documentCenter/doc/366"
    }
  }, [_vm._v("https://dev.vivo.com.cn/documentCenter/doc/366")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    attrs: {
      "href": "https://privacy.qq.com/document/preview/fc748b3d96224fdb825ea79e132c1a56"
    }
  }, [_vm._v("https://privacy.qq.com/document/preview/fc748b3d96224fdb825ea79e132c1a56")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    attrs: {
      "href": "https://github.com/bumptech/glide"
    }
  }, [_vm._v("https://github.com/bumptech/glide")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    attrs: {
      "href": "https://privacy.qq.com/document/preview/fc748b3d96224fdb825ea79e132c1a56"
    }
  }, [_vm._v("https://privacy.qq.com/document/preview/fc748b3d96224fdb825ea79e132c1a56")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("链接："), _c('a', {
    attrs: {
      "href": "https://github.com/LuckSiege/PictureSelector"
    }
  }, [_vm._v("https://github.com/LuckSiege/PictureSelector")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    attrs: {
      "href": "https://www.umeng.com/page/policy"
    }
  }, [_vm._v("https://www.umeng.com/page/policy")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n    如对本隐私政策或相关事宜有任何问题、建议、意见及咨询，您可随时通过发送邮件至"), _c('span', {
    staticClass: "blue"
  }, [_vm._v("legal@fxbjy.com")]), _vm._v("或拨打我们的客服电话"), _c('span', {
    staticClass: "blue"
  }, [_vm._v("19970080755")]), _vm._v("等多种方式与我们联系，我们将在十五个工作日内受理并处理。\n  ")])
}]}

/***/ }),
/* 539 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "privacy"
  }, [_c('p', [_vm._v("本政策仅适用于江西风向标智能科技有限公司的知心慧学学生端产品。")]), _vm._v(" "), _c('div', {
    staticClass: "update"
  }, [_c('p', [_vm._v("更新日期：2025年8月21日")]), _vm._v(" "), _c('p', [_vm._v("生效日期：2025年8月21日")])]), _vm._v(" "), _c('h2', [_vm._v("\n    知心慧学学生端APP使用许可3.2&知心慧学学生端隐私政策3.2\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n    以下内容是《知心慧学学生端APP使用许可3.2》及《知心慧学学生端隐私政策3.2》，在您登录注册知心慧学学生端前请务必审慎阅读、充分理解协议中相关条款内容。 ")]), _vm._v(" "), _c('p', [_vm._v("\n    《知心慧学学生端APP使用许可3.2》包括APP使用许可、信息使用、风险提示、知识产权。《知心慧学学生端隐私政策3.2》包括适用范围、我们收集信息的原因和内容、我们会如何使用您的信息、我们可能如何收集信息、我们会如何共享、转让、公开披露您的个人信息、如何管理您的个人信息、推广服务、我们会如何保护和保存您的个人信息、第三方提供商及其服务、知心慧学学生端会如何处理未成年人的个人信息、本政策如何更新及适用范围以及联系我们。您一旦登录注册并使用知心慧学学生端，即视为您已了解并同意《知心慧学学生端APP使用许可3.2》及《知心慧学学生端隐私政策3.2》的各项内容。\n    "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("在此特别提醒您，在点击接受本声明之前，您应事先认真阅读、了解清楚并充分理解本声明的全部内容，包括免除或者限制责任的免责条款及对您的权利限制条款。请您审阅后选择接受或不接受本声明（未成年人应在法定监护人陪同下审阅）。除非您接受本声明，否则您无权下载、安装或使用本公司基于应用软件提供的相关服务（以下称\"服务\"）。一旦您点击确认本声明，即意味着您已充分理解和接受本声明，并同意接受本声明各项条款的约束。并且，公司在法律许可的范围内享有对本声明的解释、修改以及变更的权利。")])]), _vm._v(" "), _c('h2', [_vm._v("\n    知心慧学学生端APP使用许可3.2\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n    一、APP使用许可\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n    1.您使用的“知心慧学学生端APP”（以下简称“APP”、“本APP”）是由江西风向标智能科技有限公司（以下简称“公司”）运营的教育服务平台。\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n    2.“知心慧学学生端用户”是指完成全部注册流程，愿意接受本协议并在知心慧学学生端相关使用规范的规定下使用知心慧学学生端APP服务的注册用户。\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n    3.注册成为本APP之用户或使用本APP，即表示您保证您已具备单独签订本协议并遵守本协议所有条款之民事权利能力及民事行为能力。\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n    4.您郑重承诺，将以本人真实的身份，秉承诚实信用合法的原则使用本APP，在登录和使用本APP的全过程中都负有作为理性人的谨慎和注意义务。\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n    5.本APP保留对APP使用规定的解释、修改以及变更的权利，届时将通过APP通告等方式向用户传达，如果不同意对本协议相关条款所做的修改，用户有权停止使用网络服务。如果用户继续使用网络服务，则视为用户接受本协议相关条款所做的修改。\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n    二、信息使用\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n    1.在注册、登录和使用本APP时，您同意及不可撤销地授权将您的姓名和登录账户等信息提供给我们，包括但不限于您的真实姓名、学情信息、学籍信息、登录账号信息、联系方式等。\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n    2.您在使用本APP时，承诺和保证如下内容：\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n    (a)您所提供的资料为完整，最新及正确无误；\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n    (b)本协议一经签署，即具法律效力并同意受其约束。\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n    3.\n    您的注册信息包括注册号和密码仅供本人使用，您有义务提高自我保护和防范风险意识，如提高密码级别、不随意向其他人透露您的用户名、口令等信息。如若由于您个人对账号信息保管不慎或告知他人而导致任何个人信息泄露、账户损失等，本APP及运营方将不承担任何法律责任。\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n    4.我们将对您所提供的资料进行严格的管理及保护，致力于保护用户个人数据及个人隐私安全，原则上不提供给任何个人或者第三方使用，拒绝任何组织和个人以营利为目的意图获取或者使用用户个人信息。特殊情况如司法机关、监管机构或其他政府部门依照法定程序要求提供用户个人信息等为例外。本APP在必要时将会由专业技术人员代为对您相关信息资料进行处理，以符合专业分工的要求。\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n    如发生下列任何一种情形，本APP有权随时使用用户提交信息资料、中断或终止向用户提供本协议项下的网络服务而无需通知用户:\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n    (a)用户提供的个人资料不真实；\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n    (b)用户违反本协议中规定的使用规则；\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n    (c)为免除您在生命、身体或财产方面之急迫危险的；\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n    (d)为防止他人权益之重大危害的；\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n    (e)为增进公共利益，且无害于您的重大利益的。\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n    除前款所述情形外，本APP同时保留在不事先通知用户的情况下因紧急事由随时中断或终止部分或全部网络服务的权利，对于所有服务的中断或终止而造成的任何损失，本APP无需对用户或任何第三方承担任何责任。\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "bold"
  }, [_c('p', [_vm._v("\n      三、风险提示\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      1.您于订立协议时已表示理解并同意免除我们与此相应的法律责任。如在本APP运营过程中出现我们误将您的账户终止，或变更您的有关信息，或部分停止您的各类权限，则我们将在您提出书面通知后合理期间内处理该等事宜，若因此给您带来不便甚至造成损失，您同意免除我们的相应法律责任。\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      2.您了解并同意，我们不对因下述任一情况而导致的任何损害赔偿承担责任：\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      (a)使用或未能使用本APP服务；\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      (b)对本APP服务的错误理解；\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      (c)第三方未使用真实身份，或者未经批准的使用他人的账号或更改他人的数据；\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      (d)任何非因本APP的原因而引起的与服务有关的损失。\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      3.对于任何本APP无法控制的原因（包括但不限于政府管制、通讯设施故障及其他不可抗力因素）导致的APP暂时关闭、用户信息泄露、被盗用、被篡改等非正常经营行为，本APP不承担任何责任。\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      4.您承认对于您利用本APP或信息而从事的各类行为，包括线上和线下，均为您个人行为且您个人对该类行为承担完全责任。\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      5.由于您将注册账户、密码告知他人或与他人共享注册账户，由此导致的任何个人信息的泄露，任何由于黑客攻击、计算机病毒侵入或发作、因政府管制而造成的暂时性关闭等影响网络正常经营之不可抗力而造成的个人信息泄露、丢失、被盗用或被篡改等，由于本APP不拥有或不控制的公司以及我们不雇佣或不管理的人员所造成的个人信息的泄露，本APP不承担任何责任并应免于被追诉。\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      6.您同意保障和维护知心慧学学生端APP及其他用户的利益，如因您违反有关法律、\n      法规或本协议项下的任何条款而给本APP或任何其他第三人造成损失，您同意承担由此造成的损害赔偿责任。在注册成为本APP用户或者使用本APP过程中，您与任何第三方之间发生任何纠纷，由纠纷各方自行解决，本APP并不承担任何责任。本APP不对您使用本APP的任何行为、效果或影响提供任何担保或条件，无论是明示或默示的。\n    ")])]), _vm._v(" "), _c('p', [_vm._v("\n    四、知识产权\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n    1.无论您成为本APP之会员或使用本APP，均认可我们对本APP及本APP所收集、制作、发布之各类信息拥有完全知识产权或所有权，包括但不限于各类文档、图像、数据库等，除非法律明确规定该等权利属于会员个人以外，相关权限应涵盖包括复制、修改、改写、改编、发行、翻译、创造衍生性著作、出版、将前述内容(部分或全部)加以散布、展示等。您同意我们对所有您提交的信息进行有关编排处理后形成的数据库拥有完全的知识产权。\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n    2.如您将信息公布到本APP的任何公共区域，则表示您同意，同时您自动授予，并且您陈述并保证您有权授予本APP不可撤销的、永久的、非独占的、完全免费的、中国国内范围的许可。在该等许可下，您同意本APP使用、复制、执行、显示并传播该内容，您也同意我们基于该内容创作衍生作品或将该内容整合到其他作品中且我们对该等衍生作品或整合作品拥有完全的所有者权益。除已获得我们书面许可的情况外，您不得复制、修改、公布、传播、执行、转载、许可使用、创建衍生作品、转移显示、出售、转售、以非法手段获取或以任何其他方式处置本APP收集、制作、发布的各类信息。\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n    3.请勿擅自复制或采用本APP所创造的用以制成网页的HTML。本APP对其HTML享有著作权。同时，本APP对其网址上的所有图标、图饰、图表、色彩、文字表述及其组合、版面设计、数据库均享有完全的著作权，对发布的信息均享有专有的发布和使用权，未经本APP同意，不得擅自复制、使用或转载。\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n     \n  ")]), _vm._v(" "), _c('h3', [_vm._v("\n    知心慧学学生端隐私政策3.2\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n    本政策仅适用于江西风向标智能科技有限公司的知心慧学学生端产品。\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n    最新更新日期：2025年8月21日。\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n    如对本隐私政策或相关事宜有任何问题、建议、意见及咨询，您可随时通过发送邮件至 "), _c('span', {
    staticClass: "blue"
  }, [_vm._v("legal@fxbjy.com")]), _vm._v(" 或拨打我们的客服电话"), _c('span', {
    staticClass: "blue"
  }, [_vm._v("19970080755")]), _vm._v("等多种方式与我们联系，我们将在十五个工作日内受理并处理。\n  ")]), _vm._v(" "), _c('p', {
    staticClass: "bold"
  }, [_vm._v("\n    本政策将帮助您了解以下内容：\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n    ·知心慧学学生端的个人信息收集使用规则\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n    ·我们如何保护您的个人信息\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n    ·您的权利\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n    ·我们会如何共享、转让、公开披露您的个人信息\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n    我们会如何处理未成年人的个人信息\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n    ·本政策如何更新\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n    ·如何联系我们\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n     \n  ")]), _vm._v(" "), _c('p', {
    staticClass: "bold underline"
  }, [_vm._v("\n    【特别提示】请仔细阅读《知心慧学学生端隐私政策3.2》（尤其是加粗划线的内容）（以下简称“本隐私政策”）并确定了解我们（江西风向标智能科技有限公司）对您个人信息的处理规则。阅读过程中，如您有任何疑问，可联系我们的客服咨询，如果您不同意相关协议或其中任何条款约定，知心慧学学生端将暂时无法为您提供服务。本隐私政策与您所使用的知心慧学学生端服务以及该服务所包括的各种业务功能（以下统称“我们的产品与/或服务”）息息相关，希望您在使用我们的产品与/或服务前仔细阅读并确认您已经充分理解本政策所写明的内容，并让您可以按照本隐私政策的指引做出您认为适当的选择。本隐私政策中涉及的相关术语，我们尽量以简明扼要的表述，并提供进一步说明的链接，以便您更好地理解。您使用或在我们更新本隐私政策后（我们会及时提示您更新的情况）继续使用我们的产品与/或服务，即意味着您同意本隐私政策(含更新版本)内容，并且同意我们按照本隐私政策收集、使用、保存和共享您的相关信息。如对本隐私政策或相关事宜有任何问题，您可随时通过发送邮件至"), _c('span', {
    staticClass: "blue"
  }, [_vm._v("legal@fxbjy.com")]), _vm._v("或拨打我们的任何一部客服电话等多种方式与我们联系 。\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n    一、 适用范围\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n    本隐私政策适用于知心慧学学生端提供的所有服务，您访问并使用知心慧学学生端网站、APP、小程序，均适用本隐私政策。\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n    二、我们收集信息的原因和内容\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n    为了保障您能够流畅地使用我们的核心功能并向您提供更好、更优的服务，同时为了保障您的信息安全，我们将根据您使用的服务收集您的以下信息。\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n    2.1 您直接提供给我们的信息\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n    当您注册时，您需要至少向我们提供您准备使用的知心慧学学生端账户名、密码、您本人的手机号码、电子邮箱地址（用于验证邮箱），我们将通过发送短信验证码或邮件的方式来验证您的身份是否有效。此时，您需要向我们提供以下信息：账号名称、头像（如有）和手机号码等。提供上述信息并同意注册协议和本政策后，您可以使用知心慧学学生端的部分业务功能，包括：考试查询、浏览知心慧学学生端平台内的内容等。在您注册知心慧学学生端账号时，我们会使用手机号码对您的学生信息（姓名、学校、学号/学籍号）进行绑定，将您的账号与学校信息相互关联，为您提供学情分析服务。如您拒绝提供手机号码或进行学生信息绑定，您仍可浏览部分知心慧学学生端平台内的内容，但将无法使用如成个人学情分析、学习提升方案等核心功能。\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n    2.2在您使用过程中产生的信息\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n    当您使用知心慧学学生端的某些业务功能时，为满足向您提供该产品和服务之目的，除注册信息外，您还需要进一步向我们提供包括但不限于您的个人身份信息、位置信息及其他为您提供服务所必需的信息，同时，我们的产品集成友盟+SDK及腾讯+SDK，友盟+SDK及腾讯+SDK需要收集您的设备Mac地址、唯一设备识别码（IMEI/android\n    ID/IDFA/OPENUDID/GUID、SIM 卡 IMSI\n    信息），收集这些信息的目的是推送考试成绩，提供统计分析服务，提供基础反作弊能力。提供以上信息，将有助于我们给您提供更优的服务体验，如果您不提供这些信息，并不会影响您使用知心慧学学生端的基本功能。如果您不使用特定产品和服务，则无需提供相关信息（以下将详细阐明）。\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n    我们可能会收集您的订单信息、浏览信息、使用信息，用来在您的订单失效前提前对您提示，同时向您展示历史浏览、使用、记录。\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n    我们还可能为了提供服务及改进服务质量的合理需要而获得您的其他信息，包括您与客服联系时您提供的相关信息，您参与问卷调查时向我们发送的问卷答复信息，以及您与我们的关联方、我们合作伙伴之间互动时我们获得的相关信息。对于从您的各种设备上收集到的信息，我们可能会将它们进行关联，以便我们能在这些设备上为您提供一致的服务。我们可能会将来自某项服务的信息与来自其他服务的信息结合起来，以便为您提供服务、内容和建议。\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n    2.3 征得授权同意的例外\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n    根据相关法律法规的规定，以下情形中收集您的个人信息无需征得您的授权同意：\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n    2.3.1 涉及国家安全与利益、社会公共利益；\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n    2.3.2 与犯罪侦查有关的相关活动；\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n    2.3.3 出于维护您或他人的生命财产安全但在特殊情况下无法获得您的及时授权；\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n    2.3.4 从其他合法公开的渠道中收集您的个人信息；\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n    2.3.5 法律法规规定的其他情形。\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n    三、我们会如何使用您的信息\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n    3.1\n    收集您的信息是为了向您提供服务及提升服务质量，我们会根据本隐私政策的约定进行使用。在收集您的信息后，我们将通过技术手段对数据进行去标识化处理，去标识化处理的信息将无法识别主体。请您了解并同意，在此情况下我们有权使用已经去标识化的信息，并在不透露您个人信息的前提下，我们有权对用户数据库进行分析并予以合法使用。\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n    3.2 您的信息主要有以下用途：\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n    3.2.1 为您提供您使用的各项定制服务，并维护、改进这些服务；\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n    3.2.2 帮助我们设计新服务，提升现有服务体验；\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n    3.2.3 在我们提供服务时，用于身份验证、客户服务、安全防范、诈骗监测、存档和备份用途，确保我们向您提供的产品和服务的安全性；\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n    3.2.4 邀请您参与知心慧学学生端活动和市场调查；\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n    3.2.5 开展内部审计、数据分析和研究，以更好地改善我们的产品、服务及与用户之间的沟通。\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n    四、我们可能如何收集信息\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n    4.1 您使用我们的服务时，我们会在您的计算机或移动设备上存储名为 Cookie 的小数据文件。Cookie\n    通常包含标识符、站点名称以及一些号码和字符。我们使用该等信息判断注册用户是否已经登录，提升服务/产品质量及优化用户体验。如您不希望个人信息保存在 Cookie 中，您可对浏览器进行配置，选择禁用 Cookie 功能。禁用\n    Cookie 功能后，可能影响您访问知心慧学学生端或不能充分取得知心慧学学生端提供的服务。\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n    知心慧学学生端不会将 Cookie 用于本政策所述目的之外的任何用途。您可根据自己的偏好管理或删除Cookie。您可以清除计算机上保存的所有 Cookie，大部分网络浏览器都设有阻止 Cookie 的功能。\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n    4.2 设备权限调用\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n    知心慧学学生端在提供服务的过程中，可能需要您开通一些设备权限，例如通知、相册、相机等访问权限。您也可以在设备的设置功能中随时选择关闭部分或者全部权限，从而拒绝知心慧学学生端收集相应的个人信息。在不同设备中，权限显示方式及关闭方式可能有所不同，具体请参考设备及系统开发方说明或指引。\n  ")]), _vm._v(" "), _c('p', {
    staticClass: "bold"
  }, [_vm._v("\n    4.3 根据您的服务使用情况，我们可能会调用的权限如下：\n  ")]), _vm._v(" "), _c('p', {
    staticClass: "bold"
  }, [_vm._v("\n    4.3.1 储存权限：当您下载及升级应用、使用错题本功能进行导出和储存、上传文件联系在线客服反馈问题时，我们会调用您的储存权限，保障您能顺利实现此功能。\n  ")]), _vm._v(" "), _c('p', {
    staticClass: "bold"
  }, [_vm._v("\n    4.3.2 摄像头权限：当您修改头像选择拍照上传或上传文件时，我们将调用您的摄像头权限，保障您进行使用。\n  ")]), _vm._v(" "), _c('p', {
    staticClass: "bold"
  }, [_vm._v("\n    4.3.3短信权限：当您注册账号时，我们将调用短信权限，保障您能顺利完成注册。\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n    五、我们会如何共享、转让、公开披露您的个人信息\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n    5.1 共享\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n    知心慧学学生端不会在未经您同意或授权的情况下将您的个人信息提供给第三方。但是，经您确认同意，知心慧学学生端可在以下情况下共享您的个人信息：\n  ")]), _vm._v(" "), _c('p', [_vm._v("第三方公司名称：华为终端有限公司")]), _vm._v(" "), _c('p', [_vm._v("产品/类型：华为推送sdk")]), _vm._v(" "), _c('p', [_vm._v("共享信息：应用基本信息、设备标识信息（IMEI、Android ID、AAID和Push Token）、设备的硬件信息、系统基本信息和系统设置信息、应用安装列表信息、申请获取存储权限、电话权限")]), _vm._v(" "), _c('p', [_vm._v("使用目的：用于向华为手机用户推送消息")]), _vm._v(" "), _c('p', [_vm._v("使用场景：向用户推送消息时")]), _vm._v(" "), _c('p', [_vm._v("共享方式：sdk本机采集")]), _vm._v(" "), _c('p', [_vm._v("第三方隐私权政策链接：")]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "https://developer.huawei.com/consumer/cn/doc/development/HMSCore-Guides/sdk-data-security-0000001050042177"
    }
  }, [_vm._v("https://developer.huawei.com/consumer/cn/doc/development/HMSCore-Guides/sdk-data-security-0000001050042177")])]), _vm._v(" "), _c('p', [_vm._v("第三方公司名称：小米公司")]), _vm._v(" "), _c('p', [_vm._v("产品/类型：小米推送sdk")]), _vm._v(" "), _c('p', [_vm._v("共享信息：设备标识信息(SSID、OAID、加密的Android ID)、推送消息内容、设备信息(设备厂商、型号、归属地、运营商名称等)、通知栏设置、运营商信息、申请获取存储权限、位置权限")]), _vm._v(" "), _c('p', [_vm._v("使用目的：用于向小米用户推送消息")]), _vm._v(" "), _c('p', [_vm._v("使用场景：向用户推送消息时")]), _vm._v(" "), _c('p', [_vm._v("共享方式：sdk本机采集")]), _vm._v(" "), _c('p', [_vm._v("第三方隐私权政策链接：")]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "https://dev.mi.com/console/doc/detail?pId=1822"
    }
  }, [_vm._v("https://dev.mi.com/console/doc/detail?pId=1822")])]), _vm._v(" "), _c('p', [_vm._v("第三方公司名称：珠海市魅族通讯设备有限公司")]), _vm._v(" "), _c('p', [_vm._v("产品/类型：魅族消息推送服务sdk")]), _vm._v(" "), _c('p', [_vm._v("共享信息：设备标识信息（IMEI）、运营商信息、申请获取存储权限")]), _vm._v(" "), _c('p', [_vm._v("使用目的：用于向魅族手机用户推送消息")]), _vm._v(" "), _c('p', [_vm._v("使用场景：向用户推送消息时")]), _vm._v(" "), _c('p', [_vm._v("共享方式：sdk本机采集")]), _vm._v(" "), _c('p', [_vm._v("第三方隐私权政策链接：")]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "https://www.meizu.com/legal.html"
    }
  }, [_vm._v("https://www.meizu.com/legal.html")])]), _vm._v(" "), _c('p', [_vm._v("第三方公司名称：OPPO广东移动通信有限公司")]), _vm._v(" "), _c('p', [_vm._v("产品/类型：OPPO推送sdk")]), _vm._v(" "), _c('p', [_vm._v("共享信息：匿名用户ID（OAID）")]), _vm._v(" "), _c('p', [_vm._v("使用目的：用于向OPPO用户推送消息")]), _vm._v(" "), _c('p', [_vm._v("使用场景：向用户推送消息时")]), _vm._v(" "), _c('p', [_vm._v("共享方式：sdk本机采集")]), _vm._v(" "), _c('p', [_vm._v("第三方隐私权政策链接：")]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "https://security.oppo.com/cn/privacy.html"
    }
  }, [_vm._v("https://security.oppo.com/cn/privacy.html")])]), _vm._v(" "), _c('p', [_vm._v("第三方公司名称：维沃移动通信有限公司")]), _vm._v(" "), _c('p', [_vm._v("产品/类型：VIVO推送sdk")]), _vm._v(" "), _c('p', [_vm._v("使用目的：用于向VIVO用户推送消息")]), _vm._v(" "), _c('p', [_vm._v("共享信息：匿名用户ID（OAID）")]), _vm._v(" "), _c('p', [_vm._v("使用场景：向用户推送消息时")]), _vm._v(" "), _c('p', [_vm._v("共享方式：sdk本机采集")]), _vm._v(" "), _c('p', [_vm._v("功能：用于消息推送")]), _vm._v(" "), _c('p', [_vm._v("收集个人信息字段：匿名用户ID（OAID）")]), _vm._v(" "), _c('p', [_vm._v("第三方隐私权政策链接：")]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "https://dev.vivo.com.cn/documentCenter/doc/366"
    }
  }, [_vm._v("https://dev.vivo.com.cn/documentCenter/doc/366")])]), _vm._v(" "), _c('p', [_vm._v("第三方公司名称：深圳市腾讯计算机系统有限公司")]), _vm._v(" "), _c('p', [_vm._v("产品/类型：腾讯bugly")]), _vm._v(" "), _c('p', [_vm._v("收集个人信息类型：设备信息（IMEI/MAC/Android ID/IDFA/OpenUDID/GUID/IP地址/SIM卡IMSI信息/手机参数信息等）")]), _vm._v(" "), _c('p', [_vm._v("使用目的：云平台、企业协作、辅助运营")]), _vm._v(" "), _c('p', [_vm._v("功能：云平台、企业协作、辅助运营")]), _vm._v(" "), _c('p', [_vm._v("第三方隐私权政策链接：")]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "https://privacy.qq.com/document/preview/fc748b3d96224fdb825ea79e132c1a56"
    }
  }, [_vm._v("https://privacy.qq.com/document/preview/fc748b3d96224fdb825ea79e132c1a56")])]), _vm._v(" "), _c('p', [_vm._v("第三方SDK名称：Glide")]), _vm._v(" "), _c('p', [_vm._v("产品/类型：开源代码库")]), _vm._v(" "), _c('p', [_vm._v("使用目的：加载本地或网络图片，缓存图片到本地")]), _vm._v(" "), _c('p', [_vm._v("功能：加载网络图片或本地图片，添加图片缓存，减少用户的流量使用，提高用户体验")]), _vm._v(" "), _c('p', [_vm._v("链接：")]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "https://github.com/bumptech/glide"
    }
  }, [_vm._v("https://github.com/bumptech/glide")])]), _vm._v(" "), _c('p', [_vm._v("第三方SDK名称：PictureSelector")]), _vm._v(" "), _c('p', [_vm._v("产品/类型：开源代码库")]), _vm._v(" "), _c('p', [_vm._v("使用目的：加载本地相册图片，拍照选择，收集外部存储文件和文件夹。")]), _vm._v(" "), _c('p', [_vm._v("功能：选择头像，选择文件上传")]), _vm._v(" "), _c('p', [_vm._v("链接："), _c('a', {
    attrs: {
      "href": "https://github.com/LuckSiege/PictureSelector"
    }
  }, [_vm._v("https://github.com/LuckSiege/PictureSelector")])]), _vm._v(" "), _c('p', [_vm._v("第三方SDK名称：Network SDK")]), _vm._v(" "), _c('p', [_vm._v("收集个人信息类型：设备品牌、设备型号、设备版本、系统版本、手机样式、 手机名、MAC地址、IMSI、IMEI、IP地址、网络状态")]), _vm._v(" "), _c('p', [_vm._v("使用目的：网络数据请求，数据手机")]), _vm._v(" "), _c('p', [_vm._v("收集方式：sdk本机采集")]), _vm._v(" "), _c('p', [_vm._v("使用场景：登录，设备信息收集")]), _vm._v(" "), _c('p', [_vm._v("SDK名称：友盟统计分析SDK")]), _vm._v(" "), _c('p', [_vm._v("使用目的：进行APP运营统计与分析")]), _vm._v(" "), _c('p', [_vm._v("运营方：友盟同欣（北京）科技有限公司")]), _vm._v(" "), _c('p', [_vm._v("收集个人信息类型：设备信息（IMEI/MAC/Android ID/IDFA/OAID/OpenUDID/GUID/SIM卡IMSI/ICCID）、位置信息、网络信息")]), _vm._v(" "), _c('p', [_vm._v("第三方SDK名称：com.tencent.beacon【腾讯灯塔 SDK Android】")]), _vm._v(" "), _c('p', [_vm._v("收集个人信息类型：设备品牌、设备型号、操作系统版本、系统语言、屏幕分辨率、网络类型、IP地址、设备标识符（如IMEI、IMSI、Android ID）、应用安装列表、运行进程信息")]), _vm._v(" "), _c('p', [_vm._v("使用目的：统计分析、异常监控、性能监测")]), _vm._v(" "), _c('p', [_vm._v("使用场景：用于数据采集与分析，优化产品体验")]), _vm._v(" "), _c('p', [_vm._v("第三方SDK名称：com.umeng.message【友盟+消息推送】")]), _vm._v(" "), _c('p', [_vm._v("收集个人信息类型：设备标识符（如IMEI、OAID、Android ID）、设备型号、系统版本、网络类型、语言设置、应用安装列表")]), _vm._v(" "), _c('p', [_vm._v("使用目的：实现消息推送功能")]), _vm._v(" "), _c('p', [_vm._v("使用场景：向用户推送系统通知和个性化消息")]), _vm._v(" "), _c('p', [_vm._v("第三方SDK名称：com.uc.crashsdk【UC Crash SDK】")]), _vm._v(" "), _c('p', [_vm._v("收集个人信息类型：设备型号、操作系统版本、UUID、网络类型、日志信息、进程信息")]), _vm._v(" "), _c('p', [_vm._v("使用目的：捕获和分析崩溃信息，改善应用稳定性")]), _vm._v(" "), _c('p', [_vm._v("使用场景：在应用发生异常时收集错误信息")]), _vm._v(" "), _c('p', [_vm._v("第三方SDK名称：com.umeng.umcrash【友盟+应用性能监控】")]), _vm._v(" "), _c('p', [_vm._v("收集个人信息类型：设备标识符（如IMEI、Android ID）、设备型号、系统版本、网络类型、运行进程、内存使用情况")]), _vm._v(" "), _c('p', [_vm._v("使用目的：监控应用性能，分析卡顿及异常")]), _vm._v(" "), _c('p', [_vm._v("使用场景：实时监测应用运行状态，优化性能表现")]), _vm._v(" "), _c('p', [_vm._v("隐私权政策链接：")]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "https://www.umeng.com/page/policy"
    }
  }, [_vm._v("https://www.umeng.com/page/policy")])]), _vm._v(" "), _c('p', [_vm._v("自启动和关联启动说明")]), _vm._v(" "), _c('p', [_vm._v("1、为确保本应用处于关闭或后台运行状态下可正常接收到客户端推送的信息，本应用须使用(自启动)能力，将存在一定频率通过 系统发送广播唤醒本应用自启动或关联启动行为，是因实现功能及服务所必要的。")]), _vm._v(" "), _c('p', [_vm._v("2、当您打开内容类推送消息，在征得您的明确同意后，会跳转打开相关内容。在未征得您同意的情况下，则不会有自启动或关联启动。")]), _vm._v(" "), _c('p', [_vm._v("3、当您打开本App内部下载的文件后，会关联启动第三方App。")]), _vm._v(" "), _c('p', [_vm._v("\n    5.1.1 在获取同意的情况下共享：获得您的明确同意后，知心慧学学生端会与其他方共享您的个人信息。\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n    5.1.2 共享给知心慧学学生端的关联公司：在本政策声明的使用目的范围内，您的个人信息可能会与知心慧学学生端的关联公司共享。作为一项政策，我们只会共享必要的信息。关联公司如要改变个人信息的处理目的，将再次征求您的授权同意。\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n    5.1.3\n    共享给授权合作伙伴：知心慧学学生端可能会与合作伙伴共享您的某些个人信息，以便给您提供服务、内容和建议。例如，知心慧学学生端向您寄送礼品（如有）时，知心慧学学生端必须与物流服务提供商共享您的个人信息才能安排寄送，或者安排合作伙伴向您提供服务。我们仅会出于特定、明确而合法的目的处理您的个人信息，并且只会共享提供服务所必要的信息。同时，我们会与其签署严格的保密协定，要求他们按照我们的说明、本政策以及其他任何相关的保密和安全措施来处理个人信息。在法定情形下的共享：我们可能会根据法律法规规定、诉讼争议解决需要，或按行政、司法机关依法提出的要求，对外共享您的个人信息。\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n    5.2 转让\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n    我们不会将您的个人信息转让给任何公司、组织和个人，但以下情况除外：\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n    5.2.1 事先获得您明确的同意或授权；\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n    5.2.2 根据适用的法律法规、法律程序的要求、强制性的行政或司法要求所必须的情况进行提供；\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n    5.2.3 符合与您签署的相关协议（包括在线签署的电子协议以及相应的平台规则）或其他的法律文件约定所提供；\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n    5.2.4 在涉及合并、收购、资产转让或类似的交易时，如涉及个人信息转让，我们会要求新的持有您个人信息的公司、组织继续受本隐私政策的约束，否则,我们将要求该公司、组织重新向您征求授权同意。 ")]), _vm._v(" "), _c('p', [_vm._v("\n    5.3 公开披露\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n    我们仅会在以下情况下，且采取符合法律和业界标准的安全防护措施的前提下，才会公开披露您的个人信息：\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n    5.3.1 根据您的需求，在您明确同意的披露方式下披露您所指定的个人信息；\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n    5.3.2\n    根据法律、法规的要求、强制性的行政执法或司法要求所必须提供您个人信息的情况下，我们可能会依据所要求的个人信息类型和披露方式公开披露您的个人信息。在符合法律法规的前提下，当我们收到上述披露信息的请求时，我们会要求必须出具与之相应的法律文件，如传票或调查函。我们坚信，对于要求我们提供的信息，应该在法律允许的范围内尽可能保持透明。我们对所有的请求都进行了慎重的审查，以确保其具备合法依据，且仅限于执法部门因特定调查目的且有合法权利获取的数据。在法律法规许可的前提下，我们披露的文件均在加密密钥的保护之下。\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n    六、 如何管理您的个人信息\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n    我们将尽一切可能采取适当的技术手段，保证收集到的有关于您的个人信息的准确性，并保证及时进行更新。\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n    6.1 更正或补充您的个人信息：\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n    除法律法规规定外，您有权随时访问和更正您的个人信息，具体包括：\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n    Web端路径：您可以在左上角点击头像，页面的“个人资料”菜单中查阅您提交给知心慧学学生端的所有个人信息，您也可通过上述途径更新除考生认证信息之外的其他个人信息（您的考生认证信息是您通过注册后实名认证时使用的姓名和身份证信息）。移动端具体路径为：“我的”进入我的知心慧学学生端—我的—安全中心—修改密码：您也可以通过「我的」-【意见反馈】页面，按照知心慧学学生端的相关政策及提示，或联系在线客服，对您的个人信息进行访问、更正。\n  ")]), _vm._v(" "), _c('p', [_vm._v("改变授权范围：您可以通过以下方式撤回您的授权或改变您授权我们收集和处理您的个人信息的范围:在“我的-安全中心-隐私设置中关闭系统对个人隐私信息的收集\n    ”中进行设置来授予或撤回您的授权同意。若您无法直接通过上述方式设置授权，可通过本隐私政策内提供的联系方式联系客服获得解释。")]), _vm._v(" "), _c('p', {
    staticClass: "bold"
  }, [_vm._v("\n    6.2 删除您的个人信息及注销账号\n  ")]), _vm._v(" "), _c('p', {
    staticClass: "bold"
  }, [_vm._v("\n    您可以通过「我的」-【安全中心】页面，点击账号注销，填写学生账号及学生密码后申请注销，或联系在线客服，或拨打客服电话19970080755，我们将在2周内帮助您进行注销账号及删除有关信息的处理。\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n    6.3 管理消息和推送\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n    对于您在使用服务的过程中提供的设备号，我们在运营过程中可能会向您的设备发送消息推送，用于用户消息告知、任务提醒等目的。在「我的」-【消息推送管理】页面，您可以选择是否接受定向推送信息，或选择接受部分情况下的推送通知。IOS系统用户可以在[系统设置]-[通知]-[知心慧学学生端]页面设置是否允许通知，安卓系统用户可在[系统设置]-[通知]-[知心慧学学生端]页面设置是否允许通知。\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n    七、我们会如何保护和保存您的个人信息\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n    知心慧学学生端高度重视个人信息的安全。我们采取互联网业内标准做法来保护您的个人信息，防止信息遭到未经授权访问、披露、使用、修改、损坏或丢失。我们会采取一切合理可行的措施，保护您的个人信息。我们会采取一切合理可行的措施，确保未收集与知心慧学学生端提供的服务无关的个人信息。我们会尽全力保护您的个人信息，但请您理解，由于技术的限制以及可能存在的各种恶意手段，在互联网行业，不可能始终保证信息百分之百的安全。您需要了解，您接入我们的服务所用的系统和通讯网络，有可能因我们可控范围外的因素而出现问题。我们仅允许有必要知晓这些信息的知心慧学学生端及知心慧学学生端关联方的员工、合作伙伴访问个人信息，并为此设置了严格的访问权限控制和监控机制。我们同时要求可能接触到您个人信息的所有人员履行相应的保密义务。如果未能履行这些义务，可能会被追究法律责任或被中止与知心慧学学生端的合作关系。在发生个人信息安全事件的场合，我们将按照法律法规的要求，及时向您告知：安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施等。我们将及时将事件相关情况以邮件、信函、电话、推送通知等方式告知您，难以逐一告知个人信息主体时，我们会采取合理、有效的方式发布公告。同时，我们还将按照监管部门要求，主动上报个人信息安全事件的处置情况。我们在中华人民共和国境内收集和产生的个人信息将存储在中华人民共和国境内。如果日后为处理跨境业务，需要向境外机构传输境内收集的相关个人信息的，我们会事先征得您的同意，按照法律、行政法规和相关监管部门的规定执行，并通过签订协议、核查等有效措施，要求境外机构为所获得的个人信息保密。我们仅会在达到本政策所述目的所必需的时限内保存您的个人信息，但为了遵守适用的法律法规、法院判决或裁定、其他有权机关的要求、维护公共利益等目的，我们可能会将个人信息保存时间予以适当延长。\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n    八、第三方提供商及其服务\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n    为确保流畅的浏览体验，您可能会收到来自知心慧学学生端及其合作伙伴外部的第三方（以下简称「第三方」）提供的内容或网络链接。知心慧学学生端对此类第三方无控制权。您可选择是否访问第三方提供的链接、内容、产品和服务。知心慧学学生端无法控制第三方的隐私和个人信息保护政策，此类第三方不受到本政策的约束。您在向第三方提交个人信息之前，请确保您阅读并认可这些第三方的隐私保护政策。\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n    九、知心慧学学生端会如何处理未成年人的个人信息\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n    我们鼓励父母或监护人指导未满十八岁的未成年人使用我们的服务。我们建议未成年人鼓励他们的父母或监护人阅读本政策，并建议未成年人在提交个人信息之前寻求父母或监护人的同意和指导。但是，如果您确认自己能够完全理解本政策的全部内容且您为使用知心慧学学生端服务所进行的相关操作行为与您的年龄、智力相适应的，则您可以独立进行相关操作（包括向我们提交您的个人信息）。\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n    十、本政策如何更新及适用范围\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n    为给用户提供更好的服务，知心慧学学生端的业务将不时变化，本隐私政策也将随之调整。知心慧学学生端会通过在知心慧学学生端网站、移动端上发出更新版本并提醒您相关内容的更新，也请您访问知心慧学学生端以便及时了解最新的隐私政策。知心慧学学生端保留不时更新或修改本政策的权利。如果该等修改造成您在本政策下权利的实质减少，知心慧学学生端会通过不同渠道向您发送变更通知，包括但不限于网站公示、短信、邮件通知等方式。若您不同意修改后的隐私政策，您有权并应立即停止使用知心慧学学生端的服务。如果您继续使用知心慧学学生端的服务，则视为您接受知心慧学学生端对本政策相关条款所做的修改。\n    知心慧学学生端的所有服务均适用本政策。但某些服务有其特定的隐私政策，该等特定的隐私政策更具体地说明知心慧学学生端在该服务中如何处理您的信息。如本政策与特定服务的隐私政策有不一致之处，请以该特定隐私政策为准。\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n    十一、 联系我们\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n    如对本隐私政策或相关事宜有任何问题、建议、意见及咨询，您可随时通过发送邮件至"), _c('span', {
    staticClass: "blue"
  }, [_vm._v("legal@fxbjy.com")]), _vm._v("或拨打我们的客服电话"), _c('span', {
    staticClass: "blue"
  }, [_vm._v("19970080755")]), _vm._v("等多种方式与我们联系，我们将在十五个工作日内受理并处理。\n  ")])])
}]}

/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-box"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showType == 1 || _vm.showType == 3),
      expression: "showType==1 || showType==3"
    }],
    staticClass: "choice-roles"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "roles-box"
  }, [_c('div', {
    staticClass: "card",
    on: {
      "click": function($event) {
        return _vm.handleLoginCheckClick(2)
      }
    }
  }, [_vm._m(1), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("教职工登录")])]), _vm._v(" "), _c('div', {
    staticClass: "card",
    on: {
      "click": function($event) {
        return _vm.handleLoginCheckClick(3)
      }
    }
  }, [_vm._m(2), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("学生登录")])]), _vm._v(" "), _c('div', {
    staticClass: "card",
    on: {
      "click": function($event) {
        return _vm.handleLoginCheckClick(4)
      }
    }
  }, [_vm._m(3), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("家长登录")])]), _vm._v(" "), _c('div', {
    staticClass: "card",
    on: {
      "click": function($event) {
        return _vm.handleLoginCheckClick(5)
      }
    }
  }, [_vm._m(4), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("校长登录")]), _vm._v(" "), _c('p', {
    staticClass: "msg"
  }, [_vm._v("全面升级为教职工登录，后续不在更新")])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showType == 2 && _vm.currQrStatus == 0),
      expression: "showType==2 && currQrStatus == 0"
    }],
    staticClass: "teacher"
  }, [_c('div', {
    staticClass: "title-box flx-one"
  }, [_c('h2', {
    staticClass: "title mr",
    class: _vm.isTeacherActive == 'ap' ? 'bd' : '',
    on: {
      "click": function($event) {
        return _vm.onTeacherChange('ap')
      }
    }
  }, [_vm._v("密码登录")]), _vm._v(" "), _c('h2', {
    staticClass: "title",
    class: _vm.isTeacherActive == 'sms' ? 'bd' : '',
    on: {
      "click": function($event) {
        return _vm.onTeacherChange('sms')
      }
    }
  }, [_vm._v("短信登录")])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._m(5), _vm._v(" "), (_vm.isTeacherActive == 'ap') ? _c('div', {
    staticClass: "middle"
  }, [_c('div', {
    staticClass: "user-id input-wrap"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.teacherApData.username),
      expression: "teacherApData.username"
    }],
    staticClass: "input-uesr",
    attrs: {
      "type": "text",
      "placeholder": "请输入账号"
    },
    domProps: {
      "value": (_vm.teacherApData.username)
    },
    on: {
      "keyup": function($event) {
        return _vm.teacherLoginBtn('ap')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.teacherApData, "username", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.teacherApErrMsg.password),
      expression: "teacherApErrMsg.password"
    }],
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.teacherApErrMsg.password))])]), _vm._v(" "), _c('div', {
    staticClass: "password input-wrap"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.teacherApData.password),
      expression: "teacherApData.password"
    }],
    staticClass: "input-password",
    attrs: {
      "type": "password",
      "placeholder": "请输入密码"
    },
    domProps: {
      "value": (_vm.teacherApData.password)
    },
    on: {
      "keyup": function($event) {
        return _vm.teacherLoginBtn('ap')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.teacherApData, "password", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "forget-password",
    on: {
      "click": function($event) {
        return _vm.$router.push('/forgetpassword?from=teacher')
      }
    }
  }, [_vm._v("忘记密码")])]), _vm._v(" "), _c('div', {
    staticClass: "verification-code input-wrap"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.teacherApData.captcha),
      expression: "teacherApData.captcha"
    }],
    staticClass: "input-code",
    attrs: {
      "type": "text",
      "placeholder": "请输入验证码"
    },
    domProps: {
      "value": (_vm.teacherApData.captcha)
    },
    on: {
      "keyup": function($event) {
        return _vm.teacherLoginBtn('ap')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.teacherApData, "captcha", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.teacherApErrMsg.captcha),
      expression: "teacherApErrMsg.captcha"
    }],
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.teacherApErrMsg.captcha))]), _vm._v(" "), _c('span', {
    staticClass: "code-img"
  }, [_c('img', {
    staticClass: "isWidth",
    attrs: {
      "src": _vm.codeUrl,
      "alt": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "msg",
    on: {
      "click": _vm.getValidCode
    }
  }, [_vm._v("换一个")])])]), _vm._v(" "), _c('div', {
    staticClass: "but-box"
  }, [_c('button', {
    staticClass: "btn-back",
    on: {
      "click": function($event) {
        _vm.showType = 1
      }
    }
  }, [_vm._v("返回")]), _vm._v(" "), _c('button', {
    staticClass: "btn-login",
    class: {
      'bg-highlight': _vm.isTeacherDisabled == false
    },
    attrs: {
      "disabled": _vm.isTeacherDisabled
    },
    on: {
      "click": function($event) {
        return _vm.teacherLogin('ap')
      }
    }
  }, [_vm._v(_vm._s(_vm.teacherLoginBtnText) + "\n            ")])]), _vm._v(" "), _c('p', {
    staticClass: "agreement"
  }, [_vm._v("登录即表示你同意"), _c('a', {
    attrs: {
      "href": (_vm.agreementSite + "/copyRight/version.html"),
      "target": "_blank"
    }
  }, [_vm._v("版权声明")]), _vm._v("和"), _c('a', {
    attrs: {
      "href": (_vm.agreementSite + "/copyRight/agreement.html"),
      "target": "_blank"
    }
  }, [_vm._v("软件使用协议")])])]) : _c('div', {
    staticClass: "middle"
  }, [_c('div', {
    staticClass: "user-id input-wrap"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tearcherSmsData.username),
      expression: "tearcherSmsData.username"
    }],
    staticClass: "input-uesr",
    attrs: {
      "type": "text",
      "placeholder": "请输入账号"
    },
    domProps: {
      "value": (_vm.tearcherSmsData.username)
    },
    on: {
      "keyup": function($event) {
        return _vm.teacherLoginBtn('sms')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.tearcherSmsData, "username", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.teacherSmsErrMsg.username),
      expression: "teacherSmsErrMsg.username"
    }],
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.teacherSmsErrMsg.username))])]), _vm._v(" "), _c('div', {
    staticClass: "auth-code input-wrap"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tearcherSmsData.captcha),
      expression: "tearcherSmsData.captcha"
    }],
    staticClass: "input-password",
    attrs: {
      "placeholder": "短信动态验证码"
    },
    domProps: {
      "value": (_vm.tearcherSmsData.captcha)
    },
    on: {
      "keyup": function($event) {
        return _vm.teacherLoginBtn('sms')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.tearcherSmsData, "captcha", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.teacherSmsErrMsg.captcha),
      expression: "teacherSmsErrMsg.captcha"
    }],
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.teacherSmsErrMsg.captcha))]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticClass: "authcode",
    on: {
      "click": _vm.getCode
    }
  }, [_vm._v("获取验证码")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.show),
      expression: "!show"
    }],
    staticClass: "authcode not"
  }, [_vm._v("\n              " + _vm._s(_vm.count) + "S后重试\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "but-box"
  }, [_c('button', {
    staticClass: "btn-back",
    on: {
      "click": function($event) {
        _vm.showType = 1
      }
    }
  }, [_vm._v("返回")]), _vm._v(" "), _c('button', {
    staticClass: "btn-login",
    class: {
      'bg-highlight': _vm.isTeacherDisabled == false
    },
    attrs: {
      "disabled": _vm.isTeacherDisabled
    },
    on: {
      "click": function($event) {
        return _vm.teacherLogin('sms')
      }
    }
  }, [_vm._v(_vm._s(_vm.teacherLoginBtnText) + "\n            ")])]), _vm._v(" "), _c('p', {
    staticClass: "agreement"
  }, [_vm._v("登录即表示你同意"), _c('a', {
    attrs: {
      "href": (_vm.agreementSite + "/copyRight/version.html"),
      "target": "_blank"
    }
  }, [_vm._v("版权声明")]), _vm._v("和"), _c('a', {
    attrs: {
      "href": (_vm.agreementSite + "/copyRight/agreement.html"),
      "target": "_blank"
    }
  }, [_vm._v("软件使用协议")])])]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('div', {
    staticClass: "qrcode-wrap qrcode-pr"
  }, [(_vm.qrId) ? _c('div', {
    ref: "qrcode",
    staticClass: "qrcode-po",
    attrs: {
      "id": "qrcode"
    }
  }) : _vm._e()]), _vm._v(" "), _vm._m(6)])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showType == 2 && (_vm.currQrStatus == 1 || _vm.currQrStatus == 2)),
      expression: "showType==2 && (currQrStatus == 1 || currQrStatus == 2)"
    }],
    staticClass: "teacher"
  }, [_vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "right flx-two is-w"
  }, [_c('img', {
    staticClass: "suess",
    attrs: {
      "src": __webpack_require__(408),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "scan"
  }, [_vm._v("扫描成功")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("请在手机上「确认登录」")]), _vm._v(" "), _c('a', {
    staticClass: "goback mt",
    attrs: {
      "href": "javascript:0;"
    },
    on: {
      "click": _vm.onReset
    }
  }, [_vm._v("返回短信、密码登录")]), _vm._v(" "), _c('p', {
    staticClass: "agreement"
  }, [_vm._v("登录即表示你同意"), _c('a', {
    attrs: {
      "href": (_vm.agreementSite + "/copyRight/version.html"),
      "target": "_blank"
    }
  }, [_vm._v("版权声明")]), _vm._v("、"), _c('a', {
    attrs: {
      "href": (_vm.agreementSite + "/copyRight/agreement.html"),
      "target": "_blank"
    }
  }, [_vm._v("软件使用协议")]), _vm._v("和"), _c('a', {
    attrs: {
      "href": (_vm.agreementSite + "/copyRight/service.html"),
      "target": "_blank"
    }
  }, [_vm._v("服务协议")])])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showType == 4),
      expression: "showType==4"
    }],
    staticClass: "parent"
  }, [_vm._m(9), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(148),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("家长登录")]), _vm._v(" "), _c('button', {
    staticClass: "btn-back",
    on: {
      "click": function($event) {
        _vm.showType = 1
      }
    }
  }, [_vm._v("返回")]), _vm._v(" "), _c('p', {
    staticClass: "agreement",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("登录即表示你同意"), _c('a', {
    attrs: {
      "href": (_vm.agreementSite + "/copyRight/version.html"),
      "target": "_blank"
    }
  }, [_vm._v("版权声明")]), _vm._v("和"), _c('a', {
    attrs: {
      "href": (_vm.agreementSite + "/copyRight/agreement.html"),
      "target": "_blank"
    }
  }, [_vm._v("软件使用协议")])])]), _vm._v(" "), _vm._m(10)])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showType == 5),
      expression: "showType==5"
    }],
    staticClass: "principal"
  }, [_vm._m(11), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._m(12), _vm._v(" "), _c('div', {
    staticClass: "middle"
  }, [_c('div', {
    staticClass: "user-id input-wrap"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.schoolMasterData.account),
      expression: "schoolMasterData.account"
    }],
    staticClass: "input-uesr",
    attrs: {
      "type": "text",
      "placeholder": "请输入账号"
    },
    domProps: {
      "value": (_vm.schoolMasterData.account)
    },
    on: {
      "keyup": _vm.schoolMasterLoginBtn,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.schoolMasterData, "account", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.schoolMasterErrMsg.account))])]), _vm._v(" "), _c('div', {
    staticClass: "password input-wrap"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.schoolMasterData.password),
      expression: "schoolMasterData.password"
    }],
    staticClass: "input-password",
    attrs: {
      "type": "password",
      "placeholder": "请输入密码"
    },
    domProps: {
      "value": (_vm.schoolMasterData.password)
    },
    on: {
      "keyup": _vm.schoolMasterLoginBtn,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.schoolMasterData, "password", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.schoolMasterErrMsg.password))]), _vm._v(" "), _c('span', {
    staticClass: "forget-password"
  }, [_vm._v("忘记密码")])]), _vm._v(" "), _c('div', {
    staticClass: "verification-code input-wrap"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.schoolMasterData.code),
      expression: "schoolMasterData.code"
    }],
    staticClass: "input-code",
    attrs: {
      "type": "text",
      "placeholder": "请输入验证码"
    },
    domProps: {
      "value": (_vm.schoolMasterData.code)
    },
    on: {
      "keyup": _vm.schoolMasterLoginBtn,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.schoolMasterData, "code", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.schoolMasterErrMsg.code))]), _vm._v(" "), _c('span', {
    staticClass: "code-img"
  }, [_c('img', {
    attrs: {
      "src": _vm.codeUrl2,
      "alt": "验证码"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "msg",
    on: {
      "click": _vm.getValid2Code
    }
  }, [_vm._v("换一个")])]), _vm._v(" "), _c('div', {
    staticClass: "but-box"
  }, [_c('button', {
    staticClass: "btn-back",
    on: {
      "click": function($event) {
        _vm.showType = 1
      }
    }
  }, [_vm._v("返回")]), _vm._v(" "), _c('button', {
    staticClass: "btn-login",
    class: {
      'bg-highlight': _vm.isSchoolMasterDisabled == false
    },
    attrs: {
      "disabled": _vm.isSchoolMasterDisabled
    },
    on: {
      "click": _vm.schoolMasterLogin
    }
  }, [_vm._v(_vm._s(_vm.schoolMasterLoginBtnText) + "\n          ")])]), _vm._v(" "), _c('p', {
    staticClass: "agreement"
  }, [_vm._v("登录即表示你同意"), _c('a', {
    attrs: {
      "href": (_vm.agreementSite + "/copyRight/version.html"),
      "target": "_blank"
    }
  }, [_vm._v("版权声明")]), _vm._v("和"), _c('a', {
    attrs: {
      "href": (_vm.agreementSite + "/copyRight/agreement.html"),
      "target": "_blank"
    }
  }, [_vm._v("软件使用协议")])])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showTit),
      expression: "showTit"
    }],
    staticClass: "password-tit"
  }, [_c('div', {
    staticClass: "passwordTop"
  }, [_c('div', {
    staticClass: "password-top fl"
  }, [_vm._v("\n         提示\n       ")]), _vm._v(" "), _c('div', {
    staticClass: "password-bot fr",
    on: {
      "click": function($event) {
        _vm.showTit = false
      }
    }
  }, [_c('i', {
    staticClass: "el-icon-close"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "passwordBoT"
  }, [_vm._v("\n       您已经多次输入错误密码，为安全考虑账户将锁定10分钟，请稍后再试\n     ")]), _vm._v(" "), _c('div', {
    staticClass: "passwordBtn"
  }, [_c('el-button', {
    attrs: {
      "size": "medium",
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.showTit = false
      }
    }
  }, [_vm._v("确定")])], 1)]), _vm._v(" "), _c('el-dialog', {
    staticClass: "service-dialog",
    attrs: {
      "visible": _vm.serviceDialogVisible,
      "close-on-click-modal": false,
      "width": "600px"
    },
    on: {
      "update:visible": function($event) {
        _vm.serviceDialogVisible = $event
      }
    }
  }, [_c('div', {
    staticClass: "service-dialog-title",
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("江西风向标智能科技有限公司"), _c('br'), _vm._v("产品服务协议")]), _vm._v(" "), _c('div', {
    staticClass: "service-dialog-content"
  }, [_c('div', [_vm._v("尊敬的用户：")]), _vm._v(" "), _c('div', {
    staticClass: "ident"
  }, [_vm._v("\n        您好！欢迎您使用江西风向标智能科技有限公司（以下简称“风向标”或“服务商”）出品的“知心慧学智能精准教学系统”产品及配套服务。为使您的使用过程便捷，准确提升产品使用效率，请您认真阅读本协议，\n        您在阅读并确认使用上述产品后即表示您同意本协议的内容。\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "ident",
    staticStyle: {
      "margin-top": "15px"
    }
  }, [_vm._v("\n        江西风向标智能科技有限公司（以下简称“风向标”或“服务商”、“公司”）为您（指通过登录APP或网站、公众号、小程序等方式购买并使用风向标“知心慧学智能精准教学系统”产品及配套服务的终端客户，以下也称为“用户”）提供“知心慧学智能精准教学系统”产品和配套服务（以下简称“本产品”、“产品”），您自愿购买上述产品并基于购买产品后的使用而作出如下意思表示和授权，以下意思表示及授权均为您真实意愿，您同意承担由此带来的一切风险和责任。如果您是未成年人，则请您在法定监护人陪同下审阅和判断是否同意本协议的内容，未成年人使用本产品的行为视为已获得了法定监护人的认可。如果您不同意接受本协议的全部条款，则您无权注册、登录或使用本协议所涉及产品和服务，您下载、安装、使用本产品等行为，则意味着您将自愿遵守本协议及本产品的其他有关规则，并完全服从于本产品的统一管理。\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "ident"
  }, [_vm._v("\n        风向标有权根据业务需要对本协议不定时进行调整，并将调整后的协议公布于公司官网或者产品APP、公众号、小程序中，如果您不同意调整后的本协议的，您应当停止使用本产品，否则，如果在公司调整本协议并公布后，您继续使用本产品提供的服务的，则视为您同意遵守调整后的协议。\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "bold"
  }, [_vm._v("一、关于购买产品")]), _vm._v(" "), _c('div', {
    staticClass: "ident"
  }, [_vm._v("1、用户系自愿购买本产品，并通过线上或线下的方式向风向标支付用以购买产品的费用，用户用以登录产品使用端口的账号来自风向标的授予。")]), _vm._v(" "), _c('div', {
    staticClass: "ident"
  }, [_vm._v("2、用户已具备与购买行为相适应的智力、健康状况，或经用户的法定监护人的同意购买本产品，并充分理解、知悉购买产品和使用产品行为产生的法律效果以及基于购买和使用产品的行为产生的个人信息采集情况。")]), _vm._v(" "), _c('div', {
    staticClass: "ident"
  }, [_vm._v("3、经风向标许可，用户使用试用账号登录产品使用端口，并不表示用户同意即时付费，但这并不影响为正常使用产品而授权风向标采集用户的个人信息。")]), _vm._v(" "), _c('div', {
    staticClass: "ident"
  }, [_vm._v("4、产品的试用期限届满后，用户无意付费购买的，用户同意风向标随时收回风向标授予本人的登录账号。")]), _vm._v(" "), _c('div', {
    staticClass: "bold"
  }, [_vm._v("二、用户权利和义务")]), _vm._v(" "), _c('div', {
    staticClass: "ident"
  }, [_vm._v("\n        1、用户应妥善保管自己的账号、密码，不得转让、出借、出租、出售或分享予他人使用。否则风向标有权根据实际情况暂时封停或永久查封此账号，当用户的账号或密码遭到未经授权的使用时，用户应当立即通知风向标，否则未经授权的使用行为均视为用户本人行为。\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "ident"
  }, [_vm._v("\n        2、风向标有权随时对本产品内容等进行调整，包括但不限于增加、删除、修改本产品服务内容，一旦本产品的服务内容发生增加、删除、修改，公司将在相关页面上进行提示；如果用户不同意相关变更和修改，可以取消已经获取的服务并停止使用；如果用户继续使用本产品提供的服务，则视为用户已经接受全部变更、修改。除非另有明确约定，否则用户使用本产品内新增的服务内容将同样受本协议各项条款的约束。\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "ident"
  }, [_vm._v("\n        3、本产品内提供的服务分为试用期间的免费服务和正式使用的收费服务。对于现阶段免费提供的服务内容，公司有权随时根据公司政策的调整将其变更为收费服务，如果发生该等变更的，公司将提前告知用户，如果用户不同意的，可以停止使用该服务。对于收费的服务内容，公司有权自行确定该等服务的价格并不时调整，调整后的价格将在本产品平台中进行公示或以其他方式告知用户，如果用户不同意调整后的价格的，则用户可以在其原购买的收费服务到期后停止付费购买收费服务。如果用户在公司调整价格并公示或告知后，仍继续购买收费服务的，则视为用户同意该调整后的价格。\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "ident"
  }, [_vm._v("\n        4、用户如对付费购买的服务不满意的，有权终止服务。用户需在规定时间内，在客户端自行申请或拨打客服电话，申请终止服务及退款，退款金额按照客户端公示的退款规则计算，公司有权根据业务发展不时调整退款规则并在客户端内公示；公司有权保留已终止服务的用户的所有使用信息，对用户在使用付费服务期间发生的违反本协议及相关规定的行为，公司仍有权行使本协议规定的权利并追究用户的法律责任。\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "ident"
  }, [_vm._v("\n        5、公司不时将对付费服务提供优惠政策或开展优惠活动，该等优惠政策或优惠活动以本产品平台上的实时信息为准，用户知悉并认可，公司有权自行决定是否提供优惠政策或开展优惠互动，以及优惠政策或优惠活动的内容、条件和有效期，并不时进行调整或终止。\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "ident"
  }, [_vm._v("6、公司禁止以任何形式倒卖、贩售、出租、出借、转让用户账号的行为，一经查明，公司将采取包括但不限于封号、封禁IP、追究相关责任人法律责任的处理措施。")]), _vm._v(" "), _c('div', {
    staticClass: "bold"
  }, [_vm._v("三、平台管理")]), _vm._v(" "), _c('div', {
    staticClass: "ident"
  }, [_vm._v("1、用户应保证注册、登录并使用的账号符合中国相关法律法规的规定，符合《互联网用户账号名称管理规定》，符合本协议的各项规定。公司有权对用户注册、登录并使用的账号名称、头像和简介等注册信息进行审核，用户确保其使用的用户账号名称、头像和简介等信息中不得出现违法和不良信息，不存在以虚假信息骗取账号名称注册的情形；用户应确保其使用的用户账号名称不得为冒用关联机构或社会名人注册的账号名称。")]), _vm._v(" "), _c('div', {
    staticClass: "ident"
  }, [_vm._v("2、如果用户以虚假信息骗取账号名称注册，或用户的账号头像、简介等注册信息存在违法和不良信息的，公司有权采取通知限期改正、暂停使用、注销登记等措施；如果用户冒用关联机构或社会名人注册账号名称的，公司有权注销用户的账号，并向互联网信息内容主管部门报告。")]), _vm._v(" "), _c('div', {
    staticClass: "ident"
  }, [_vm._v("3、凡用户存在发布广告、暴力、色情、政治、宗教等内容，或抄袭、模仿管理人员ID，用以假冒管理人员或破坏管理人员形象，或模仿或盗用他人ID个人签名，发布的内容包含有严重影响网友浏览的内容或格式，或者存在其他扰乱本产品秩序的，或影响公司正常经营行为的，公司有权删除其相应账号，情节严重者，将酌情封禁对应IP。")]), _vm._v(" "), _c('div', {
    staticClass: "ident"
  }, [_vm._v("4、公司提供账号注销功能，可以在本产品中实现。注销账号之后此账号内的数据无法恢复，账号信息内容也将全部清除，包含但不限于该账号发布过的文章、评论等。注销行为操作后无法撤销，请用户谨慎申请。 ")]), _vm._v(" "), _c('div', {
    staticClass: "ident"
  }, [_vm._v("5、投诉和举报：如果用户认为本产品中的信息、资料、内容等存在违反法律法规及本产品相关管理规定的，涉嫌侮辱或者诽谤他人，或者侵犯用户或第三方的知识产权或其他合法权利情形的，您可以通过本产品内的专用渠道进行举报、投诉，或者向公司官方邮箱info@fxbjy.com发送权利通知书，公司将在收到您的投诉后将依据中国法律法规和政府规范性文件及本产品平台管理规定采取措施进行处理，包括但不限于移除相关内容或屏蔽相关链接，以及其他公司认为适当的处理方式，情节严重者，公司有权向政府相关部门进行举报。")]), _vm._v(" "), _c('div', {
    staticClass: "bold"
  }, [_vm._v("四、知识产权")]), _vm._v(" "), _c('div', {
    staticClass: "ident"
  }, [_vm._v("1、无论您成为本产品之会员或使用本产品，均认可公司对本产品及本产品所收集、制作、发布之各类信息拥有完全知识产权或所有权，包括但不限于各类文档、图像、数据库等，除非法律明确规定该等权利属于用户个人以外，相关权限应涵盖包括复制、修改、改写、改编、发行、翻译、创造衍生性著作、出版、将前述内容(部分或全部)加以散布、展示等。您同意公司对您提交的信息进行有关编排处理后形成的数据库拥有完全的知识产权。")]), _vm._v(" "), _c('div', {
    staticClass: "ident"
  }, [_vm._v("2、如您将信息公布到本产品的任何公共区域，则表示您同意，同时您自动授予，并且您陈述并保证您有权授予本产品不可撤销的、永久的、非独占的、完全免费的、中华人民共和国范围的许可。在该等许可下，您同意本产品使用、复制、执行、显示并传播该内容，您也同意公司基于该内容创作衍生作品或将该内容整合到其他作品中且公司对该等衍生作品或整合作品拥有完全的所有者权益。除已获得公司书面许可的情况外，您不得复制、修改、公布、传播、执行、转载、许可使用、创建衍生作品、转移显示、出售、转售、以非法手段获取或以任何其他方式处置本产品收集、制作、发布的各类信息。")]), _vm._v(" "), _c('div', {
    staticClass: "ident"
  }, [_vm._v("3、请勿擅自复制或采用本产品所创造的用以制成网页的HTML。公司对其HTML享有著作权。同时，公司对其网址上的所有图标、图饰、图表、色彩、文字表述及其组合、版面设计、数据库均享有完全的著作权，对发布的信息均享有专有的发布和使用权，未经公司同意，不得擅自复制、使用或转载。")]), _vm._v(" "), _c('div', {
    staticClass: "ident"
  }, [_vm._v("4、未经公司事先许可，禁止使用任何机器人、爬虫程序、其他自动设备，或手动程序等来监视或复制本产品网页或其所包含的任何内容。否则，公司有权依法追究法律责任。")]), _vm._v(" "), _c('div', {
    staticClass: "bold"
  }, [_vm._v("五、关于个人隐私和信息采集")]), _vm._v(" "), _c('div', [_vm._v("（一）信息采集授权")]), _vm._v(" "), _c('div', {
    staticClass: "ident"
  }, [_vm._v("1、采集途径。您不可撤销地授权风向标以为您提供产品之目的，通过以下途径获取本人信息：")]), _vm._v(" "), _c('div', {
    staticClass: "ident bold"
  }, [_vm._v("（1）您确认，您在申请试用和正式使用本产品（包括APP移动端、网站、H5页面链接、微信公众号、小程序等）时，向风向标提供的信息；")]), _vm._v(" "), _c('div', {
    staticClass: "ident bold"
  }, [_vm._v("（2）您在试用和正式使用产品后，风向标向您所在学校班级任课老师和您提供的考试成绩、学习状况、在校情况等信息。")]), _vm._v(" "), _c('div', {
    staticClass: "ident"
  }, [_vm._v("2、采集范围。您不可撤销地授权风向标以为您提供产品及服务之目的，获取您个人以下范围的信息：")]), _vm._v(" "), _c('div', {
    staticClass: "ident"
  }, [_vm._v("（1）您申请试用产品时提交的姓名、所在学校、年级、班级、学号、考号等必要信息；")]), _vm._v(" "), _c('div', {
    staticClass: "ident"
  }, [_vm._v("（2）您使用产品后通过产品系统上传的个人考卷、答题本、作业集、错题本以及历次考试成绩等；")]), _vm._v(" "), _c('div', {
    staticClass: "ident"
  }, [_vm._v("（3）您所在学校班级老师通过本产品教师端获取的您考试成绩、测评报告等。")]), _vm._v(" "), _c('div', [_vm._v("（二）信息使用授权")]), _vm._v(" "), _c('div', {
    staticClass: "ident bold"
  }, [_vm._v("您同意并不可撤销地授权风向标以为您提供产品之目的，保存、整理、加工本协议第五条第一款所述的、通过合法途径采集的您的信息，用于您更好的使用产品，以及辅助老师教学，并基于此目的，授权风向标通过本产品教师端向您所在学校和班级老师推送上述信息。")]), _vm._v(" "), _c('div', {
    staticClass: "ident"
  }, [_vm._v("上述授权系您对风向标做出的单方承诺，效力具有独立性，不受本条款所属协议成立与否及效力状态的影响。")]), _vm._v(" "), _c('div', {
    staticClass: "ident"
  }, [_vm._v("以上授权期限为您作出本授权承诺之日起至您在风向标处所有业务终结之日止。")]), _vm._v(" "), _c('div', [_vm._v("（三）信息使用共享")]), _vm._v(" "), _c('div', {
    staticClass: "ident"
  }, [_vm._v("您授权风向标，除法律另有规定之外，将您提供给风向标的信息、使用产品产生的信息以及风向标根据本协议约定查询、收集的信息，用于风向标及其因服务必要委托的合作伙伴为您提供服务、推荐产品、开展市场调查以及信息数据分析。")]), _vm._v(" "), _c('div', {
    staticClass: "ident"
  }, [_vm._v("您授权风向标，除法律另有规定外，基于为您提供更优质服务和产品的目的，向风向标因服务必要开展合伙的伙伴提供、查询、收集您的信息。")]), _vm._v(" "), _c('div', {
    staticClass: "ident"
  }, [_vm._v("为确保您的个人信息安全，风向标对上述信息负有保密义务，并尽最大努力采取各种措施保证信息安全。")]), _vm._v(" "), _c('div', {
    staticClass: "ident"
  }, [_vm._v("本条款自您签署或确认本协议时生效，具有独立法律效力，不受本条款所属协议成立与否及效力状态的影响。")]), _vm._v(" "), _c('div', [_vm._v("（四）用户知悉")]), _vm._v(" "), _c('div', {
    staticClass: "ident bold"
  }, [_vm._v("包含您姓名、所在学校、年级、班级、学号、考号等信息为您的个人信息。您应充分了解并明确知悉风向标向第三方采集并在法律法规许可范围内向信息使用者提供这些信息后，信息被其他主体对外提供和使用的风险，包括但不限于：这些信息对您的学习可能产生不利影响；这些信息被风向标依法提供给第三方后被他人不当利用的风险；第三方向您推销产品或服务而打扰您的风险。此情况下，您同意并不可撤销地授权风向标依照本协议约定向其他机构提供您的个人信息。")]), _vm._v(" "), _c('div', {
    staticClass: "bold"
  }, [_vm._v("六、责任有限和免责条款")]), _vm._v(" "), _c('div', {
    staticClass: "bold ident"
  }, [_vm._v("1、不允诺担保：本产品用户提问、回答、发言仅代表用户个人观点，与公司无关，且本产品不对用户发表的回答或评论的正确性、准确性、真实性进行保证。本产品为按现状提供，包含瑕疵及缺陷，公司不提供任何其他担保。公司不允诺其他无论是明示的还是默示的保证和担保，包括但不限于对特定目的的适销性和适应性，不侵权，以及任何出自交易过程或商业惯例的保证和条件。从公司或他处获取的任何建议或信息，不论是口头的还是书面的，都不会对公司产生本协议明确约定之外的其他保证和担保。")]), _vm._v(" "), _c('div', {
    staticClass: "bold ident"
  }, [_vm._v("2、责任有限：适用法律所允许的最大范围内，不论出于何种原因，公司对用户的全部责任为用户为使用作业帮的产品和服务而向公司支付的费用总额。如果公司免费向用户提供了本产品服务，则公司无义务对用户承担任何赔偿责任。任何情况下，公司不对出自本协议或与本协议有关的或与本产品的运行有关的任何特殊的、偶然的、惩罚性或间接的损害（包括但不限于数据损失、利润损失或营业损失）或采购替代产品承担责任，不论该等责任是基于合同、担保、侵权（包括过失）、严格责任或其他，也不论公司是否被事先告知了损失或损害发生的可能性。即使本协议约定的有限补救措施未能实现其根本目的，前述的责任限制依然适用。")]), _vm._v(" "), _c('div', {
    staticClass: "bold ident"
  }, [_vm._v("3、免责：如因下所列任何原因而造成的用户资料泄露、丢失、被盗用或被篡改等，公司均有权获得免责：")]), _vm._v(" "), _c('div', {
    staticClass: "bold ident"
  }, [_vm._v("（1）任何因政府管制而造成的暂时性关闭等影响网络正常浏览的不可抗力原因；")]), _vm._v(" "), _c('div', {
    staticClass: "bold ident"
  }, [_vm._v("（2）任何计算机系统问题、黑客攻击、计算机病毒侵入或发作的原因；")]), _vm._v(" "), _c('div', {
    staticClass: "bold ident"
  }, [_vm._v("（3）任何因网络安全问题导致的账户或银行卡信息泄露，该风险可能会给用户造成经济损失，用户承诺自行承担向侵权方追究责任及追究责任不能的后果；")]), _vm._v(" "), _c('div', {
    staticClass: "bold ident"
  }, [_vm._v("（4）任何因用户个人原因导致的用户资料泄露、丢失、被盗用或被篡改等；")]), _vm._v(" "), _c('div', {
    staticClass: "bold ident"
  }, [_vm._v("（5）其他不能归责于公司的原因。")]), _vm._v(" "), _c('div', [_vm._v("七、其他")]), _vm._v(" "), _c('div', {
    staticClass: "ident"
  }, [_vm._v("1、如果本产品平台上某一子服务附有单独的使用协议的，则该子服务的使用将受该单独使用协议的约束。")]), _vm._v(" "), _c('div', {
    staticClass: "ident"
  }, [_vm._v("2、本协议的签订、生效、履行、争议的解决均适用中华人民共和国法律。")]), _vm._v(" "), _c('div', {
    staticClass: "ident"
  }, [_vm._v("3、有关本协议的争议应通过友好协商解决，如果协商不成，该争议将提交风向标所在地有管辖权的法院诉讼解决。")]), _vm._v(" "), _c('div', {
    staticClass: "ident"
  }, [_vm._v("4、用户对作业帮平台的意见及建议可通过客服邮箱"), _c('span', {
    staticClass: "blue"
  }, [_vm._v("info@fxbjy.com")]), _vm._v("与公司进行联系。")])]), _vm._v(" "), _c('div', {
    staticClass: "service-dialog-foot",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": _vm.onDisagreeBtnClick
    }
  }, [_vm._v("不同意")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.onAgreeBtnClick
    }
  }, [_c('span', {
    staticStyle: {
      "padding": "0 30px"
    }
  }, [_vm._v("同 意")])])], 1)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title-box"
  }, [_c('h2', {
    staticClass: "title"
  }, [_vm._v("选择您的角色登录")]), _vm._v(" "), _c('i', {
    staticClass: "border-bottom"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "img-wrap"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(81),
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "img-new",
    attrs: {
      "src": __webpack_require__(466),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "img-wrap"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(458),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "img-wrap"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(148),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "img-wrap"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(155),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "left"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(81),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("教职工登录")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text"
  }, [_c('p', [_vm._v("打开知心慧学教师端")]), _vm._v(" "), _c('p', [_vm._v("点击 个人中心-扫一扫")]), _vm._v(" "), _c('p', [_vm._v("快速登录")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title-box"
  }, [_c('h2', {
    staticClass: "title"
  }, [_vm._v("登录")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "left new-left"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(81),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("老师登录")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title-box"
  }, [_c('h2', {
    staticClass: "title"
  }, [_vm._v("登录")]), _vm._v(" "), _c('i', {
    staticClass: "border-bottom"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "right"
  }, [_c('div', {
    staticClass: "qrcode-wrap"
  }, [_c('img', {
    staticClass: "qrcode-img",
    attrs: {
      "src": __webpack_require__(416),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_c('p', [_vm._v("微信公众号登录")]), _vm._v(" "), _c('p', [_vm._v("扫描二维码")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title-box"
  }, [_c('h2', {
    staticClass: "title"
  }, [_vm._v("登录")]), _vm._v(" "), _c('i', {
    staticClass: "border-bottom"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "left"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(155),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("校长登录")])])
}]}

/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sign"
  }, [_c('div', {
    staticClass: "sign_head"
  }, [_vm._v("领用出库")]), _vm._v(" "), (!_vm.isCompleted) ? [_c('div', {
    staticClass: "sign_panel sign_info"
  }, [_c('div', {
    staticClass: "sign_item"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "sign_info-val"
  }, [_vm._v("\n          " + _vm._s(_vm.data.outTitle) + "\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "sign_item"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "sign_info-val"
  }, [_vm._v("\n          " + _vm._s(_vm.data.outCode) + "\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "sign_item"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "sign_info-val"
  }, [_vm._v("\n          " + _vm._s(_vm.data.userName) + "\n        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "sign_panel sign_info"
  }, [_c('div', {
    staticClass: "sign_item"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "sign_info-val"
  }, [_vm._v("\n          " + _vm._s(_vm.data.itemName) + "\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "sign_item"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "sign_info-val"
  }, [_vm._v("\n          " + _vm._s(_vm.data.invNo) + "\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "sign_item"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "sign_info-val"
  }, [_vm._v("\n          " + _vm._s(_vm.data.no) + "\n        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "sign_panel",
    staticStyle: {
      "margin-bottom": "1.2rem"
    }
  }, [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "sign_panel-body"
  }, [_vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "qm",
    on: {
      "click": _vm.gotoSign
    }
  }, [(!_vm.url) ? [_c('img', {
    staticClass: "placeholeder",
    attrs: {
      "src": __webpack_require__(142),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v("点击进入签名")])] : _c('img', {
    staticClass: "signimg",
    attrs: {
      "src": _vm.url,
      "alt": ""
    }
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "sign_bottom"
  }, [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.gotoSign
    }
  }, [_vm._v("重新签名")]), _vm._v(" "), _c('button', {
    staticClass: "confirm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("保存")])])] : _c('div', {
    staticClass: "sign_completed"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(418),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v("完成")])])], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sign_item-label"
  }, [_c('img', {
    staticClass: "sign_icon",
    attrs: {
      "src": __webpack_require__(423),
      "alt": ""
    }
  }), _vm._v("领用标题：\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sign_item-label"
  }, [_c('img', {
    staticClass: "sign_icon",
    attrs: {
      "src": __webpack_require__(424),
      "alt": ""
    }
  }), _vm._v("领用单号：\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sign_item-label"
  }, [_c('img', {
    staticClass: "sign_icon",
    attrs: {
      "src": __webpack_require__(144),
      "alt": ""
    }
  }), _vm._v("领用人：\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sign_item-label"
  }, [_c('img', {
    staticClass: "sign_icon",
    attrs: {
      "src": __webpack_require__(145),
      "alt": ""
    }
  }), _vm._v("品目名称：\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sign_item-label"
  }, [_c('img', {
    staticClass: "sign_icon",
    attrs: {
      "src": __webpack_require__(422),
      "alt": ""
    }
  }), _vm._v("库存数量：\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sign_item-label"
  }, [_c('img', {
    staticClass: "sign_icon",
    attrs: {
      "src": __webpack_require__(426),
      "alt": ""
    }
  }), _vm._v("领取数量：\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sign_panel-head"
  }, [_c('div', [_c('img', {
    staticClass: "sign_icon",
    attrs: {
      "src": __webpack_require__(146),
      "alt": ""
    }
  }), _vm._v("\n          签名\n        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sm"
  }, [_c('div', [_c('img', {
    staticClass: "sign_icon",
    attrs: {
      "src": __webpack_require__(428),
      "alt": ""
    }
  })]), _vm._v("\n\n          说明：领用出库后，商品由领用人负责，如出现丢失损坏，会按照适当成本赔偿。签字代表同意本说明。\n        ")])
}]}

/***/ }),
/* 542 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper"
  })
},staticRenderFns: []}

/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper",
    attrs: {
      "id": "teacher"
    }
  }, [_c('section', {
    staticClass: "wmtg"
  }, [_c('div', {
    staticClass: "title-box"
  }, [_c('h2', {
    staticClass: "title"
  }, [_vm._v("我们为您提供")]), _vm._v(" "), _c('i', {
    staticClass: "border-bottom"
  })]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('img', {
    staticClass: "card-img",
    attrs: {
      "src": __webpack_require__(462),
      "alt": "智能题库"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "card-name"
  }, [_vm._v("智能题库")]), _vm._v(" "), _c('p', {
    staticClass: "card-text"
  }, [_vm._v("知心慧学为您提供内容丰富的动态智能题库。它分类详细，各类题目一应俱全；试题每日更新，每道都详细标注了知识点、考点属性。大量教师精编套卷、自主研发套卷，全面满足您的组卷需求！")])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('img', {
    staticClass: "card-img",
    attrs: {
      "src": __webpack_require__(460),
      "alt": "阅卷系统"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "card-name"
  }, [_vm._v("阅卷系统")]), _vm._v(" "), _c('p', {
    staticClass: "card-text"
  }, [_vm._v("同时支持网上阅卷和纸笔阅卷，客观题自动批阅，两种阅卷方式均不需要人工统分，系统自动统计。在不改变批改习惯的前提下，助您提升阅卷效率，事半功倍！")])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('img', {
    staticClass: "card-img",
    attrs: {
      "src": __webpack_require__(439),
      "alt": "教学宝"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "card-name"
  }, [_vm._v("教学宝")]), _vm._v(" "), _c('p', {
    staticClass: "card-text"
  }, [_vm._v("我们在每次考试结束之后为您打印“教学宝”，将答题详情、学情统计、学生成绩动态跟踪表、班级变式训练题等整理成册。是您进行科学备课、精准讲评、个性化教学的必备神器。")])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('img', {
    staticClass: "card-img",
    attrs: {
      "src": __webpack_require__(457),
      "alt": "学情统计"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "card-name"
  }, [_vm._v("学情统计")]), _vm._v(" "), _c('p', {
    staticClass: "card-text"
  }, [_vm._v("系统自动收集记录每次考试的详细答题数据，智能分析班级考试学情，分析每道试题的答题情况，自动记录每个知识点的历次得分情况。班级学情统计跃然于纸，一目了然！")])])])]), _vm._v(" "), _c('section', {
    staticClass: "wmdcp"
  }, [_c('div', {
    staticClass: "title-box"
  }, [_c('h2', {
    staticClass: "title"
  }, [_vm._v("我们的产品")]), _vm._v(" "), _c('i', {
    staticClass: "border-bottom"
  })]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('img', {
    staticClass: "img-chanping",
    attrs: {
      "src": __webpack_require__(434),
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "img-line-2",
    attrs: {
      "src": __webpack_require__(442),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "jsd"
  }, [_vm._v("教师端")]), _vm._v(" "), _c('img', {
    staticClass: "img-line-1",
    attrs: {
      "src": __webpack_require__(441),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "jxb"
  }, [_vm._v("教学宝")])])])])
}]}

/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app-download"
  }, [(_vm.weChat) ? _c('img', {
    staticClass: "open",
    attrs: {
      "src": __webpack_require__(80),
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('img', {
    staticClass: "open",
    attrs: {
      "src": __webpack_require__(79),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "app-list"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(141)
    },
    on: {
      "click": function($event) {
        return _vm.toApp(0)
      }
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": __webpack_require__(140)
    },
    on: {
      "click": function($event) {
        return _vm.toApp(1)
      }
    }
  })])])
},staticRenderFns: []}

/***/ }),
/* 545 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "privacy"
  }, [_c('p', [_vm._v("本政策仅适用于江西风向标智能科技有限公司的知心慧学教师端产品。")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('h2', [_vm._v("隐私政策及权限说明")]), _vm._v(" "), _c('p', {
    staticClass: "bold"
  }, [_vm._v("知心慧学教师端App采用严格的数据安全措施保护您的隐私安全。")]), _vm._v(" "), _c('p', {
    staticClass: "bold"
  }, [_vm._v("您选择【同意并开始使用】即表示您已充分阅读、理解和接受\n    "), _c('a', {
    staticClass: "blue",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        return _vm.clickPrivacy(1)
      }
    }
  }, [_vm._v("《用户服务协议》")]), _vm._v("和"), _c('a', {
    staticClass: "blue",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        return _vm.clickPrivacy(2)
      }
    }
  }, [_vm._v("《隐私政策》")]), _vm._v("。\n    您也可以选择【不同意并退出】，知心慧学教师端App将无法为您提供产品或服务。\n  ")]), _vm._v(" "), _c('p', {
    staticClass: "bold"
  }, [_vm._v("\n      知心慧学教师端app使用许可2.2&知心慧学教师端隐私政策2.2\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      以下内容是《知心慧学教师端app使用许可2.2》及《知心慧学教师端隐私政策2.2》，在你登录注册知心慧学教师端前请务必审慎阅读、充分理解协议中相关条款内容。《知心慧学教师端app使用许可2.2》包括app使用许可；信息使用；风险提示；知识产权。《知心慧学教师端隐私政策2.2》包括适用范围；我们收集信息的原因和内容；我们会如何使用您的信息；我们可能如何收集信息；我们会如何共享、转让、公开披露您的个人信息；如何管理您的个人信息；推广服务；我们会如何保护和保存您的个人信息；第三方提供商及其服务；本政策如何更新及适用范围；联系我们。你一旦登录注册知心慧学教师端，即视为你已了解并同意《知心慧学教师端app使用许可2.2》及《知心慧学教师端隐私政策2.2》的各项内容。\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      在此特别提醒您，在点击接受本声明之前，您应事先认真阅读、了解清楚并充分理解本声明的全部内容，包括免除或者限制责任的免责条款及对您的权利限制条款。请您审阅并接受或不接受本声明（未成年人应在法定监护人陪同下审阅）。\n      除非您接受本声明，否则您无权下载、安装或使用本公司基于应用软件提供的相关服务（以下称\"服务\"）。一旦您点击确认本声明，即意味着您已充分理解和接受本声明，并同意接受本声明各项条款的约束。并且，公司在法律许可的范围内享有对本声明的解释、修改以及变更的权利。\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bold"
  }, [_vm._v("\n      知心慧学教师端app使用许可2.2\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      一、APP使用许可\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      1.您使用的“知心慧学教师端”（以下简称“APP”）是由江西风向标智能科技有限公司（以下简称“公司”）运营的在线教育增值服务平台。\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      2.“知心慧学教师端用户”是指完成全部注册流程，愿意接受本协议并在知心慧学教师端相关使用规范的规定下使用知心慧学教师端APP服务的注册用户。\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      3.注册成为本APP之用户或使用本APP，即表示您保证您已具备单独签订本协议并遵守本协议所有条款之民事权利能力及民事行为能力。 ")]), _vm._v(" "), _c('p', [_vm._v("\n      4.您郑重承诺，将以本人真实的身份，秉承诚实信用合法的原则使用本APP，在登录和使用本APP的全过程中都负有作为理性人的谨慎和注意义务。 ")]), _vm._v(" "), _c('p', [_vm._v("\n      5.本公司保留对APP使用规定的解释、修改以及变更的权利，届时将通过APP通告等方式向用户传达，如果不同意对本协议相关条款所做的修改，用户有权停止使用网络服务。如果用户继续使用网络服务，则视为用户接受本协议相关条款所做的修改。如您未在通知规定的时间内表示反对，将会被视为默认。\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      二、信息使用\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "key-msg"
  }, [_vm._v("\n      1.在注册、登陆和使用知心慧学教师端APP时，您同意及不可撤销地授权将您的姓名和账户等信息提供给我们，包括但不限于您的真实姓名、联系方式、身份证号码、住址、账号信息等。\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      2.您在使用知心慧学教师端时，承诺和保证如下内容：\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      (a)您所提供的资料为完整，最新及正确无误；\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      (b)本协议一经签署，即具法律效力并同意受其约束。\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      3.您的注册信息包括注册号和密码仅供本人使用，您有义务提高自我保护和防范风险意识，如提高密码级别、不随意向其他人透露您的用户名、口令等信息。如若由于您个人对账号信息保管不慎或告知他人而导致任何个人信息泄露、账户损失等，知心慧学教师端将不予承担任何责任。\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "key-msg"
  }, [_vm._v("\n      4.我们将对您所提供的资料进行严格的管理及保护，致力于保护用户个人数据及个人隐私安全，原则上不提供给任何个人或者第三方使用，拒绝任何组织和个人以营利为目的意图获取或者使用用户个人信息。特殊情况如司法机关、监管机构或其他政府部门依照法定程序要求提供用户个人信息等为例外。本APP在必要时将会由专业技术人员代为对您相关信息资料进行处理，以符合专业分工的要求。\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      如发生下列任何一种情形，本APP有权随时使用用户提交信息资料、中断或终止向用户提供本协议项下的网络服务而无需通知用户：\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      (a)用户提供的个人资料不真实；\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      (b)用户违反本协议中规定的使用规则；\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      (c)为免除您在生命、身体或财产方面之急迫危险的；\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      (d)为防止他人权益之重大危害的；\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      (e)为增进公共利益，且无害于您的重大利益的。除前款所述情形外，本APP同时保留在不事先通知用户的情况下随时中断或终止部分或全部网络服务的权利，对于所有服务的中断或终止而造成的任何损失，本APP无需对用户或任何第三方承担任何责任。\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      三、风险提示\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      1.对在任何情况下因使用或不能使用本APP所产生的直接、间接、偶然、特殊及后续的损害及风险，我们不承担任何责任。损失包括但不限于决策对于由此给您造成的任何不便或损害，包括但不限于：决策失误、操作不当、遗忘或泄露账户密码、密码被他人破解、您使用的终端设备被第三方侵入而造成的损失。\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      2.您于订立协议时已表示理解并同意免除我们与此相应的法律责任。如在本APP运营过程中出现我们误将您的账户终止，或变更您的有关信息，或部分停止您的各类权限，则我们将在您提出书面通知后合理期间内处理该等事宜，若因此给您带来不便甚至造成损失，您同意免除我们的相应法律责任。\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      3.您了解并同意，我们不对因下述任一情况而导致的任何损害赔偿承担责任： (a)使用或未能使用本APP服务； (b)对本APP服务的错误理解； (c)第三方未使用真实身份，或者未经批准的使用他人的账号或更改他人的数据；\n      (d)任何非因本APP的原因而引起的与服务有关的损失。\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      4.对于任何本APP无法控制的原因（包括但不限于政府管制、通讯设施故障及其他不可抗力因素）导致的APP暂时关闭、用户信息泄露、被盗用、被篡改等非正常经营行为，本APP不承担任何责任。\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      5.您承认对于您利用本APP或信息而从事的各类行为，包括线上和线下，均为您个人行为且您个人对该类行为承担完全责任。您同意保障和维护APP及其他用户的利益，如因违反有关法律、法规或本协议项下的任何条款而给本APP或任何其他第三人造成损失，您同意承担由此造成的损害赔偿责任。\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      6.由于您将用户密码告知他人或与他人共享注册账户，由此导致的任何个人信息的泄露，任何由于黑客攻击、计算机病毒侵入或发作、因政府管制而造成的暂时性关闭等影响网络正常经营之不可抗力而造成的个人信息泄露、丢失、被盗用或被篡改等，由于本APP不拥有或不控制的公司以及我们不雇佣或不管理的人员所造成的个人信息的泄露，本APP不承担任何责任并应免于被追诉。\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      7.用户同意保障和维护知心慧学教师端APP及其他用户的利益，如因用户违反有关法律、\n      法规或本协议项下的任何条款而给本APP或任何其他第三人造成损失，用户同意承担由此造成的损害赔偿责任。在注册成为本APP用户或者使用本APP过程中，您与任何第三方之间发生任何纠纷，由纠纷各方自行解决，本APP并不承担任何责任。本APP不对您使用本APP的任何行为、效果或影响提供任何担保或条件，无论是明示、默示或法定的。\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      四、知识产权\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      1.无论您成为本APP之会员或使用本APP，均认可我们对本APP及本APP所收集、制作、发布之各类信息拥有完全知识产权或所有权，包括但不限于各类文档、图像、数据库等，除非法律明确规定该等权利属于会员个人以外，相关权限应涵盖包括复制、修改、改写、改编、发行、翻译、创造衍生性著作、出版、将前述内容(部分或全部)加以散布、展示等。您同意我们对所有会员提交的信息进行有关编排处理后形成的数据库拥有完全的知识产权。\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      2.如您将信息公布到本APP的任何公共区域，则表示您同意，同时您自动授予，并且您陈述并保证您有权授予本APP不可撤销的、永久的、非独占的、完全免费的、世界范围的许可。在该等许可下，您同意本APP使用、复制、执行、显示并传播该内容，您也同意我们基于该内容创作衍生作品或将该内容整合到其他作品中且我们对该等衍生作品或整合作品拥有完全的所有者权益。除已获得我们书面许可的情况外，您不得复制、修改、公布、传播、执行、转载、许可使用、创建衍生作品、转移显示、出售、转售、以非法手段获取或以任何其他方式处置本APP收集、制作、发布的各类信息。\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      3.请勿擅自复制或采用本APP所创造的用以制成网页的HTML。本APP对其HTML享有著作权。同时，本APP对其网址上的所有图标、图饰、图表、色彩、文字表述及其组合、版面设计、数据库均享有完全的著作权，对发布的信息均享有专有的发布和使用权，未经本APP同意，不得擅自复制、使用或转载。\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n       \n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bold tac"
  }, [_vm._v("\n      知心慧学教师端隐私政策2.2\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n       \n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      本政策仅适用于江西风向标智能科技有限公司的知心慧学教师端产品。\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      最新更新日期：2025年7月31日。\n    ")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('p', [_vm._v("\n       \n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bold"
  }, [_vm._v("\n      本政策将帮助您了解以下内容：\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      ·知心慧学教师端的个人信息收集使用规则\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      ·我们如何保护您的个人信息\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      ·您的权利\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      ·我们会如何共享、转让、公开披露您的个人信息\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      ·本政策如何更新\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      ·如何联系我们\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      【特别提示】请仔细阅读《知心慧学教师端隐私政策2.2》（尤其是加粗划线的内容）并确定了解我们（江西风向标智能科技有限公司）对您个人信息的处理规则。阅读过程中，如您有任何疑问，可联系我们的客服咨询，如果您不同意相关协议或其中任何条款约定，知心慧学教师端将暂时无法为您提供定制服务。本隐私政策与您所使用的知心慧学教师端服务以及该服务所包括的各种业务功能（以下统称“我们的产品与/或服务”）息息相关，希望您在使用我们的产品与/或服务前仔细阅读并确认您已经充分理解本政策所写明的内容，并让您可以按照本隐私政策的指引做出您认为适当的选择。本隐私政策中涉及的相关术语，我们尽量以简明扼要的表述，并提供进一步说明的链接，以便您更好地理解。您使用或在我们更新本隐私政策后（我们会及时提示您更新的情况）继续使用我们的产品与/或服务，即意味着您同意本隐私政策(含更新版本)内容，并且同意我们按照本隐私政策收集、使用、保存和共享您的相关信息。如对本隐私政策或相关事宜有任何问题，您可随时通过发送邮件至info@fxbjy.com\n      或拨打我们的任何一部客服电话等多种方式与我们联系 。 ")]), _vm._v(" "), _c('p', [_vm._v("\n      一、 适用范围\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      本隐私政策适用于知心慧学教师端。教师端提供的所有服务，您访问知心慧学教师端网站、客户端，均适用本隐私政策。 ")]), _vm._v(" "), _c('p', [_vm._v("\n      二、我们收集信息的原因和内容\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      为了保障您能够流畅地使用我们的核心功能并向您提供更好、更优的服务，同时为了保障您的信息安全，我们将根据您使用的服务收集您的以下信息。\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      1、您直接提供给我们的信息\n    ")]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('p', [_vm._v("\n      2、在您使用过程中产生的信息\n    ")]), _vm._v(" "), _vm._m(3), _c('p', [_vm._v("\n      我们可能对您的使用信息、浏览信息进行记录，用来为您展示历史使用、浏览记录。\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      我们还可能为了提供服务及改进服务质量的合理需要而获得您的其他信息，包括您与客服联系时您提供的相关信息， 您参与问卷调查时向我们发送的问卷答复信息，以及您与我们的关联方、我们合作伙伴之间互动时我们获得的相关信息。\n      对于您的账号个人设置信息，我们可能会将它们进行关联，以便我们能在您登录其他设备时为您提供一致的服务。 我们可能会将来自某项服务的信息与来自其他服务的信息结合起来，以便为您提供服务、定制内容和建议。\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      3、征得授权同意的例外\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      根据相关法律法规的规定，以下情形中收集您的个人信息无需征得您的授权同意：\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      （1）涉及国家安全与利益、社会公共利益；\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      （2）与犯罪侦查有关的相关活动；\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      （3）出于维护您或他人的生命财产安全但在特殊情况下无法获得您的及时授权；\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      （4）从其他合法公开的渠道中收集您的个人信息；\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      （5）法律法规规定的其他情形。\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      三、我们会如何使用您的信息\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      收集您的信息是为了向您提供服务及提升服务质量，我们会根据本隐私政策的约定进行使用，在收集您的信息后，我们将通过技术手段对数据进行去标识化处理，去标识化处理的信息将无法识别主体。请您了解并同意，在此情况下我们有权使用已经去标识化的信息；并在不透露您个人信息的前提下，我们有权对用户数据库进行分析并予以合法使用。\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "key-msg"
  }, [_vm._v("\n      您的信息主要有以下用途：\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "key-msg"
  }, [_vm._v("\n      （1）为您提供您使用的各项定制服务，并维护、改进这些服务。\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "key-msg"
  }, [_vm._v("\n      （2）帮助我们设计新服务，提升现有服务体验。\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "key-msg"
  }, [_vm._v("\n      （3）在我们提供服务时，用于身份验证、客户服务、安全防范、诈骗监测、存档和备份用途，确保我们向您提供的产品和服务的安全性。\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "key-msg"
  }, [_vm._v("\n      （4）邀请您参与知心慧学教师端活动和市场调查。\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "key-msg"
  }, [_vm._v("\n      （5）开展内部审计、数据分析和研究，以更好地改善我们的产品、服务及与用户之间的沟通。\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      四、我们可能如何收集信息\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      1、您使用我们的服务时，我们会在您的计算机或移动设备上存储名为 Cookie 的小数据文件。Cookie\n      通常包含标识符、站点名称以及一些号码和字符。我们使用该等信息判断注册用户是否已经登录，提升服务/产品质量及优化用户体验。如您不希望个人信息保存在 Cookie 中，您可对浏览器进行配置，选择禁用 Cookie 功能。禁用\n      Cookie 功能后，可能影响您访问知心慧学教师端或不能充分取得知心慧学教师端提供的服务。\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      知心慧学教师端不会将 Cookie 用于本政策所述目的之外的任何用途。您可根据自己的偏好管理或删除Cookie。您可以清除计算机上保存的所有 Cookie，大部分网络浏览器都设有阻止 Cookie 的功能。\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      2、设备权限调用\n    ")]), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('p', [_vm._v("\n      根据您的服务使用情况，我们可能会调用的权限如下：\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      （1）储存权限。当您下载及升级应用、试卷保存、阅卷信息保存、联系在线客服反馈问题时，我们会调用您的储存权限，保障您能顺利实现此功能。\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      （2）摄像头权限。当您提交意见反馈、修改头像时，我们将调用您的摄像头权限，保障您的使用。\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      （3）语音权限：当您使用知心慧学教师端直播课功能，或类似直播服务用于线上上课和发言时，我们将调用您设备的语音权限，以保证您能顺利实现此功能。\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      （4）短信权限：当您注册账号时，我们将调用短信权限，保障您能顺利完成注册。\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      五、我们会如何共享、转让、公开披露您的个人信息\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      1、共享\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      知心慧学教师端不会在未经您同意或授权的情况下将您的个人信息提供给第三方。但是，经您确认同意，知心慧学教师端可在以下情况下共享您的个人信息：\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      在获取同意的情况下共享：获得您的明确同意后，知心慧学教师端会与其他方共享您的个人信息。\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      共享给知心慧学教师端的关联公司：在本政策声明的使用目的范围内，您的个人信息可能会与知心慧学教师端的关联公司共享。作为一项政策，我们只会共享必要的信息。关联公司如要改变个人信息的处理目的，将再次征求您的授权同意。\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      共享给授权合作伙伴：知心慧学教师端可能会与合作伙伴共享您的某些个人信息，以便给您提供服务、内容和建议。例如，知心慧学教师端向您寄送礼品（如有）时，知心慧学教师端必须与物流服务提供商共享您的个人信息才能安排寄送，或者安排合作伙伴向您提供服务。我们仅会出于特定、明确而合法的目的处理您的个人信息，并且只会共享提供服务所必要的信息。同时，我们会与其签署严格的保密协定，要求他们按照我们的说明、本政策以及其他任何相关的保密和安全措施来处理个人信息。在法定情形下的共享：我们可能会根据法律法规规定、诉讼争议解决需要，或按行政、司法机关依法提出的要求，对外共享您的个人信息。\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "key-msg"
  }, [_vm._v("事先获得您明确同意的情况下，我们会在法律法规允许且不违背公序良俗的范围内，依据您的授权范围与第三方共享您的信息。")]), _vm._v(" "), _c('p', [_vm._v("为知心慧学教师端App相关功能的实现与应用安全稳定的运行，我们可能会接入由第三方提供的软件开发包（SDK）实现相关目的。 我们会对合作方获取信息的软件工具开发包（SDK）进行严格的安全监测，以保护数据安全。")]), _vm._v(" "), _c('p', [_vm._v("请注意，第三方SDK可能因为其版本升级、策略调整原因导致数据处理类型存在一定变化，请以其公示的官方说明为准。")]), _vm._v(" "), _c('p', [_vm._v("1.1 第三方SDK目录")]), _vm._v(" "), _c('p', [_vm._v("第三方SDK名称：微信 SDK")]), _vm._v(" "), _c('p', [_vm._v("所属公司名称：深圳市腾讯计算机系统有限公司")]), _vm._v(" "), _c('p', [_vm._v("收集个人信息类型：设备品牌、设备型号、设备版本、系统版本、生成ID、手机样式、手机名、iccid、bssid、MAC地址、IMSI、IMEI、IP地址、网络状态")]), _vm._v(" "), _c('p', [_vm._v("使用目的：授权登录、内容分享")]), _vm._v(" "), _c('p', [_vm._v("收集方式：sdk本机采集")]), _vm._v(" "), _c('p', [_vm._v("使用场景：微信授权登录、分享内容至微信")]), _vm._v(" "), _c('p', [_vm._v("第三方SDK隐私政策或开发指南：")]), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('p', [_vm._v("第三方公司名称：友盟同欣（北京）科技有限公司")]), _vm._v(" "), _c('p', [_vm._v("产品/类型：友盟sdk")]), _vm._v(" "), _c('p', [_vm._v("收集个人信息类型：IMEI/OAID/MAC/Android ID /IDFA/OpenUDID/GUID/IP地址/SIM卡IMSI信息等）")]), _vm._v(" "), _c('p', [_vm._v("使用目的：云平台、企业协作、辅助运营")]), _vm._v(" "), _c('p', [_vm._v("收集方式：sdk本机采集")]), _vm._v(" "), _c('p', [_vm._v("功能：为成功调起您用户设备中应用，高效实现第三方登录和社会化分享功能，我们会收集系统在装的应用列表信息，提升您用户的使用体验")]), _vm._v(" "), _c('p', [_vm._v("第三方隐私权政策链接：")]), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('p', [_vm._v("第三方公司名称：华为终端有限公司")]), _vm._v(" "), _c('p', [_vm._v("产品/类型：华为推送sdk")]), _vm._v(" "), _c('p', [_vm._v("收集个人信息类型：应用基本信息、设备标识信息（IMEI、Android ID、AAID和Push Token）、设备的硬件信息、系统基本信息和系统设置信息、应用安装列表信息、申请获取存储权限、电话权限")]), _vm._v(" "), _c('p', [_vm._v("使用目的：用于向华为手机用户推送消息")]), _vm._v(" "), _c('p', [_vm._v("收集方式：sdk本机采集")]), _vm._v(" "), _c('p', [_vm._v("使用场景：向用户推送消息时")]), _vm._v(" "), _c('p', [_vm._v("第三方隐私权政策链接：")]), _vm._v(" "), _vm._m(7), _vm._v(" "), _c('p', [_vm._v("第三方公司名称：小米公司")]), _vm._v(" "), _c('p', [_vm._v("产品/类型：小米推送sdk")]), _vm._v(" "), _c('p', [_vm._v("收集个人信息类型：设备标识信息(SSID、OAID、加密的Android ID)、推送消息内容、设备信息(设备厂商、型号、归属地、运营商名称等)、通知栏设置、运营商信息、申请获取存储权限、位置权限")]), _vm._v(" "), _c('p', [_vm._v("使用目的：用于向小米用户推送消息")]), _vm._v(" "), _c('p', [_vm._v("收集方式：sdk本机采集")]), _vm._v(" "), _c('p', [_vm._v("使用场景：向用户推送消息时")]), _vm._v(" "), _c('p', [_vm._v("第三方隐私权政策链接：")]), _vm._v(" "), _vm._m(8), _vm._v(" "), _c('p', [_vm._v("第三方公司名称：珠海市魅族通讯设备有限公司")]), _vm._v(" "), _c('p', [_vm._v("产品/类型：魅族消息推送服务sdk")]), _vm._v(" "), _c('p', [_vm._v("收集个人信息类型：设备标识信息（IMEI）、运营商信息、申请获取存储权限")]), _vm._v(" "), _c('p', [_vm._v("使用目的：用于向魅族手机用户推送消息")]), _vm._v(" "), _c('p', [_vm._v("收集方式：sdk本机采集")]), _vm._v(" "), _c('p', [_vm._v("使用场景：向用户推送消息时")]), _vm._v(" "), _c('p', [_vm._v("第三方隐私权政策链接：")]), _vm._v(" "), _vm._m(9), _vm._v(" "), _c('p', [_vm._v("第三方公司名称：OPPO广东移动通信有限公司")]), _vm._v(" "), _c('p', [_vm._v("产品/类型：OPPO推送sdk")]), _vm._v(" "), _c('p', [_vm._v("收集个人信息类型：匿名用户ID（OAID）")]), _vm._v(" "), _c('p', [_vm._v("使用目的：用于向OPPO用户推送消息")]), _vm._v(" "), _c('p', [_vm._v("收集方式：sdk本机采集")]), _vm._v(" "), _c('p', [_vm._v("使用场景：向用户推送消息时")]), _vm._v(" "), _c('p', [_vm._v("第三方隐私权政策链接：")]), _vm._v(" "), _vm._m(10), _vm._v(" "), _c('p', [_vm._v("第三方公司名称：维沃移动通信有限公司")]), _vm._v(" "), _c('p', [_vm._v("产品/类型：VIVO推送sdk")]), _vm._v(" "), _c('p', [_vm._v("收集个人信息类型：匿名用户ID（OAID）")]), _vm._v(" "), _c('p', [_vm._v("使用目的：用于向VIVO用户推送消息")]), _vm._v(" "), _c('p', [_vm._v("收集方式：sdk本机采集")]), _vm._v(" "), _c('p', [_vm._v("使用场景：向用户推送消息时")]), _vm._v(" "), _c('p', [_vm._v("功能：用于消息推送")]), _vm._v(" "), _c('p', [_vm._v("收集个人信息字段：匿名用户ID（OAID）")]), _vm._v(" "), _c('p', [_vm._v("第三方隐私权政策链接：")]), _vm._v(" "), _vm._m(11), _vm._v(" "), _c('p', [_vm._v("第三方公司名称：深圳市腾讯计算机系统有限公司")]), _vm._v(" "), _c('p', [_vm._v("产品/类型：腾讯bugly")]), _vm._v(" "), _c('p', [_vm._v("收集个人信息类型：设备信息（IMEI/MAC/Android ID/IDFA/OpenUDID/GUID/IP地址/SIM卡IMSI信息/手机参数信息等）")]), _vm._v(" "), _c('p', [_vm._v("使用目的：云平台、企业协作、辅助运营")]), _vm._v(" "), _c('p', [_vm._v("收集方式：sdk本机采集")]), _vm._v(" "), _c('p', [_vm._v("功能：云平台、企业协作、辅助运营")]), _vm._v(" "), _c('p', [_vm._v("第三方隐私权政策链接：")]), _vm._v(" "), _vm._m(12), _vm._v(" "), _c('p', [_vm._v("第三方SDK名称：PictureSelector")]), _vm._v(" "), _c('p', [_vm._v("产品/类型：开源代码库")]), _vm._v(" "), _c('p', [_vm._v("使用目的：加载本地相册图片，拍照选择，收集外部存储文件和文件夹。")]), _vm._v(" "), _c('p', [_vm._v("功能：选择头像，选择文件上传")]), _vm._v(" "), _vm._m(13), _vm._v(" "), _c('p', [_vm._v("第三方SDK名称：Network SDK")]), _vm._v(" "), _c('p', [_vm._v("收集个人信息类型：设备品牌、设备型号、设备版本、系统版本、手机样式、 手机名、MAC地址、IMSI、IMEI、IP地址、网络状态")]), _vm._v(" "), _c('p', [_vm._v("使用目的：网络数据请求，数据手机")]), _vm._v(" "), _c('p', [_vm._v("收集方式：sdk本机采集")]), _vm._v(" "), _c('p', [_vm._v("使用场景：登录，设备信息收集")]), _vm._v(" "), _c('p', [_vm._v("第三方SDK名称：com.umeng.analytics【友盟+移动统计】")]), _vm._v(" "), _c('p', [_vm._v("收集个人信息类型：设备品牌、设备型号、设备版本、系统版本、手机样式、 手机名、MAC地址、IMSI、IMEI、IP地址、网络状态")]), _vm._v(" "), _c('p', [_vm._v("使用目的：采集用户设备信息分析")]), _vm._v(" "), _c('p', [_vm._v("使用场景：设备信息收集")]), _vm._v(" "), _c('p', [_vm._v("第三方SDK名称：com.umeng.message【友盟+消息推送】")]), _vm._v(" "), _c('p', [_vm._v("收集个人信息类型：设备品牌、设备型号、设备版本、系统版本、手机样式、 手机名、MAC地址、IMSI、IMEI、IP地址、网络状态")]), _vm._v(" "), _c('p', [_vm._v("使用目的：推送消息给用户")]), _vm._v(" "), _c('p', [_vm._v("使用场景：考试报告信息推送给老师提醒老师查看")]), _vm._v(" "), _c('p', [_vm._v("第三方SDK名称：com.uc.crashsdk【Crash】")]), _vm._v(" "), _c('p', [_vm._v("收集个人信息类型：设备品牌、设备型号、设备版本、系统版本、手机样式、 手机名、MAC地址、IMSI、IMEI、IP地址、网络状态")]), _vm._v(" "), _c('p', [_vm._v("使用目的：提高稳定性，收集错误日志")]), _vm._v(" "), _c('p', [_vm._v("使用场景：用户APP报错时手机错误日志以供我们定位问题修复")]), _vm._v(" "), _c('p', [_vm._v("第三方SDK名称：com.umeng.umcrash【友盟+应用性能监控】")]), _vm._v(" "), _c('p', [_vm._v("收集个人信息类型：设备品牌、设备型号、设备版本、系统版本、手机样式、 手机名、MAC地址、IMSI、IMEI、IP地址、网络状态")]), _vm._v(" "), _c('p', [_vm._v("使用目的：提高稳定性，收集错误日志")]), _vm._v(" "), _c('p', [_vm._v("使用场景：用户APP报错时手机错误日志以供我们定位问题修复")]), _vm._v(" "), _c('p', [_vm._v("自启动和关联启动说明")]), _vm._v(" "), _c('p', [_vm._v("1、为确保本应用处于关闭或后台运行状态下可正常接收到客户端推送的信息，本应用须使用(自启动)能力，将存在一定频率通过 系统发送广播唤醒本应用自启动或关联启动行为，是因实现功能及服务所必要的。")]), _vm._v(" "), _c('p', [_vm._v("2、当您打开内容类推送消息，在征得您的明确同意后，会跳转打开相关内容。在未征得您同意的情况下，则不会有自启动或关联启动。")]), _vm._v(" "), _c('p', [_vm._v("3、当您打开本App内部下载的文件后，会关联启动第三方App。")]), _vm._v(" "), _c('p', [_vm._v("\n      2、转让\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      我们不会将您的个人信息转让给任何公司、组织和个人，但以下情况除外：\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      事先获得您明确的同意或授权；\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      根据适用的法律法规、法律程序的要求、强制性的行政或司法要求所必须的情况进行提供；\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      符合与您签署的相关协议（包括在线签署的电子协议以及相应的平台规则）或其他的法律文件约定所提供；在涉及合并、收购、资产转让或类似的交易时，如涉及个人信息转让，我们会要求新的持有您个人信息的公司、组织继续受本隐私政策的约束，否则,我们将要求该公司、组织重新向您征求授权同意\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      3、公开披露\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      我们仅会在以下情况下，且采取符合法律和业界标准的安全防护措施的前提下，才会公开披露您的个人信息：\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      根据您的需求，在您明确同意的披露方式下披露您所指定的个人信息；\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      根据法律、法规的要求、强制性的行政执法或司法要求所必须提供您个人信息的情况下，我们可能会依据所要求的个人信息类型和披露方式公开披露您的个人信息。在符合法律法规的前提下，当我们收到上述披露信息的请求时，我们会要求必须出具与之相应的法律文件，如传票或调查函。我们坚信，对于要求我们提供的信息，应该在法律允许的范围内尽可能保持透明。我们对所有的请求都进行了慎重的审查，以确保其具备合法依据，且仅限于执法部门因特定调查目的且有合法权利获取的数据。在法律法规许可的前提下，我们披露的文件均在加密密钥的保护之下。\n    ")]), _vm._v(" "), _c('p', [_vm._v("六、 关于未成年个人信息")]), _vm._v(" "), _c('p', [_vm._v("\n      我们的产品主要面向成人，我们重视对未成年人个人信息的保护。若您是18周岁以下的未成年人，在使用我们的服务或产品前，应事先取得您的家长或法定监护人的同意并在他们的指导下使用。若您是未成年人的监护人，当您对您所监护的未成年人的个人信息有相关疑问或拒绝进一步收集被监护人信息，或要求我们删除被监护人信息，请通过第十一条中的联系方式与我们联系。\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      七、 如何管理您的个人信息\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      我们将尽一切可能采取适当的技术手段，保证收集到的有关于您的个人信息的准确性，并保证及时进行更新。\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      1、更正或补充您的个人信息\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      除法律法规规定外，您有权随时访问和更正您的个人信息，具体包括：\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      Web端路径：您可以在左上角点击头像，页面的“个人资料”菜单中查阅您提交给知心慧学教师端的所有个人信息，你也可通过上述途径更新除教师认证信息之外的其他个人信息（您的姓名、学科、手机号、岗位）。移动端具体路径为：\n      “我的”进入我的知心慧学教师端--修改密码：您也可以通过「个人中心」-【意见反馈】页面，按照知心慧学教师端的相关政策及提示，或联系在线客服，对您的个人信息进行访问、更正。\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bold"
  }, [_vm._v("\n      2、删除您的个人信息及注销账号\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "key-msg"
  }, [_vm._v("\n      您可以通过「我的」-【安全中心】页面，点击账号注销，填写账号及密码后申请注销，或联系在线客服，或拨打客服电话19970080755，我们将在2周内帮助您进行注销账号及删除有关信息的处理。 ")]), _vm._v(" "), _c('p'), _c('p', [_vm._v("\n      3、消息管理推送\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      对于您在使用服务的过程中提供的设备号，我们在运营过程中可能会向您的设备发送消息推送，用于用户消息告知、任务提醒等目的。在「个人中心」-【消息推送管理】页面，您可以选择是否接受定向推送信息，或选择接受部分情况下的推送通知。IOS系统用户可以在[系统设置]-[通知]-[知心慧学教师端]页面设置是否允许通知，安卓系统用户可在[系统设置]-[通知]-[知心慧学教师端]页面设置是否允许通知。\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      八、我们会如何保护和保存您的个人信息\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      知心慧学教师端重视个人信息的安全。我们采取互联网业内标准做法来保护您的个人信息，防止信息遭到未经授权访问、披露、使用、修改、损坏或丢失。我们会采取一切合理可行的措施，保护您的个人信息。\n      我们会采取一切合理可行的措施，确保未收集与知心慧学教师端提供的服务无关的个人信息。我们会尽全力保护您的个人信息，但请您理解，由于技术的限制以及可能存在的各种恶意手段，在互联网行业，不可能始终保证信息百分之百的安全。您需要了解，您接入我们的服务所用的系统和通讯网络，有可能因我们可控范围外的因素而出现问题。我们仅允许有必要知晓这些信息的知心慧学教师端及知心慧学教师端关联方的员工、合作伙伴访问个人信息，并为此设置了严格的访问权限控制和监控机制。我们同时要求可能接触到您个人信息的所有人员履行相应的保密义务。如果未能履行这些义务，可能会被追究法律责任或被中止与知心慧学教师端的合作关系。我们同时要求可能接触到您个人信息的所有人员履行相应的保密义务。如果未能履行这些义务，可能会被追究法律责任或被中止与知心慧学教师端的合作关系。在发生个人信息安全事件的场合，我们将按照法律法规的要求，及时向您告知：安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施等。我们将及时将事件相关情况以邮件、信函、电话、推送通知等方式告知您，难以逐一告知个人信息主体时，我们会采取合理、有效的方式发布公告。同时，我们还将按照监管部门要求，主动上报个人信息安全事件的处置情况。我们在中华人民共和国境内收集和产生的个人信息将存储在中华人民共和国境内。如果日后为处理跨境业务，需要向境外机构传输境内收集的相关个人信息的，我们会事先征得您的同意，按照法律、行政法规和相关监管部门的规定执行，并通过签订协议、核查等有效措施，要求境外机构为所获得的个人信息保密。我们仅会在达到本政策所述目的所必需的时限内保存您的个人信息，但为了遵守适用的法律法规、法院判决或裁定、其他有权机关的要求、维护公共利益等目的，我们可能会将个人信息保存时间予以适当延长。\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      九、 第三方提供商及其服务\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      为确保流畅的浏览体验，您可能会收到来自知心慧学教师端及其合作伙伴外部的第三方（以下简称「第三方」）提供的内容或网络链接。知心慧学教师端对此类第三方无控制权。您可选择是否访问第三方提供的链接、内容、产品和服务。知心慧学教师端无法控制第三方的隐私和个人信息保护政策，此类第三方不受到本政策的约束。您在向第三方提交个人信息之前，请确保您阅读并认可这些第三方的隐私保护政策。\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      十、本政策如何更新及适用范围\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      为给用户提供更好的服务，知心慧学教师端的业务将不时变化，本隐私政策也将随之调整。知心慧学教师端会通过在知心慧学教师端网站、移动端上发出更新版本并提醒您相关内容的更新，也请您访问知心慧学教师端以便及时了解最新的隐私政策。知心慧学教师端保留不时更新或修改本政策的权利。如果该等修改造成您在本政策下权利的实质减少，知心慧学教师端会通过不同渠道向您发送变更通知，包括但不限于网站公示、短信、邮件通知等方式。\n      若您不同意修改后的隐私政策，您有权并应立即停止使用知心慧学教师端的服务。如果您继续使用知心慧学教师端的服务，则视为您接受知心慧学教师端对本政策相关条款所做的修改。\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      知心慧学教师端的所有服务均适用本政策。但某些服务有其特定的隐私政策，该等特定的隐私政策更具体地说明知心慧学教师端在该服务中如何处理您的信息。如本政策与特定服务的隐私政策有不一致之处，请以该特定隐私政策为准。\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      十一、联系我们\n    ")]), _vm._v(" "), _c('p', [_vm._v("您在使用知心慧学教师端的过程中对本隐私政策或对您个人信息有任何问题、建议、意见及咨询，请通过以下联系方式与我们联系：")]), _vm._v(" "), _vm._m(14), _vm._v(" "), _vm._m(15), _vm._v(" "), _c('p', [_vm._v("如您有相关申诉问题，也可通过上方联系方式与我们联系。若您对我们的回复不满意，特别是您认为我们的个人信息处理行为损害了您的合法权益，在您向我们反馈后我们无法提供让您满意的回复且拒绝改进的，您可以向相关监管机构进行投诉和举报。\n    ")])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "update"
  }, [_c('p', [_vm._v("更新日期：2025年7月31日")]), _vm._v(" "), _c('p', [_vm._v("生效日期：2025年7月31日")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n      如对本隐私政策或相关事宜有任何问题、建议、意见及咨询，您可随时通过发送邮件至 "), _c('span', {
    staticClass: "blue"
  }, [_vm._v("legal@fxbjy.com")]), _vm._v("或拨打我们的客服电话"), _c('span', {
    staticClass: "blue"
  }, [_vm._v("19970080755")]), _vm._v("等多种方式与我们联系，我们将在十五个工作日内受理并处理。\n    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "key-msg"
  }, [_vm._v("当您注册时，您需要至少向我们提供您准备使用的知心慧学教师端账户名、密码、您本人的手机号码、电子邮箱地址（用于验证邮箱），我们将通过发送短信验证码或邮件的方式来验证您的身份是否有效。此时，您需要向我们提供以下信息：账号名称、头像（如有）和手机号码等。")]), _vm._v("提供上述信息并同意注册协议和本政策后，您可以使用知心慧学教师端的部分业务功能，包括：查看学生学情分析、组卷、阅卷、浏览知心慧学教师端平台内的内容等。"), _c('span', {
    staticClass: "key-msg"
  }, [_vm._v("在您注册知心慧学教师端账号时，我们会使用手机号码对您任课的班级进行绑定，便于将您与其他用户区分并准确判断您的学习情况，为您提供考情报告信息。")]), _vm._v("如您拒绝提供手机号码或进行学情信息绑定，您仍可浏览部分知心慧学教师端平台内的内容，但将无法使用查看学生学情分析、组卷、阅卷等核心功能。\n    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n      当您使用知心慧学教师端的某些业务功能时，为满足向您提供该产品和服务之目的，"), _c('span', {
    staticClass: "key-msg"
  }, [_vm._v("除注册信息外，\n        您还需要进一步向我们提供包括但不限于您的个人身份信息及其他为您提供服务所必需的信息，同时，我们的产品集成友盟+SDK， 友盟+SDK需要收集您的设备Mac地址、唯一设备识别码 （IMEI/android\n        ID/IDFA/OPENUDID/GUID、SIM 卡 IMSI 信息），收集这些信息的目的是提供统计分析服务，提供基础反作弊能力。")]), _vm._v("提供以上信息，将有助于我们给您提供更优的服务体验，如果您不提供这些信息，\n      并不会影响您使用知心慧学教师端的基本功能。如果您不使用特定产品和服务，则无需提供相关信息（以下将详细阐明）。\n    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "key-msg"
  }, [_vm._v("知心慧学教师端在提供服务的过程中，可能需要您开通一些设备权限，例如通知、相册、相机等访问权限。您也可以在设备的设置功能中随时选择关闭部分或者全部权限，从而拒绝知心慧学教师端收集相应的个人信息。")]), _vm._v("在不同设备中，权限显示方式及关闭方式可能有所不同，具体请参考设备及系统开发方说明或指引。\n    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    attrs: {
      "href": "https://developers.weixin.qq.com/doc/oplatform/Mobile_App/Share_and_Favorites/Share_and_Favorites.html"
    }
  }, [_vm._v("https://developers.weixin.qq.com/doc/oplatform/Mobile_App/Share_and_Favorites/Share_and_Favorites.html")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    attrs: {
      "href": "https://www.umeng.com/page/policy?spm=a211eg.10560647.0.0.eb2c34dcwKPqBz"
    }
  }, [_vm._v("https://www.umeng.com/page/policy?spm=a211eg.10560647.0.0.eb2c34dcwKPqBz")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    attrs: {
      "href": "https://developer.huawei.com/consumer/cn/doc/development/HMSCore-Guides/sdk-data-security-0000001050042177"
    }
  }, [_vm._v("https://developer.huawei.com/consumer/cn/doc/development/HMSCore-Guides/sdk-data-security-0000001050042177")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    attrs: {
      "href": "https://dev.mi.com/console/doc/detail?pId=1822"
    }
  }, [_vm._v("https://dev.mi.com/console/doc/detail?pId=1822")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    attrs: {
      "href": "https://www.meizu.com/legal.html"
    }
  }, [_vm._v("https://www.meizu.com/legal.html")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    attrs: {
      "href": "https://security.oppo.com/cn/privacy.html"
    }
  }, [_vm._v("https://security.oppo.com/cn/privacy.html")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    attrs: {
      "href": "https://dev.vivo.com.cn/documentCenter/doc/366"
    }
  }, [_vm._v("https://dev.vivo.com.cn/documentCenter/doc/366")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    attrs: {
      "href": "https://privacy.qq.com/document/preview/fc748b3d96224fdb825ea79e132c1a56"
    }
  }, [_vm._v("https://privacy.qq.com/document/preview/fc748b3d96224fdb825ea79e132c1a56")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("链接："), _c('a', {
    attrs: {
      "href": "https://github.com/LuckSiege/PictureSelector"
    }
  }, [_vm._v("https://github.com/LuckSiege/PictureSelector")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("联系电话"), _c('span', {
    staticClass: "blue"
  }, [_vm._v("19970080755")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("邮箱 "), _c('span', {
    staticClass: "blue"
  }, [_vm._v("legal@fxbjy.com")])])
}]}

/***/ }),
/* 546 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "english"
  }, [_c('viewer', {
    attrs: {
      "images": _vm.urls
    }
  }, [_vm._l((_vm.urls), function(a, i) {
    return [(i <= 4) ? _c('img', {
      staticClass: "hj-image-lazy",
      attrs: {
        "src": a
      }
    }) : _vm._e()]
  })], 2)], 1)
},staticRenderFns: []}

/***/ }),
/* 547 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "privacy"
  }, [_c('p', [_vm._v("本政策仅适用于江西风向标智能科技有限公司的知心慧学教师端产品。")]), _vm._v(" "), _c('p', [_vm._v("\n          更新日期：2025年7月31日\n      ")]), _vm._v(" "), _c('p', [_vm._v("\n          生效日期：2025年7月31日\n      ")]), _vm._v(" "), _c('p', [_vm._v("\n           \n      ")]), _vm._v(" "), _c('h2', {
    staticClass: "bold"
  }, [_vm._v("\n        知心慧学教师端app使用许可2.2&知心慧学教师端隐私政策2.2        ")]), _vm._v(" "), _c('p', [_vm._v("\n        以下内容是《知心慧学教师端app使用许可2.2》及《知心慧学教师端隐私政策2.2》，在你登录注册知心慧学教师端前请务必审慎阅读、充分理解协议中相关条款内容。《知心慧学教师端app使用许可2.2》包括app使用许可；信息使用；风险提示；知识产权。《知心慧学教师端隐私政策2.2》包括适用范围；我们收集信息的原因和内容；我们会如何使用您的信息；我们可能如何收集信息；我们会如何共享、转让、公开披露您的个人信息；如何管理您的个人信息；推广服务；我们会如何保护和保存您的个人信息；第三方提供商及其服务；本政策如何更新及适用范围；联系我们。你一旦登录注册知心慧学教师端，即视为你已了解并同意《知心慧学教师端app使用许可2.2》及《知心慧学教师端隐私政策2.2》的各项内容。        ")]), _vm._v(" "), _c('p', [_vm._v("\n          在此特别提醒您，在点击接受本声明之前，您应事先认真阅读、了解清楚并充分理解本声明的全部内容，包括免除或者限制责任的免责条款及对您的权利限制条款。请您审阅并接受或不接受本声明（未成年人应在法定监护人陪同下审阅）。 除非您接受本声明，否则您无权下载、安装或使用本公司基于应用软件提供的相关服务（以下称\"服务\"）。一旦您点击确认本声明，即意味着您已充分理解和接受本声明，并同意接受本声明各项条款的约束。并且，公司在法律许可的范围内享有对本声明的解释、修改以及变更的权利。\n      ")]), _vm._v(" "), _c('h2', {
    staticClass: "bold"
  }, [_vm._v("\n        知心慧学教师端app使用许可2.2\n      ")]), _vm._v(" "), _c('p', [_vm._v("\n          一、APP使用许可\n      ")]), _vm._v(" "), _c('p', [_vm._v("\n          1.您使用的“知心慧学教师端”（以下简称“APP”）是由江西风向标智能科技有限公司（以下简称“公司”）运营的在线教育增值服务平台。\n      ")]), _vm._v(" "), _c('p', [_vm._v("\n          2.“知心慧学教师端用户”是指完成全部注册流程，愿意接受本协议并在知心慧学教师端相关使用规范的规定下使用知心慧学教师端APP服务的注册用户。\n      ")]), _vm._v(" "), _c('p', [_vm._v("\n        3.注册成为本APP之用户或使用本APP，即表示您保证您已具备单独签订本协议并遵守本协议所有条款之民事权利能力及民事行为能力。        ")]), _vm._v(" "), _c('p', [_vm._v("\n        4.您郑重承诺，将以本人真实的身份，秉承诚实信用合法的原则使用本APP，在登录和使用本APP的全过程中都负有作为理性人的谨慎和注意义务。        ")]), _vm._v(" "), _c('p', [_vm._v("\n          5.本公司保留对APP使用规定的解释、修改以及变更的权利，届时将通过APP通告等方式向用户传达，如果不同意对本协议相关条款所做的修改，用户有权停止使用网络服务。如果用户继续使用网络服务，则视为用户接受本协议相关条款所做的修改。如您未在通知规定的时间内表示反对，将会被视为默认。\n      ")]), _vm._v(" "), _c('p', [_vm._v("\n          二、信息使用\n      ")]), _vm._v(" "), _c('p', {
    staticClass: "key-msg"
  }, [_vm._v("\n          1.在注册、登陆和使用知心慧学教师端APP时，您同意及不可撤销地授权将您的姓名和账户等信息提供给我们，包括但不限于您的真实姓名、联系方式、身份证号码、住址、账号信息等。\n      ")]), _vm._v(" "), _c('p', [_vm._v("\n          2.您在使用知心慧学教师端时，承诺和保证如下内容：\n      ")]), _vm._v(" "), _c('p', [_vm._v("\n          (a)您所提供的资料为完整，最新及正确无误；\n      ")]), _vm._v(" "), _c('p', [_vm._v("\n          (b)本协议一经签署，即具法律效力并同意受其约束。\n      ")]), _vm._v(" "), _c('p', [_vm._v("\n          3.您的注册信息包括注册号和密码仅供本人使用，您有义务提高自我保护和防范风险意识，如提高密码级别、不随意向其他人透露您的用户名、口令等信息。如若由于您个人对账号信息保管不慎或告知他人而导致任何个人信息泄露、账户损失等，知心慧学教师端将不予承担任何责任。\n      ")]), _vm._v(" "), _c('p', {
    staticClass: "key-msg"
  }, [_vm._v("\n          4.我们将对您所提供的资料进行严格的管理及保护，致力于保护用户个人数据及个人隐私安全，原则上不提供给任何个人或者第三方使用，拒绝任何组织和个人以营利为目的意图获取或者使用用户个人信息。特殊情况如司法机关、监管机构或其他政府部门依照法定程序要求提供用户个人信息等为例外。本APP在必要时将会由专业技术人员代为对您相关信息资料进行处理，以符合专业分工的要求。\n      ")]), _vm._v(" "), _c('p', [_vm._v("\n          如发生下列任何一种情形，本APP有权随时使用用户提交信息资料、中断或终止向用户提供本协议项下的网络服务而无需通知用户：\n      ")]), _vm._v(" "), _c('p', [_vm._v("\n          (a)用户提供的个人资料不真实；\n      ")]), _vm._v(" "), _c('p', [_vm._v("\n          (b)用户违反本协议中规定的使用规则；\n      ")]), _vm._v(" "), _c('p', [_vm._v("\n          (c)为免除您在生命、身体或财产方面之急迫危险的；\n      ")]), _vm._v(" "), _c('p', [_vm._v("\n          (d)为防止他人权益之重大危害的；\n      ")]), _vm._v(" "), _c('p', [_vm._v("\n          (e)为增进公共利益，且无害于您的重大利益的。除前款所述情形外，本APP同时保留在不事先通知用户的情况下随时中断或终止部分或全部网络服务的权利，对于所有服务的中断或终止而造成的任何损失，本APP无需对用户或任何第三方承担任何责任。\n      ")]), _vm._v(" "), _c('p', [_vm._v("\n          三、风险提示\n      ")]), _vm._v(" "), _c('p', [_vm._v("\n          1.对在任何情况下因使用或不能使用本APP所产生的直接、间接、偶然、特殊及后续的损害及风险，我们不承担任何责任。损失包括但不限于决策对于由此给您造成的任何不便或损害，包括但不限于：决策失误、操作不当、遗忘或泄露账户密码、密码被他人破解、您使用的终端设备被第三方侵入而造成的损失。\n      ")]), _vm._v(" "), _c('p', [_vm._v("\n        2.您于订立协议时已表示理解并同意免除我们与此相应的法律责任。如在本APP运营过程中出现我们误将您的账户终止，或变更您的有关信息，或部分停止您的各类权限，则我们将在您提出书面通知后合理期间内处理该等事宜，若因此给您带来不便甚至造成损失，您同意免除我们的相应法律责任。        ")]), _vm._v(" "), _c('p', [_vm._v("\n          3.您了解并同意，我们不对因下述任一情况而导致的任何损害赔偿承担责任： (a)使用或未能使用本APP服务； (b)对本APP服务的错误理解； (c)第三方未使用真实身份，或者未经批准的使用他人的账号或更改他人的数据； (d)任何非因本APP的原因而引起的与服务有关的损失。\n      ")]), _vm._v(" "), _c('p', [_vm._v("\n          4.对于任何本APP无法控制的原因（包括但不限于政府管制、通讯设施故障及其他不可抗力因素）导致的APP暂时关闭、用户信息泄露、被盗用、被篡改等非正常经营行为，本APP不承担任何责任。\n      ")]), _vm._v(" "), _c('p', [_vm._v("\n          5.您承认对于您利用本APP或信息而从事的各类行为，包括线上和线下，均为您个人行为且您个人对该类行为承担完全责任。您同意保障和维护APP及其他用户的利益，如因违反有关法律、法规或本协议项下的任何条款而给本APP或任何其他第三人造成损失，您同意承担由此造成的损害赔偿责任。\n      ")]), _vm._v(" "), _c('p', [_vm._v("\n        6.由于您将用户密码告知他人或与他人共享注册账户，由此导致的任何个人信息的泄露，任何由于黑客攻击、计算机病毒侵入或发作、因政府管制而造成的暂时性关闭等影响网络正常经营之不可抗力而造成的个人信息泄露、丢失、被盗用或被篡改等，由于本APP不拥有或不控制的公司以及我们不雇佣或不管理的人员所造成的个人信息的泄露，本APP不承担任何责任并应免于被追诉。        ")]), _vm._v(" "), _c('p', [_vm._v("\n          7.用户同意保障和维护知心慧学教师端APP及其他用户的利益，如因用户违反有关法律、 法规或本协议项下的任何条款而给本APP或任何其他第三人造成损失，用户同意承担由此造成的损害赔偿责任。在注册成为本APP用户或者使用本APP过程中，您与任何第三方之间发生任何纠纷，由纠纷各方自行解决，本APP并不承担任何责任。本APP不对您使用本APP的任何行为、效果或影响提供任何担保或条件，无论是明示、默示或法定的。\n      ")]), _vm._v(" "), _c('p', [_vm._v("\n          四、知识产权\n      ")]), _vm._v(" "), _c('p', [_vm._v("\n          1.无论您成为本APP之会员或使用本APP，均认可我们对本APP及本APP所收集、制作、发布之各类信息拥有完全知识产权或所有权，包括但不限于各类文档、图像、数据库等，除非法律明确规定该等权利属于会员个人以外，相关权限应涵盖包括复制、修改、改写、改编、发行、翻译、创造衍生性著作、出版、将前述内容(部分或全部)加以散布、展示等。您同意我们对所有会员提交的信息进行有关编排处理后形成的数据库拥有完全的知识产权。\n      ")]), _vm._v(" "), _c('p', [_vm._v("\n          2.如您将信息公布到本APP的任何公共区域，则表示您同意，同时您自动授予，并且您陈述并保证您有权授予本APP不可撤销的、永久的、非独占的、完全免费的、世界范围的许可。在该等许可下，您同意本APP使用、复制、执行、显示并传播该内容，您也同意我们基于该内容创作衍生作品或将该内容整合到其他作品中且我们对该等衍生作品或整合作品拥有完全的所有者权益。除已获得我们书面许可的情况外，您不得复制、修改、公布、传播、执行、转载、许可使用、创建衍生作品、转移显示、出售、转售、以非法手段获取或以任何其他方式处置本APP收集、制作、发布的各类信息。\n      ")]), _vm._v(" "), _c('p', [_vm._v("\n          3.请勿擅自复制或采用本APP所创造的用以制成网页的HTML。本APP对其HTML享有著作权。同时，本APP对其网址上的所有图标、图饰、图表、色彩、文字表述及其组合、版面设计、数据库均享有完全的著作权，对发布的信息均享有专有的发布和使用权，未经本APP同意，不得擅自复制、使用或转载。\n      ")]), _vm._v(" "), _c('p', [_vm._v("\n           \n      ")]), _vm._v(" "), _c('p', {
    staticClass: "bold tac"
  }, [_vm._v("\n        知心慧学教师端隐私政策2.2\n      ")]), _vm._v(" "), _c('p', [_vm._v("\n           \n      ")]), _vm._v(" "), _c('p', [_vm._v("\n          本政策仅适用于江西风向标智能科技有限公司的知心慧学教师端产品。\n      ")]), _vm._v(" "), _c('p', [_vm._v("\n          最新更新日期：2025年7月31日。\n      ")]), _vm._v(" "), _c('p', [_vm._v("\n          如对本隐私政策或相关事宜有任何问题、建议、意见及咨询，您可随时通过发送邮件至 "), _c('span', {
    staticClass: "blue"
  }, [_vm._v("legal@fxbjy.com")]), _vm._v("或拨打我们的客服电话"), _c('span', {
    staticClass: "blue"
  }, [_vm._v("19970080755")]), _vm._v("等多种方式与我们联系，我们将在十五个工作日内受理并处理。\n      ")]), _vm._v(" "), _c('p', [_vm._v("\n           \n      ")]), _vm._v(" "), _c('p', {
    staticClass: "bold"
  }, [_vm._v("\n          本政策将帮助您了解以下内容：\n      ")]), _vm._v(" "), _c('p', [_vm._v("\n          ·知心慧学教师端的个人信息收集使用规则\n      ")]), _vm._v(" "), _c('p', [_vm._v("\n          ·我们如何保护您的个人信息\n      ")]), _vm._v(" "), _c('p', [_vm._v("\n          ·您的权利\n      ")]), _vm._v(" "), _c('p', [_vm._v("\n          ·我们会如何共享、转让、公开披露您的个人信息\n      ")]), _vm._v(" "), _c('p', [_vm._v("\n          ·本政策如何更新\n      ")]), _vm._v(" "), _c('p', [_vm._v("\n          ·如何联系我们\n      ")]), _vm._v(" "), _c('p', [_vm._v("\n        【特别提示】请仔细阅读《知心慧学教师端隐私政策2.2》（尤其是加粗划线的内容）并确定了解我们（江西风向标智能科技有限公司）对您个人信息的处理规则。阅读过程中，如您有任何疑问，可联系我们的客服咨询，如果您不同意相关协议或其中任何条款约定，知心慧学教师端将暂时无法为您提供定制服务。本隐私政策与您所使用的知心慧学教师端服务以及该服务所包括的各种业务功能（以下统称“我们的产品与/或服务”）息息相关，希望您在使用我们的产品与/或服务前仔细阅读并确认您已经充分理解本政策所写明的内容，并让您可以按照本隐私政策的指引做出您认为适当的选择。本隐私政策中涉及的相关术语，我们尽量以简明扼要的表述，并提供进一步说明的链接，以便您更好地理解。您使用或在我们更新本隐私政策后（我们会及时提示您更新的情况）继续使用我们的产品与/或服务，即意味着您同意本隐私政策(含更新版本)内容，并且同意我们按照本隐私政策收集、使用、保存和共享您的相关信息。如对本隐私政策或相关事宜有任何问题，您可随时通过发送邮件至info@fxbjy.com 或拨打我们的任何一部客服电话等多种方式与我们联系 。        ")]), _vm._v(" "), _c('p', [_vm._v("\n          一、 适用范围\n      ")]), _vm._v(" "), _c('p', [_vm._v("\n        本隐私政策适用于知心慧学教师端。教师端提供的所有服务，您访问知心慧学教师端网站、客户端，均适用本隐私政策。        ")]), _vm._v(" "), _c('p', [_vm._v("\n          二、我们收集信息的原因和内容\n      ")]), _vm._v(" "), _c('p', [_vm._v("\n          为了保障您能够流畅地使用我们的核心功能并向您提供更好、更优的服务，同时为了保障您的信息安全，我们将根据您使用的服务收集您的以下信息。\n      ")]), _vm._v(" "), _c('p', [_vm._v("\n          1、您直接提供给我们的信息\n      ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "key-msg"
  }, [_vm._v("当您注册时，您需要至少向我们提供您准备使用的知心慧学教师端账户名、密码、您本人的手机号码、电子邮箱地址（用于验证邮箱），我们将通过发送短信验证码或邮件的方式来验证您的身份是否有效。此时，您需要向我们提供以下信息：账号名称、头像（如有）和手机号码等。")]), _vm._v("提供上述信息并同意注册协议和本政策后，您可以使用知心慧学教师端的部分业务功能，包括：查看学生学情分析、组卷、阅卷、浏览知心慧学教师端平台内的内容等。"), _c('span', {
    staticClass: "key-msg"
  }, [_vm._v("在您注册知心慧学教师端账号时，我们会使用手机号码对您任课的班级进行绑定，便于将您与其他用户区分并准确判断您的学习情况，为您提供考情报告信息。")]), _vm._v("如您拒绝提供手机号码或进行学情信息绑定，您仍可浏览部分知心慧学教师端平台内的内容，但将无法使用查看学生学情分析、组卷、阅卷等核心功能。        ")]), _vm._v(" "), _c('p', [_vm._v("\n          2、在您使用过程中产生的信息\n      ")]), _vm._v(" "), _c('p', [_vm._v("\n        当您使用知心慧学教师端的某些业务功能时，为满足向您提供该产品和服务之目的，"), _c('span', {
    staticClass: "key-msg"
  }, [_vm._v("除注册信息外， 您还需要进一步向我们提供包括但不限于您的个人身份信息及其他为您提供服务所必需的信息，同时，我们的产品集成友盟+SDK(友盟同欣(北京)科技有限公司),友盟+SDK 需要收集您的设备信息(设备型号、操作系统版本、设备 Mac 地址、Android ID、GAID/OAID 广告标识符、IMEI、IMSI、设备序列号)、应用安装列表、网络状态等信息,用于提供统计分析服务、消息推送服务、基础反作弊能力。上述信息由 SDK 在您使用 App 过程中自动采集,仅用于实现前述统计分析、推送及反作弊目的,不会用于其他用途,也不会与第三方共享(法律法规另有规定的除外)。提供以上信息将有助于我们给您提供更优的服务体验;如果您不提供这些信息,并不会影响您使用知心慧学教师端的基本功能。友盟+SDK 的详细隐私政策请见:[友盟隐私政策链接：https://developer.umeng.com/docs/147377/detail/3038360]。")]), _vm._v("提供以上信息，将有助于我们给您提供更优的服务体验，如果您不提供这些信息， 并不会影响您使用知心慧学教师端的基本功能。如果您不使用特定产品和服务，则无需提供相关信息（以下将详细阐明）。\n      ")]), _c('p', [_vm._v("\n          我们可能对您的使用信息、浏览信息进行记录，用来为您展示历史使用、浏览记录。\n      ")]), _vm._v(" "), _c('p', [_vm._v("\n          我们还可能为了提供服务及改进服务质量的合理需要而获得您的其他信息，包括您与客服联系时您提供的相关信息， 您参与问卷调查时向我们发送的问卷答复信息，以及您与我们的关联方、我们合作伙伴之间互动时我们获得的相关信息。 对于您的账号个人设置信息，我们可能会将它们进行关联，以便我们能在您登录其他设备时为您提供一致的服务。 我们可能会将来自某项服务的信息与来自其他服务的信息结合起来，以便为您提供服务、定制内容和建议。\n      ")]), _vm._v(" "), _c('p', [_vm._v("\n          3、征得授权同意的例外\n      ")]), _vm._v(" "), _c('p', [_vm._v("\n          根据相关法律法规的规定，以下情形中收集您的个人信息无需征得您的授权同意：\n      ")]), _vm._v(" "), _c('p', [_vm._v("\n          （1）涉及国家安全与利益、社会公共利益；\n      ")]), _vm._v(" "), _c('p', [_vm._v("\n          （2）与犯罪侦查有关的相关活动；\n      ")]), _vm._v(" "), _c('p', [_vm._v("\n          （3）出于维护您或他人的生命财产安全但在特殊情况下无法获得您的及时授权；\n      ")]), _vm._v(" "), _c('p', [_vm._v("\n          （4）从其他合法公开的渠道中收集您的个人信息；\n      ")]), _vm._v(" "), _c('p', [_vm._v("\n          （5）法律法规规定的其他情形。\n      ")]), _vm._v(" "), _c('p', [_vm._v("\n          三、我们会如何使用您的信息\n      ")]), _vm._v(" "), _c('p', [_vm._v("\n          收集您的信息是为了向您提供服务及提升服务质量，我们会根据本隐私政策的约定进行使用，在收集您的信息后，我们将通过技术手段对数据进行去标识化处理，去标识化处理的信息将无法识别主体。请您了解并同意，在此情况下我们有权使用已经去标识化的信息；并在不透露您个人信息的前提下，我们有权对用户数据库进行分析并予以合法使用。\n      ")]), _vm._v(" "), _c('p', {
    staticClass: "key-msg"
  }, [_vm._v("\n          您的信息主要有以下用途：\n      ")]), _vm._v(" "), _c('p', {
    staticClass: "key-msg"
  }, [_vm._v("\n          （1）为您提供您使用的各项定制服务，并维护、改进这些服务。\n      ")]), _vm._v(" "), _c('p', {
    staticClass: "key-msg"
  }, [_vm._v("\n          （2）帮助我们设计新服务，提升现有服务体验。\n      ")]), _vm._v(" "), _c('p', {
    staticClass: "key-msg"
  }, [_vm._v("\n          （3）在我们提供服务时，用于身份验证、客户服务、安全防范、诈骗监测、存档和备份用途，确保我们向您提供的产品和服务的安全性。\n      ")]), _vm._v(" "), _c('p', {
    staticClass: "key-msg"
  }, [_vm._v("\n          （4）邀请您参与知心慧学教师端活动和市场调查。\n      ")]), _vm._v(" "), _c('p', {
    staticClass: "key-msg"
  }, [_vm._v("\n          （5）开展内部审计、数据分析和研究，以更好地改善我们的产品、服务及与用户之间的沟通。\n      ")]), _vm._v(" "), _c('p', [_vm._v("\n          四、我们可能如何收集信息\n      ")]), _vm._v(" "), _c('p', [_vm._v("\n          1、您使用我们的服务时，我们会在您的计算机或移动设备上存储名为 Cookie 的小数据文件。Cookie 通常包含标识符、站点名称以及一些号码和字符。我们使用该等信息判断注册用户是否已经登录，提升服务/产品质量及优化用户体验。如您不希望个人信息保存在 Cookie 中，您可对浏览器进行配置，选择禁用 Cookie 功能。禁用 Cookie 功能后，可能影响您访问知心慧学教师端或不能充分取得知心慧学教师端提供的服务。\n      ")]), _vm._v(" "), _c('p', [_vm._v("\n          知心慧学教师端不会将 Cookie 用于本政策所述目的之外的任何用途。您可根据自己的偏好管理或删除Cookie。您可以清除计算机上保存的所有 Cookie，大部分网络浏览器都设有阻止 Cookie 的功能。\n      ")]), _vm._v(" "), _c('p', [_vm._v("\n          2、设备权限调用\n      ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "key-msg"
  }, [_vm._v("知心慧学教师端在提供服务的过程中，可能需要您开通一些设备权限，例如通知、相册、相机等访问权限。您也可以在设备的设置功能中随时选择关闭部分或者全部权限，从而拒绝知心慧学教师端收集相应的个人信息。")]), _vm._v("在不同设备中，权限显示方式及关闭方式可能有所不同，具体请参考设备及系统开发方说明或指引。\n      ")]), _vm._v(" "), _c('p', [_vm._v("\n          根据您的服务使用情况，我们可能会调用的权限如下：\n      ")]), _vm._v(" "), _c('p', [_vm._v("\n          （1）储存权限。当您下载及升级应用、试卷保存、阅卷信息保存、联系在线客服反馈问题时，我们会调用您的储存权限，保障您能顺利实现此功能。\n      ")]), _vm._v(" "), _c('p', [_vm._v("\n          （2）摄像头权限。当您提交意见反馈、修改头像时，我们将调用您的摄像头权限，保障您的使用。\n      ")]), _vm._v(" "), _c('p', [_vm._v("\n          （3）语音权限：当您使用知心慧学教师端直播课功能，或类似直播服务用于线上上课和发言时，我们将调用您设备的语音权限，以保证您能顺利实现此功能。\n      ")]), _vm._v(" "), _c('p', [_vm._v("\n          （4）短信权限：当您注册账号时，我们将调用短信权限，保障您能顺利完成注册。\n      ")]), _vm._v(" "), _c('p', [_vm._v("\n          五、我们会如何共享、转让、公开披露您的个人信息\n      ")]), _vm._v(" "), _c('p', [_vm._v("\n          1、共享\n      ")]), _vm._v(" "), _c('p', [_vm._v("\n          知心慧学教师端不会在未经您同意或授权的情况下将您的个人信息提供给第三方。但是，经您确认同意，知心慧学教师端可在以下情况下共享您的个人信息：\n      ")]), _vm._v(" "), _c('p', [_vm._v("\n          在获取同意的情况下共享：获得您的明确同意后，知心慧学教师端会与其他方共享您的个人信息。\n      ")]), _vm._v(" "), _c('p', [_vm._v("\n          共享给知心慧学教师端的关联公司：在本政策声明的使用目的范围内，您的个人信息可能会与知心慧学教师端的关联公司共享。作为一项政策，我们只会共享必要的信息。关联公司如要改变个人信息的处理目的，将再次征求您的授权同意。\n      ")]), _vm._v(" "), _c('p', [_vm._v("\n          共享给授权合作伙伴：知心慧学教师端可能会与合作伙伴共享您的某些个人信息，以便给您提供服务、内容和建议。例如，知心慧学教师端向您寄送礼品（如有）时，知心慧学教师端必须与物流服务提供商共享您的个人信息才能安排寄送，或者安排合作伙伴向您提供服务。我们仅会出于特定、明确而合法的目的处理您的个人信息，并且只会共享提供服务所必要的信息。同时，我们会与其签署严格的保密协定，要求他们按照我们的说明、本政策以及其他任何相关的保密和安全措施来处理个人信息。在法定情形下的共享：我们可能会根据法律法规规定、诉讼争议解决需要，或按行政、司法机关依法提出的要求，对外共享您的个人信息。\n      ")]), _vm._v(" "), _c('p', {
    staticClass: "key-msg"
  }, [_vm._v("事先获得您明确同意的情况下，我们会在法律法规允许且不违背公序良俗的范围内，依据您的授权范围与第三方共享您的信息。")]), _vm._v(" "), _c('p', [_vm._v("为知心慧学教师端App相关功能的实现与应用安全稳定的运行，我们可能会接入由第三方提供的软件开发包（SDK）实现相关目的。 我们会对合作方获取信息的软件工具开发包（SDK）进行严格的安全监测，以保护数据安全。")]), _vm._v(" "), _c('p', [_vm._v("请注意，第三方SDK可能因为其版本升级、策略调整原因导致数据处理类型存在一定变化，请以其公示的官方说明为准。")]), _vm._v(" "), _c('p', [_vm._v("1.1 第三方SDK目录")]), _vm._v(" "), _c('p', [_vm._v("第三方SDK名称：微信 SDK")]), _vm._v(" "), _c('p', [_vm._v("所属公司名称：深圳市腾讯计算机系统有限公司")]), _vm._v(" "), _c('p', [_vm._v("收集个人信息类型：设备品牌、设备型号、设备版本、系统版本、生成ID、手机样式、手机名、iccid、bssid、MAC地址、IMSI、IMEI、IP地址、网络状态")]), _vm._v(" "), _c('p', [_vm._v("使用目的：授权登录、内容分享")]), _vm._v(" "), _c('p', [_vm._v("收集方式：sdk本机采集")]), _vm._v(" "), _c('p', [_vm._v("使用场景：微信授权登录、分享内容至微信")]), _vm._v(" "), _c('p', [_vm._v("第三方SDK隐私政策或开发指南：")]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "https://developers.weixin.qq.com/doc/oplatform/Mobile_App/Share_and_Favorites/Share_and_Favorites.html"
    }
  }, [_vm._v("https://developers.weixin.qq.com/doc/oplatform/Mobile_App/Share_and_Favorites/Share_and_Favorites.html")])]), _vm._v(" "), _c('p', [_vm._v("第三方公司名称：友盟同欣（北京）科技有限公司")]), _vm._v(" "), _c('p', [_vm._v("产品/类型：友盟sdk")]), _vm._v(" "), _c('p', [_vm._v("收集个人信息类型：IMEI/OAID/MAC/Android ID /IDFA/OpenUDID/GUID/IP地址/SIM卡IMSI信息等）")]), _vm._v(" "), _c('p', [_vm._v("使用目的：云平台、企业协作、辅助运营")]), _vm._v(" "), _c('p', [_vm._v("收集方式：sdk本机采集")]), _vm._v(" "), _c('p', [_vm._v("功能：为成功调起您用户设备中应用，高效实现第三方登录和社会化分享功能，我们会收集系统在装的应用列表信息，提升您用户的使用体验")]), _vm._v(" "), _c('p', [_vm._v("第三方隐私权政策链接：")]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "https://www.umeng.com/page/policy?spm=a211eg.10560647.0.0.eb2c34dcwKPqBz"
    }
  }, [_vm._v("https://www.umeng.com/page/policy?spm=a211eg.10560647.0.0.eb2c34dcwKPqBz")])]), _vm._v(" "), _c('p', [_vm._v("第三方公司名称：华为终端有限公司")]), _vm._v(" "), _c('p', [_vm._v("产品/类型：华为推送sdk")]), _vm._v(" "), _c('p', [_vm._v("收集个人信息类型：应用基本信息、设备标识信息（IMEI、Android ID、AAID和Push Token）、设备的硬件信息、系统基本信息和系统设置信息、应用安装列表信息、申请获取存储权限、电话权限")]), _vm._v(" "), _c('p', [_vm._v("使用目的：用于向华为手机用户推送消息")]), _vm._v(" "), _c('p', [_vm._v("收集方式：sdk本机采集")]), _vm._v(" "), _c('p', [_vm._v("使用场景：向用户推送消息时")]), _vm._v(" "), _c('p', [_vm._v("第三方隐私权政策链接：")]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "https://developer.huawei.com/consumer/cn/doc/development/HMSCore-Guides/sdk-data-security-0000001050042177"
    }
  }, [_vm._v("https://developer.huawei.com/consumer/cn/doc/development/HMSCore-Guides/sdk-data-security-0000001050042177")])]), _vm._v(" "), _c('p', [_vm._v("第三方公司名称：小米公司")]), _vm._v(" "), _c('p', [_vm._v("产品/类型：小米推送sdk")]), _vm._v(" "), _c('p', [_vm._v("收集个人信息类型：设备标识信息(SSID、OAID、加密的Android ID)、推送消息内容、设备信息(设备厂商、型号、归属地、运营商名称等)、通知栏设置、运营商信息、申请获取存储权限、位置权限")]), _vm._v(" "), _c('p', [_vm._v("使用目的：用于向小米用户推送消息")]), _vm._v(" "), _c('p', [_vm._v("收集方式：sdk本机采集")]), _vm._v(" "), _c('p', [_vm._v("使用场景：向用户推送消息时")]), _vm._v(" "), _c('p', [_vm._v("第三方隐私权政策链接：")]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "https://dev.mi.com/console/doc/detail?pId=1822"
    }
  }, [_vm._v("https://dev.mi.com/console/doc/detail?pId=1822")])]), _vm._v(" "), _c('p', [_vm._v("第三方公司名称：珠海市魅族通讯设备有限公司")]), _vm._v(" "), _c('p', [_vm._v("产品/类型：魅族消息推送服务sdk")]), _vm._v(" "), _c('p', [_vm._v("收集个人信息类型：设备标识信息（IMEI）、运营商信息、申请获取存储权限")]), _vm._v(" "), _c('p', [_vm._v("使用目的：用于向魅族手机用户推送消息")]), _vm._v(" "), _c('p', [_vm._v("收集方式：sdk本机采集")]), _vm._v(" "), _c('p', [_vm._v("使用场景：向用户推送消息时")]), _vm._v(" "), _c('p', [_vm._v("第三方隐私权政策链接：")]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "https://www.meizu.com/legal.html"
    }
  }, [_vm._v("https://www.meizu.com/legal.html")])]), _vm._v(" "), _c('p', [_vm._v("第三方公司名称：OPPO广东移动通信有限公司")]), _vm._v(" "), _c('p', [_vm._v("产品/类型：OPPO推送sdk")]), _vm._v(" "), _c('p', [_vm._v("收集个人信息类型：匿名用户ID（OAID）")]), _vm._v(" "), _c('p', [_vm._v("使用目的：用于向OPPO用户推送消息")]), _vm._v(" "), _c('p', [_vm._v("收集方式：sdk本机采集")]), _vm._v(" "), _c('p', [_vm._v("使用场景：向用户推送消息时")]), _vm._v(" "), _c('p', [_vm._v("第三方隐私权政策链接：")]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "https://security.oppo.com/cn/privacy.html"
    }
  }, [_vm._v("https://security.oppo.com/cn/privacy.html")])]), _vm._v(" "), _c('p', [_vm._v("第三方公司名称：维沃移动通信有限公司")]), _vm._v(" "), _c('p', [_vm._v("产品/类型：VIVO推送sdk")]), _vm._v(" "), _c('p', [_vm._v("收集个人信息类型：匿名用户ID（OAID）")]), _vm._v(" "), _c('p', [_vm._v("使用目的：用于向VIVO用户推送消息")]), _vm._v(" "), _c('p', [_vm._v("收集方式：sdk本机采集")]), _vm._v(" "), _c('p', [_vm._v("使用场景：向用户推送消息时")]), _vm._v(" "), _c('p', [_vm._v("功能：用于消息推送")]), _vm._v(" "), _c('p', [_vm._v("收集个人信息字段：匿名用户ID（OAID）")]), _vm._v(" "), _c('p', [_vm._v("第三方隐私权政策链接：")]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "https://dev.vivo.com.cn/documentCenter/doc/366"
    }
  }, [_vm._v("https://dev.vivo.com.cn/documentCenter/doc/366")])]), _vm._v(" "), _c('p', [_vm._v("第三方公司名称：深圳市腾讯计算机系统有限公司")]), _vm._v(" "), _c('p', [_vm._v("产品/类型：腾讯bugly")]), _vm._v(" "), _c('p', [_vm._v("收集个人信息类型：设备信息（IMEI/MAC/Android ID/IDFA/OpenUDID/GUID/IP地址/SIM卡IMSI信息/手机参数信息等）")]), _vm._v(" "), _c('p', [_vm._v("使用目的：云平台、企业协作、辅助运营")]), _vm._v(" "), _c('p', [_vm._v("收集方式：sdk本机采集")]), _vm._v(" "), _c('p', [_vm._v("功能：云平台、企业协作、辅助运营")]), _vm._v(" "), _c('p', [_vm._v("第三方隐私权政策链接：")]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "https://privacy.qq.com/document/preview/fc748b3d96224fdb825ea79e132c1a56"
    }
  }, [_vm._v("https://privacy.qq.com/document/preview/fc748b3d96224fdb825ea79e132c1a56")])]), _vm._v(" "), _c('p', [_vm._v("第三方SDK名称：PictureSelector")]), _vm._v(" "), _c('p', [_vm._v("产品/类型：开源代码库")]), _vm._v(" "), _c('p', [_vm._v("使用目的：加载本地相册图片，拍照选择，收集外部存储文件和文件夹。")]), _vm._v(" "), _c('p', [_vm._v("功能：选择头像，选择文件上传")]), _vm._v(" "), _c('p', [_vm._v("链接："), _c('a', {
    attrs: {
      "href": "https://github.com/LuckSiege/PictureSelector"
    }
  }, [_vm._v("https://github.com/LuckSiege/PictureSelector")])]), _vm._v(" "), _c('p', [_vm._v("第三方SDK名称：Network SDK")]), _vm._v(" "), _c('p', [_vm._v("收集个人信息类型：设备品牌、设备型号、设备版本、系统版本、手机样式、\t手机名、MAC地址、IMSI、IMEI、IP地址、网络状态")]), _vm._v(" "), _c('p', [_vm._v("使用目的：网络数据请求，数据手机")]), _vm._v(" "), _c('p', [_vm._v("收集方式：sdk本机采集")]), _vm._v(" "), _c('p', [_vm._v("使用场景：登录，设备信息收集")]), _vm._v(" "), _c('p', [_vm._v("第三方SDK名称：com.umeng.analytics【友盟+移动统计】")]), _vm._v(" "), _c('p', [_vm._v("收集个人信息类型：设备品牌、设备型号、设备版本、系统版本、手机样式、\t手机名、MAC地址、IMSI、IMEI、IP地址、网络状态")]), _vm._v(" "), _c('p', [_vm._v("使用目的：采集用户设备信息分析")]), _vm._v(" "), _c('p', [_vm._v("使用场景：设备信息收集")]), _vm._v(" "), _c('p', [_vm._v("第三方SDK名称：com.umeng.message【友盟+消息推送】")]), _vm._v(" "), _c('p', [_vm._v("收集个人信息类型：设备品牌、设备型号、设备版本、系统版本、手机样式、\t手机名、MAC地址、IMSI、IMEI、IP地址、网络状态")]), _vm._v(" "), _c('p', [_vm._v("使用目的：推送消息给用户")]), _vm._v(" "), _c('p', [_vm._v("使用场景：考试报告信息推送给老师提醒老师查看")]), _vm._v(" "), _c('p', [_vm._v("第三方SDK名称：com.uc.crashsdk【Crash】")]), _vm._v(" "), _c('p', [_vm._v("收集个人信息类型：设备品牌、设备型号、设备版本、系统版本、手机样式、\t手机名、MAC地址、IMSI、IMEI、IP地址、网络状态")]), _vm._v(" "), _c('p', [_vm._v("使用目的：提高稳定性，收集错误日志")]), _vm._v(" "), _c('p', [_vm._v("使用场景：用户APP报错时手机错误日志以供我们定位问题修复")]), _vm._v(" "), _c('p', [_vm._v("第三方SDK名称：com.umeng.umcrash【友盟+应用性能监控】")]), _vm._v(" "), _c('p', [_vm._v("收集个人信息类型：设备品牌、设备型号、设备版本、系统版本、手机样式、\t手机名、MAC地址、IMSI、IMEI、IP地址、网络状态")]), _vm._v(" "), _c('p', [_vm._v("使用目的：提高稳定性，收集错误日志")]), _vm._v(" "), _c('p', [_vm._v("使用场景：用户APP报错时手机错误日志以供我们定位问题修复")]), _vm._v(" "), _c('p', [_vm._v("自启动和关联启动说明")]), _vm._v(" "), _c('p', [_vm._v("1、为确保本应用处于关闭或后台运行状态下可正常接收到客户端推送的信息，本应用须使用(自启动)能力，将存在一定频率通过 系统发送广播唤醒本应用自启动或关联启动行为，是因实现功能及服务所必要的。")]), _vm._v(" "), _c('p', [_vm._v("2、当您打开内容类推送消息，在征得您的明确同意后，会跳转打开相关内容。在未征得您同意的情况下，则不会有自启动或关联启动。")]), _vm._v(" "), _c('p', [_vm._v("3、当您打开本App内部下载的文件后，会关联启动第三方App。")]), _vm._v(" "), _c('p', [_vm._v("\n          2、转让\n      ")]), _vm._v(" "), _c('p', [_vm._v("\n          我们不会将您的个人信息转让给任何公司、组织和个人，但以下情况除外：\n      ")]), _vm._v(" "), _c('p', [_vm._v("\n          事先获得您明确的同意或授权；\n      ")]), _vm._v(" "), _c('p', [_vm._v("\n          根据适用的法律法规、法律程序的要求、强制性的行政或司法要求所必须的情况进行提供；\n      ")]), _vm._v(" "), _c('p', [_vm._v("\n        符合与您签署的相关协议（包括在线签署的电子协议以及相应的平台规则）或其他的法律文件约定所提供；在涉及合并、收购、资产转让或类似的交易时，如涉及个人信息转让，我们会要求新的持有您个人信息的公司、组织继续受本隐私政策的约束，否则,我们将要求该公司、组织重新向您征求授权同意        ")]), _vm._v(" "), _c('p', [_vm._v("\n          3、公开披露\n      ")]), _vm._v(" "), _c('p', [_vm._v("\n          我们仅会在以下情况下，且采取符合法律和业界标准的安全防护措施的前提下，才会公开披露您的个人信息：\n      ")]), _vm._v(" "), _c('p', [_vm._v("\n          根据您的需求，在您明确同意的披露方式下披露您所指定的个人信息；\n      ")]), _vm._v(" "), _c('p', [_vm._v("\n          根据法律、法规的要求、强制性的行政执法或司法要求所必须提供您个人信息的情况下，我们可能会依据所要求的个人信息类型和披露方式公开披露您的个人信息。在符合法律法规的前提下，当我们收到上述披露信息的请求时，我们会要求必须出具与之相应的法律文件，如传票或调查函。我们坚信，对于要求我们提供的信息，应该在法律允许的范围内尽可能保持透明。我们对所有的请求都进行了慎重的审查，以确保其具备合法依据，且仅限于执法部门因特定调查目的且有合法权利获取的数据。在法律法规许可的前提下，我们披露的文件均在加密密钥的保护之下。\n      ")]), _vm._v(" "), _c('p', [_vm._v("六、\t关于未成年个人信息")]), _vm._v(" "), _c('p', [_vm._v("我们的产品主要面向成人，我们重视对未成年人个人信息的保护。若您是18周岁以下的未成年人，在使用我们的服务或产品前，应事先取得您的家长或法定监护人的同意并在他们的指导下使用。若您是未成年人的监护人，当您对您所监护的未成年人的个人信息有相关疑问或拒绝进一步收集被监护人信息，或要求我们删除被监护人信息，请通过第十一条中的联系方式与我们联系。")]), _vm._v(" "), _c('p', [_vm._v("\n        七、 如何管理您的个人信息\n      ")]), _vm._v(" "), _c('p', [_vm._v("\n          我们将尽一切可能采取适当的技术手段，保证收集到的有关于您的个人信息的准确性，并保证及时进行更新。\n      ")]), _vm._v(" "), _c('p', [_vm._v("\n          1、更正或补充您的个人信息\n      ")]), _vm._v(" "), _c('p', [_vm._v("\n          除法律法规规定外，您有权随时访问和更正您的个人信息，具体包括：\n      ")]), _vm._v(" "), _c('p', [_vm._v("\n          Web端路径：您可以在左上角点击头像，页面的“个人资料”菜单中查阅您提交给知心慧学教师端的所有个人信息，你也可通过上述途径更新除教师认证信息之外的其他个人信息（您的姓名、学科、手机号、岗位）。移动端具体路径为： “我的”进入我的知心慧学教师端--修改密码：您也可以通过「个人中心」-【意见反馈】页面，按照知心慧学教师端的相关政策及提示，或联系在线客服，对您的个人信息进行访问、更正。\n      ")]), _vm._v(" "), _c('p', {
    staticClass: "bold"
  }, [_vm._v("\n      2、删除您的个人信息及注销账号\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "key-msg"
  }, [_vm._v("\n      您可以通过「我的」-【安全中心】页面，点击账号注销，填写账号及密码后申请注销，或联系在线客服，或拨打客服电话19970080755，我们将在2周内帮助您进行注销账号及删除有关信息的处理。 ")]), _vm._v(" "), _c('p'), _c('p', [_vm._v("\n          3、消息管理推送\n      ")]), _vm._v(" "), _c('p', [_vm._v("\n          对于您在使用服务的过程中提供的设备号，我们在运营过程中可能会向您的设备发送消息推送，用于用户消息告知、任务提醒等目的。在「个人中心」-【消息推送管理】页面，您可以选择是否接受定向推送信息，或选择接受部分情况下的推送通知。IOS系统用户可以在[系统设置]-[通知]-[知心慧学教师端]页面设置是否允许通知，安卓系统用户可在[系统设置]-[通知]-[知心慧学教师端]页面设置是否允许通知。\n      ")]), _vm._v(" "), _c('p', [_vm._v("\n        八、我们会如何保护和保存您的个人信息\n      ")]), _vm._v(" "), _c('p', [_vm._v("\n          知心慧学教师端重视个人信息的安全。我们采取互联网业内标准做法来保护您的个人信息，防止信息遭到未经授权访问、披露、使用、修改、损坏或丢失。我们会采取一切合理可行的措施，保护您的个人信息。 我们会采取一切合理可行的措施，确保未收集与知心慧学教师端提供的服务无关的个人信息。我们会尽全力保护您的个人信息，但请您理解，由于技术的限制以及可能存在的各种恶意手段，在互联网行业，不可能始终保证信息百分之百的安全。您需要了解，您接入我们的服务所用的系统和通讯网络，有可能因我们可控范围外的因素而出现问题。我们仅允许有必要知晓这些信息的知心慧学教师端及知心慧学教师端关联方的员工、合作伙伴访问个人信息，并为此设置了严格的访问权限控制和监控机制。我们同时要求可能接触到您个人信息的所有人员履行相应的保密义务。如果未能履行这些义务，可能会被追究法律责任或被中止与知心慧学教师端的合作关系。我们同时要求可能接触到您个人信息的所有人员履行相应的保密义务。如果未能履行这些义务，可能会被追究法律责任或被中止与知心慧学教师端的合作关系。在发生个人信息安全事件的场合，我们将按照法律法规的要求，及时向您告知：安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施等。我们将及时将事件相关情况以邮件、信函、电话、推送通知等方式告知您，难以逐一告知个人信息主体时，我们会采取合理、有效的方式发布公告。同时，我们还将按照监管部门要求，主动上报个人信息安全事件的处置情况。我们在中华人民共和国境内收集和产生的个人信息将存储在中华人民共和国境内。如果日后为处理跨境业务，需要向境外机构传输境内收集的相关个人信息的，我们会事先征得您的同意，按照法律、行政法规和相关监管部门的规定执行，并通过签订协议、核查等有效措施，要求境外机构为所获得的个人信息保密。我们仅会在达到本政策所述目的所必需的时限内保存您的个人信息，但为了遵守适用的法律法规、法院判决或裁定、其他有权机关的要求、维护公共利益等目的，我们可能会将个人信息保存时间予以适当延长。\n      ")]), _vm._v(" "), _c('p', [_vm._v("\n        九、 第三方提供商及其服务\n      ")]), _vm._v(" "), _c('p', [_vm._v("\n          为确保流畅的浏览体验，您可能会收到来自知心慧学教师端及其合作伙伴外部的第三方（以下简称「第三方」）提供的内容或网络链接。知心慧学教师端对此类第三方无控制权。您可选择是否访问第三方提供的链接、内容、产品和服务。知心慧学教师端无法控制第三方的隐私和个人信息保护政策，此类第三方不受到本政策的约束。您在向第三方提交个人信息之前，请确保您阅读并认可这些第三方的隐私保护政策。\n      ")]), _vm._v(" "), _c('p', [_vm._v("\n        十、本政策如何更新及适用范围\n      ")]), _vm._v(" "), _c('p', [_vm._v("\n          为给用户提供更好的服务，知心慧学教师端的业务将不时变化，本隐私政策也将随之调整。知心慧学教师端会通过在知心慧学教师端网站、移动端上发出更新版本并提醒您相关内容的更新，也请您访问知心慧学教师端以便及时了解最新的隐私政策。知心慧学教师端保留不时更新或修改本政策的权利。如果该等修改造成您在本政策下权利的实质减少，知心慧学教师端会通过不同渠道向您发送变更通知，包括但不限于网站公示、短信、邮件通知等方式。 若您不同意修改后的隐私政策，您有权并应立即停止使用知心慧学教师端的服务。如果您继续使用知心慧学教师端的服务，则视为您接受知心慧学教师端对本政策相关条款所做的修改。\n      ")]), _vm._v(" "), _c('p', [_vm._v("\n          知心慧学教师端的所有服务均适用本政策。但某些服务有其特定的隐私政策，该等特定的隐私政策更具体地说明知心慧学教师端在该服务中如何处理您的信息。如本政策与特定服务的隐私政策有不一致之处，请以该特定隐私政策为准。\n      ")]), _vm._v(" "), _c('p', [_vm._v("\n        十一、联系我们\n      ")]), _vm._v(" "), _c('p', [_vm._v("您在使用知心慧学教师端的过程中对本隐私政策或对您个人信息有任何问题、建议、意见及咨询，请通过以下联系方式与我们联系：")]), _vm._v(" "), _c('p', [_vm._v("联系电话"), _c('span', {
    staticClass: "blue"
  }, [_vm._v("19970080755")])]), _vm._v(" "), _c('p', [_vm._v("邮箱 "), _c('span', {
    staticClass: "blue"
  }, [_vm._v("legal@fxbjy.com")])]), _vm._v(" "), _c('p', [_vm._v("如您有相关申诉问题，也可通过上方联系方式与我们联系。若您对我们的回复不满意，特别是您认为我们的个人信息处理行为损害了您的合法权益，在您向我们反馈后我们无法提供让您满意的回复且拒绝改进的，您可以向相关监管机构进行投诉和举报。")])])
}]}

/***/ }),
/* 548 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "user-know"
  }, [_c('div', {
    staticClass: "update"
  }, [_c('p', [_vm._v("更新日期：2021年10月14日")]), _vm._v(" "), _c('p', [_vm._v("生效日期：2021年10月14日")])]), _vm._v(" "), _c('div', [_vm._v("知心慧学学生端app使用许可&知心慧学学生端隐私政策")]), _vm._v(" "), _c('div', [_vm._v("以下内容是《app使用许可》及《知心慧学学生端隐私政策》，在你登录注册知心慧学学生端前请务必审慎阅读、充分理解协议中相关条款内容。《app使用许可》包括app使用许可；信息使用；风险提示；知识产权。《知心慧学学生端隐私政策》包括适用范围；我们收集信息的原因和内容；我们会如何使用您的信息；我们可能如何收集信息；我们会如何共享、转让、公开披露您的个人信息；如何管理您的个人信息；推广服务；我们会如何保护和保存您的个人信息；第三方提供商及其服务；知心慧学学生端会如何处理未成年人的个人信息；本政策如何更新及适用范围；联系我们。 你一旦登录注册知心慧学学生端，即视为你已了解并同意《app使用许可》及《知心慧学学生端隐私政策》的各项内容。\n在此特别提醒您，在点击接受本声明之前，您应事先认真阅读、了解清楚并充分理解本声明的全部内容，包括免除或者限制责任的免责条款及对您的权利限制条款。请您审阅并接受或不接受本声明（未成年人应在法定监护人陪同下审阅）。 除非您接受本声明，否则您无权下载、安装或使用本公司基于应用软件提供的相关服务（以下称\"服务\"）。一旦您点击确认本声明，即意味着您已充分理解和接受本声明，并同意接受本声明各项条款的约束。并且，公司在法律许可的范围内享有对本声明的解释、修改以及变更的权利。")]), _vm._v(" "), _c('div', [_vm._v("一、APP使用许可")]), _vm._v(" "), _c('div', [_vm._v("1.您使用的“知心慧学学生端”（以下简称“APP”）是由江西风向标教育科技有限公司（以下简称“公司”）运营的在线教育增值服务平台。")]), _vm._v(" "), _c('div', [_vm._v("2.“知心慧学学生端用户”是指完成全部注册流程，愿意接受本协议并在知心慧学学生端相关使用规范的规定下使用知心慧学学生端APP服务的注册用户。")]), _vm._v(" "), _c('div', [_vm._v("3.注册成为本APP之用户或使用本APP，即表示您保证您已具备单独签定本协议并遵守本协议所有条款之民事权利能力及民事行为能力。")]), _vm._v(" "), _c('div', [_vm._v("4.您郑重承诺，将以本人真实的身份，秉承诚实信用合法的原则使用本APP，在登陆和使用本APP的全过程中都负有作为理性人的谨慎和注意义务。")]), _vm._v(" "), _c('div', [_vm._v("5.本APP保留对APP使用规定的解释、修改以及变更的权利，届时将通过APP通告等方式向用户传达，如果不同意对本协议相关条款所做的修改，用户有权停止使用网络服务。如果用户继续使用网络服务，则视为用户接受本协议相关条款所做的修改。如您未在通知规定的时间内表示反对，将会被视为默认。")]), _vm._v(" "), _c('div', [_vm._v("二、信息使用")]), _vm._v(" "), _c('div', [_vm._v("1.在注册、登陆和使用知心慧学学生端APP时，您同意及不可撤销地授权将您的姓名和账户等信息提供给我们，包括但不限于您的真实姓名、身份证号码、住址、账号信息等。")]), _vm._v(" "), _c('div', [_vm._v("2.您在使用知心慧学学生端时，承诺和保证如下内容：")]), _vm._v(" "), _c('div', [_vm._v("(a)您所提供的资料为完整，最新及正确无误；")]), _vm._v(" "), _c('div', [_vm._v("(b)本协议一经签署，即具法律效力并同意受其约束。")]), _vm._v(" "), _c('div', [_vm._v("3.\t您的注册信息包括注册号和密码仅供本人使用，您有义务提高自我保护和防范风险意识，如提高密码级别、不随意向其他人透露您的用户名、口令等信息。如若由于您个人对账号信息保管不慎或告知他人而导致任何个人信息泄露、账户损失等，知心慧学学生端将不予承担任何责任。")]), _vm._v(" "), _c('div', [_vm._v("4.我们将对您所提供的资料进行严格的管理及保护，致力于保护用户个人数据及个人隐私安全，原则上不提供给任何个人或者第三方使用，拒绝任何组织和个人以营利为目的意图获取或者使用用户个人信息。特殊情况如司法机关、监管机构或其他政府部门依照法定程序要求提供用户个人信息等为例外。本APP在必要时将会由专业技术人员代为对您相关信息资料进行处理，以符合专业分工的要求。")]), _vm._v(" "), _c('div', [_vm._v("如发生下列任何一种情形，本APP有权随时使用用户提交信息资料、中断或终止向用户提供本协议项下的网络服务而无需通知用户:")]), _vm._v(" "), _c('div', [_vm._v("(a)用户提供的个人资料不真实；")]), _vm._v(" "), _c('div', [_vm._v("(b)用户违反本协议中规定的使用规则；")]), _vm._v(" "), _c('div', [_vm._v("(c)为免除您在生命、身体或财产方面之急迫危险的；")]), _vm._v(" "), _c('div', [_vm._v("(d)为防止他人权益之重大危害的；")]), _vm._v(" "), _c('div', [_vm._v("(e)为增进公共利益，且无害于您的重大利益的。除前款所述情形外，本APP同时保留在不事先通知用户的情况下随时中断或终止部分或全部网络服务的权利，对于所有服务的中断或终止而造成的任何损失，本APP无需对用户或任何第三方承担任何责任。")]), _vm._v(" "), _c('div', [_vm._v("三、风险提示")]), _vm._v(" "), _c('div', [_vm._v("1.对在任何情况下因使用或不能使用本APP所产生的直接、间接、偶然、特殊及后续的损害及风险，我们不承担任何责任。损失包括但不限于决策对于由此给您造成的任何不便或损害，包括但不限于：决策失误、操作不当、遗忘或泄露账户密码、密码被他人破解、您使用的终端设备被第三方侵入而造成的损失。")]), _vm._v(" "), _c('div', [_vm._v("2.您于订立协议时已表示理解并同意免除我们与此相应的法律责任。如在本APP运营过程中出现我们误将您的帐户终止，或变更您的有关信息，或部分停止您的各类权限，则我们将在您提出书面通知后合理期间内处理该等事宜，若因此给您带来不便甚至造成损失，您同意免除我们的相应法律责任。")]), _vm._v(" "), _c('div', [_vm._v("3.您了解并同意，我们不对因下述任一情况而导致的任何损害赔偿承担责任： (a)使用或未能使用本APP服务； (b)对本APP服务的错误理解； (c)第三方未使用真实身份，或者未经批准的使用他人的账号或更改他人的数据； (d)任何非因本APP的原因而引起的与服务有关的损失。")]), _vm._v(" "), _c('div', [_vm._v("4.对于任何本APP无法控制的原因（包括但不限于政府管制、通讯设施故障及其他不可抗力因素）导致的APP暂时关闭、用户信息泄露、被盗用、被篡改等非正常经营行为，本APP不承担任何责任。")]), _vm._v(" "), _c('div', [_vm._v("5.您承认对于您利用本APP或信息而从事的各类行为，包括线上和线下，均为您个人行为且您个人对该类行为承担完全责任。您同意保障和维护APP及其他用户的利益，如因违反有关法律、法规或本协议项下的任何条款而给本APP或任何其他第三人造成损失，您同意承担由此造成的损害赔偿责任。")]), _vm._v(" "), _c('div', [_vm._v("6.由于您将用户密码告知他人或与他人共享注册帐户，由此导致的任何个人信息的泄露，)任何由于黑客政击、计算机病毒侵入或发作、因政府管制而造成的暂时性关闭等影响网络正常经营之不可抗力而造成的个人信息泄露、丢失、被盗用或被篡改等，由于本APP不拥有或不控制的公司以及我们不雇佣或不管理的人员所造成的个人信息的泄露，本APP不承担任何责任并应免于被追诉。")]), _vm._v(" "), _c('div', [_vm._v("7.用户同意保障和维护知心慧学学生端APP及其他用户的利益，如因用户违反有关法律、 法规或本协议项下的任何条款而给本APP或任何其他第三人造成损失，用户同意承担由此造成的损害赔偿责任。在注册成为本APP用户或者使用本APP过程中，您与任何第三方之间发生任何纠纷，由纠纷各方自行解决，本APP并不承担任何责任。本APP不对您使用本APP的任何行为、效果或影响提供任何担保或条件，无论是明示、默示或法定的。")]), _vm._v(" "), _c('div', [_vm._v("四、知识产权")]), _vm._v(" "), _c('div', [_vm._v("1.无论您成为本APP之会员或使用本APP，均认可我们对本APP及本APP所收集、制作、发布之各类信息拥有完全知识产权或所有权，包括但不限于各类文档、图像、数据库等，除非法律明确规定该等权利属于会员个人以外，相关权限应涵盖包括复制、修改、改写、改编、发行、翻译、创造衍生性著作、出版、将前述内容(部分或全部)加以散布、展示等。您同意我们对所有会员提交的信息进行有关编排处理后形成的数据库拥有完全的知识产权。")]), _vm._v(" "), _c('div', [_vm._v("2.如您将信息公布到本APP的任何公共区域，则表示您同意，同时您自动授予，并且您陈述并保证您有权授予本APP不可撤销的、永久的、非独占的、完全免费的、世界范围的许可。在该等许可下，您同意本APP使用、复制、执行、显示并传播该内容，您也同意我们基于该内容创作衍生作品或将该内容整合到其他作品中且我们对该等衍生作品或整合作品拥有完全的所有者权益。除已获得我们书面许可的情况外，您不得复制、修改、公布、传播、执行、转载、许可使用、创建衍生作品、转移显示、出售、转售、以非法手段获取或以任何其他方式处置本APP收集、制作、发布的各类信息。")]), _vm._v(" "), _c('div', [_vm._v("3.请勿擅自复制或采用本APP所创造的用以制成网页的HTML。本APP对其HTML享有著作权。同时，本APP对其网址上的所有图标、图饰、图表、色彩、文字表述及其组合、版面设计、数据库均享有完全的著作权，对发布的信息均享有专有的发布和使用权，未经本APP同意，不得擅自复制、使用或转载。")]), _vm._v(" "), _c('div', [_vm._v("知心慧学学生端隐私政策")]), _vm._v(" "), _c('div', [_vm._v("【特别提示】请仔细阅读《知心慧学学生端隐私政策》（尤其是加粗划线的内容）并确定了解我们对您个人信息的处理规则。阅读过程中，如您有任何疑问，可联系我们的客服咨询，如果您不同意相关协议或其中任何条款约定，知心慧学学生端将暂时无法为您提供个性化服务。本隐私政策与您所使用的知心慧学学生端服务以及该服务所包括的各种业务功能（以下统称“我们的产品与/或服务”）息息相关，希望您在使用我们的产品与/或服务前仔细阅读并确认您已经充分理解本政策所写明的内容，并让您可以按照本隐私政策的指引做出您认为适当的选择。本隐私政策中涉及的相关术语，我们尽量以简明扼要的表述，并提供进一步说明的链接，以便您更好地理解。您使用或在我们更新本隐私政策后（我们会及时提示您更新的情况）继续使用我们的产品与/或服务，即意味着您同意本隐私政策(含更新版本)内容，并且同意我们按照本隐私政策收集、使用、保存和共享您的相关信息。如对本隐私政策或相关事宜有任何问题，您可随时通过发送邮件至"), _c('span', {
    staticClass: "blue"
  }, [_vm._v("info@fxbjy.com")]), _vm._v(" 或拨打我们的任何一部客服电话等多种方式与我们联系 。")]), _vm._v(" "), _c('div', [_vm._v("一、 适用范围")]), _vm._v(" "), _c('div', [_vm._v("本隐私政策适用于知心慧学学生端学生端提供的所有服务，您访问知心慧学学生端学生端网站、客户端，均适用本隐私政策")]), _vm._v(" "), _c('div', [_vm._v("二、我们收集信息的原因和内容")]), _vm._v(" "), _c('div', [_vm._v("为了保障您能够流畅地使用我们的核心功能并向您提供更好、更优、更个性化的服务，同时为了保障您的信息安全，我们将根据您使用的服务收集您的以下信息。")]), _vm._v(" "), _c('div', [_vm._v("2.1 您直接提供给我们的信息")]), _vm._v(" "), _c('div', [_vm._v("当您注册时，您需要至少向我们提供您准备使用的知心慧学学生端账户名、密码、您本人的手机号码、电子邮箱地址（用于验证邮箱），我们将通过发送短信验证码或邮件的方式来验证您的身份是否有效。此时，您需要向我们提供以下信息：帐号名称、头像（如有）和手机号码等。提供上述信息并同意注册协议和本政策后，您可以使用知心慧学学生端的部分业务功能，包括：成绩发布后的查分，浏览知心慧学学生端平台内的内容等。在您注册知心慧学学生端帐号时，我们会使用手机号码对您的学生信息（姓名、学校、学号/学籍号）进行绑定，便于将您与其他用户区分并准确判断您的学习情况，为您提供个性化的服务。如您拒绝提供手机号码或进行学生信息绑定，您仍可浏览部分知心慧学学生端平台内的内容，但将无法使用如成个性化学情分析，学习提升方案等核心功能。")]), _vm._v(" "), _c('div', [_vm._v("2.2在您使用过程中产生的信息。")]), _vm._v(" "), _c('div', [_vm._v("当您使用知心慧学学生端的某些业务功能时，为满足向您提供该产品和服务之目的，除注册信息外，您还需要进一步向我们提供包括但不限于您的个人身份信息、位置信息及其他为您提供服务所必需的信息，如果您不使用特定产品和服务，则无需提供相关信息（以下将详细阐明）。")]), _vm._v(" "), _c('div', [_vm._v("位置信息。当您开启设备定位功能并使用我们基于位置提供的相关服务时，我们会收集有关您位置的信息。该信息属于敏感信息，拒绝提供该信息仅会使您无法使用与位置信息相关的功能，但不影响您正常使用知心慧学学生端的其他功能。我们可能会收集您的订单信息、浏览信息、您的兴趣爱好（您可以在账户设置中选择）进行数据分析以形成用户画像，用来将您感兴趣的内容或服务信息展示给您；或在您搜索时向您展示您可能希望找到的内容。我们还可能为了提供服务及改进服务质量的合理需要而获得您的其他信息，包括您与客服联系时您提供的相关信息，您参与问卷调查时向我们发送的问卷答复信息，以及您与我们的关联方、我们合作伙伴之间互动时我们获得的相关信息。对于从您的各种设备上收集到的信息，我们可能会将它们进行关联，以便我们能在这些设备上为您提供一致的服务。我们可能会将来自某项服务的信息与来自其他服务的信息结合起来，以便为您提供服务、个性化内容和建议。")]), _vm._v(" "), _c('div', [_vm._v("2.3 征得授权同意的例外")]), _vm._v(" "), _c('div', [_vm._v("根据相关法律法规的规定，以下情形中收集您的个人信息无需征得您的授权同意：")]), _vm._v(" "), _c('div', [_vm._v("（1）涉及国家安全与利益、社会公共利益；")]), _vm._v(" "), _c('div', [_vm._v("（2）与犯罪侦查有关的相关活动；")]), _vm._v(" "), _c('div', [_vm._v("（3）出于维护您或他人的生命财产安全但在特殊情况下无法获得您的及时授权；")]), _vm._v(" "), _c('div', [_vm._v("（4）从其他合法公开的渠道中收集您的个人信息；")]), _vm._v(" "), _c('div', [_vm._v("（5）法律法规规定的其他情形。")]), _vm._v(" "), _c('div', [_vm._v("三、我们会如何使用您的信息")]), _vm._v(" "), _c('div', [_vm._v("收集您的信息是为了向您提供服务及提升服务质量，我们会根据本隐私政策的约定进行使用，在收集您的信息后，我们将通过技术手段对数据进行去标识化处理，去标识化处理的信息将无法识别主体。请您了解并同意，在此情况下我们有权使用已经去标识化的信息；并在不透露您个人信息的前提下，我们有权对用户数据库进行分析并予以合法使用。")]), _vm._v(" "), _c('div', [_vm._v("您的信息主要有以下用途：")]), _vm._v(" "), _c('div', [_vm._v("为您提供您使用的各项个性化服务，并维护、改进这些服务。")]), _vm._v(" "), _c('div', [_vm._v("帮助我们设计新服务，提升现有服务体验。")]), _vm._v(" "), _c('div', [_vm._v("在我们提供服务时，用于身份验证、客户服务、安全防范、诈骗监测、存档和备份用途，确保我们向您提供的产品和服务的安全性。")]), _vm._v(" "), _c('div', [_vm._v("向您发送您可能感兴趣的学习类产品和服务的信息，包括但不限于向您发出学习产品和服务信息，或通过系统向您展示个性化的学习产品推广信息；邀请您参与知心慧学学生端活动和市场调查。")]), _vm._v(" "), _c('div', [_vm._v("开展内部审计、数据分析和研究，以更好地改善我们的产品、服务及与用户之间的沟通。")]), _vm._v(" "), _c('div', [_vm._v("四、我们可能如何收集信息")]), _vm._v(" "), _c('div', [_vm._v("您使用我们的服务时，我们会在您的计算机或移动设备上存储名为 Cookie 的小数据文件。Cookie 通常包含标识符、站点名称以及一些号码和字符。我们使用该等信息判断注册用户是否已经登录，提升服务/产品质量及优化用户体验。如您不希望个人信息保存在 Cookie 中，您可对浏览器进行配置，选择禁用 Cookie 功能。禁用 Cookie 功能后，可能影响您访问知心慧学学生端或不能充分取得知心慧学学生端提供的服务。")]), _vm._v(" "), _c('div', [_vm._v("知心慧学学生端不会将 Cookie 用于本政策所述目的之外的任何用途。您可根据自己的偏好管理或删除Cookie。您可以清除计算机上保存的所有 Cookie，大部分网络浏览器都设有阻止 Cookie 的功能。")]), _vm._v(" "), _c('div', [_vm._v("4.2 设备权限调用")]), _vm._v(" "), _c('div', [_vm._v("知心慧学学生端在提供服务的过程中，可能需要您开通一些设备权限，例如通知、相册、相机等访问权限。您也可以在设备的设置功能中随时选择关闭部分或者全部权限，从而拒绝知心慧学学生端收集相应的个人信息。在不同设备中，权限显示方式及关闭方式可能有所不同，具体请参考设备及系统开发方说明或指引。")]), _vm._v(" "), _c('div', [_vm._v("根据您的服务使用情况，我们可能会调用的权限如下：")]), _vm._v(" "), _c('div', [_vm._v("（1）储存权限。当您下载及升级应用、使用错题本功能进行导出和储存、上传文件联系在线客服反馈问题时，我们会调用您的储存权限，保障您能顺利实现此功能。")]), _vm._v(" "), _c('div', [_vm._v("（2）摄像头权限。当您修改头像选择拍照上传或上传作业时，我们将调用您的摄像头权限，保障您进行个性化的使用。")]), _vm._v(" "), _c('div', [_vm._v("（3）短信权限：当您注册账号时，我们将调用短信权限，保障您能顺利完成注册。")]), _vm._v(" "), _c('div', [_vm._v("五、我们会如何共享、转让、公开披露您的个人信息")]), _vm._v(" "), _c('div', [_vm._v("5.1 共享")]), _vm._v(" "), _c('div', [_vm._v("知心慧学学生端不会在未经您同意或授权的情况下将您的个人信息提供给第三方。但是，经您确认同意，知心慧学学生端可在以下情况下共享您的个人信息。")]), _vm._v(" "), _c('div', [_vm._v("在获取同意的情况下共享：获得您的明确同意后，知心慧学学生端会与其他方共享您的个人信息。")]), _vm._v(" "), _c('div', [_vm._v("共享给知心慧学学生端的关联公司：在本政策声明的使用目的范围内，您的个人信息可能会与知心慧学学生端的关联公司共享。作为一项政策，我们只会共享必要的信息。关联公司如要改变个人信息的处理目的，将再次征求您的授权同意。")]), _vm._v(" "), _c('div', [_vm._v("共享给授权合作伙伴：知心慧学学生端可能会与合作伙伴共享您的某些个人信息，以便给您提供服务、个性化内容和建议。例如，知心慧学学生端向您寄送礼品（如有）时，知心慧学学生端必须与物流服务提供商共享您的个人信息才能安排寄送，或者安排合作伙伴向您提供服务。我们仅会出于特定、明确而合法的目的处理您的个人信息，并且只会共享提供服务所必要的信息。同时，我们会与其签署严格的保密协定，要求他们按照我们的说明、本政策以及其他任何相关的保密和安全措施来处理个人信息。在法定情形下的共享：我们可能会根据法律法规规定、诉讼争议解决需要，或按行政、司法机关依法提出的要求，对外共享您的个人信息。")]), _vm._v(" "), _c('div', [_vm._v("5.2 转让")]), _vm._v(" "), _c('div', [_vm._v("我们不会将您的个人信息转让给任何公司、组织和个人，但以下情况除外：")]), _vm._v(" "), _c('div', [_vm._v("事先获得您明确的同意或授权；")]), _vm._v(" "), _c('div', [_vm._v("根据适用的法律法规、法律程序的要求、强制性的行政或司法要求所必须的情况进行提供；")]), _vm._v(" "), _c('div', [_vm._v("符合与您签署的相关协议（包括在线签署的电子协议以及相应的平台规则）或其他的法律文件约定所提供；在涉及合并、收购、资产转让或类似的交易时，如涉及到个人信息转让，我们会要求新的持有您个人信息的公司、组织继续受本隐私政策的约束，否则,我们将要求该公司、组织重新向您征求授权同意")]), _vm._v(" "), _c('div', [_vm._v("5.3 公开披露")]), _vm._v(" "), _c('div', [_vm._v("我们仅会在以下情况下，且采取符合法律和业界标准的安全防护措施的前提下，才会公开披露您的个人信息")]), _vm._v(" "), _c('div', [_vm._v("根据您的需求，在您明确同意的披露方式下披露您所指定的个人信息；")]), _vm._v(" "), _c('div', [_vm._v("根据法律、法规的要求、强制性的行政执法或司法要求所必须提供您个人信息的情况下，我们可能会依据所要求的个人信息类型和披露方式公开披露您的个人信息。在符合法律法规的前提下，当我们收到上述披露信息的请求时，我们会要求必须出具与之相应的法律文件，如传票或调查函。我们坚信，对于要求我们提供的信息，应该在法律允许的范围内尽可能保持透明。我们对所有的请求都进行了慎重的审查，以确保其具备合法依据，且仅限于执法部门因特定调查目的且有合法权利获取的数据。在法律法规许可的前提下，我们披露的文件均在加密密钥的保护之下。")]), _vm._v(" "), _c('div', [_vm._v("六、 如何管理您的个人信息")]), _vm._v(" "), _c('div', [_vm._v("我们将尽一切可能采取适当的技术手段，保证收集到的有关于您的个人信息的准确性，并保证及时进行更新。")]), _vm._v(" "), _c('div', [_vm._v("6.1 更正或补充您的个人信息")]), _vm._v(" "), _c('div', [_vm._v("除法律法规规定外，您有权随时访问和更正您的个人信息，具体包括：")]), _vm._v(" "), _c('div', [_vm._v("Web端路径：您可以在左上角点击头像，页面的“个人资料”菜单中查阅您提交给知心慧学学生端的所有个人信息，你也可通过上述途径更新除考生认证信息之外的其他个人信息（您的考生认证信息是您通过注册后 实名认证时使用的姓名和身份证信息）。移动端具体路径为： “我的”进入我的知心慧学学生端--修改密码：您也可以通过「我的」-【意见反馈】页面，按照知心慧学学生端的相关政策及提示，或联系在线客服，对您的个人信息进行访问、更正。")]), _vm._v(" "), _c('div', [_vm._v("6.2 删除您的个人信息")]), _vm._v(" "), _c('div', [_vm._v("您也可以通过「我的」-【意见反馈】页面，按照知心慧学学生端的相关政策及提示，或联系在线客服，或拨打客服电话021-68582680，我们将在2周内帮助您进行删除账号及有关信息的处理。")]), _vm._v(" "), _c('div', [_vm._v("七、我们会如何保护和保存您的个人信息")]), _vm._v(" "), _c('div', [_vm._v("知心慧学学生端重视个人信息的安全。我们采取互联网业内标准做法来保护您的个人信息，防止信息遭到未经授权访问、披露、使用、修改、损坏或丢失。我们会采取一切合理可行的措施，保护您的个人信息。 我们会采取一切合理可行的措施，确保未收集与知心慧学学生端提供的服务无关的个人信息。我们会尽全力保护您的个人信息，但请您理解，由于技术的限制以及可能存在的各种恶意手段，在互联网行业，不可能始终保证信息百分之百的安全。您需要了解，您接入我们的服务所用的系统和通讯网络，有可能因我们可控范围外的因素而出现问题。我们仅允许有必要知晓这些信息的知心慧学学生端及知心慧学学生端关联方的员工、合作伙伴访问个人信息，并为此设置了严格的访问权限控制和监控机制。我们同时要求可能接触到您个人信息的所有人员履行相应的保密义务。如果未能履行这些义务，可能会被追究法律责任或被中止与知心慧学学生端的合作关系。我们同时要求可能接触到您个人信息的所有人员履行相应的保密义务。如果未能履行这些义务，可能会被追究法律责任或被中止与知心慧学学生端的合作关系。在发生个人信息安全事件的场合，我们将按照法律法规的要求，及时向您告知：安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施等。我们将及时将事件相关情况以邮件、信函、电话、推送通知等方式告知您，难以逐一告知个人信息主体时，我们会采取合理、有效的方式发布公告。同时，我们还将按照监管部门要求，主动上报个人信息安全事件的处置情况。我们在中华人民共和国境内收集和产生的个人信息将存储在中华人民共和国境内。如果日后为处理跨境业务，需要向境外机构传输境内收集的相关个人信息的，我们会事先征得您的同意，按照法律、行政法规和相关监管部门的规定执行，并通过签订协议、核查等有效措施，要求境外机构为所获得的个人信息保密。我们仅会在达到本政策所述目的所必需的时限内保存您的个人信息，但为了遵守适用的法律法规、法院判决或裁定、其他有权机关的要求、维护公共利益等目的，我们可能会将个人信息保存时间予以适当延长。")]), _vm._v(" "), _c('div', [_vm._v("八、 第三方提供商及其服务")]), _vm._v(" "), _c('div', [_vm._v("为确保流畅的浏览体验，您可能会收到来自知心慧学学生端及其合作伙伴外部的第三方（以下简称「第三方」）提供的内容或网络链接。知心慧学学生端对此类第三方无控制权。您可选择是否访问第三方提供的链接、内容、产品和服务。知心慧学学生端无法控制第三方的隐私和个人信息保护政策，此类第三方不受到本政策的约束。您在向第三方提交个人信息之前，请确保您阅读并认可这些第三方的隐私保护政策。")]), _vm._v(" "), _c('div', [_vm._v("九、知心慧学学生端会如何处理未成年人的个人信息")]), _vm._v(" "), _c('div', [_vm._v("我们鼓励父母或监护人指导未满十八岁的未成年人使用我们的服务。我们建议未成年人鼓励他们的父母或监护人阅读本政策，并建议未成年人在提交个人信息之前寻求父母或监护人的同意和指导。但是，如果您确认自己能够完全理解本政策的全部内容且您为使用知心慧学学生端服务所进行的相关操作行为与您的年龄、智力相适应的，则您可以独立进行相关操作（包括向我们提交您的个人信息）。")]), _vm._v(" "), _c('div', [_vm._v("十、 本政策如何更新及适用范围")]), _vm._v(" "), _c('div', [_vm._v("为给用户提供更好的服务，知心慧学学生端的业务将不时变化，本隐私政策也将随之调整。知心慧学学生端会通过在知心慧学学生端网站、移动端上发出更新版本并提醒您相关内容的更新，也请您访问知心慧学学生端以便及时了解最新的隐私政策。知心慧学学生端保留不时更新或修改本政策的权利。如果该等修改造成您在本政策下权利的实质减少，知心慧学学生端会通过不同渠道向您发送变更通知，包括但不限于网站公示、短信、邮件通知等方式。 若您不同意修改后的隐私政策，您有权并应立即停止使用知心慧学学生端的服务。如果您继续使用知心慧学学生端的服务，则视为您接受知心慧学学生端对本政策相关条款所做的修改。 知心慧学学生端的所有服务均适用本政策。但某些服务有其特定的隐私政策，该等特定的隐私政策更具体地说明知心慧学学生端在该服务中如何处理您的信息。如本政策与特定服务的隐私政策有不一致之处，请以该特定隐私政策为准。")]), _vm._v(" "), _c('div', [_vm._v("十一、 联系我们")]), _vm._v(" "), _c('div', [_vm._v("如对本隐私政策或相关事宜有任何问题，您可随时通过发送邮件至 "), _c('span', {
    staticClass: "blue"
  }, [_vm._v("info@fxbjy.com")]), _vm._v(" 或拨打我们的任何一部客服电话等多种方式与我们联系 。")])])
}]}

/***/ }),
/* 549 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "user-know"
  }, [_c('div', {
    staticClass: "update"
  }, [_c('p', [_vm._v("更新日期：2022年6月2日")]), _vm._v(" "), _c('p', [_vm._v("生效日期：2022年6月2日")])]), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("江西风向标智能科技有限公司"), _c('br'), _vm._v("产品服务协议")]), _vm._v(" "), _c('div', [_vm._v("尊敬的用户：")]), _vm._v(" "), _c('div', {
    staticClass: "ident"
  }, [_vm._v("您好！欢迎您使用江西风向标智能科技有限公司（以下简称“风向标”或“服务商”）出品的“知心慧学智能精准教学系统”产品及配套服务。为使您的使用过程便捷，准确提升产品使用效率，请您认真阅读本协议， 您在阅读并确认使用上述产品后即表示您同意本协议的内容。")]), _vm._v(" "), _c('div', {
    staticClass: "ident",
    staticStyle: {
      "margin-top": ".2rem"
    }
  }, [_vm._v("\n    江西风向标智能科技有限公司（以下简称“风向标”或“服务商”、“公司”）为您（指通过登录APP或网站、公众号、小程序等方式购买并使用风向标“知心慧学智能精准教学系统”产品及配套服务的终端客户，以下也称为“用户”）提供“知心慧学智能精准教学系统”产品和配套服务（以下简称“本产品”、“产品”），您自愿购买上述产品并基于购买产品后的使用而作出如下意思表示和授权，以下意思表示及授权均为您真实意愿，您同意承担由此带来的一切风险和责任。如果您是未成年人，则请您在法定监护人陪同下审阅和判断是否同意本协议的内容，未成年人使用本产品的行为视为已获得了法定监护人的认可。如果您不同意接受本协议的全部条款，则您无权注册、登录或使用本协议所涉及产品和服务，您下载、安装、使用本产品等行为，则意味着您将自愿遵守本协议及本产品的其他有关规则，并完全服从于本产品的统一管理。\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "ident"
  }, [_vm._v("\n    风向标有权根据业务需要对本协议不定时进行调整，并将调整后的协议公布于公司官网或者产品APP、公众号、小程序中，如果您不同意调整后的本协议的，您应当停止使用本产品，否则，如果在公司调整本协议并公布后，您继续使用本产品提供的服务的，则视为您同意遵守调整后的协议。\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "bold"
  }, [_vm._v("一、关于购买产品")]), _vm._v(" "), _c('div', {
    staticClass: "ident"
  }, [_vm._v("1、用户系自愿购买本产品，并通过线上或线下的方式向风向标支付用以购买产品的费用，用户用以登录产品使用端口的账号来自风向标的授予。")]), _vm._v(" "), _c('div', {
    staticClass: "ident"
  }, [_vm._v("2、用户已具备与购买行为相适应的智力、健康状况，或经用户的法定监护人的同意购买本产品，并充分理解、知悉购买产品和使用产品行为产生的法律效果以及基于购买和使用产品的行为产生的个人信息采集情况。")]), _vm._v(" "), _c('div', {
    staticClass: "ident"
  }, [_vm._v("3、经风向标许可，用户使用试用账号登录产品使用端口，并不表示用户同意即时付费，但这并不影响为正常使用产品而授权风向标采集用户的个人信息。")]), _vm._v(" "), _c('div', {
    staticClass: "ident"
  }, [_vm._v("4、产品的试用期限届满后，用户无意付费购买的，用户同意风向标随时收回风向标授予本人的登录账号。")]), _vm._v(" "), _c('div', {
    staticClass: "bold"
  }, [_vm._v("二、用户权利和义务")]), _vm._v(" "), _c('div', {
    staticClass: "ident"
  }, [_vm._v("\n    1、用户应妥善保管自己的账号、密码，不得转让、出借、出租、出售或分享予他人使用。否则风向标有权根据实际情况暂时封停或永久查封此账号，当用户的账号或密码遭到未经授权的使用时，用户应当立即通知风向标，否则未经授权的使用行为均视为用户本人行为。\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "ident"
  }, [_vm._v("\n    2、风向标有权随时对本产品内容等进行调整，包括但不限于增加、删除、修改本产品服务内容，一旦本产品的服务内容发生增加、删除、修改，公司将在相关页面上进行提示；如果用户不同意相关变更和修改，可以取消已经获取的服务并停止使用；如果用户继续使用本产品提供的服务，则视为用户已经接受全部变更、修改。除非另有明确约定，否则用户使用本产品内新增的服务内容将同样受本协议各项条款的约束。\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "ident"
  }, [_vm._v("\n    3、本产品内提供的服务分为试用期间的免费服务和正式使用的收费服务。对于现阶段免费提供的服务内容，公司有权随时根据公司政策的调整将其变更为收费服务，如果发生该等变更的，公司将提前告知用户，如果用户不同意的，可以停止使用该服务。对于收费的服务内容，公司有权自行确定该等服务的价格并不时调整，调整后的价格将在本产品平台中进行公示或以其他方式告知用户，如果用户不同意调整后的价格的，则用户可以在其原购买的收费服务到期后停止付费购买收费服务。如果用户在公司调整价格并公示或告知后，仍继续购买收费服务的，则视为用户同意该调整后的价格。\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "ident"
  }, [_vm._v("\n    4、用户如对付费购买的服务不满意的，有权终止服务。用户需在规定时间内，在客户端自行申请或拨打客服电话，申请终止服务及退款，退款金额按照客户端公示的退款规则计算，公司有权根据业务发展不时调整退款规则并在客户端内公示；公司有权保留已终止服务的用户的所有使用信息，对用户在使用付费服务期间发生的违反本协议及相关规定的行为，公司仍有权行使本协议规定的权利并追究用户的法律责任。\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "ident"
  }, [_vm._v("\n    5、公司不时将对付费服务提供优惠政策或开展优惠活动，该等优惠政策或优惠活动以本产品平台上的实时信息为准，用户知悉并认可，公司有权自行决定是否提供优惠政策或开展优惠互动，以及优惠政策或优惠活动的内容、条件和有效期，并不时进行调整或终止。\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "ident"
  }, [_vm._v("6、公司禁止以任何形式倒卖、贩售、出租、出借、转让用户账号的行为，一经查明，公司将采取包括但不限于封号、封禁IP、追究相关责任人法律责任的处理措施。")]), _vm._v(" "), _c('div', {
    staticClass: "bold"
  }, [_vm._v("三、平台管理")]), _vm._v(" "), _c('div', {
    staticClass: "ident"
  }, [_vm._v("1、用户应保证注册、登录并使用的账号符合中国相关法律法规的规定，符合《互联网用户账号名称管理规定》，符合本协议的各项规定。公司有权对用户注册、登录并使用的账号名称、头像和简介等注册信息进行审核，用户确保其使用的用户账号名称、头像和简介等信息中不得出现违法和不良信息，不存在以虚假信息骗取账号名称注册的情形；用户应确保其使用的用户账号名称不得为冒用关联机构或社会名人注册的账号名称。")]), _vm._v(" "), _c('div', {
    staticClass: "ident"
  }, [_vm._v("2、如果用户以虚假信息骗取账号名称注册，或用户的账号头像、简介等注册信息存在违法和不良信息的，公司有权采取通知限期改正、暂停使用、注销登记等措施；如果用户冒用关联机构或社会名人注册账号名称的，公司有权注销用户的账号，并向互联网信息内容主管部门报告。")]), _vm._v(" "), _c('div', {
    staticClass: "ident"
  }, [_vm._v("3、凡用户存在发布广告、暴力、色情、政治、宗教等内容，或抄袭、模仿管理人员ID，用以假冒管理人员或破坏管理人员形象，或模仿或盗用他人ID个人签名，发布的内容包含有严重影响网友浏览的内容或格式，或者存在其他扰乱本产品秩序的，或影响公司正常经营行为的，公司有权删除其相应账号，情节严重者，将酌情封禁对应IP。")]), _vm._v(" "), _c('div', {
    staticClass: "ident"
  }, [_vm._v("4、公司提供账号注销功能，可以在本产品中实现。注销账号之后此账号内的数据无法恢复，账号信息内容也将全部清除，包含但不限于该账号发布过的文章、评论等。注销行为操作后无法撤销，请用户谨慎申请。")]), _vm._v(" "), _c('div', {
    staticClass: "ident"
  }, [_vm._v("5、投诉和举报：如果用户认为本产品中的信息、资料、内容等存在违反法律法规及本产品相关管理规定的，涉嫌侮辱或者诽谤他人，或者侵犯用户或第三方的知识产权或其他合法权利情形的，您可以通过本产品内的专用渠道进行举报、投诉，或者向公司官方邮箱info@fxbjy.com发送权利通知书，公司将在收到您的投诉后将依据中国法律法规和政府规范性文件及本产品平台管理规定采取措施进行处理，包括但不限于移除相关内容或屏蔽相关链接，以及其他公司认为适当的处理方式，情节严重者，公司有权向政府相关部门进行举报。")]), _vm._v(" "), _c('div', {
    staticClass: "bold"
  }, [_vm._v("四、知识产权")]), _vm._v(" "), _c('div', {
    staticClass: "ident"
  }, [_vm._v("1、无论您成为本产品之会员或使用本产品，均认可公司对本产品及本产品所收集、制作、发布之各类信息拥有完全知识产权或所有权，包括但不限于各类文档、图像、数据库等，除非法律明确规定该等权利属于用户个人以外，相关权限应涵盖包括复制、修改、改写、改编、发行、翻译、创造衍生性著作、出版、将前述内容(部分或全部)加以散布、展示等。您同意公司对您提交的信息进行有关编排处理后形成的数据库拥有完全的知识产权。")]), _vm._v(" "), _c('div', {
    staticClass: "ident"
  }, [_vm._v("2、如您将信息公布到本产品的任何公共区域，则表示您同意，同时您自动授予，并且您陈述并保证您有权授予本产品不可撤销的、永久的、非独占的、完全免费的、中华人民共和国范围的许可。在该等许可下，您同意本产品使用、复制、执行、显示并传播该内容，您也同意公司基于该内容创作衍生作品或将该内容整合到其他作品中且公司对该等衍生作品或整合作品拥有完全的所有者权益。除已获得公司书面许可的情况外，您不得复制、修改、公布、传播、执行、转载、许可使用、创建衍生作品、转移显示、出售、转售、以非法手段获取或以任何其他方式处置本产品收集、制作、发布的各类信息。")]), _vm._v(" "), _c('div', {
    staticClass: "ident"
  }, [_vm._v("3、请勿擅自复制或采用本产品所创造的用以制成网页的HTML。公司对其HTML享有著作权。同时，公司对其网址上的所有图标、图饰、图表、色彩、文字表述及其组合、版面设计、数据库均享有完全的著作权，对发布的信息均享有专有的发布和使用权，未经公司同意，不得擅自复制、使用或转载。")]), _vm._v(" "), _c('div', {
    staticClass: "ident"
  }, [_vm._v("4、未经公司事先许可，禁止使用任何机器人、爬虫程序、其他自动设备，或手动程序等来监视或复制本产品网页或其所包含的任何内容。否则，公司有权依法追究法律责任。")]), _vm._v(" "), _c('div', {
    staticClass: "bold"
  }, [_vm._v("五、关于个人隐私和信息采集")]), _vm._v(" "), _c('div', [_vm._v("（一）信息采集授权")]), _vm._v(" "), _c('div', {
    staticClass: "ident"
  }, [_vm._v("1、采集途径。您不可撤销地授权风向标以为您提供产品之目的，通过以下途径获取本人信息：")]), _vm._v(" "), _c('div', {
    staticClass: "ident bold"
  }, [_vm._v("（1）您确认，您在申请试用和正式使用本产品（包括APP移动端、网站、H5页面链接、微信公众号、小程序等）时，向风向标提供的信息；")]), _vm._v(" "), _c('div', {
    staticClass: "ident bold"
  }, [_vm._v("（2）您在试用和正式使用产品后，风向标向您所在学校班级任课老师和您提供的考试成绩、学习状况、在校情况等信息。")]), _vm._v(" "), _c('div', {
    staticClass: "ident"
  }, [_vm._v("2、采集范围。您不可撤销地授权风向标以为您提供产品及服务之目的，获取您个人以下范围的信息：")]), _vm._v(" "), _c('div', {
    staticClass: "ident"
  }, [_vm._v("（1）您申请试用产品时提交的姓名、所在学校、年级、班级、学号、考号等必要信息；")]), _vm._v(" "), _c('div', {
    staticClass: "ident"
  }, [_vm._v("（2）您使用产品后通过产品系统上传的个人考卷、答题本、作业集、错题本以及历次考试成绩等；")]), _vm._v(" "), _c('div', {
    staticClass: "ident"
  }, [_vm._v("（3）您所在学校班级老师通过本产品教师端获取的您考试成绩、测评报告等。")]), _vm._v(" "), _c('div', [_vm._v("（二）信息使用授权")]), _vm._v(" "), _c('div', {
    staticClass: "ident bold"
  }, [_vm._v("您同意并不可撤销地授权风向标以为您提供产品之目的，保存、整理、加工本协议第五条第一款所述的、通过合法途径采集的您的信息，用于您更好的使用产品，以及辅助老师教学，并基于此目的，授权风向标通过本产品教师端向您所在学校和班级老师推送上述信息。")]), _vm._v(" "), _c('div', {
    staticClass: "ident"
  }, [_vm._v("上述授权系您对风向标做出的单方承诺，效力具有独立性，不受本条款所属协议成立与否及效力状态的影响。")]), _vm._v(" "), _c('div', {
    staticClass: "ident"
  }, [_vm._v("以上授权期限为您作出本授权承诺之日起至您在风向标处所有业务终结之日止。")]), _vm._v(" "), _c('div', [_vm._v("（三）信息使用共享")]), _vm._v(" "), _c('div', {
    staticClass: "ident"
  }, [_vm._v("您授权风向标，除法律另有规定之外，将您提供给风向标的信息、使用产品产生的信息以及风向标根据本协议约定查询、收集的信息，用于风向标及其因服务必要委托的合作伙伴为您提供服务、推荐产品、开展市场调查以及信息数据分析。")]), _vm._v(" "), _c('div', {
    staticClass: "ident"
  }, [_vm._v("您授权风向标，除法律另有规定外，基于为您提供更优质服务和产品的目的，向风向标因服务必要开展合伙的伙伴提供、查询、收集您的信息。")]), _vm._v(" "), _c('div', {
    staticClass: "ident"
  }, [_vm._v("为确保您的个人信息安全，风向标对上述信息负有保密义务，并尽最大努力采取各种措施保证信息安全。")]), _vm._v(" "), _c('div', {
    staticClass: "ident"
  }, [_vm._v("本条款自您签署或确认本协议时生效，具有独立法律效力，不受本条款所属协议成立与否及效力状态的影响。")]), _vm._v(" "), _c('div', [_vm._v("（四）用户知悉")]), _vm._v(" "), _c('div', {
    staticClass: "ident bold"
  }, [_vm._v("包含您姓名、所在学校、年级、班级、学号、考号等信息为您的个人信息。您应充分了解并明确知悉风向标向第三方采集并在法律法规许可范围内向信息使用者提供这些信息后，信息被其他主体对外提供和使用的风险，包括但不限于：这些信息对您的学习可能产生不利影响；这些信息被风向标依法提供给第三方后被他人不当利用的风险；第三方向您推销产品或服务而打扰您的风险。此情况下，您同意并不可撤销地授权风向标依照本协议约定向其他机构提供您的个人信息。")]), _vm._v(" "), _c('div', {
    staticClass: "bold"
  }, [_vm._v("六、责任有限和免责条款")]), _vm._v(" "), _c('div', {
    staticClass: "bold ident"
  }, [_vm._v("1、不允诺担保：本产品用户提问、回答、发言仅代表用户个人观点，与公司无关，且本产品不对用户发表的回答或评论的正确性、准确性、真实性进行保证。本产品为按现状提供，包含瑕疵及缺陷，公司不提供任何其他担保。公司不允诺其他无论是明示的还是默示的保证和担保，包括但不限于对特定目的的适销性和适应性，不侵权，以及任何出自交易过程或商业惯例的保证和条件。从公司或他处获取的任何建议或信息，不论是口头的还是书面的，都不会对公司产生本协议明确约定之外的其他保证和担保。")]), _vm._v(" "), _c('div', {
    staticClass: "bold ident"
  }, [_vm._v("2、责任有限：适用法律所允许的最大范围内，不论出于何种原因，公司对用户的全部责任为用户为使用风向标的产品和服务而向公司支付的费用总额。如果公司免费向用户提供了本产品服务，则公司无义务对用户承担任何赔偿责任。任何情况下，公司不对出自本协议或与本协议有关的或与本产品的运行有关的任何特殊的、偶然的、惩罚性或间接的损害（包括但不限于数据损失、利润损失或营业损失）或采购替代产品承担责任，不论该等责任是基于合同、担保、侵权（包括过失）、严格责任或其他，也不论公司是否被事先告知了损失或损害发生的可能性。即使本协议约定的有限补救措施未能实现其根本目的，前述的责任限制依然适用。")]), _vm._v(" "), _c('div', {
    staticClass: "bold ident"
  }, [_vm._v("3、免责：如因下所列任何原因而造成的用户资料泄露、丢失、被盗用或被篡改等，公司均有权获得免责：")]), _vm._v(" "), _c('div', {
    staticClass: "bold ident"
  }, [_vm._v("（1）任何因政府管制而造成的暂时性关闭等影响网络正常浏览的不可抗力原因；")]), _vm._v(" "), _c('div', {
    staticClass: "bold ident"
  }, [_vm._v("（2）任何计算机系统问题、黑客攻击、计算机病毒侵入或发作的原因；")]), _vm._v(" "), _c('div', {
    staticClass: "bold ident"
  }, [_vm._v("（3）任何因网络安全问题导致的账户或银行卡信息泄露，该风险可能会给用户造成经济损失，用户承诺自行承担向侵权方追究责任及追究责任不能的后果；")]), _vm._v(" "), _c('div', {
    staticClass: "bold ident"
  }, [_vm._v("（4）任何因用户个人原因导致的用户资料泄露、丢失、被盗用或被篡改等；")]), _vm._v(" "), _c('div', {
    staticClass: "bold ident"
  }, [_vm._v("（5）其他不能归责于公司的原因。")]), _vm._v(" "), _c('div', [_vm._v("七、其他")]), _vm._v(" "), _c('div', {
    staticClass: "ident"
  }, [_vm._v("1、如果本产品平台上某一子服务附有单独的使用协议的，则该子服务的使用将受该单独使用协议的约束。")]), _vm._v(" "), _c('div', {
    staticClass: "ident"
  }, [_vm._v("2、本协议的签订、生效、履行、争议的解决均适用中华人民共和国法律。")]), _vm._v(" "), _c('div', {
    staticClass: "ident"
  }, [_vm._v("3、有关本协议的争议应通过友好协商解决，如果协商不成，该争议将提交风向标所在地有管辖权的法院诉讼解决。")]), _vm._v(" "), _c('div', {
    staticClass: "ident"
  }, [_vm._v("4、用户对知心慧学平台的意见及建议可通过客服邮箱info@fxbjy.com与公司进行联系。")])])
}]}

/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper"
  }, [_c('section', {
    staticClass: "wmdcp"
  }, [_c('div', {
    staticClass: "title-box"
  }, [_c('h2', {
    staticClass: "title"
  }, [_vm._v("我们的产品")]), _vm._v(" "), _c('i', {
    staticClass: "border-bottom"
  })]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', {
    staticClass: "item clearfix"
  }, [_c('div', {
    staticClass: "logo"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(444),
      "alt": "五级钻石纠错本"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "msg"
  }, [_c('p', {
    staticClass: "name"
  }, [_vm._v("五级钻石纠错本")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("根据知识认知规律，科学设计五级纠错，个性化呈现。由知心慧学“个性化学习宝”系统智能整理，学管团队打印制作成精美活页夹。")])])]), _vm._v(" "), _c('div', {
    staticClass: "item clearfix"
  }, [_c('div', {
    staticClass: "logo"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(445),
      "alt": "两步皇冠个性化学习宝"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "msg"
  }, [_c('p', {
    staticClass: "name"
  }, [_vm._v("两步皇冠个性化学习宝")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("知心慧学“个性化学习宝”系统针对学生自己的错题情况，量身定制个性化训练方案，查缺补漏，举一反三，避免学生盲目训练，减轻负担，提高学习效率。打印制作成精美活页夹。")])])]), _vm._v(" "), _c('div', {
    staticClass: "item clearfix"
  }, [_c('div', {
    staticClass: "logo"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(446),
      "alt": "三步尽管个性化学习宝"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "msg"
  }, [_c('p', {
    staticClass: "name"
  }, [_vm._v("三步金冠个性化学习宝")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("\n              知心慧学“个性化学习宝”系统针对学生自己的错题情况，量身定制个性化训练方案，查缺补漏，举一反三。避免学生盲目训练，减轻负担，提高学习效率。错题、变式训练题同时呈现，方便纠错学习，体验感更好。打印制作成精美活页夹。")])])])]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('img', {
    staticClass: "img-wmdcp",
    attrs: {
      "src": __webpack_require__(456),
      "alt": ""
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "jctf"
  }, [_c('img', {
    staticClass: "img-jctf",
    attrs: {
      "src": __webpack_require__(437),
      "alt": ""
    }
  })])])
}]}

/***/ }),
/* 551 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "user-know"
  }, [_c('div', {
    staticClass: "update"
  }, [_c('p', [_vm._v("更新日期：更新日期：2022年6月2日")]), _vm._v(" "), _c('p', [_vm._v("生效日期：更新日期：2022年6月2日")])]), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("版权声明")]), _vm._v(" "), _c('div', [_vm._v("欢迎光临并使用知心慧学，用户在使用知心慧学前请认真阅读本声明，用户开始使用知心慧学即表明已了解、尊重并遵守本声明的所有内容。如用户对本声明有任何异议，请不要使用知心慧学。在以下声明中，知心慧学的用户统称为“您”。\n  ")]), _vm._v(" "), _c('div', [_vm._v("1、知心慧学由江西风向标智能科技有限公司（以下简称“风向标”）出品，其载体包括手机APP、H5、网站、公众号、小程序等，上述载体的所有权、经营权、管理权均属于风向标。本版权声明适用于上述所有载体。")]), _vm._v(" "), _c('div', [_vm._v("\n    2、您在知心慧学上传的文章、试卷、课题集、作业集、课件、教案、学案等文字、图形资料和音频、视频材料（以下统称“作品”），如属于您原创，即表示上述作品的著作权归风向标所有，或由您与风向标协议约定共同所有。您保证对于您上传的原创作品拥有完整的、无瑕疵的著作权，若因第三方向风向标追究上述作品著作权的法律责任，给风向标造成的一切损失由您全部承担。\n  ")]), _vm._v(" "), _c('div', [_vm._v("\n    3、您转载他人的材料上传至知心慧学，必须取得原著作权人的同意或非排他性许可，您通过其他渠道转载到知心慧学的材料，须得到来源渠道的许可，如可以不经来源渠道许可转载的，您也须注明来源渠道的名称或地址，否则一切后果由您全部承担。\n  ")]), _vm._v(" "), _c('div', [_vm._v("4、您承诺：您在知心慧学所上传的所有作品内容符合法律、法规和规范性文件的相关规定，不侵犯任何第三方的合法权益。如您违反前述保证，风向标有权删除相关内容，并可以暂停或终止向您提供服务。")]), _vm._v(" "), _c('div', [_vm._v("\n    5、任何转载知心慧学已经刊登的作品的，均须得到作品原著作权人和风向标的同意，否则因此引发的法律责任由转载方全部承担；作品原著作权人和风向标未声明不得转载的，转载方也应在转载时注明作品出处，且不得对所转载内容进行任何形式的篡改、增减、节选、歪曲等，否则风向标将依法追究其法律责任。\n  ")]), _vm._v(" "), _c('div', [_vm._v("6、转载或引用知心慧学原创或首发内容时，须注明作者姓名，并标注“来源：知心慧学 "), _c('a', {
    attrs: {
      "href": "http://www.zhixinhuixue.com"
    }
  }, [_vm._v("www.zhixinhuixue.com")]), _vm._v("”，转载须保持作品完整，违者风向标将依法追究其责\n  ")]), _vm._v(" "), _c('div', [_vm._v("7、对于知心慧学发布的非原创或非首发内容，均转载自其它媒体、杂志、刊物，转载目的在于传递更多信息，并不代表知心慧学赞同其观点和对其真实性负责。")]), _vm._v(" "), _c('div', [_vm._v("8、知心慧学不拥有转载作品的版权，无权许可他人转载。如需转载，请联系著作权人，以获取授权。引用、转载、复制、摘编或以其他任何方式使用转载作品的，必须保留本网站注明的“来源”，不得擅自篡改为“来源：知心慧学\n    www.zhixinhuixue.com”，违者本网站将依法追究其责任。\n  ")]), _vm._v(" "), _c('div', [_vm._v("9、擅自使用知心慧学名义转载不规范来源的信息、版权不明的资讯、稿件等作品，或盗用知心慧学名义发布信息，风向标将依法追究其法律责任。")]), _vm._v(" "), _c('div', [_vm._v("10、异议协调：对于知心慧学发布内容的版权或相关事项有异议的，请及时联系风向标协商处理。邮箱："), _c('a', {
    staticClass: "blue",
    attrs: {
      "href": "mailto:info@fxbjy.com"
    }
  }, [_vm._v("info@fxbjy.com")])]), _vm._v(" "), _c('div', [_vm._v("\n    11、因业务调整，本声明可能随时被修改。您应经常访问本页面以便了解当前的条款，因为这些条款与您密切相关。这些条款的某些条文也可能被知心慧学中某些页面上或某些具体服务明确指定的法律通告或条款所取代，您应该了解这些内容，一旦接受本条款，即意味着您已经同时详细阅读并接受了这些被引用或取代的条款。\n  ")]), _vm._v(" "), _c('div', [_vm._v("12、风向标拥有对本声明的最终解释权。")])])
}]}

/***/ }),
/* 552 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "user-know"
  }, [_c('div', {
    staticClass: "update"
  }, [_c('p', [_vm._v("更新日期：2022年6月2日")]), _vm._v(" "), _c('p', [_vm._v("生效日期：2022年6月2日")])]), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("版权声明")]), _vm._v(" "), _c('div', [_vm._v("欢迎光临并使用知心慧学，用户在使用知心慧学前请认真阅读本声明，用户开始使用知心慧学即表明已了解、尊重并遵守本声明的所有内容。如用户对本声明有任何异议，请不要使用知心慧学。在以下声明中，知心慧学的用户统称为“您”。\n  ")]), _vm._v(" "), _c('div', [_vm._v("1、知心慧学由江西风向标智能科技有限公司（以下简称“风向标”）出品，其载体包括手机APP、H5、网站、公众号、小程序等，上述载体的所有权、经营权、管理权均属于风向标。本版权声明适用于上述所有载体。")]), _vm._v(" "), _c('div', [_vm._v("\n    2、您在知心慧学上传的文章、试卷、课题集、作业集、课件、教案、学案等文字、图形资料和音频、视频材料（以下统称“作品”），如属于您原创，即表示上述作品的著作权归风向标所有，或由您与风向标协议约定共同所有。您保证对于您上传的原创作品拥有完整的、无瑕疵的著作权，若因第三方向风向标追究上述作品著作权的法律责任，给风向标造成的一切损失由您全部承担。\n  ")]), _vm._v(" "), _c('div', [_vm._v("\n    3、您转载他人的材料上传至知心慧学，必须取得原著作权人的同意或非排他性许可，您通过其他渠道转载到知心慧学的材料，须得到来源渠道的许可，如可以不经来源渠道许可转载的，您也须注明来源渠道的名称或地址，否则一切后果由您全部承担。\n  ")]), _vm._v(" "), _c('div', [_vm._v("4、您承诺：您在知心慧学所上传的所有作品内容符合法律、法规和规范性文件的相关规定，不侵犯任何第三方的合法权益。如您违反前述保证，风向标有权删除相关内容，并可以暂停或终止向您提供服务。")]), _vm._v(" "), _c('div', [_vm._v("\n    5、任何转载知心慧学已经刊登的作品的，均须得到作品原著作权人和风向标的同意，否则因此引发的法律责任由转载方全部承担；作品原著作权人和风向标未声明不得转载的，转载方也应在转载时注明作品出处，且不得对所转载内容进行任何形式的篡改、增减、节选、歪曲等，否则风向标将依法追究其法律责任。\n  ")]), _vm._v(" "), _c('div', [_vm._v("6、转载或引用知心慧学原创或首发内容时，须注明作者姓名，并标注“来源：知心慧学 www.zhixinhuixue.com”，转载须保持作品完整，违者风向标将依法追究其责任。\n  ")]), _vm._v(" "), _c('div', [_vm._v("7、对于知心慧学发布的非原创或非首发内容，均转载自其它媒体、杂志、刊物，转载目的在于传递更多信息，并不代表知心慧学赞同其观点和对其真实性负责。")]), _vm._v(" "), _c('div', [_vm._v("8、知心慧学不拥有转载作品的版权，无权许可他人转载。如需转载，请联系著作权人，以获取授权。引用、转载、复制、摘编或以其他任何方式使用转载作品的，必须保留本网站注明的“来源”，不得擅自篡改为“来源：知心慧学\n    www.zhixinhuixue.com”，违者本网站将依法追究其责任。\n  ")]), _vm._v(" "), _c('div', [_vm._v("9、擅自使用知心慧学名义转载不规范来源的信息、版权不明的资讯、稿件等作品，或盗用知心慧学名义发布信息，风向标将依法追究其法律责任。")]), _vm._v(" "), _c('div', [_vm._v("10、异议协调：对于知心慧学发布内容的版权或相关事项有异议的，请及时联系风向标协商处理。邮箱："), _c('a', {
    staticClass: "blue",
    attrs: {
      "href": "mailto:info@fxbjy.com"
    }
  }, [_vm._v("info@fxbjy.com")])]), _vm._v(" "), _c('div', [_vm._v("\n    11、因业务调整，本声明可能随时被修改。您应经常访问本页面以便了解当前的条款，因为这些条款与您密切相关。这些条款的某些条文也可能被知心慧学中某些页面上或某些具体服务明确指定的法律通告或条款所取代，您应该了解这些内容，一旦接受本条款，即意味着您已经同时详细阅读并接受了这些被引用或取代的条款。\n  ")]), _vm._v(" "), _c('div', [_vm._v("12、风向标拥有对本声明的最终解释权。")])])
}]}

/***/ }),
/* 553 */,
/* 554 */,
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./0.png": 120,
	"./1.png": 121,
	"./2.png": 122,
	"./3.png": 123,
	"./4.png": 124
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 555;

/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./0.png": 125,
	"./1.png": 126,
	"./10.png": 127,
	"./11.png": 128,
	"./12.png": 129,
	"./13.png": 130,
	"./2.png": 131,
	"./3.png": 132,
	"./4.png": 133,
	"./5.png": 134,
	"./6.png": 135,
	"./7.png": 136,
	"./8.png": 137,
	"./9.png": 138
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 556;

/***/ })
],[287]);


// WEBPACK FOOTER //
// static/js/app.5080fc00dd0d89e3f1c2.js